// src/components/map/map.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment PlaceDisplayFragment on PlacesDialog {\n    placesDialogEGDSTextsContentSection {\n      heading {\n        text\n      }\n      subHeading {\n        text\n      }\n      clearSavedPlaceIcon {\n        id\n        description\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment PlacesTypeaheadFragment on PlacesDialogTypeAheadContentSection {\n    content {\n      label\n      placeholder\n      renderType\n      typeaheadPlaceholder\n      typeaheadEmptyResultPlaceholder\n      typeaheadInfo {\n        client\n        regionType\n        isDestination\n        maxNumberOfResults\n        personalize\n        lineOfBusiness\n        packageType\n        typeaheadFeatures\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment PlacesSearchFragment on PlacesDialog {\n    placesDialogTypeAheadContentSection {\n      heading {\n        text\n      }\n      subHeading {\n        text\n      }\n      ...PlacesTypeaheadFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment PlacesSwitchesFragment on PlacesDialog {\n    placesDialogUITogglesContentSection {\n      subHeading {\n        text\n      }\n      content {\n        ...SwitchToggleFragment\n      }\n    }\n  }\n  fragment SwitchToggleFragment on FilterOption {\n    checked\n    checkedLabel\n    enabled\n    uncheckedLabel\n    filteredValues\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment PlacesDialogFragment on PlacesDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        closeText\n      }\n    }\n    trigger {\n      icon {\n        description\n        token\n      }\n      disabled\n    }\n    ...PlacesSearchFragment\n    ...PlaceDisplayFragment\n    ...PlacesSwitchesFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment MapActionsFragment on PropertyInfoMap {\n    callToAction {\n      action {\n        targetRef\n      }\n      button {\n        primary\n      }\n      event {\n        eventName\n        eventType\n        eventVersion\n      }\n    }\n    dialogs {\n      ...PlacesDialogFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  query MapQuery($context: ContextInput!, $propertyId: String!, $shoppingContext: ShoppingContextInput) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      id\n      summary {\n        map {\n          egdsBasicMap {\n            ...DynamicMapFragment\n          }\n          mapInfoCards {\n            ...MapCardContentFragment\n          }\n          toolbar {\n            title\n            icon {\n              description\n            }\n          }\n          ...MapActionsFragment\n        }\n        location {\n          coordinates {\n            latitude\n            longitude\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment GalleryButtonsFragment on PropertyImageGallery {\n    galleryButtons {\n      accessibility\n      icon {\n        description\n        id\n      }\n      action {\n        accessibility\n        resource {\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment CarouselContainerFragment on PropertyImageGallery {\n    label\n    images {\n      alt\n      image {\n        url\n        description\n        thumbnailClickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      lowResImage {\n        url\n      }\n      previewImage {\n        url\n      }\n      trackingId\n      imageId\n    }\n    ...GalleryButtonsFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment MosaicContainerFragment on PropertyImageGallery {\n    label\n    images {\n      ...PropertyImageFragment\n    }\n    ...GalleryButtonsFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment MediaGalleryDialogFragment on PropertyImageGallery {\n    images {\n      alt\n      image {\n        url\n        description\n        thumbnailClickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      thumbnail {\n        url\n        description\n      }\n      fallbackImage {\n        url\n        description\n      }\n      trackingId\n      imageId\n    }\n    categories {\n      categoryId: id\n      name\n      images {\n        alt\n        subjectId\n        image {\n          url\n          description\n          thumbnailClickAnalytics {\n            linkName\n            referrerId\n          }\n        }\n        thumbnail {\n          url\n          description\n        }\n        fallbackImage {\n          url\n          description\n        }\n        trackingId\n        imageId\n      }\n    }\n    mediaGalleryDialog {\n      toolbar {\n        icon {\n          iconId: id\n          description\n        }\n      }\n      trigger {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment ThumbnailGalleryDialogFragment on PropertyImageGallery {\n    images {\n      alt\n      subjectId\n      image {\n        url\n        description\n        thumbnailClickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      previewImage {\n        url\n      }\n      thumbnail {\n        url\n        description\n      }\n      trackingId\n      imageId\n      fallbackImage {\n        url\n        description\n      }\n    }\n    categories {\n      categoryId: id\n      name\n      images {\n        alt\n        subjectId\n        image {\n          url\n          description\n          thumbnailClickAnalytics {\n            linkName\n            referrerId\n          }\n        }\n        thumbnail {\n          url\n          description\n        }\n        previewImage {\n          url\n        }\n        fallbackImage {\n          url\n          description\n        }\n        imageId\n        trackingId\n      }\n    }\n    thumbnailGalleryDialog {\n      toolbar {\n        title\n        icon {\n          iconId: id\n          description\n        }\n      }\n      trigger {\n        accessibilityLabel\n        value\n      }\n    }\n    primaryButton {\n      propertyTargetRef\n      button {\n        text\n        accessibilityLabel\n        analytics {\n          referrerId\n          linkName\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyImageGalleryFragment on PropertyImageGallery {\n    ...MosaicContainerFragment\n    ...CarouselContainerFragment\n    ...MediaGalleryDialogFragment\n    ...ThumbnailGalleryDialogFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment AddressFragment on PropertyLocation {\n    coordinates {\n      latitude\n      longitude\n    }\n    address {\n      addressLine\n      city\n      countryCode\n      firstAddressLine\n      province\n    }\n    mapDialog {\n      trigger {\n        value\n        icon {\n          iconId: id\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryMapTriggerFragment on PropertyInfo {\n    id\n    summary {\n      location {\n        ...AddressFragment\n        mapTrigger {\n          ...MapTriggerFragment\n        }\n        staticImage {\n          description\n          url\n        }\n        video {\n          description\n          thumbnailClickAnalytics {\n            linkName\n            referrerId\n          }\n          playPauseAnalytics {\n            linkName\n            referrerId\n          }\n          thumbnail {\n            value\n          }\n          url {\n            value\n          }\n        }\n      }\n      nearbyPOIs {\n        heading\n        items {\n          text\n          icon {\n            iconId: id\n            description\n          }\n          moreInfo\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment CleanlinessDialogFragment on CleanlinessDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingDialogTriggerMessageFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment NearByPoisLinkFragment on LodgingDialogTriggerMessage {\n    accessibilityLabel\n    value\n    icon {\n      id\n      description\n    }\n    clientSideAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment MoreInfoDialogFragment on MoreInfoDialog {\n    dialog {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      icon {\n        iconId: id\n        description\n      }\n      title\n    }\n    trigger {\n      ...LodgingDialogTriggerMessageFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyTakeoverAmenitiesFragment on PropertyTakeoverAmenities {\n    amenityClosures {\n      ...PropertyInfoContentFragment\n    }\n    highlight {\n      ...PropertyInfoContentFragment\n    }\n    property {\n      ...PropertyInfoContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  query PropertyAmenitiesQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      summary {\n        amenities(searchCriteria: $searchCriteria) {\n          takeover {\n            ...PropertyTakeoverAmenitiesFragment\n          }\n          viewAmenitiesAdaptExAttemptEvents {\n            campaignId\n            events {\n              payloadId\n              eventType\n              eventTarget\n              banditDisplayed\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment SeeMorePropertyAmenitiesDialogFragment on AmenitiesDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingDialogTriggerMessageFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  fragment SeeMoreActionFragment on SeeMoreAction {\n    __typename\n    ... on AmenitiesDialog {\n      ...SeeMorePropertyAmenitiesDialogFragment\n    }\n    ... on CleanlinessDialog {\n      ...CleanlinessDialogFragment\n    }\n    ... on MoreInfoDialog {\n      ...MoreInfoDialogFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyInfoContentWithSeeMoreActionFragment on PropertyInfoContent {\n    header {\n      ...PropertyInfoContentHeaderFragment\n    }\n    ...PropertyInfoContentItemsFragment\n    seeMoreAction {\n      ...SeeMoreActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyDescriptionAndMoreInfoSectionFragment on PropertyDetails {\n    description {\n      ...LodgingEGDSParagraphFragment\n    }\n    contentSections {\n      ...PropertyInfoContentWithSeeMoreActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyDetailsReviewsBreakdownFragment on PropertyReviewSummary {\n    ...PropertyReviewsBreakdownFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  query PropertyInfoDetailsQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput!\n    $damageLiability: DamageLiability\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      propertyDetails(searchCriteria: $searchCriteria) {\n        gallery {\n          ...PropertyImageGalleryFragment\n        }\n        heading {\n          ...LodgingEGDSHeadingFragment\n        }\n        rating {\n          ...LodgingEGDSRatingFragment\n        }\n        ...PropertyDescriptionAndMoreInfoSectionFragment\n      }\n\n      propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n        policies {\n          ...PropertyContentSectionGroupFragment\n        }\n        importantInfo {\n          ...PropertyContentSectionGroupFragment\n        }\n      }\n\n      summary {\n        nearbyPOIs {\n          header {\n            text\n          }\n        }\n      }\n      ...SummaryMapTriggerFragment\n    }\n\n    propertyReviewSummaries(context: $context, propertyIds: [$propertyId], searchCriteria: $searchCriteria) {\n      ...PropertyDetailsReviewsBreakdownFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingAdaptExEventsFragment on ShoppingAdaptExEvent {\n    banditDisplayed\n    eventTarget\n    eventType\n    payloadId\n  }\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  fragment ProductHighlightsSectionFragment on ProductHighlightsSection {\n    highlightsType\n    content {\n      header {\n        text\n        subText\n        icon {\n          id\n          description\n          spotLight\n        }\n      }\n      items {\n        ... on EGDSPlainText {\n          text\n          __typename\n        }\n        ... on ShoppingProductContentGraphicsItem {\n          impressionAnalytics {\n            referrerId\n            linkName\n          }\n          leadingIcon {\n            id\n            description\n          }\n          text\n          __typename\n        }\n      }\n      impressionAnalytics {\n        event\n        referrerId\n        linkName\n      }\n    }\n    adaptExCampaignEvents {\n      campaignId\n      adaptExAttemptEvents {\n        ...ShoppingAdaptExEventsFragment\n      }\n      adaptExSuccessEvents {\n        ...ShoppingAdaptExEventsFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  fragment ProductUniquenessFragment on ProductUniqueness {\n    impression {\n      ... on ClientSideImpressionEventAnalytics {\n        linkName\n        referrerId\n        event\n        uisPrimeMessages {\n          messageContent\n          schemaName\n        }\n      }\n    }\n    title {\n      ...LodgingEGDSGraphicTextFragment\n    }\n    details {\n      ...EGDSSpannableListFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  query ProductHighlightsQuery($context: ContextInput!, $productIdentifier: ProductIdentifierInput!) {\n    productHighlights(context: $context, productIdentifier: $productIdentifier) {\n      ... on ProductUniqueness {\n        ...ProductUniquenessFragment\n      }\n      ... on ProductHighlightsSection {\n        ...ProductHighlightsSectionFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  fragment RelevantAmenitiesItemFragment on PropertyInfoSection {\n    header {\n      text\n    }\n    contents {\n      items {\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  fragment RelevantAmenitiesFragment on PropertyInfo {\n    __typename\n    summary {\n      __typename\n      amenities(searchCriteria: $searchCriteria) {\n        __typename\n        relevantAmenities {\n          ...RelevantAmenitiesItemFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  fragment AmenitiesTabsFragment on ShoppingTabs {\n    selectedTabId\n    tabs {\n      label\n      accessibility\n      tabId\n      contentId\n      clickAnalytics {\n        referrerId\n        linkName\n      }\n    }\n  }\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  fragment AmenitiesDialogFragment on PropertyAmenities {\n    amenitiesDialog {\n      toolbar {\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        icon {\n          iconId: id\n          description\n        }\n        title\n      }\n    }\n    takeover {\n      ...PropertyTakeoverAmenitiesFragment\n    }\n    viewAmenitiesAdaptExAttemptEvents {\n      campaignId\n      events {\n        payloadId\n        eventType\n        eventTarget\n        banditDisplayed\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  fragment AmenitiesLinkFragment on PropertyAmenities {\n    amenitiesDialog {\n      trigger {\n        value\n        accessibilityLabel\n        icon {\n          iconId: id\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  query SummarySeeAllAmenitiesQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n    $damageLiability: DamageLiability\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      summary {\n        amenities(searchCriteria: $searchCriteria) {\n          tabs {\n            ...AmenitiesTabsFragment\n          }\n          topAmenities {\n            ...PropertyInfoContentFragment\n          }\n          propertyContentPreferences {\n            ...PropertyContentFragment\n          }\n          relevantAmenities {\n            ...RelevantAmenitiesItemFragment\n          }\n          ...AmenitiesLinkFragment\n          ...AmenitiesDialogFragment\n        }\n        tagline\n      }\n      propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n        aboutThisProperty {\n          ...PropertyContentSectionGroupFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  fragment HostProfileFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      aboutThisHost {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  fragment AboutThisPropertyDialogFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      aboutThisProperty {\n        ...PropertyContentSectionGroupFragment\n      }\n      aboutThisHost {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyInfoFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      aboutThisProperty {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  fragment AboutThisPropertySummaryFragment on PropertyInfo {\n    ...PropertyInfoFragment\n    ...HostProfileFragment\n    ...AboutThisPropertyDialogFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  fragment AmenitiesSimplifiedViewFragment on PropertyInfo {\n    __typename\n    summary {\n      __typename\n      amenities(searchCriteria: $searchCriteria) {\n        __typename\n        topAmenities {\n          ...PropertyInfoContentFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  fragment AmenityDescriptionJumpLinkFragment on PropertyInfoSection {\n    action {\n      ...LodgingJumpLinkFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  fragment AmenityContentFragment on PropertyInfoContent {\n    __typename\n    heading\n    items {\n      __typename\n      text\n    }\n    icon {\n      __typename\n      iconId: id\n    }\n    structuredData {\n      __typename\n      itemprop\n      itemscope\n      itemtype\n    }\n  }\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  fragment AmenityHeadingFragment on LodgingHeader {\n    __typename\n    text\n    subText\n  }\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  fragment AmenitySectionFragment on PropertyInfoSection {\n    __typename\n    header {\n      ...AmenityHeadingFragment\n    }\n    contents {\n      ...AmenityContentFragment\n    }\n    expando {\n      collapseButton {\n        text\n        accessibilityLabel\n        analytics {\n          eventType\n          referrerId\n          linkName\n        }\n      }\n      expandButton {\n        text\n        accessibilityLabel\n        analytics {\n          eventType\n          referrerId\n          linkName\n        }\n      }\n      items\n    }\n    ...AmenityDescriptionJumpLinkFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  fragment AmenityDescriptionFragment on PropertyInfo {\n    __typename\n    summary {\n      __typename\n      amenities(searchCriteria: $searchCriteria) {\n        __typename\n        amenities {\n          ...AmenitySectionFragment\n        }\n        viewAmenitiesAdaptExAttemptEvents {\n          campaignId\n          events {\n            payloadId\n            eventType\n            eventTarget\n            banditDisplayed\n          }\n        }\n        reserveAdaptExSuccessEvents {\n          campaignId\n          events {\n            payloadId\n            eventType\n            eventTarget\n            banditDisplayed\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  fragment BookByPhoneFragment on PropertyInfo {\n    telesales {\n      telesalesNumber {\n        phoneNumber\n        value\n      }\n      description {\n        value\n      }\n      tracking {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  fragment __PropertyDirectFeedbackPromptIdFragment on PropertyInfo {\n    directFeedback {\n      __typename\n      callToAction {\n        callToAction {\n          ... on EGDSStandardLink {\n            action {\n              analytics {\n                linkName\n                referrerId\n              }\n            }\n            icon {\n              id\n              size\n            }\n            text\n          }\n        }\n        promptId\n        contextValues {\n          key\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  fragment FaqFragment on PropertyFAQ {\n    question {\n      text\n    }\n    answer {\n      text\n    }\n  }\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  fragment FrequentlyAskedQuestionsFragment on PropertyInfo {\n    id\n    frequentlyAskedQuestions {\n      title {\n        text\n        subText\n      }\n      askAQuestion {\n        primary\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n      faqs {\n        ...FaqFragment\n      }\n      expando {\n        collapseButton {\n          text\n          accessibilityLabel\n          analytics {\n            eventType\n            referrerId\n            linkName\n          }\n        }\n        expandButton {\n          text\n          accessibilityLabel\n          analytics {\n            eventType\n            referrerId\n            linkName\n          }\n        }\n        items\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  fragment GalleryFragment on PropertyInfo {\n    summary {\n      name\n      overview {\n        accessibilityLabel\n      }\n    }\n    propertyGallery {\n      ...PropertyImageGalleryFragment\n    }\n    id\n  }\n\n  ",
        "\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n  fragment InventorySourceFragment on PropertyInfo {\n    summary {\n      propertySource {\n        accessibilityLabel\n        label\n        graphic {\n          __typename\n          ... on Mark {\n            description\n            id\n            size\n            token\n            url {\n              value\n            }\n          }\n        }\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  fragment NavigationBarTabsFragment on PropertySummary {\n    navigationBarTabs {\n      localizedName\n      sectionName\n    }\n  }\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  fragment NavigationBarFragment on PropertyInfo {\n    summary {\n      ...NavigationBarTabsFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyNumberFragment on PropertyInfo {\n    propertyIdDisplay(identifier: $identifier) {\n      ...EGDSSpannableTextFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  fragment SaveTripItemFragment on PropertyInfo {\n    saveTripItem(searchCriteria: $searchCriteria) {\n      ...TripsSaveItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  fragment ShareDescriptionFragment on ShoppingShareContent {\n    description\n    image {\n      url\n      altText\n    }\n  }\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  fragment ShareOptionsFragment on ShoppingShareContent {\n    urlParameterKeys\n    shareLinks {\n      ... on ShoppingCopyLink {\n        __typename\n        icon {\n          id\n          description\n        }\n        name\n        copiedUrl\n        analytics {\n          linkName\n          referrerId\n        }\n        toast {\n          text\n        }\n        referrerId\n      }\n      ... on ShoppingSocialMediaLink {\n        __typename\n        graphic {\n          ... on Icon {\n            ...IconFragment\n            __typename\n          }\n          ... on Mark {\n            ...MarkFragment\n            __typename\n          }\n        }\n        name\n        analytics {\n          linkName\n          referrerId\n        }\n        url\n        encodedUrlParameterKey\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  fragment ShareDialogFragment on ShoppingShareLinkAction {\n    sheet {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      closeText\n    }\n    content {\n      ...ShareDescriptionFragment\n      ...ShareOptionsFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  fragment ShareDialogPopOverFragment on ShoppingShareLinkAction {\n    sheet {\n      closeAnalytics {\n        __typename\n      }\n      closeText\n    }\n    content {\n      ...ShareDescriptionFragment\n      ...ShareOptionsFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingShareLinksFragment on PropertyInfo {\n    shoppingShareLinks {\n      action {\n        ...ShareDialogFragment\n      }\n      button {\n        primary\n        analytics {\n          referrerId\n          linkName\n        }\n        icon {\n          id\n          description\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  fragment ShortlistFragment on PropertyInfo {\n    summary {\n      name\n    }\n    shortList {\n      button {\n        checked\n        checkedAccessibilityLabel\n        checkedAnalytics {\n          linkName\n          referrerId\n        }\n        uncheckedAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  fragment SpaceOverviewInfoFragment on PropertyInfoContent {\n    items {\n      icon {\n        description\n        iconId: id\n        size\n      }\n      text\n    }\n  }\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  fragment SpaceOverviewTitleFragment on PropertyInfoContent {\n    header {\n      text\n    }\n  }\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  fragment SpaceOverviewFragment on PropertyInfo {\n    propertyHighlightedDetails {\n      ...SpaceOverviewTitleFragment\n      ...SpaceOverviewInfoFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryAmenitiesFragment on PropertyInfo {\n    summary {\n      amenities(searchCriteria: $searchCriteria) {\n        tabs {\n          ...AmenitiesTabsFragment\n        }\n        topAmenities {\n          ...PropertyInfoContentFragment\n        }\n        propertyContentPreferences {\n          ...PropertyContentFragment\n        }\n        amenitiesAdaptExSuccessEvents {\n          ...LodgingAdaptExAnalyticsEventFragment\n        }\n        relevantAmenities {\n          ...RelevantAmenitiesItemFragment\n        }\n        ...AmenitiesLinkFragment\n        ...AmenitiesDialogFragment\n      }\n      tagline\n    }\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      aboutThisProperty {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsNearbyEditorialFragment on PropertyEditorial {\n    content\n  }\n"
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsNearbyPoisItemsFragment on PropertyInfoContent {\n    items {\n      text\n      moreInfo\n      icon {\n        iconId: id\n      }\n    }\n  }\n"
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsNearbyPoisFragment on PropertyWhatsAround {\n    nearbyPOIs {\n      ...WhatsNearbyPoisItemsFragment\n      title\n      icon {\n        iconId: id\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject68 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsNearbySectionFragment on PropertyLocation {\n    whatsAround {\n      title\n      ...WhatsNearbyPoisFragment\n      editorial {\n        ...WhatsNearbyEditorialFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject69 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryNearByPoisFragment on PropertyInfo {\n    id\n    summary {\n      nearbyPOIs {\n        heading\n        items {\n          text\n          icon {\n            iconId: id\n            description\n          }\n          moreInfo\n        }\n        seeMoreAction {\n          ...SeeMoreActionFragment\n        }\n        adaptExAttemptEvents {\n          ...LodgingAdaptExAnalyticsEventFragment\n        }\n        adaptExSuccessEvents {\n          ...LodgingAdaptExAnalyticsEventFragment\n        }\n        impressionAnalytics {\n          referrerId\n          linkName\n        }\n      }\n      location {\n        ...WhatsNearbySectionFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject70 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryBannerMessageFragment on PropertyInfo {\n    summary {\n      bannerMessageCard {\n        heading\n        graphic {\n          ... on Mark {\n            id\n            description\n            url {\n              relativePath\n              value\n            }\n          }\n        }\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject71 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryHeaderFragment on PropertyInfo {\n    summary {\n      name\n      latinAlphabetName\n      overview {\n        vipMessaging\n        starRating\n        propertyRating {\n          accessibility\n          rating\n        }\n      }\n      starRatingIcon {\n        description\n        iconId: id\n      }\n      featuredMessages {\n        icon {\n          iconId: id\n          description\n        }\n        value\n      }\n      tagline\n      messages {\n        ... on EGDSPlainText {\n          text\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject72 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryChatbotLaunchFragment on PropertyInfo {\n    summary {\n      lodgingChatbot {\n        header {\n          text\n        }\n        action {\n          primary\n        }\n        content\n      }\n    }\n  }\n"
    ]);
    _templateObject73 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryVipBadgeFragment on PropertyInfo {\n    summary {\n      overview {\n        vipMessaging\n      }\n    }\n  }\n"
    ]);
    _templateObject74 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryGeoFragment on PropertyInfo {\n    ...SummaryMapTriggerFragment\n    ...SummaryNearByPoisFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject75 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryFragment on PropertyInfo {\n    ...SummaryAmenitiesFragment\n    ...SummaryMapTriggerFragment\n    ...SummaryNearByPoisFragment\n    ...SummaryHeaderFragment\n    ...SummaryBannerMessageFragment\n    ...SummaryChatbotLaunchFragment\n    ...RelevantAmenitiesFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject76 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundLinkFragment on LodgingLinkMessage {\n    link {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      uri {\n        value\n      }\n    }\n    value\n    icon {\n      id\n      description\n    }\n  }\n"
    ]);
    _templateObject77 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundEditorialFragment on PropertyEditorial {\n    content\n    crossLinks {\n      ...WhatsAroundLinkFragment\n    }\n    title\n  }\n\n  ",
        "\n"
    ]);
    _templateObject78 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundMapFragment on PropertyWhatsAround {\n    staticImage {\n      description\n      url\n    }\n    mapTrigger {\n      ...MapTriggerFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject79 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundIconFragment on Icon {\n    iconId: id\n  }\n"
    ]);
    _templateObject80 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundPoisItemFragment on PropertyInfoContent {\n    items {\n      text\n      moreInfo\n      icon {\n        ...WhatsAroundIconFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject81 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundPoisFragment on PropertyWhatsAround {\n    nearbyPOIs {\n      ...WhatsAroundPoisItemFragment\n      title\n      icon {\n        ...WhatsAroundIconFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject82 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundFragment on PropertyInfo {\n    id\n    summary {\n      location {\n        whatsAround {\n          title\n          expando {\n            collapseButton {\n              text\n              accessibilityLabel\n              analytics {\n                eventType\n                referrerId\n                linkName\n              }\n            }\n            expandButton {\n              text\n              accessibilityLabel\n              analytics {\n                eventType\n                referrerId\n                linkName\n              }\n            }\n            items\n          }\n          editorial {\n            ...WhatsAroundEditorialFragment\n          }\n          ...WhatsAroundPoisFragment\n          ...WhatsAroundMapFragment\n        }\n      }\n      map {\n        trigger {\n          value\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject83 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _tagged_template_literal([
        "\n  query PropertyDetailsBasicQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n    $damageLiability: DamageLiability\n    $identifier: String\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext, searchCriteria: $searchCriteria) {\n      id\n      ...AmenityDescriptionFragment\n      ...PoliciesFragment\n      ...PropertyDetailedAmenitiesFragment\n      ...ImportantInfoFragment\n      ...FrequentlyAskedQuestionsFragment\n      ...NavigationBarFragment\n      ...AboutThisPropertyFragment\n      ...WhatsAroundFragment\n      ...GalleryFragment\n      ...SummaryFragment\n      ...BookByPhoneFragment\n      ...SpaceOverviewFragment\n      ...InventorySourceFragment\n      ...ShortlistFragment\n      ...SaveTripItemFragment\n      ...AmenitiesSimplifiedViewFragment\n      ...RelevantAmenitiesFragment\n      ...SpecialFeaturesFragment\n      ...HostProfileFragment\n      ...ShoppingShareLinksFragment\n      ...__PropertyDirectFeedbackPromptIdFragment\n      ...PropertyNumberFragment\n      ...SummaryVipBadgeFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject84 = function _templateObject() {
        return data;
    };
    return data;
}
import React7 from "react";
import { gql as gql7, useQuery } from "@apollo/client";
import distance from "@turf/distance";
import { point } from "@turf/helpers";
import { EGDSEGMapsQualifier } from "@egds/react-core/map";
import { EGDSSheet as EGDSSheet2 } from "@egds/react-core/sheet";
import { EGDSToolbar as EGDSToolbar2 } from "@egds/react-core/toolbar";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { convertMarkers, DynamicMap, MapCardContent as MapCardContent2 } from "@shared-ui/retail-dynamic-map";
import { ViewMedium as ViewMedium2, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
// src/components/map/utils.ts
var isProductType = function(markerType) {
    return markerType === "property" || markerType === "product";
};
var filterFeatureObject = function(f) {
    return true;
};
// src/components/map/analytics/map-analytics.tsx
import { useEgMapClickstream } from "@shared-ui/retail-dynamic-map";
var BASE_RFRR = "HOT.HIS.Module.Map";
var _obj;
var MapTracksDictionary = (_obj = {}, _define_property(_obj, "PAN" /* PAN */ , [
    "".concat(BASE_RFRR, ".Pan"),
    "User panning PWA HIS Map"
]), _define_property(_obj, "ZOOM_IN" /* ZOOM_IN */ , [
    "".concat(BASE_RFRR, ".Zoom.In"),
    "User zooming in on PWA HIS Map"
]), _define_property(_obj, "ZOOM_OUT" /* ZOOM_OUT */ , [
    "".concat(BASE_RFRR, ".Zoom.Out"),
    "User zooming out on PWA HIS Map"
]), _define_property(_obj, "CLOSE" /* CLOSE */ , [
    "".concat(BASE_RFRR, ".Link.Close"),
    "Close map dialog"
]), _obj);
var _obj1;
var FilterTracksDictionary = (_obj1 = {}, _define_property(_obj1, "RESTAURANT_APPLIED" /* RESTAURANT */ , [
    "".concat(BASE_RFRR, ".RestaurantsFilterApplied"),
    "Show restaurants on HIS map"
]), _define_property(_obj1, "LANDMARK_APPLIED" /* LANDMARK */ , [
    "".concat(BASE_RFRR, ".LandmarksFilterApplied"),
    "Show landmarks on HIS map"
]), _define_property(_obj1, "BOTH_APPLIED" /* BOTH */ , [
    "".concat(BASE_RFRR, ".BothFiltersApplied"),
    "Show landmarks and restaurants on HIS map"
]), _define_property(_obj1, "NONE_APPLIED" /* NONE */ , [
    "".concat(BASE_RFRR, ".NoFiltersApplied"),
    "Show only airports and hotel on HIS map"
]), _obj1);
function useAnalytics(onCloseCallback) {
    var _useEgMapClickstream = useEgMapClickstream(), trackMapInit = _useEgMapClickstream.trackMapInit, trackMapPresented = _useEgMapClickstream.trackMapPresented, trackMapContentPresented = _useEgMapClickstream.trackMapContentPresented, trackMapHidden = _useEgMapClickstream.trackMapHidden;
    var onClose = function() {
        if (onCloseCallback) {
            onCloseCallback();
        }
        trackMapHidden();
    };
    return {
        trackMapInit: trackMapInit,
        trackMapPresented: trackMapPresented,
        trackMapContentPresented: trackMapContentPresented,
        onClose: onClose
    };
}
// src/components/map/map-actions.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSButtonSize, EGDSFloatingButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { useRefTargetScroll } from "@shared-ui/ref-context";
import { buildData, buildEvent, MapCardContent, MapCardSize, useEgMapClickstream as useEgMapClickstream3 } from "@shared-ui/retail-dynamic-map";
import { PlaceCard } from "@shared-ui/retail-places-place-details";
import { ViewMedium, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
// src/components/map/places-dialog.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex2 } from "@egds/react-core/layout-flex";
import { EGDSSheet, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { CustomPlaceSearchType, useEgMapClickstream as useEgMapClickstream2 } from "@shared-ui/retail-dynamic-map";
import { ViewLarge as ViewLarge2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
// src/components/map/place-display.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSSubheading, EGDSText } from "@egds/react-core/text";
var __PlaceDisplayFragment = gql(_templateObject());
var PlaceDisplay = function(props) {
    var _data_placesDialogEGDSTextsContentSection_heading, _data_placesDialogEGDSTextsContentSection, _data_placesDialogEGDSTextsContentSection1;
    var data = props.data, savedFeature = props.savedFeature, saveCustomPlace = props.saveCustomPlace;
    var heading = data === null || data === void 0 ? void 0 : (_data_placesDialogEGDSTextsContentSection = data.placesDialogEGDSTextsContentSection) === null || _data_placesDialogEGDSTextsContentSection === void 0 ? void 0 : (_data_placesDialogEGDSTextsContentSection_heading = _data_placesDialogEGDSTextsContentSection.heading) === null || _data_placesDialogEGDSTextsContentSection_heading === void 0 ? void 0 : _data_placesDialogEGDSTextsContentSection_heading.text;
    var clearSavedPlaceIcon = data === null || data === void 0 ? void 0 : (_data_placesDialogEGDSTextsContentSection1 = data.placesDialogEGDSTextsContentSection) === null || _data_placesDialogEGDSTextsContentSection1 === void 0 ? void 0 : _data_placesDialogEGDSTextsContentSection1.clearSavedPlaceIcon;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(EGDSSpacing, {
        padding: {
            blockstart: "one",
            blockend: "one"
        }
    }, heading && /* @__PURE__ */ React.createElement(EGDSHeading, {
        tag: "h3",
        size: 5
    }, heading)), /* @__PURE__ */ React.createElement(EGDSSpacing, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React.createElement(EGDSLayoutFlex, {
        justifyContent: "space-between",
        alignContent: "center",
        alignItems: "center"
    }, /* @__PURE__ */ React.createElement(EGDSLayoutFlexItem, {
        grow: 1
    }, /* @__PURE__ */ React.createElement(EGDSIcon, {
        name: "place",
        size: EGDSIconSize.SMALL
    })), /* @__PURE__ */ React.createElement(EGDSLayoutFlexItem, {
        grow: 10
    }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(EGDSText, {
        weight: "bold"
    }, savedFeature.name), /* @__PURE__ */ React.createElement(EGDSSpacing, null, /* @__PURE__ */ React.createElement(EGDSSubheading, null, savedFeature.text)))), /* @__PURE__ */ React.createElement(EGDSLayoutFlexItem, {
        grow: 1
    }, /* @__PURE__ */ React.createElement("button", {
        onClick: function() {
            return saveCustomPlace(void 0);
        },
        type: "button"
    }, /* @__PURE__ */ React.createElement(EGDSIcon, {
        id: clearSavedPlaceIcon === null || clearSavedPlaceIcon === void 0 ? void 0 : clearSavedPlaceIcon.id,
        name: "close",
        size: EGDSIconSize.SMALL,
        title: clearSavedPlaceIcon === null || clearSavedPlaceIcon === void 0 ? void 0 : clearSavedPlaceIcon.description
    }))))));
};
PlaceDisplay.fragment = __PlaceDisplayFragment;
PlaceDisplay.displayName = "placeDisplay";
// src/components/map/places-search.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { TypeaheadRenderType as TypeaheadRenderType2 } from "@egds/react-core/typeahead";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/components/map/places-typeahead.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSTypeahead, ESSAdapter } from "@egds/react-core/typeahead";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { useGoogleMapsSdkVersion } from "@shared-ui/retail-map-google-maps-sdk-version-provider";
var __PlacesTypeaheadFragment = gql2(_templateObject1());
var PlacesTypeahead = function(props) {
    var _typeaheadContent_typeaheadInfo, _typeaheadContent_typeaheadInfo1, _typeaheadContent_typeaheadInfo2, _useGoogleMapsSdkVersion;
    var data = props.data, handleChange = props.handleChange, typeaheadLogger = props.typeaheadLogger, strictFullscreen = props.strictFullscreen, renderType = props.renderType;
    var context = useBexApi().context;
    var identity = context.identity, locale = context.locale, siteId = context.siteId;
    var expuserid = Number(identity === null || identity === void 0 ? void 0 : identity.expUserId) || -1;
    var isProduction = process.env.NODE_ENV === "production";
    var _ref = identity || {}, guid = _ref.duaid;
    var typeaheadContent = data === null || data === void 0 ? void 0 : data.content;
    var _typeaheadContent_label;
    var label = (_typeaheadContent_label = typeaheadContent === null || typeaheadContent === void 0 ? void 0 : typeaheadContent.label) !== null && _typeaheadContent_label !== void 0 ? _typeaheadContent_label : "";
    var _typeaheadContent_placeholder;
    var placeholder = (_typeaheadContent_placeholder = typeaheadContent === null || typeaheadContent === void 0 ? void 0 : typeaheadContent.placeholder) !== null && _typeaheadContent_placeholder !== void 0 ? _typeaheadContent_placeholder : "";
    var _typeaheadContent_typeaheadEmptyResultPlaceholder;
    var noResultsPlaceholder = (_typeaheadContent_typeaheadEmptyResultPlaceholder = typeaheadContent === null || typeaheadContent === void 0 ? void 0 : typeaheadContent.typeaheadEmptyResultPlaceholder) !== null && _typeaheadContent_typeaheadEmptyResultPlaceholder !== void 0 ? _typeaheadContent_typeaheadEmptyResultPlaceholder : "";
    var exposure = useExperiment("Custom_Place_on_PDP_Map_iteration_2", false).exposure;
    var hasGoogleFallback = exposure.bucket === 1;
    var features = "ta_hierarchy|postal_code|contextual_ta".concat(hasGoogleFallback && "|google");
    var _typeaheadContent_typeaheadInfo_client, _typeaheadContent_typeaheadInfo_maxNumberOfResults, _typeaheadContent_typeaheadInfo_regionType;
    var adapter = new ESSAdapter({
        client: (_typeaheadContent_typeaheadInfo_client = typeaheadContent === null || typeaheadContent === void 0 ? void 0 : (_typeaheadContent_typeaheadInfo = typeaheadContent.typeaheadInfo) === null || _typeaheadContent_typeaheadInfo === void 0 ? void 0 : _typeaheadContent_typeaheadInfo.client) !== null && _typeaheadContent_typeaheadInfo_client !== void 0 ? _typeaheadContent_typeaheadInfo_client : "Homepage",
        domain: isProduction ? void 0 : "https://www.expedia.com/",
        dest: true,
        expuserid: expuserid,
        features: features,
        guid: guid,
        lob: "HOTELS",
        locale: locale,
        maxResults: (_typeaheadContent_typeaheadInfo_maxNumberOfResults = typeaheadContent === null || typeaheadContent === void 0 ? void 0 : (_typeaheadContent_typeaheadInfo1 = typeaheadContent.typeaheadInfo) === null || _typeaheadContent_typeaheadInfo1 === void 0 ? void 0 : _typeaheadContent_typeaheadInfo1.maxNumberOfResults) !== null && _typeaheadContent_typeaheadInfo_maxNumberOfResults !== void 0 ? _typeaheadContent_typeaheadInfo_maxNumberOfResults : 10,
        regionType: (_typeaheadContent_typeaheadInfo_regionType = typeaheadContent === null || typeaheadContent === void 0 ? void 0 : (_typeaheadContent_typeaheadInfo2 = typeaheadContent.typeaheadInfo) === null || _typeaheadContent_typeaheadInfo2 === void 0 ? void 0 : _typeaheadContent_typeaheadInfo2.regionType) !== null && _typeaheadContent_typeaheadInfo_regionType !== void 0 ? _typeaheadContent_typeaheadInfo_regionType : 2047,
        siteId: siteId,
        personalize: true,
        typeaheadLogger: typeaheadLogger,
        fetchLocation: hasGoogleFallback,
        googleApiVersion: (_useGoogleMapsSdkVersion = useGoogleMapsSdkVersion()) === null || _useGoogleMapsSdkVersion === void 0 ? void 0 : _useGoogleMapsSdkVersion.version
    });
    return /* @__PURE__ */ React2.createElement(EGDSTypeahead, {
        adapter: adapter,
        icon: "place",
        name: "placesTypeAhead",
        onUpdate: handleChange,
        stid: "typeahead-adaptive",
        value: "",
        strictFullscreen: strictFullscreen,
        typeaheadPlaceholder: placeholder,
        typeaheadEmptyResultPlaceholder: noResultsPlaceholder,
        id: "placesTypeAhead",
        label: label,
        renderType: renderType
    });
};
PlacesTypeahead.fragment = __PlacesTypeaheadFragment;
PlacesTypeahead.displayName = "PlacesTypeahead";
// src/components/map/places-search.tsx
var __PlacesSearchFragment = gql3(_templateObject2(), PlacesTypeahead.fragment);
var PlacesSearch = function(props) {
    var _typeAheadData_heading, _typeAheadData_subHeading;
    var data = props.data, handleChange = props.handleChange, typeaheadLogger = props.typeaheadLogger;
    var typeAheadData = data === null || data === void 0 ? void 0 : data.placesDialogTypeAheadContentSection;
    var heading = typeAheadData === null || typeAheadData === void 0 ? void 0 : (_typeAheadData_heading = typeAheadData.heading) === null || _typeAheadData_heading === void 0 ? void 0 : _typeAheadData_heading.text;
    var subHeading = typeAheadData === null || typeAheadData === void 0 ? void 0 : (_typeAheadData_subHeading = typeAheadData.subHeading) === null || _typeAheadData_subHeading === void 0 ? void 0 : _typeAheadData_subHeading.text;
    return /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(EGDSSpacing2, {
        padding: {
            blockstart: "one",
            blockend: "one"
        }
    }, heading && /* @__PURE__ */ React3.createElement(EGDSHeading2, {
        tag: "h3",
        size: 5
    }, heading)), /* @__PURE__ */ React3.createElement(EGDSSpacing2, {
        padding: {
            blockstart: "one",
            blockend: "three"
        }
    }, subHeading && /* @__PURE__ */ React3.createElement(EGDSHeading2, {
        tag: "h4"
    }, /* @__PURE__ */ React3.createElement(EGDSText2, {
        weight: "regular",
        inline: true
    }, subHeading))), typeAheadData && /* @__PURE__ */ React3.createElement(Viewport, null, /* @__PURE__ */ React3.createElement(ViewSmall, null, /* @__PURE__ */ React3.createElement(PlacesTypeahead, {
        data: typeAheadData,
        handleChange: handleChange,
        typeaheadLogger: typeaheadLogger,
        strictFullscreen: true,
        renderType: TypeaheadRenderType2.DIALOG
    })), /* @__PURE__ */ React3.createElement(ViewLarge, null, /* @__PURE__ */ React3.createElement(PlacesTypeahead, {
        data: typeAheadData,
        handleChange: handleChange,
        typeaheadLogger: typeaheadLogger
    }))));
};
PlacesSearch.fragment = __PlacesSearchFragment;
PlacesSearch.displayName = "PlacesSearch";
// src/components/map/places-switches.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSText as EGDSText3 } from "@egds/react-core/text";
import { LodgingEGDSSwitch } from "@shared-ui/lodging-fragments";
var uniqueQualifiersList = function(values) {
    return Array.from(new Set(values.flatMap(function(v) {
        return v;
    }) || []));
};
var __PlacesSwitchesFragment = gql4(_templateObject3());
function isFilterOption(content) {
    return content.__typename === "FilterOption";
}
var findToggledFilterIndex = function(toggledFilters, values) {
    return toggledFilters.map(function(qualifiers) {
        return qualifiers.join(",");
    }).indexOf(values.join(","));
};
var isToggledFilterSelected = function(toggledFilters, values) {
    return findToggledFilterIndex(toggledFilters.on, values) >= 0;
};
var computeToggledFilters = function(data) {
    var _data_placesDialogUITogglesContentSection_content_filter_filter, _data_placesDialogUITogglesContentSection_content_filter, _data_placesDialogUITogglesContentSection_content, _data_placesDialogUITogglesContentSection, _data_placesDialogUITogglesContentSection_content_filter_filter1, _data_placesDialogUITogglesContentSection_content_filter1, _data_placesDialogUITogglesContentSection_content1, _data_placesDialogUITogglesContentSection1;
    return {
        off: (data === null || data === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection = data.placesDialogUITogglesContentSection) === null || _data_placesDialogUITogglesContentSection === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection_content = _data_placesDialogUITogglesContentSection.content) === null || _data_placesDialogUITogglesContentSection_content === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection_content_filter = _data_placesDialogUITogglesContentSection_content.filter(isFilterOption)) === null || _data_placesDialogUITogglesContentSection_content_filter === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection_content_filter_filter = _data_placesDialogUITogglesContentSection_content_filter.filter(function(toggle) {
            return !toggle.checked;
        })) === null || _data_placesDialogUITogglesContentSection_content_filter_filter === void 0 ? void 0 : _data_placesDialogUITogglesContentSection_content_filter_filter.map(function(toggle) {
            return toggle.filteredValues;
        })) || [],
        on: (data === null || data === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection1 = data.placesDialogUITogglesContentSection) === null || _data_placesDialogUITogglesContentSection1 === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection_content1 = _data_placesDialogUITogglesContentSection1.content) === null || _data_placesDialogUITogglesContentSection_content1 === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection_content_filter1 = _data_placesDialogUITogglesContentSection_content1.filter(isFilterOption)) === null || _data_placesDialogUITogglesContentSection_content_filter1 === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection_content_filter_filter1 = _data_placesDialogUITogglesContentSection_content_filter1.filter(function(toggle) {
            return toggle.checked;
        })) === null || _data_placesDialogUITogglesContentSection_content_filter_filter1 === void 0 ? void 0 : _data_placesDialogUITogglesContentSection_content_filter_filter1.map(function(toggle) {
            return toggle.filteredValues;
        })) || []
    };
};
var PlacesSwitches = function(param) {
    var data = param.data, toggledFilters = param.toggledFilters, setToggledFilters = param.setToggledFilters;
    var _data_placesDialogUITogglesContentSection_subHeading;
    var _React4_useState = _sliced_to_array(React4.useState(void 0), 2), localToggledFilters = _React4_useState[0], setLocalToggledFilters = _React4_useState[1];
    React4.useEffect(function() {
        if (!toggledFilters) {
            var computedToggledFilters = computeToggledFilters(data);
            setToggledFilters(computedToggledFilters);
            setLocalToggledFilters(computedToggledFilters);
        } else {
            setLocalToggledFilters(toggledFilters);
        }
    }, [
        toggledFilters,
        setToggledFilters,
        setLocalToggledFilters,
        data
    ]);
    var handleToggle = React4.useCallback(function(checked, filteredValues) {
        var _ref = localToggledFilters || {}, _ref_on = _ref.on, on = _ref_on === void 0 ? [] : _ref_on, _ref_off = _ref.off, off = _ref_off === void 0 ? [] : _ref_off;
        var indexInOff = findToggledFilterIndex(off, filteredValues);
        var indexInOn = findToggledFilterIndex(on, filteredValues);
        var computedToggledFilters = checked === true ? {
            off: indexInOff < 0 ? off : _to_consumable_array(off.slice(0, indexInOff)).concat(_to_consumable_array(off.slice(indexInOff + 1))),
            on: indexInOn < 0 ? _to_consumable_array(on).concat([
                filteredValues
            ]) : on
        } : {
            off: indexInOff < 0 ? _to_consumable_array(off).concat([
                filteredValues
            ]) : off,
            on: indexInOn < 0 ? on : _to_consumable_array(on.slice(0, indexInOn)).concat(_to_consumable_array(on.slice(indexInOn + 1)))
        };
        setToggledFilters(computedToggledFilters);
        setLocalToggledFilters(computedToggledFilters);
    }, [
        localToggledFilters,
        setToggledFilters,
        setLocalToggledFilters
    ]);
    if (!data || !data.placesDialogUITogglesContentSection) {
        return null;
    }
    var subHeading = (_data_placesDialogUITogglesContentSection_subHeading = data.placesDialogUITogglesContentSection.subHeading) === null || _data_placesDialogUITogglesContentSection_subHeading === void 0 ? void 0 : _data_placesDialogUITogglesContentSection_subHeading.text;
    var content = data.placesDialogUITogglesContentSection.content;
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(EGDSSpacing3, {
        padding: {
            blockstart: "six"
        }
    }, subHeading && /* @__PURE__ */ React4.createElement(EGDSHeading3, {
        tag: "h4"
    }, /* @__PURE__ */ React4.createElement(EGDSText3, {
        weight: "regular",
        inline: true
    }, subHeading))), content === null || content === void 0 ? void 0 : content.filter(isFilterOption).map(function(toggle, idx) {
        var filteredValues = toggle.filteredValues, switchData = _object_without_properties(toggle, [
            "filteredValues"
        ]);
        var isChecked = toggledFilters !== void 0 ? isToggledFilterSelected(toggledFilters, filteredValues) : void 0;
        return /* @__PURE__ */ React4.createElement(EGDSSpacing3, {
            padding: {
                blockstart: "three",
                blockend: "two"
            },
            key: "switch-".concat(idx)
        }, /* @__PURE__ */ React4.createElement(LodgingEGDSSwitch, {
            data: switchData,
            checked: isChecked,
            handleToggle: function(checked) {
                return handleToggle(checked, filteredValues);
            }
        }));
    }));
};
PlacesSwitches.fragment = __PlacesSwitchesFragment;
PlacesSwitches.displayName = "placesSwitches";
// src/components/map/places-dialog.tsx
var __PlacesDialogFragment = gql5(_templateObject4(), PlacesSearch.fragment, PlaceDisplay.fragment, PlacesSwitches.fragment);
var PlacesDialog = function(param) {
    var data = param.data, setSavedFeature = param.setSavedFeature, savedFeature = param.savedFeature, typeaheadLogger = param.typeaheadLogger, toggledFilters = param.toggledFilters, setToggledFilters = param.setToggledFilters, closeDialog = param.onClosePlacesDialog, showPlacesDialog = param.showPlacesDialog;
    var _data_trigger_icon, _data_trigger, _data_dialog_toolbar, _data_dialog;
    var _useEgMapClickstream2 = useEgMapClickstream2(), trackMapCustomPlaceAdded = _useEgMapClickstream2.trackMapCustomPlaceAdded, trackMapCustomPlaceRemoved = _useEgMapClickstream2.trackMapCustomPlaceRemoved;
    var saveCustomPlace = function(feature) {
        if (feature) {
            var featureDetail = feature.name || feature.text || feature.id.toString();
            trackMapCustomPlaceAdded(CustomPlaceSearchType.GAIA, featureDetail, feature.id.toString());
        } else if (savedFeature) {
            var featureDetail1 = savedFeature.name || savedFeature.text || savedFeature.id.toString();
            trackMapCustomPlaceRemoved(CustomPlaceSearchType.GAIA, featureDetail1, savedFeature.id.toString());
        }
        setSavedFeature(feature);
    };
    var getNameAndText = function(fullName, shortName, type) {
        var nameArray;
        if (type === "AIRPORT") {
            nameArray = shortName || fullName ? [
                shortName || fullName
            ] : [];
        } else {
            var _fullName_split;
            nameArray = (_fullName_split = fullName === null || fullName === void 0 ? void 0 : fullName.split(", ")) !== null && _fullName_split !== void 0 ? _fullName_split : [];
        }
        return {
            name: nameArray.shift(),
            text: nameArray.join(", ")
        };
    };
    var handleTypeaheadChange = function(selection) {
        var selectionData = selection.data;
        if (!selectionData) {
            return null;
        }
        var regionNames = selectionData.regionNames, type = selectionData.type, location = selectionData.location, essId = selectionData.essId;
        var _getNameAndText = getNameAndText(regionNames === null || regionNames === void 0 ? void 0 : regionNames.fullName, regionNames === null || regionNames === void 0 ? void 0 : regionNames.shortName, type), name = _getNameAndText.name, text = _getNameAndText.text;
        var _ref = location || {}, lat = _ref.lat, long = _ref.long;
        var idFromLatLong = "".concat(lat).concat(long).replace(/\./g, "");
        var _essId_sourceId;
        var feature = {
            id: (_essId_sourceId = essId === null || essId === void 0 ? void 0 : essId.sourceId) !== null && _essId_sourceId !== void 0 ? _essId_sourceId : idFromLatLong,
            lat: parseFloat(lat),
            lng: parseFloat(long),
            type: "place",
            status: "unknown",
            name: name,
            text: text,
            qualifiers: [
                "searchedLocation",
                essId ? "essId" : "noEssId"
            ],
            score: 1,
            ariaLabels: {
                default: name,
                onSelect: name
            }
        };
        saveCustomPlace(feature);
        closeDialog();
    };
    var dialogTitle = data === null || data === void 0 ? void 0 : (_data_trigger = data.trigger) === null || _data_trigger === void 0 ? void 0 : (_data_trigger_icon = _data_trigger.icon) === null || _data_trigger_icon === void 0 ? void 0 : _data_trigger_icon.description;
    var _data_dialog_toolbar_closeText;
    var toolbarCloseText = (_data_dialog_toolbar_closeText = data === null || data === void 0 ? void 0 : (_data_dialog = data.dialog) === null || _data_dialog === void 0 ? void 0 : (_data_dialog_toolbar = _data_dialog.toolbar) === null || _data_dialog_toolbar === void 0 ? void 0 : _data_dialog_toolbar.closeText) !== null && _data_dialog_toolbar_closeText !== void 0 ? _data_dialog_toolbar_closeText : "";
    var dialogLayout = /* @__PURE__ */ React5.createElement(EGDSLayoutFlex2, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React5.createElement(EGDSToolbar, {
        navigationContent: {
            onClick: closeDialog,
            navIconLabel: toolbarCloseText
        },
        toolbarTitle: dialogTitle
    }), /* @__PURE__ */ React5.createElement(EGDSSheetContent, null, savedFeature && /* @__PURE__ */ React5.createElement(PlaceDisplay, {
        data: data,
        savedFeature: savedFeature,
        saveCustomPlace: saveCustomPlace
    }), !savedFeature && /* @__PURE__ */ React5.createElement(PlacesSearch, {
        data: data,
        handleChange: handleTypeaheadChange,
        typeaheadLogger: typeaheadLogger
    }), /* @__PURE__ */ React5.createElement(PlacesSwitches, {
        toggledFilters: toggledFilters,
        setToggledFilters: setToggledFilters,
        data: data
    })));
    return /* @__PURE__ */ React5.createElement(Viewport2, null, /* @__PURE__ */ React5.createElement(ViewSmall2, null, /* @__PURE__ */ React5.createElement(EGDSSheetTransition, {
        isVisible: showPlacesDialog
    }, /* @__PURE__ */ React5.createElement(EGDSSheet, {
        isVisible: showPlacesDialog,
        type: "side",
        sideSheetLayout: {
            position: "leading",
            columns: 12
        },
        triggerRef: null
    }, dialogLayout))), /* @__PURE__ */ React5.createElement(ViewLarge2, null, /* @__PURE__ */ React5.createElement(EGDSSheetTransition, {
        isVisible: showPlacesDialog
    }, /* @__PURE__ */ React5.createElement(EGDSSheet, {
        isVisible: showPlacesDialog,
        type: "side",
        sideSheetLayout: {
            position: "leading",
            columns: 4
        },
        triggerRef: null
    }, dialogLayout))));
};
PlacesDialog.fragment = __PlacesDialogFragment;
PlacesDialog.displayName = "PlacesDialog";
// src/components/map/map-actions.tsx
var SCROLL_TIMEOUT = 1e3;
var __MapActionsFragment = gql6(_templateObject5(), PlacesDialog.fragment);
var MapActionsComponent = function(param) {
    var data = param.data, onClose = param.onClose, savedFeature = param.savedFeature, typeaheadLogger = param.typeaheadLogger, onTogglesChanged = param.onTogglesChanged, setSavedFeature = param.setSavedFeature, cardContent = param.cardContent, // note: currently EALP is still returning content for place card, however we are no longer using it. However, this
    // is a temporary state, and EALP will be updated to only return a place ID in the near future.
    selectedFeature = param.selectedFeature, setSelectedFeature = param.setSelectedFeature, directionsTo = param.directionsTo, closePlaceCard = param.closePlaceCard;
    var _placesDialogData_trigger_icon, _placesDialogData_trigger;
    var scrollTo = useRefTargetScroll().scrollTo;
    var _useEgMapClickstream3 = useEgMapClickstream3(), trackMapPlacesDialogOpened = _useEgMapClickstream3.trackMapPlacesDialogOpened, trackMapPlacesDialogClosed = _useEgMapClickstream3.trackMapPlacesDialogClosed;
    var _React6_useState = _sliced_to_array(React6.useState(), 2), toggledFilters = _React6_useState[0], setToggledFilters = _React6_useState[1];
    var clickstreamTrack = useEgClickstream();
    var placesDialogData = (data === null || data === void 0 ? void 0 : data.dialogs) && (data === null || data === void 0 ? void 0 : data.dialogs[0]);
    var dialogTitle = placesDialogData === null || placesDialogData === void 0 ? void 0 : (_placesDialogData_trigger = placesDialogData.trigger) === null || _placesDialogData_trigger === void 0 ? void 0 : (_placesDialogData_trigger_icon = _placesDialogData_trigger.icon) === null || _placesDialogData_trigger_icon === void 0 ? void 0 : _placesDialogData_trigger_icon.description;
    var _React6_useState1 = _sliced_to_array(React6.useState(false), 2), showPlacesDialog = _React6_useState1[0], setShowPlacesDialog = _React6_useState1[1];
    var openPlacesDialog = function() {
        setShowPlacesDialog(true);
        trackMapPlacesDialogOpened();
    };
    var closePlacesDialog = function() {
        setShowPlacesDialog(false);
        trackMapPlacesDialogClosed();
    };
    React6.useEffect(function() {
        var initialFilters = computeToggledFilters(placesDialogData);
        if (initialFilters.off.length > 0) {
            setToggledFilters(initialFilters);
        }
    }, []);
    React6.useEffect(function() {
        if (toggledFilters) {
            onTogglesChanged(toggledFilters);
        }
    }, [
        toggledFilters,
        onTogglesChanged
    ]);
    React6.useEffect(function() {
        if (savedFeature) {
            setSelectedFeature(savedFeature);
        }
    }, [
        savedFeature,
        setSelectedFeature
    ]);
    var PlacesButton = /* @__PURE__ */ React6.createElement(EGDSFloatingButton, {
        size: EGDSButtonSize.LARGE,
        onClick: openPlacesDialog
    }, /* @__PURE__ */ React6.createElement(EGDSIcon2, {
        name: "place"
    }), dialogTitle);
    var placesDialog = placesDialogData && /* @__PURE__ */ React6.createElement(PlacesDialog, {
        data: placesDialogData,
        setSavedFeature: setSavedFeature,
        savedFeature: savedFeature,
        typeaheadLogger: typeaheadLogger,
        toggledFilters: toggledFilters,
        setToggledFilters: setToggledFilters,
        onClosePlacesDialog: closePlacesDialog,
        showPlacesDialog: showPlacesDialog
    });
    var _ref = (data === null || data === void 0 ? void 0 : data.callToAction) || {}, chooseARoomButton = _ref.button, chooseARoomAction = _ref.action, chooseARoomClickStreamEvent = _ref.event;
    var chooseARoomBtnLabel = chooseARoomButton === null || chooseARoomButton === void 0 ? void 0 : chooseARoomButton.primary;
    var onChooseARoomButtonClick = function() {
        trackMapChooseARoomBtnClick();
        onClose();
        var targetRef = (chooseARoomAction || {}).targetRef;
        if (targetRef) {
            setTimeout(function() {
                scrollTo(targetRef, []);
            }, SCROLL_TIMEOUT);
        }
    };
    var trackMapChooseARoomBtnClick = function() {
        var _ref = chooseARoomClickStreamEvent || {}, _ref_eventName = _ref.eventName, eventName = _ref_eventName === void 0 ? "" : _ref_eventName, _ref_eventType = _ref.eventType, eventType = _ref_eventType === void 0 ? "" : _ref_eventType, _ref_eventVersion = _ref.eventVersion, eventVersion = _ref_eventVersion === void 0 ? "" : _ref_eventVersion;
        if (eventName && eventType && eventVersion && clickstreamTrack) {
            var event = buildEvent(eventName, eventType, eventVersion);
            clickstreamTrack(buildData(event, {}));
        }
    };
    var createPlaceCardDetailsFragment = function(feature, content) {
        var _content_id, _content_title, _ref;
        return {
            id: ((_content_id = content === null || content === void 0 ? void 0 : content.id) !== null && _content_id !== void 0 ? _content_id : feature.id).toString(),
            title: {
                text: (_ref = (_content_title = content === null || content === void 0 ? void 0 : content.title) !== null && _content_title !== void 0 ? _content_title : feature.name) !== null && _ref !== void 0 ? _ref : "",
                __typename: "EGDSPlainText"
            },
            subtitle: null,
            description: (content === null || content === void 0 ? void 0 : content.description) ? {
                text: content.description,
                __typename: "EGDSPlainText"
            } : null,
            footerText: (content === null || content === void 0 ? void 0 : content.subTitle) ? {
                text: content.subTitle,
                __typename: "EGDSPlainText"
            } : null,
            media: null,
            closeAction: {
                __typename: "UITertiaryButton",
                accessibility: "Close",
                icon: {
                    __typename: "Icon",
                    description: "close",
                    id: "close",
                    token: "close"
                }
            },
            __typename: "PlaceCardDetails"
        };
    };
    var productOrPlaceCard = function(type, size) {
        if (isProductType(type) && cardContent) {
            return /* @__PURE__ */ React6.createElement(MapCardContent, {
                data: cardContent,
                size: size
            });
        }
        if (selectedFeature && type === "place") {
            return /* @__PURE__ */ React6.createElement(PlaceCard, {
                data: createPlaceCardDetailsFragment(selectedFeature, cardContent),
                inputs: {
                    placeId: "".concat(selectedFeature.id),
                    directionsTo: directionsTo
                },
                size: size,
                onClose: closePlaceCard
            });
        }
    };
    var mapCard = /* @__PURE__ */ React6.createElement(Viewport3, null, /* @__PURE__ */ React6.createElement(ViewSmall3, null, /* @__PURE__ */ React6.createElement(EGDSSpacing4, {
        margin: {
            inline: "three",
            blockend: "three"
        }
    }, /* @__PURE__ */ React6.createElement(EGDSLayoutFlexItem2, {
        maxWidth: 351,
        alignSelf: "center"
    }, /* @__PURE__ */ React6.createElement("div", {
        style: {
            pointerEvents: "all"
        }
    }, productOrPlaceCard(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.type, MapCardSize.COMPACT))))), /* @__PURE__ */ React6.createElement(ViewMedium, null, /* @__PURE__ */ React6.createElement(EGDSSpacing4, {
        margin: {
            inline: "three",
            blockend: "three"
        }
    }, /* @__PURE__ */ React6.createElement(EGDSLayoutFlexItem2, {
        maxWidth: 720,
        alignSelf: "stretch"
    }, /* @__PURE__ */ React6.createElement("div", {
        style: {
            pointerEvents: "all"
        }
    }, productOrPlaceCard(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.type, MapCardSize.STANDARD))))));
    var chooseARoomButtonItem = /* @__PURE__ */ React6.createElement(EGDSLayoutFlexItem2, null, chooseARoomBtnLabel && /* @__PURE__ */ React6.createElement(EGDSFloatingButton, {
        size: EGDSButtonSize.LARGE,
        onClick: onChooseARoomButtonClick,
        name: chooseARoomBtnLabel
    }, chooseARoomBtnLabel));
    return /* @__PURE__ */ React6.createElement(EGDSLayoutPosition, {
        type: "absolute",
        position: {
            bottom: "zero"
        },
        style: {
            width: "100%"
        }
    }, /* @__PURE__ */ React6.createElement(EGDSLayoutFlex3, {
        direction: "column"
    }, /* @__PURE__ */ React6.createElement(EGDSLayoutFlexItem2, {
        alignSelf: "center"
    }, /* @__PURE__ */ React6.createElement(EGDSSpacing4, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React6.createElement(EGDSLayoutFlex3, {
        space: "four",
        justifyContent: "center"
    }, placesDialogData && /* @__PURE__ */ React6.createElement(EGDSLayoutFlexItem2, null, !showPlacesDialog && PlacesButton), chooseARoomButtonItem))), !!selectedFeature && mapCard), placesDialog);
};
MapActionsComponent.displayName = "MapActions";
MapActionsComponent.fragment = __MapActionsFragment;
var MapActions = MapActionsComponent;
// src/components/map/map-viewport.ts
var excludeAirportFilter = function(param) {
    var qualifiers = param.qualifiers;
    return !(qualifiers === null || qualifiers === void 0 ? void 0 : qualifiers.find(function(qualifier) {
        return qualifier === "transport__airport";
    }));
};
var mapFeaturesToCoordinates = function(features) {
    return features.filter(function(f) {
        return f.lat !== void 0 && f.lng !== void 0;
    }).filter(excludeAirportFilter).map(function(feature) {
        return [
            feature.lat || 0,
            feature.lng || 0
        ];
    });
};
// src/components/map/map.tsx
import { merge } from "merge-anything";
var __MapQuery = gql7(_templateObject6(), DynamicMap.fragment, MapCardContent2.fragment, MapActions.fragment);
var QUALIFIER_HIDDEN = "hidden";
var isEgdsMapFeature = function(mapMarker) {
    return mapMarker.__typename === "EGDSMapFeature";
};
var identifyQualifiersUpdate = function(qualifierUpdates, feature, qualifier) {
    var update = qualifierUpdates.find(function(qu) {
        return qu.qualifier === qualifier;
    });
    if (update) {
        update.features.push(feature);
    } else {
        qualifierUpdates.push({
            features: [
                feature
            ],
            qualifier: qualifier
        });
    }
};
var hideFeaturesFromToggles = function(map, features, qualifiersToHide, qualifiersToKeep) {
    var featuresToHideFull = [];
    var featuresToHide = [];
    var featuresToShow = [];
    var qualifiersToAddToFeatures = [];
    var qualifiersToRemoveOnFeatures = [];
    var featuresRetrievedFromMap = map.listFeatures();
    features.forEach(function(feature) {
        var id = feature.id, type = feature.type, _feature_qualifiers = feature.qualifiers, qualifiers = _feature_qualifiers === void 0 ? [] : _feature_qualifiers;
        var featureFromMap = [
            featuresRetrievedFromMap.find(function(f) {
                return f.id === id && f.type === type;
            })
        ].filter(filterFeatureObject)[0];
        if (featureFromMap) {
            var tmp = featureFromMap.qualifiers, qualifiersFromMap = tmp === void 0 ? [] : tmp;
            var hidingQualifiers = qualifiers.filter(function(q) {
                return qualifiersToHide.includes(q);
            }) || [];
            var otherQualifiers = qualifiers.filter(function(q) {
                return !qualifiersToHide.includes(q);
            }) || [];
            if (hidingQualifiers.length > 0 && !qualifiers.some(function(q) {
                return qualifiersToKeep.includes(q);
            })) {
                featuresToHide.push({
                    id: id,
                    type: type
                });
                featuresToHideFull.push(feature);
            } else {
                featuresToShow.push({
                    id: id,
                    type: type
                });
            }
            if (qualifiersFromMap && qualifiersFromMap.length > 0) {
                hidingQualifiers.forEach(function(q) {
                    if (qualifiersFromMap.includes(q)) {
                        identifyQualifiersUpdate(qualifiersToRemoveOnFeatures, feature, q);
                    }
                });
                otherQualifiers.forEach(function(q) {
                    if (!qualifiersFromMap.includes(q)) {
                        identifyQualifiersUpdate(qualifiersToAddToFeatures, feature, q);
                    }
                });
            }
        }
    });
    qualifiersToAddToFeatures.forEach(function(update) {
        return map.addQualifierToFeatures(update.features, update.qualifier);
    });
    qualifiersToRemoveOnFeatures.forEach(function(update) {
        return map.removeQualifierFromFeatures(update.features, update.qualifier);
    });
    map.addQualifierToFeatures(featuresToHide, QUALIFIER_HIDDEN);
    map.removeQualifierFromFeatures(featuresToShow, QUALIFIER_HIDDEN);
};
var MapComponent = function(props) {
    var _propertyInfo_summary_location, _propertyInfo_summary, _propertyInfo_summary1, _egdsBasicMap_config, _mapData_toolbar, _mapData_toolbar_icon, _mapData_toolbar1;
    var context = useBexApi2().context;
    var locale = context.locale;
    var inputs = props.inputs, beforeInit = props.beforeInit, onInit = props.onInit, egMapsConfig = props.egMapsConfig, onCloseCallback = props.onClose, setSavedFeature = props.setSavedFeature, savedFeature = props.savedFeature, typeaheadLogger = props.typeaheadLogger, clientPadding = props.clientPadding, triggerRef = props.triggerRef, skipSsr = props.skipSsr;
    var _React7_useState = _sliced_to_array(React7.useState(savedFeature), 2), internalSavedFeature = _React7_useState[0], setInternalSavedFeature = _React7_useState[1];
    var _React7_useState1 = _sliced_to_array(React7.useState(void 0), 2), qualifiersToggleValues = _React7_useState1[0], setQualifiersToggleValues = _React7_useState1[1];
    var centerMapOnCustomFeatureAndSelectIt = React7.useRef(true);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__MapQuery, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var mapRef = React7.useRef();
    var track = useClickTracker();
    var _React7_useState2 = _sliced_to_array(React7.useState(), 2), cardContent = _React7_useState2[0], setCardContent = _React7_useState2[1];
    var _React7_useState3 = _sliced_to_array(React7.useState(), 2), selectedFeature = _React7_useState3[0], setSelectedFeature = _React7_useState3[1];
    var propertyInfo = (data !== null && data !== void 0 ? data : {}).propertyInfo;
    var propertyCoordinates = propertyInfo === null || propertyInfo === void 0 ? void 0 : (_propertyInfo_summary = propertyInfo.summary) === null || _propertyInfo_summary === void 0 ? void 0 : (_propertyInfo_summary_location = _propertyInfo_summary.location) === null || _propertyInfo_summary_location === void 0 ? void 0 : _propertyInfo_summary_location.coordinates;
    var propertyId = propertyInfo ? propertyInfo.id.toString() : "";
    var directionsTo = {
        id: propertyId,
        type: "PRODUCT" /* PRODUCT */ 
    };
    var mapData = propertyInfo === null || propertyInfo === void 0 ? void 0 : (_propertyInfo_summary1 = propertyInfo.summary) === null || _propertyInfo_summary1 === void 0 ? void 0 : _propertyInfo_summary1.map;
    var egdsBasicMap = mapData === null || mapData === void 0 ? void 0 : mapData.egdsBasicMap;
    var dynamicMapId = egdsBasicMap === null || egdsBasicMap === void 0 ? void 0 : (_egdsBasicMap_config = egdsBasicMap.config) === null || _egdsBasicMap_config === void 0 ? void 0 : _egdsBasicMap_config.mapId;
    var egMapsFeatures = egdsBasicMap === null || egdsBasicMap === void 0 ? void 0 : egdsBasicMap.markers;
    var egFeatures = egMapsFeatures ? convertMarkers(egMapsFeatures === null || egMapsFeatures === void 0 ? void 0 : egMapsFeatures.map(function(m) {
        return m;
    })) : [];
    var mapCards = mapData === null || mapData === void 0 ? void 0 : mapData.mapInfoCards;
    var onClose = useAnalytics(onCloseCallback).onClose;
    var doCenterMapOnCustomFeatureAndSelectIt = function(map, allFeatures, customFeature, propCoordinates) {
        var options = propCoordinates ? {
            centeredOn: [
                propCoordinates.latitude,
                propCoordinates.longitude
            ]
        } : void 0;
        var coordinates = mapFeaturesToCoordinates(customFeature ? _to_consumable_array(allFeatures).concat([
            customFeature
        ]) : allFeatures);
        map.boundsContaining(coordinates, true, options).then(function(param) {
            var sw = param.sw, ne = param.ne;
            map.fitBounds(sw, ne, true, clientPadding !== null && clientPadding !== void 0 ? clientPadding : "0px 0px 20%");
            if (internalSavedFeature) {
                map.selectFeature(customFeature.id, customFeature.type);
            }
        });
    };
    var internalOnFeaturePushed = React7.useCallback(function(map) {
        if (centerMapOnCustomFeatureAndSelectIt.current && internalSavedFeature) {
            doCenterMapOnCustomFeatureAndSelectIt(map, egFeatures, internalSavedFeature, propertyCoordinates);
            centerMapOnCustomFeatureAndSelectIt.current = false;
        }
        var _ref = qualifiersToggleValues || {}, tmp = _ref.off, qualifiersToHide = tmp === void 0 ? [] : tmp, tmp1 = _ref.on, qualifiersToKeep = tmp1 === void 0 ? [] : tmp1;
        hideFeaturesFromToggles(map, egFeatures, uniqueQualifiersList(qualifiersToHide), uniqueQualifiersList(qualifiersToKeep));
    }, [
        internalSavedFeature,
        egFeatures,
        propertyCoordinates,
        qualifiersToggleValues
    ]);
    React7.useEffect(function() {
        if (!internalSavedFeature) {
            centerMapOnCustomFeatureAndSelectIt.current = true;
        }
        if (setSavedFeature) {
            setSavedFeature(internalSavedFeature);
        }
    }, [
        internalSavedFeature
    ]);
    React7.useEffect(function() {
        if (setSavedFeature && internalSavedFeature && internalSavedFeature.lng !== void 0 && internalSavedFeature.lat !== void 0 && propertyCoordinates) {
            var customPlace = point([
                internalSavedFeature.lng,
                internalSavedFeature.lat
            ]);
            var property = point([
                propertyCoordinates.longitude,
                propertyCoordinates.latitude
            ]);
            var d = distance(customPlace, property, {
                units: "miles"
            });
            if (d >= 80) {
                setSavedFeature(void 0);
                setInternalSavedFeature(void 0);
            }
        }
    }, [
        propertyCoordinates
    ]);
    var closeCard = React7.useCallback(function() {
        var _mapRef_current;
        setCardContent(void 0);
        setSelectedFeature(void 0);
        (_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.clearSelectedFeature();
    }, [
        cardContent
    ]);
    React7.useEffect(function() {
        if (mapRef.current) {
            var _ref = qualifiersToggleValues || {}, tmp = _ref.off, qualifiersToHide = tmp === void 0 ? [] : tmp, tmp1 = _ref.on, qualifiersToKeep = tmp1 === void 0 ? [] : tmp1;
            hideFeaturesFromToggles(mapRef.current, egFeatures, uniqueQualifiersList(qualifiersToHide), uniqueQualifiersList(qualifiersToKeep));
        }
    }, [
        egFeatures,
        internalSavedFeature,
        qualifiersToggleValues
    ]);
    var internalBeforeInit = React7.useCallback(function(mapObj) {
        if (beforeInit) {
            beforeInit(mapObj);
        }
    }, []);
    var internalOnInit = React7.useCallback(function(mapObj) {
        mapRef.current = mapObj;
        mapObj.addSelectionChangeListener(function(event) {
            var eventFeature = event.feature;
            var _filter = _sliced_to_array([
                eventFeature
            ].filter(filterFeatureObject), 1), feature = _filter[0];
            if (feature) {
                switch(event.action){
                    case "select":
                        {
                            setCardContent(void 0);
                            setSelectedFeature(void 0);
                            var card = mapCards === null || mapCards === void 0 ? void 0 : mapCards.find(function(egCard) {
                                return egCard.id === feature.id;
                            });
                            if (card && isProductType(feature.type)) {
                                var _egMapsFeatures_filter_find;
                                setSelectedFeature(feature);
                                setCardContent(card);
                                var markerDataAnalytics = egMapsFeatures === null || egMapsFeatures === void 0 ? void 0 : (_egMapsFeatures_filter_find = egMapsFeatures.filter(isEgdsMapFeature).find(function(marker) {
                                    return feature.id === marker.id;
                                })) === null || _egMapsFeatures_filter_find === void 0 ? void 0 : _egMapsFeatures_filter_find.clientSideAnalytics;
                                if (markerDataAnalytics) {
                                    track(markerDataAnalytics.referrerId, markerDataAnalytics.linkName);
                                }
                            } else if (feature.id && feature.type === "place") {
                                setSelectedFeature(feature);
                                setCardContent(card);
                            }
                            break;
                        }
                    case "clearSelection":
                    default:
                        setCardContent(void 0);
                        setSelectedFeature(void 0);
                        break;
                }
            }
        });
        if (onInit) {
            onInit(mapObj);
        }
    }, [
        egdsBasicMap
    ]);
    var googleMapsConfig = React7.useMemo(function() {
        return dynamicMapId ? {
            gmapsAddConfig: {
                mapId: dynamicMapId
            }
        } : void 0;
    }, [
        dynamicMapId
    ]);
    var dynamicMapConfig = React7.useMemo(function() {
        return merge({
            googleMaps: googleMapsConfig,
            locale: locale,
            markers: {
                product: {
                    markerType: {
                        available: "pin"
                    }
                },
                property: {
                    markerType: {
                        available: "pin"
                    }
                },
                place: {
                    show: _define_property({}, "unknown#".concat(QUALIFIER_HIDDEN), false),
                    textLabel: {
                        show: _define_property({}, EGDSEGMapsQualifier.METRO_STATION, false)
                    }
                }
            }
        }, egMapsConfig || {});
    }, [
        locale,
        googleMapsConfig,
        egMapsConfig
    ]);
    var supplementalFeatures = React7.useMemo(function() {
        if (internalSavedFeature) {
            return [
                internalSavedFeature
            ];
        }
        return void 0;
    }, [
        internalSavedFeature
    ]);
    if (loading || error || !data || !egdsBasicMap) {
        return null;
    }
    var sheetProps = {
        returnFocusOnClose: true,
        triggerRef: triggerRef,
        isVisible: true
    };
    var sheetContent = /* @__PURE__ */ React7.createElement(React7.Fragment, null, (mapData === null || mapData === void 0 ? void 0 : mapData.toolbar) ? /* @__PURE__ */ React7.createElement(EGDSToolbar2, {
        toolbarTitle: (mapData === null || mapData === void 0 ? void 0 : (_mapData_toolbar = mapData.toolbar) === null || _mapData_toolbar === void 0 ? void 0 : _mapData_toolbar.title) || "",
        navigationContent: {
            onClick: onClose,
            navType: "close",
            navIconLabel: mapData === null || mapData === void 0 ? void 0 : (_mapData_toolbar1 = mapData.toolbar) === null || _mapData_toolbar1 === void 0 ? void 0 : (_mapData_toolbar_icon = _mapData_toolbar1.icon) === null || _mapData_toolbar_icon === void 0 ? void 0 : _mapData_toolbar_icon.description
        }
    }) : null, /* @__PURE__ */ React7.createElement(DynamicMap, {
        data: egdsBasicMap,
        supplementalFeatures: supplementalFeatures,
        onInit: internalOnInit,
        beforeInit: internalBeforeInit,
        egMapsConfig: dynamicMapConfig,
        clientPadding: clientPadding !== null && clientPadding !== void 0 ? clientPadding : "0px 0px 20%",
        onFeaturesPushed: internalOnFeaturePushed,
        updateViewport: false,
        selectedFeatureId: propertyId
    }), mapData && /* @__PURE__ */ React7.createElement(MapActions, {
        setSavedFeature: setInternalSavedFeature,
        savedFeature: internalSavedFeature,
        typeaheadLogger: typeaheadLogger,
        onTogglesChanged: setQualifiersToggleValues,
        onClose: onClose,
        data: mapData,
        cardContent: cardContent,
        setSelectedFeature: setSelectedFeature,
        selectedFeature: selectedFeature,
        directionsTo: directionsTo,
        closePlaceCard: closeCard
    }));
    return /* @__PURE__ */ React7.createElement(Viewport4, null, /* @__PURE__ */ React7.createElement(ViewSmall4, null, /* @__PURE__ */ React7.createElement(EGDSSheet2, _object_spread_props(_object_spread({}, sheetProps), {
        type: "full"
    }), sheetContent)), /* @__PURE__ */ React7.createElement(ViewMedium2, null, /* @__PURE__ */ React7.createElement(EGDSSheet2, _object_spread_props(_object_spread({}, sheetProps), {
        type: "centered",
        height: 1200,
        centeredSheetSize: "medium"
    }), sheetContent)));
};
MapComponent.displayName = "sharedui-Map";
var Map = MapComponent;
// src/context/property-details-adaptex-context.tsx
import React8, { createContext, useState } from "react";
var defaultState = {
    reserveAdaptExSuccessEvents: [],
    amenitiesAdaptExSuccessEvents: [],
    nearByPoisAdaptExSuccessEvents: []
};
var defaultValue = [
    defaultState,
    function() {
        return void 0;
    }
];
var PropertyDetailsAdaptExContext = createContext(defaultValue);
var Provider = PropertyDetailsAdaptExContext.Provider;
var PropertyDetailsAdaptExProvider = function(param) {
    var children = param.children;
    var value = useState(defaultState);
    return /* @__PURE__ */ React8.createElement(Provider, {
        value: value
    }, children);
};
// src/components/property-info-details/property-info-details.tsx
import React39 from "react";
import { gql as gql26, useQuery as useQuery3 } from "@apollo/client";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType6 } from "@egds/react-core/images";
import { EGDSLayoutGrid as EGDSLayoutGrid6, EGDSLayoutGridItem as EGDSLayoutGridItem5 } from "@egds/react-core/layout-grid";
import { EGDSSheetTransition as EGDSSheetTransition6 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing18 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading6 } from "@egds/react-core/text";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
import { LodgingEGDSHeading, LodgingEGDSRating, PropertyContentSectionGroup } from "@shared-ui/lodging-fragments";
import { ViewMedium as ViewMedium7, Viewport as Viewport10, ViewSmall as ViewSmall10 } from "@shared-ui/viewport-context";
// src/components/gallery/property-image-gallery.tsx
import React21 from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { useDialog } from "@shared-ui/dialog-context";
import { ViewLarge as ViewLarge4, ViewMedium as ViewMedium6, Viewport as Viewport8, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";
// src/components/gallery/__private/utils/aerial-view-dialog.tsx
import React9 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSMediaGalleryImageDialog } from "@egds/react-core/media-gallery";
import { EGDSScrim, EGDSScrimType } from "@egds/react-core/scrim";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
import { VideoPlayer } from "@egds/react-property-experience";
import { useClickTracker as useClickTracker2, useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium3, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
// src/components/gallery/__private/utils/google-aerial-view.ts
var accessToken = "AIzaSyABOFQNLMiTVN0AG3eWNmspVfVC8gNda68";
var fetchAerialViewVideo = function(videoId) {
    return fetch("https://aerialview.googleapis.com/v1/videos:lookupVideo?key=".concat(accessToken, "&videoId=").concat(videoId), {
        method: "GET",
        headers: new Headers({
            "Content-Type": "application/json",
            Referer: "https://www.expedia.com/"
        })
    }).then(function(response) {
        return response.json();
    });
};
var buildEgClickstreamData = function(name, type) {
    var result = {
        event: {
            event_name: name,
            event_type: type,
            event_version: "1.0.0",
            event_category: ""
        },
        experience: {
            app_name: "shared-ui",
            app_version: "1.0.0",
            page_name: "PDP Page"
        }
    };
    return result;
};
// src/components/gallery/__private/utils/aerial-view-dialog.tsx
var AerialViewDialog = function(props) {
    var isDialogOpen = props.isDialogOpen, onDialogDismiss = props.onDialogDismiss, triggerRef = props.triggerRef, aerialViewLandscape = props.aerialViewLandscape;
    var track = useClickTracker2();
    var trackEGClickStream = useEgClickstream2();
    var dialogAnalytics = React9.useMemo(function() {
        var callback = function(id, description) {
            track(id, description);
            trackEGClickStream(buildEgClickstreamData("aerial_view.closed", "Interaction"));
        };
        var dialog = {
            id: "HOT.HIS.AerialViewTrigger",
            description: "Close aerial view dialog",
            callback: callback
        };
        return dialog;
    }, [
        track,
        trackEGClickStream
    ]);
    return /* @__PURE__ */ React9.createElement(EGDSMediaGalleryImageDialog, {
        dialogShow: isDialogOpen,
        onDismiss: onDialogDismiss,
        strictFullscreen: true,
        analytics: dialogAnalytics
    }, aerialViewLandscape.length > 0 && /* @__PURE__ */ React9.createElement(EGDSLayoutFlex4, {
        justifyContent: "center",
        alignItems: "center",
        blockSize: "full_size",
        direction: "column"
    }, /* @__PURE__ */ React9.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */ React9.createElement(VideoPlayer, {
        src: aerialViewLandscape,
        autoPlay: true,
        muted: true,
        controlsList: "nodownload"
    })), /* @__PURE__ */ React9.createElement(Viewport5, null, /* @__PURE__ */ React9.createElement(ViewSmall5, null, /* @__PURE__ */ React9.createElement(EGDSLayoutFlexItem3, {
        alignSelf: "start"
    }, /* @__PURE__ */ React9.createElement(EGDSSpacing5, {
        margin: "three"
    }, /* @__PURE__ */ React9.createElement(EGDSText4, {
        theme: "light"
    }, "Aerial view of property")))), /* @__PURE__ */ React9.createElement(ViewMedium3, null, /* @__PURE__ */ React9.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */ React9.createElement(EGDSSpacing5, {
        margin: "three"
    }, /* @__PURE__ */ React9.createElement(EGDSScrim, {
        type: EGDSScrimType.BOTTOM
    }, /* @__PURE__ */ React9.createElement(EGDSText4, {
        theme: "light"
    }, "Aerial view of property"))))))));
};
AerialViewDialog.displayName = "AerialViewDialog";
// src/components/gallery/__private/__fragments/containers/carousel-container.tsx
import React14 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2 } from "@egds/react-core/images";
import { useClickTracker as useClickTracker4, useEgClickstream as useEgClickstream4 } from "@shared-ui/clickstream-analytics-context";
import { Experiment, ExperimentControl, ExperimentVariant, useExperiment as useExperiment3 } from "@shared-ui/experiment-context";
// src/components/gallery/__private/utils/resolve-image-source.ts
var resolveImageSource = function(image, isPreviewImageUsed, isFirstLowResImage) {
    if (isPreviewImageUsed && image.previewImage) {
        return image.previewImage.url;
    }
    if (isFirstLowResImage && image.lowResImage) {
        return image.lowResImage.url;
    }
    return image.image.url;
};
// src/components/gallery/__private/utils/to-uitk-images.ts
function toEGDSImages(images, isPreviewImageUsed) {
    return images.map(function(img) {
        var _img_image, _img_image1, _img_thumbnail, _img_fallbackImage;
        var _img_image_description, _img_alt;
        return {
            src: resolveImageSource(img, isPreviewImageUsed),
            caption: (_img_image_description = (_img_image = img.image) === null || _img_image === void 0 ? void 0 : _img_image.description) !== null && _img_image_description !== void 0 ? _img_image_description : "",
            alt: (_img_alt = img.alt) !== null && _img_alt !== void 0 ? _img_alt : (_img_image1 = img.image) === null || _img_image1 === void 0 ? void 0 : _img_image1.description,
            thumbnailSrc: (_img_thumbnail = img.thumbnail) === null || _img_thumbnail === void 0 ? void 0 : _img_thumbnail.url,
            fallbackImage: (_img_fallbackImage = img.fallbackImage) === null || _img_fallbackImage === void 0 ? void 0 : _img_fallbackImage.url
        };
    });
}
function toEGDSImagesWithFirstLowResImage(images, isPreviewImageUsed) {
    return images.map(function(img, index) {
        var _img_image, _img_image1, _img_thumbnail, _img_fallbackImage;
        var _img_image_description, _img_alt;
        return {
            src: resolveImageSource(img, isPreviewImageUsed, index === 0),
            caption: (_img_image_description = (_img_image = img.image) === null || _img_image === void 0 ? void 0 : _img_image.description) !== null && _img_image_description !== void 0 ? _img_image_description : "",
            alt: (_img_alt = img.alt) !== null && _img_alt !== void 0 ? _img_alt : (_img_image1 = img.image) === null || _img_image1 === void 0 ? void 0 : _img_image1.description,
            thumbnailSrc: (_img_thumbnail = img.thumbnail) === null || _img_thumbnail === void 0 ? void 0 : _img_thumbnail.url,
            fallbackImage: (_img_fallbackImage = img.fallbackImage) === null || _img_fallbackImage === void 0 ? void 0 : _img_fallbackImage.url
        };
    });
}
// src/components/gallery/__private/__fragments/utils/additional-uis-prime-micro-messages-utils.ts
var getCarouselNextIndex = function(currentIndex, mediaLength, carouselActionId) {
    if (carouselActionId.includes("clickRight")) {
        return currentIndex < mediaLength - 1 ? currentIndex + 1 : 0;
    }
    if (carouselActionId.includes("clickLeft")) {
        return currentIndex > 0 ? currentIndex - 1 : mediaLength - 1;
    }
    return currentIndex;
};
function additionalUisPrimeMicroMessages(galleryPosition, algoMediaGuid, galleryMaxPosition, imageId, productId, galleryName, galleryCategory) {
    var _messages_;
    var timestamp = Date.now().toString();
    var messages = [
        {
            schemaName: "allHotelProducts",
            messageContent: {
                hotelProducts: [
                    _object_spread({
                        imageGalleryAlgorithm: {
                            name: "heroaesthetics.v20190411-hsc.v20190223"
                        },
                        algoMediaGuid: algoMediaGuid
                    }, productId ? {
                        productId: Number(productId)
                    } : {}, imageId ? {
                        imageId: Number(imageId)
                    } : {})
                ]
            }
        },
        {
            schemaName: "imageTracking",
            messageContent: {
                galleryName: galleryName,
                galleryType: "GALLERY_TYPE_SINGLE",
                galleryMaxPosition: galleryMaxPosition,
                galleryPosition: galleryPosition,
                repeatedGalleryIndex: null,
                imageGalleryMetaTagList: [
                    {
                        imageGalleryMetaTagValue: timestamp,
                        imageGalleryMetaTagType: "DEVICE_TIME_STAMP"
                    }
                ]
            }
        }
    ];
    if (galleryCategory && ((_messages_ = messages[1]) === null || _messages_ === void 0 ? void 0 : _messages_.messageContent.imageGalleryMetaTagList)) {
        messages[1].messageContent.imageGalleryMetaTagList.push({
            imageGalleryMetaTagValue: galleryCategory,
            imageGalleryMetaTagType: "GALLERY_FILTER"
        });
    }
    return messages;
}
// src/components/gallery/__private/__fragments/carousel/carousel.tsx
import React10 from "react";
import { EGDSOverlayButton, UitkButtonSize } from "@egds/react-core/button";
import { EGDSCarousel, EGDSCarouselPaginationDots } from "@egds/react-core/carousel";
import { EGDSIcon as EGDSIcon3, UitkIconSize } from "@egds/react-core/icons";
import { EGDSFigure, EGDSImage, EGDSImageLink } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { EGDSScrim as EGDSScrim2, EGDSScrimType as EGDSScrimType2 } from "@egds/react-core/scrim";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { useLocalization } from "@shared-ui/localization-context";
var CarouselOverlayButtonComponent = function(param) {
    var button = param.button, onClick = param.onClick, showTextLabel = param.showTextLabel;
    var _button_icon, _button_icon1;
    return /* @__PURE__ */ React10.createElement(EGDSOverlayButton, {
        "aria-label": (button === null || button === void 0 ? void 0 : button.accessibility) || "",
        size: UitkButtonSize.SMALL,
        onClick: onClick
    }, /* @__PURE__ */ React10.createElement(EGDSIcon3, {
        size: UitkIconSize.SMALL,
        name: (button === null || button === void 0 ? void 0 : (_button_icon = button.icon) === null || _button_icon === void 0 ? void 0 : _button_icon.id) || "",
        id: "PhotoGallery-".concat(button === null || button === void 0 ? void 0 : (_button_icon1 = button.icon) === null || _button_icon1 === void 0 ? void 0 : _button_icon1.id)
    }), !showTextLabel && (button === null || button === void 0 ? void 0 : button.accessibility));
};
var NumberOfImagesButtonComponent = function(param) {
    var uitkImages = param.uitkImages, handleMediaButtonClick = param.handleMediaButtonClick;
    var formatText = useLocalization().formatText;
    return /* @__PURE__ */ React10.createElement(EGDSOverlayButton, {
        size: UitkButtonSize.SMALL,
        onClick: handleMediaButtonClick
    }, /* @__PURE__ */ React10.createElement(EGDSIcon3, {
        name: "photo_library",
        id: "photo_library-id",
        title: formatText("gallerycarousel.mediaGalleryButton", uitkImages.length)
    }), /* @__PURE__ */ React10.createElement("span", {
        "aria-hidden": "true"
    }, String(uitkImages.length)));
};
var Carousel = function(props) {
    var _carouselRef_current, _carouselRef_current1;
    var ratio = props.ratio, uitkImages = props.uitkImages, controlAnalytics = props.controlAnalytics, label = props.label, handleIndexChange = props.handleIndexChange, handleImageClick = props.handleImageClick, handleMediaButtonClick = props.handleMediaButtonClick, onVirtualTourClick = props.onVirtualTourClick, onAerialViewClick = props.onAerialViewClick, virtualTourButton = props.virtualTourButton, aerialViewButton = props.aerialViewButton;
    var carouselRef = React10.useRef(null);
    var _React10_useState = _sliced_to_array(React10.useState(0), 2), currentIndex = _React10_useState[0], setCurrentIndex = _React10_useState[1];
    var _useExperiment2 = useExperiment2("mWeb_larger_image_for_top_of_PDP_gallery"), mWebLargerImageExposure = _useExperiment2.exposure;
    var isVariant = mWebLargerImageExposure.bucket !== 0;
    var onIndexChange = function(index) {
        setCurrentIndex(index);
        handleIndexChange(index);
    };
    return /* @__PURE__ */ React10.createElement(EGDSLayoutPosition2, {
        type: "relative"
    }, /* @__PURE__ */ React10.createElement(EGDSCarousel, {
        carouselRef: carouselRef,
        analytics: controlAnalytics,
        carouselHeaderLevel: "h2",
        carouselHeaderText: label || "",
        carouselName: "PhotoGallery",
        itemsVisible: {
            sm: 1,
            md: 1,
            lg: 1
        },
        onIndexChange: onIndexChange,
        hideNav: isVariant,
        pagingPersistent: !isVariant,
        pagingInset: !isVariant,
        pagingOverlay: !isVariant,
        peek: false,
        wrapItems: true,
        buttonText: {
            nextButton: "Show next card",
            prevButton: "Show previous card"
        }
    }, uitkImages.map(function(image, i) {
        return /* @__PURE__ */ React10.createElement(EGDSFigure, {
            ratio: ratio,
            key: i
        }, /* @__PURE__ */ React10.createElement(EGDSImage, {
            placeholderImage: true,
            alt: image.alt,
            src: image.src
        }), /* @__PURE__ */ React10.createElement(EGDSImageLink, null, /* @__PURE__ */ React10.createElement("button", {
            type: "button",
            onClick: handleImageClick
        }, image.alt)));
    })), ((_carouselRef_current = carouselRef.current) === null || _carouselRef_current === void 0 ? void 0 : _carouselRef_current.changeIndex) && isVariant && /* @__PURE__ */ React10.createElement(EGDSScrim2, {
        type: EGDSScrimType2.BOTTOM
    }, /* @__PURE__ */ React10.createElement(EGDSCarouselPaginationDots, {
        activeIndex: currentIndex,
        inset: true,
        itemCount: uitkImages.length,
        changeIndex: (_carouselRef_current1 = carouselRef.current) === null || _carouselRef_current1 === void 0 ? void 0 : _carouselRef_current1.changeIndex
    })), isVariant ? /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(EGDSLayoutPosition2, {
        position: {
            bottom: "three",
            left: "three",
            zindex: "layer3"
        },
        type: "absolute"
    }, virtualTourButton && /* @__PURE__ */ React10.createElement(CarouselOverlayButtonComponent, {
        button: virtualTourButton,
        onClick: onVirtualTourClick,
        showTextLabel: isVariant
    }), aerialViewButton && /* @__PURE__ */ React10.createElement(CarouselOverlayButtonComponent, {
        button: aerialViewButton,
        onClick: onAerialViewClick,
        showTextLabel: isVariant
    })), /* @__PURE__ */ React10.createElement(EGDSLayoutPosition2, {
        position: {
            bottom: "three",
            right: "three",
            zindex: "layer3"
        },
        type: "absolute"
    }, /* @__PURE__ */ React10.createElement(NumberOfImagesButtonComponent, {
        uitkImages: uitkImages,
        handleMediaButtonClick: handleMediaButtonClick
    }))) : /* @__PURE__ */ React10.createElement(EGDSLayoutPosition2, {
        position: {
            bottom: "three",
            right: "three",
            zindex: "layer3"
        },
        type: "absolute"
    }, /* @__PURE__ */ React10.createElement(EGDSLayoutFlex5, {
        space: "two"
    }, /* @__PURE__ */ React10.createElement(EGDSLayoutFlexItem4, null, virtualTourButton && /* @__PURE__ */ React10.createElement(CarouselOverlayButtonComponent, {
        button: virtualTourButton,
        onClick: onVirtualTourClick,
        showTextLabel: isVariant
    }), aerialViewButton && /* @__PURE__ */ React10.createElement(CarouselOverlayButtonComponent, {
        button: aerialViewButton,
        onClick: onAerialViewClick,
        showTextLabel: isVariant
    })), /* @__PURE__ */ React10.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */ React10.createElement(NumberOfImagesButtonComponent, {
        uitkImages: uitkImages,
        handleMediaButtonClick: handleMediaButtonClick
    })))));
};
// src/components/gallery/__private/__fragments/carousel/intersection-tracker.tsx
import React11 from "react";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
var Tracker = function(param) {
    var imageIndex = param.imageIndex, images = param.images, propertyId = param.propertyId, children = param.children;
    var _images_imageIndex, _images_imageIndex1;
    return /* @__PURE__ */ React11.createElement(IntersectionTracker, {
        tag: "span",
        referrerId: "HOT.HIS.MosaicTileImageImpression.".concat(imageIndex),
        linkName: "Mosaic Tile Image Impression",
        trackOnce: true,
        additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(imageIndex, (_images_imageIndex = images[imageIndex]) === null || _images_imageIndex === void 0 ? void 0 : _images_imageIndex.trackingId, images.length, (_images_imageIndex1 = images[imageIndex]) === null || _images_imageIndex1 === void 0 ? void 0 : _images_imageIndex1.imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ )
    }, children);
};
// src/components/gallery/__private/__fragments/carousel/tracker-wrapper.tsx
import React12 from "react";
import { EgClickstreamImpressionTracker } from "@shared-ui/clickstream-analytics-context";
var TrackerWrapper = function(param) {
    var children = param.children, aerialViewButton = param.aerialViewButton;
    return aerialViewButton ? /* @__PURE__ */ React12.createElement(EgClickstreamImpressionTracker, {
        eventData: buildEgClickstreamData("aerial_view.presented", "Impression")
    }, children) : children;
};
// src/components/gallery/__private/__fragments/gallery-buttons/gallery-buttons.tsx
import React13 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSOverlayButton as EGDSOverlayButton2 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon4 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex6 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition3 } from "@egds/react-core/layout-position";
import { useClickTracker as useClickTracker3, useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
var __GalleryButtonsFragment = gql8(_templateObject7());
var TRIGGER_POSITION = {
    position: {
        zindex: "layer2",
        bottom: "three",
        right: "three"
    },
    type: "absolute"
};
var GalleryButtons = function(props) {
    var data = props.data, onThumbnailGalleryClick = props.onThumbnailGalleryClick, onVirtualTourClick = props.onVirtualTourClick, onAerialViewClick = props.onAerialViewClick, thumbnailButtonText = props.thumbnailButtonText, thumbnailDialogTriggerTitle = props.thumbnailDialogTriggerTitle, thumbnailDialogTriggerAccessibilityLabel = props.thumbnailDialogTriggerAccessibilityLabel;
    var galleryButtons = data.galleryButtons;
    var track = useClickTracker3();
    var trackEGClickStream = useEgClickstream3();
    var handleGalleryButtonClick = React13.useCallback(function(index) {
        var _galleryButtons_index_icon, _galleryButtons_index, _galleryButtons_index_action, _galleryButtons_index1, _galleryButtons_index_icon1, _galleryButtons_index2, _galleryButtons_index_action1, _galleryButtons_index3;
        if ((galleryButtons === null || galleryButtons === void 0 ? void 0 : (_galleryButtons_index = galleryButtons[index]) === null || _galleryButtons_index === void 0 ? void 0 : (_galleryButtons_index_icon = _galleryButtons_index.icon) === null || _galleryButtons_index_icon === void 0 ? void 0 : _galleryButtons_index_icon.id) === "tour_360" && ((_galleryButtons_index1 = galleryButtons[index]) === null || _galleryButtons_index1 === void 0 ? void 0 : (_galleryButtons_index_action = _galleryButtons_index1.action) === null || _galleryButtons_index_action === void 0 ? void 0 : _galleryButtons_index_action.resource)) {
            var _galleryButtons_index_action_resource, _galleryButtons_index_action2, _galleryButtons_index4;
            var btnVal = ((_galleryButtons_index4 = galleryButtons[index]) === null || _galleryButtons_index4 === void 0 ? void 0 : (_galleryButtons_index_action2 = _galleryButtons_index4.action) === null || _galleryButtons_index_action2 === void 0 ? void 0 : (_galleryButtons_index_action_resource = _galleryButtons_index_action2.resource) === null || _galleryButtons_index_action_resource === void 0 ? void 0 : _galleryButtons_index_action_resource.value) || "";
            onVirtualTourClick(btnVal);
        } else if ((galleryButtons === null || galleryButtons === void 0 ? void 0 : (_galleryButtons_index2 = galleryButtons[index]) === null || _galleryButtons_index2 === void 0 ? void 0 : (_galleryButtons_index_icon1 = _galleryButtons_index2.icon) === null || _galleryButtons_index_icon1 === void 0 ? void 0 : _galleryButtons_index_icon1.id) === "visibility" && ((_galleryButtons_index3 = galleryButtons[index]) === null || _galleryButtons_index3 === void 0 ? void 0 : (_galleryButtons_index_action1 = _galleryButtons_index3.action) === null || _galleryButtons_index_action1 === void 0 ? void 0 : _galleryButtons_index_action1.resource)) {
            var _galleryButtons_index_action_resource1, _galleryButtons_index_action3, _galleryButtons_index5;
            var btnVal1 = (galleryButtons === null || galleryButtons === void 0 ? void 0 : (_galleryButtons_index5 = galleryButtons[index]) === null || _galleryButtons_index5 === void 0 ? void 0 : (_galleryButtons_index_action3 = _galleryButtons_index5.action) === null || _galleryButtons_index_action3 === void 0 ? void 0 : (_galleryButtons_index_action_resource1 = _galleryButtons_index_action3.resource) === null || _galleryButtons_index_action_resource1 === void 0 ? void 0 : _galleryButtons_index_action_resource1.value) || "";
            trackEGClickStream(buildEgClickstreamData("aerial_view.selected", "Interaction"));
            onAerialViewClick(btnVal1.replace("#", ""));
        }
    }, [
        galleryButtons,
        trackEGClickStream,
        onVirtualTourClick,
        onAerialViewClick
    ]);
    var thubnailButtonAnalytics = React13.useMemo(function() {
        return {
            id: "HOT.HIS.PhotoGalleryTrigger",
            description: "Open Room Gallery dialog",
            callback: function(id, desc) {
                return track(id, desc);
            }
        };
    }, [
        track
    ]);
    return /* @__PURE__ */ React13.createElement(EGDSLayoutPosition3, _object_spread({}, TRIGGER_POSITION), /* @__PURE__ */ React13.createElement(EGDSLayoutFlex6, {
        space: "two",
        wrap: "nowrap"
    }, galleryButtons === null || galleryButtons === void 0 ? void 0 : galleryButtons.map(function(galleryButton, buttonIndex) {
        var _galleryButton_icon, _galleryButton_action, _galleryButton_icon1, _galleryButton_icon2;
        return(// eslint-disable-next-line react/jsx-key
        /* @__PURE__ */ React13.createElement(TrackerWrapper, {
            aerialViewButton: (galleryButton === null || galleryButton === void 0 ? void 0 : (_galleryButton_icon = galleryButton.icon) === null || _galleryButton_icon === void 0 ? void 0 : _galleryButton_icon.id) === "visibility" && (galleryButton === null || galleryButton === void 0 ? void 0 : (_galleryButton_action = galleryButton.action) === null || _galleryButton_action === void 0 ? void 0 : _galleryButton_action.resource)
        }, /* @__PURE__ */ React13.createElement(EGDSOverlayButton2, {
            key: "gallery-mosaic-action-".concat((_galleryButton_icon1 = galleryButton.icon) === null || _galleryButton_icon1 === void 0 ? void 0 : _galleryButton_icon1.id),
            "aria-label": "gallery-mosaic-action",
            onClick: function() {
                return handleGalleryButtonClick(buttonIndex);
            }
        }, /* @__PURE__ */ React13.createElement(EGDSIcon4, {
            name: ((_galleryButton_icon2 = galleryButton.icon) === null || _galleryButton_icon2 === void 0 ? void 0 : _galleryButton_icon2.id) || "",
            id: "gallery-mosaic-action-trigger"
        }), galleryButton.accessibility)));
    }), /* @__PURE__ */ React13.createElement(EGDSOverlayButton2, {
        "aria-label": thumbnailDialogTriggerAccessibilityLabel || "",
        onClick: onThumbnailGalleryClick,
        analytics: thubnailButtonAnalytics
    }, /* @__PURE__ */ React13.createElement(EGDSIcon4, {
        name: "photo_library",
        id: "gallery-mosaic-thumbnail-trigger"
    }), thumbnailButtonText)));
};
GalleryButtons.displayName = "GalleryButtons";
GalleryButtons.fragment = __GalleryButtonsFragment;
// src/components/gallery/__private/__fragments/containers/carousel-container.tsx
var __CarouselContainerFragment = gql9(_templateObject8(), GalleryButtons.fragment);
var CarouselContainer = function(props) {
    var data = props.data, onImageClick = props.onImageClick, onVirtualTourClick = props.onVirtualTourClick, onAerialViewClick = props.onAerialViewClick, onTriggerClick = props.onTriggerClick, imageIndexState = props.imageIndexState, propertyId = props.propertyId;
    var galleryButtons = data.galleryButtons, images = data.images, label = data.label;
    var track = useClickTracker4();
    var trackEgClickStream = useEgClickstream4();
    var _React14_useState = _sliced_to_array(React14.useState(false), 2), logExposure = _React14_useState[0], setLogExposure = _React14_useState[1];
    var _imageIndexState = _sliced_to_array(imageIndexState, 2), imageIndex = _imageIndexState[0], setImageIndex = _imageIndexState[1];
    var _useExperiment3 = useExperiment3("Akamai_smart_cropping_for_PDP_image_gallery"), akamaiSmartCroppingExposure = _useExperiment3.exposure;
    var _useExperiment31 = useExperiment3("mWeb_larger_image_for_top_of_PDP_gallery"), largerImageExposure = _useExperiment31.exposure;
    var isPreviewImageUsed = akamaiSmartCroppingExposure.bucket !== 0 || largerImageExposure.bucket !== 0;
    var controlAnalytics = React14.useMemo(function() {
        return {
            id: "HOT.HIS.Main",
            description: "Change image in gallery carousel",
            callback: function(id, desc) {
                var nextImageIndex = getCarouselNextIndex(imageIndex, images.length, id);
                var _ref = images[nextImageIndex] || {
                    trackingId: void 0,
                    imageId: void 0
                }, trackingId = _ref.trackingId, imageId = _ref.imageId;
                track(id, desc, void 0, additionalUisPrimeMicroMessages(nextImageIndex, trackingId, images.length, imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ ));
            }
        };
    }, [
        track
    ]);
    var handleIndexChange = React14.useCallback(function(index) {
        setImageIndex(index);
        setLogExposure(true);
    }, [
        setImageIndex,
        setLogExposure
    ]);
    var handleImageClick = React14.useCallback(function() {
        var _images_imageIndex, _images_imageIndex1, _images_imageIndex2;
        var image = (_images_imageIndex = images[imageIndex]) === null || _images_imageIndex === void 0 ? void 0 : _images_imageIndex.image;
        if (image === null || image === void 0 ? void 0 : image.thumbnailClickAnalytics) {
            var thumbnailClickAnalytics = image.thumbnailClickAnalytics;
            track(thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.referrerId, thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.linkName);
        }
        track("HOT.HIS.LaunchMainPhotoGallery", "Launch Photo Gallery From Image Click", void 0, additionalUisPrimeMicroMessages(imageIndex, (_images_imageIndex1 = images[imageIndex]) === null || _images_imageIndex1 === void 0 ? void 0 : _images_imageIndex1.trackingId, images.length, (_images_imageIndex2 = images[imageIndex]) === null || _images_imageIndex2 === void 0 ? void 0 : _images_imageIndex2.imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ ));
        onImageClick();
        setLogExposure(true);
    }, [
        track,
        onImageClick
    ]);
    var handleMediaButtonClick = React14.useCallback(function() {
        track("HOT.HIS.PhotoGalleryTrigger", "Open Room Gallery dialog");
        onTriggerClick();
        setLogExposure(true);
    }, [
        track,
        onTriggerClick
    ]);
    var virtualTourButton = galleryButtons === null || galleryButtons === void 0 ? void 0 : galleryButtons.find(function(button) {
        var _button_icon, _button_action_resource, _button_action;
        return ((_button_icon = button.icon) === null || _button_icon === void 0 ? void 0 : _button_icon.id) === "tour_360" ? (_button_action = button.action) === null || _button_action === void 0 ? void 0 : (_button_action_resource = _button_action.resource) === null || _button_action_resource === void 0 ? void 0 : _button_action_resource.value : null;
    });
    var aerialViewButton = galleryButtons === null || galleryButtons === void 0 ? void 0 : galleryButtons.find(function(button) {
        var _button_icon, _button_action_resource, _button_action;
        return ((_button_icon = button.icon) === null || _button_icon === void 0 ? void 0 : _button_icon.id) === "visibility" ? (_button_action = button.action) === null || _button_action === void 0 ? void 0 : (_button_action_resource = _button_action.resource) === null || _button_action_resource === void 0 ? void 0 : _button_action_resource.value : null;
    });
    var handleonVirtualTourButtonClick = React14.useCallback(function() {
        if (virtualTourButton === null || virtualTourButton === void 0 ? void 0 : virtualTourButton.action) {
            onVirtualTourClick(virtualTourButton.action.resource.value);
        }
    }, [
        onVirtualTourClick,
        virtualTourButton
    ]);
    var handleAerialViewButtonClick = React14.useCallback(function() {
        if (aerialViewButton === null || aerialViewButton === void 0 ? void 0 : aerialViewButton.action) {
            var _aerialViewButton_action_resource, _aerialViewButton_action;
            var btnVal = ((_aerialViewButton_action = aerialViewButton.action) === null || _aerialViewButton_action === void 0 ? void 0 : (_aerialViewButton_action_resource = _aerialViewButton_action.resource) === null || _aerialViewButton_action_resource === void 0 ? void 0 : _aerialViewButton_action_resource.value) || "";
            trackEgClickStream(buildEgClickstreamData("aerial_view.selected", "Interaction"));
            onAerialViewClick(btnVal.replace("#", ""));
            setLogExposure(true);
        }
    }, [
        trackEgClickStream,
        onAerialViewClick,
        aerialViewButton
    ]);
    var uitkImages = React14.useMemo(function() {
        return toEGDSImagesWithFirstLowResImage(images, isPreviewImageUsed);
    }, [
        images,
        isPreviewImageUsed
    ]);
    var carouselComponent = function(imageRatio) {
        return /* @__PURE__ */ React14.createElement(TrackerWrapper, {
            aerialViewButton: aerialViewButton
        }, /* @__PURE__ */ React14.createElement(Tracker, {
            propertyId: propertyId,
            images: images,
            imageIndex: imageIndex
        }, /* @__PURE__ */ React14.createElement(Carousel, {
            ratio: imageRatio,
            uitkImages: uitkImages,
            controlAnalytics: controlAnalytics,
            label: label,
            handleIndexChange: handleIndexChange,
            handleImageClick: handleImageClick,
            handleMediaButtonClick: handleMediaButtonClick,
            onVirtualTourClick: handleonVirtualTourButtonClick,
            onAerialViewClick: handleAerialViewButtonClick,
            virtualTourButton: virtualTourButton,
            aerialViewButton: aerialViewButton
        })));
    };
    var largerImageExperiment = /* @__PURE__ */ React14.createElement(Experiment, {
        name: "mWeb_larger_image_for_top_of_PDP_gallery",
        logExposure: true
    }, /* @__PURE__ */ React14.createElement(ExperimentControl, null, carouselComponent(EGDSFigureAspectRatioType2.R16_9)), /* @__PURE__ */ React14.createElement(ExperimentVariant, {
        bucket: 1
    }, carouselComponent(EGDSFigureAspectRatioType2.R3_2)), /* @__PURE__ */ React14.createElement(ExperimentVariant, {
        bucket: 2
    }, carouselComponent(EGDSFigureAspectRatioType2.R1_1)));
    return /* @__PURE__ */ React14.createElement(Experiment, {
        name: "mWeb_PDP_Full_image_gallery_ranking_algorithm_with_new_scene_classifier",
        logExposure: logExposure
    }, /* @__PURE__ */ React14.createElement(ExperimentControl, null, largerImageExperiment), /* @__PURE__ */ React14.createElement(ExperimentVariant, {
        bucket: 1
    }));
};
CarouselContainer.displayName = "CarouselContainer";
CarouselContainer.fragment = __CarouselContainerFragment;
// src/components/gallery/__private/__fragments/containers/mosaic-container.tsx
import React15 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition4 } from "@egds/react-core/layout-position";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { PropertyImage } from "@shared-ui/lodging-fragments";
var __MosaicContainerFragment = gql10(_templateObject9(), PropertyImage.fragment, GalleryButtons.fragment);
function numberOfColumns(numberOfImages) {
    switch(numberOfImages){
        case 5:
            return 4;
        case 3:
            return 3;
        default:
            return 1;
    }
}
var MosaicContainer = function(props) {
    var _mosaicImages_;
    var data = props.data, imagesToShow = props.imagesToShow, onVirtualTourClick = props.onVirtualTourClick, onAerialViewClick = props.onAerialViewClick, onImageClick = props.onImageClick, onTriggerClick = props.onTriggerClick, thumbnailDialogTriggerTitle = props.thumbnailDialogTriggerTitle, thumbnailDialogTriggerAccessibilityLabel = props.thumbnailDialogTriggerAccessibilityLabel, propertyId = props.propertyId;
    var images = data.images, label = data.label;
    var track = useClickTracker5();
    var mosaicImages = React15.useMemo(function() {
        var imageSlice = images.slice(0, imagesToShow);
        if (imageSlice.length % 2 === 0) {
            imageSlice.pop();
        }
        return imageSlice;
    }, [
        images,
        imagesToShow
    ]);
    var handleImageClick = React15.useCallback(function(index) {
        var _ref = mosaicImages[index] || {
            trackingId: void 0,
            imageId: void 0
        }, trackingId = _ref.trackingId, imageId = _ref.imageId;
        track("HOT.HIS.ClickMosaicTileImage.".concat(index), "Property mosaic tile image click", void 0, additionalUisPrimeMicroMessages(index, trackingId, mosaicImages.length, imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ ));
        track("HOT.HIS.LaunchMainPhotoGallery", "Launch Photo Gallery From Image Click");
        onImageClick(index);
    }, [
        track,
        onImageClick
    ]);
    var columns = numberOfColumns(mosaicImages.length);
    return /* @__PURE__ */ React15.createElement(EGDSLayoutPosition4, {
        type: "relative"
    }, /* @__PURE__ */ React15.createElement(EGDSLayoutGrid, {
        columns: columns,
        rows: 2,
        space: "half"
    }, /* @__PURE__ */ React15.createElement("meta", {
        itemProp: "image",
        content: (_mosaicImages_ = mosaicImages[0]) === null || _mosaicImages_ === void 0 ? void 0 : _mosaicImages_.image.url
    }), /* @__PURE__ */ React15.createElement("h2", {
        className: "is-visually-hidden"
    }, label), mosaicImages.map(function(img, index) {
        return /* @__PURE__ */ React15.createElement(EGDSLayoutGridItem, {
            key: "mosaic-image-".concat(index),
            colSpan: index === 0 ? 2 : 1,
            rowSpan: index === 0 ? 2 : 1
        }, /* @__PURE__ */ React15.createElement(PropertyImage, {
            data: img,
            onClick: handleImageClick,
            index: index,
            fetchPriority: index === 0 ? "high" : void 0,
            galleryLength: imagesToShow,
            propertyId: propertyId
        }));
    }), /* @__PURE__ */ React15.createElement(GalleryButtons, {
        data: data,
        onThumbnailGalleryClick: onTriggerClick,
        onVirtualTourClick: onVirtualTourClick,
        onAerialViewClick: onAerialViewClick,
        thumbnailButtonText: thumbnailDialogTriggerTitle,
        thumbnailDialogTriggerTitle: thumbnailDialogTriggerTitle,
        thumbnailDialogTriggerAccessibilityLabel: thumbnailDialogTriggerAccessibilityLabel
    })));
};
MosaicContainer.fragment = __MosaicContainerFragment;
MosaicContainer.displayName = "MosaicContainer";
// src/components/gallery/__private/__fragments/dialogs/media-gallery-dialog.tsx
import React16 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkMediaGalleryImageDialog as EGDSMediaGalleryImageDialog2, UitkMediaGalleryImageView as EGDSMediaGalleryImageView } from "@egds/react-core/media-gallery";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
var __MediaGalleryDialogFragment = gql11(_templateObject10());
var MediaGalleryDialog = function(props) {
    var data = props.data, isDialogOpen = props.isDialogOpen, onDialogDismiss = props.onDialogDismiss, imageIndexState = props.imageIndexState, categoryImageIndexState = props.categoryImageIndexState, categoryIndexState = props.categoryIndexState, propertyId = props.propertyId;
    var categories = data.categories, images = data.images, mediaGalleryDialog = data.mediaGalleryDialog;
    var _imageIndexState = _sliced_to_array(imageIndexState, 2), imageIndex = _imageIndexState[0], setImageIndex = _imageIndexState[1];
    var _categoryImageIndexState = _sliced_to_array(categoryImageIndexState, 2), categoryImageIndex = _categoryImageIndexState[0], setCategoryImageIndex = _categoryImageIndexState[1];
    var _categoryIndexState = _sliced_to_array(categoryIndexState, 1), categoryIndex = _categoryIndexState[0];
    var track = useClickTracker6();
    var galleryImages = React16.useMemo(function() {
        if (categoryIndex < 0) {
            return toEGDSImages(images);
        }
        var currentCategory = categories ? categories[categoryIndex] : null;
        return toEGDSImages((currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.images) || []);
    }, [
        categoryIndex,
        categories,
        images
    ]);
    var toolbarProps = React16.useMemo(function() {
        var _mediaGalleryDialog_toolbar_icon, _mediaGalleryDialog_toolbar, _mediaGalleryDialog_toolbar_icon1, _mediaGalleryDialog_toolbar1;
        return {
            type: mediaGalleryDialog === null || mediaGalleryDialog === void 0 ? void 0 : (_mediaGalleryDialog_toolbar = mediaGalleryDialog.toolbar) === null || _mediaGalleryDialog_toolbar === void 0 ? void 0 : (_mediaGalleryDialog_toolbar_icon = _mediaGalleryDialog_toolbar.icon) === null || _mediaGalleryDialog_toolbar_icon === void 0 ? void 0 : _mediaGalleryDialog_toolbar_icon.iconId,
            navIconLabel: mediaGalleryDialog === null || mediaGalleryDialog === void 0 ? void 0 : (_mediaGalleryDialog_toolbar1 = mediaGalleryDialog.toolbar) === null || _mediaGalleryDialog_toolbar1 === void 0 ? void 0 : (_mediaGalleryDialog_toolbar_icon1 = _mediaGalleryDialog_toolbar1.icon) === null || _mediaGalleryDialog_toolbar_icon1 === void 0 ? void 0 : _mediaGalleryDialog_toolbar_icon1.description
        };
    }, [
        mediaGalleryDialog
    ]);
    var galleryControlAnalytics = React16.useMemo(function() {
        var callback = function(id, description) {
            var _categories_categoryIndex;
            var categoryImages = (categories === null || categories === void 0 ? void 0 : (_categories_categoryIndex = categories[categoryIndex]) === null || _categories_categoryIndex === void 0 ? void 0 : _categories_categoryIndex.images) || images;
            var _ref = categoryImages[categoryImageIndex] || {
                trackingId: void 0,
                imageId: void 0
            }, trackingId = _ref.trackingId, imageId = _ref.imageId;
            track(id, description, void 0, additionalUisPrimeMicroMessages(categoryImageIndex, trackingId, galleryImages.length, imageId, propertyId, "PDP_FULL_SCREEN_IMAGE_GALLERY" /* PDP_FULL_SCREEN_IMAGE_GALLERY */ ));
        };
        var galleryControl = {
            id: "HOT.HIS.PhotoGalleryTrigger",
            description: "Change image in media gallery",
            callback: callback
        };
        return galleryControl;
    }, [
        track
    ]);
    var dialogAnalytics = React16.useMemo(function() {
        var callback = function(id, description) {
            return track(id, description);
        };
        var dialog = {
            id: "HOT.HIS.PhotoGalleryTrigger",
            description: "Close review gallery dialog",
            callback: callback
        };
        return dialog;
    }, [
        track
    ]);
    var handleIndexChange = React16.useCallback(function(index) {
        if (categoryIndex < 0) {
            setImageIndex(index);
            return;
        }
        setCategoryImageIndex(index);
    }, [
        categoryIndex,
        setCategoryImageIndex,
        setImageIndex
    ]);
    if (!(galleryImages === null || galleryImages === void 0 ? void 0 : galleryImages.length)) {
        return null;
    }
    var mediaGalleryImageViewProps = {
        currentIndex: categoryIndex >= 0 ? categoryImageIndex : imageIndex,
        onIndexChange: handleIndexChange,
        galleryName: "Dialog",
        analytics: galleryControlAnalytics
    };
    return /* @__PURE__ */ React16.createElement(EGDSMediaGalleryImageDialog2, _object_spread({
        dialogShow: isDialogOpen,
        onDismiss: onDialogDismiss,
        strictFullscreen: true,
        analytics: dialogAnalytics
    }, toolbarProps), /* @__PURE__ */ React16.createElement(EGDSMediaGalleryImageView, _object_spread_props(_object_spread({}, mediaGalleryImageViewProps), {
        images: galleryImages,
        stretchToFill: false
    })));
};
MediaGalleryDialog.displayName = "MediaGalleryDialog";
MediaGalleryDialog.fragment = __MediaGalleryDialogFragment;
// src/components/gallery/__private/__fragments/dialogs/thumbnail-gallery-dialog.tsx
import React20 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkFloatingButton, UitkFloatingFullWidthButton, UitkPrimaryButton } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { UitkLayoutPosition } from "@egds/react-core/layout-position";
import { UitkScrim, UitkScrimType } from "@egds/react-core/scrim";
import { EGDSSheet as EGDSSheet3, EGDSSheetContent as EGDSSheetContent2 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing9, UitkSpacing } from "@egds/react-core/spacing";
import { UitkText } from "@egds/react-core/text";
import { EGDSToolbar as EGDSToolbar3 } from "@egds/react-core/toolbar";
import { SheetCenteredLarge } from "@egds/react-property-experience";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2, useExperiment as useExperiment7 } from "@shared-ui/experiment-context";
import { useRefContext, useRefTargetScroll as useRefTargetScroll2 } from "@shared-ui/ref-context";
import { ViewMedium as ViewMedium5, Viewport as Viewport7, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
import { useInView } from "react-intersection-observer";
// src/components/gallery/__private/__fragments/dialogs/thumbnail-gallery-pills.tsx
import React19 from "react";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType4 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex7 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid4 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition5 } from "@egds/react-core/layout-position";
import { EGDSPill } from "@egds/react-core/pill";
import { EGDSScrollable } from "@egds/react-core/scrollable";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading4 } from "@egds/react-core/text";
import { ViewRow } from "@egds/react-search-experience";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment6 } from "@shared-ui/experiment-context";
import { defaultViewSizes, useMediaQueries, ViewLarge as ViewLarge3, ViewMedium as ViewMedium4, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
// src/components/gallery/__private/utils/to-uitk-images-with-thumbnail-analytics.ts
function toEGDSImagesWithThumbnailAnalytics(images, isPreviewImageUsed) {
    return images.map(function(img) {
        var _img_image, _img_image1, _img_thumbnail, _img_fallbackImage, _img_image2;
        var _img_image_description, _img_alt;
        return {
            src: resolveImageSource(img, isPreviewImageUsed),
            caption: (_img_image_description = (_img_image = img.image) === null || _img_image === void 0 ? void 0 : _img_image.description) !== null && _img_image_description !== void 0 ? _img_image_description : "",
            alt: (_img_alt = img.alt) !== null && _img_alt !== void 0 ? _img_alt : (_img_image1 = img.image) === null || _img_image1 === void 0 ? void 0 : _img_image1.description,
            thumbnailSrc: (_img_thumbnail = img.thumbnail) === null || _img_thumbnail === void 0 ? void 0 : _img_thumbnail.url,
            fallbackImage: (_img_fallbackImage = img.fallbackImage) === null || _img_fallbackImage === void 0 ? void 0 : _img_fallbackImage.url,
            thumbnailClickAnalytics: (_img_image2 = img.image) === null || _img_image2 === void 0 ? void 0 : _img_image2.thumbnailClickAnalytics,
            trackingId: img.trackingId || null,
            imageId: img.imageId || null
        };
    });
}
// src/components/gallery/__private/__fragments/dialogs/media-gallery-thumbnail-view.tsx
import React17 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSList } from "@egds/react-core/list";
import { UitkMediaGalleryThumbnail as EGDSMediaGalleryThumbnail } from "@egds/react-core/media-gallery";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment4 } from "@shared-ui/experiment-context";
var MediaGalleryThumbnailView = function(param) {
    var images = param.images, onImageSelected = param.onImageSelected, columns = param.columns, space = param.space, imagesRatio = param.imagesRatio, focusIndex = param.focusIndex, containerRef = param.containerRef, propertyId = param.propertyId, categoryId = param.categoryId;
    var exposure = useExperiment4("Add_reserve_button_in_the_image_gallery_Web").exposure;
    if (!(images === null || images === void 0 ? void 0 : images.length)) {
        return null;
    }
    return /* @__PURE__ */ React17.createElement(EGDSList, {
        bullet: "no-bullet",
        spacing: false
    }, /* @__PURE__ */ React17.createElement(EGDSLayoutGrid2, {
        columns: columns,
        space: space
    }, images.map(function(image, index) {
        return /* @__PURE__ */ React17.createElement(EGDSLayoutGridItem2, {
            key: index
        }, /* @__PURE__ */ React17.createElement("div", {
            "data-stid": "image-thumbnail-view-with-label"
        }, /* @__PURE__ */ React17.createElement(IntersectionTracker2, {
            trackOnce: true,
            referrerId: "HOT.HIS.ThumbnailImageImpression.".concat(categoryId ? "".concat(categoryId, ".") : "").concat(index),
            linkName: "Thumbnail Image Impression",
            additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(index, image.trackingId, images.length, image.imageId, propertyId, "PDP_FULL_IMAGE_GALLERY" /* PDP_FULL_IMAGE_GALLERY */ , categoryId)
        }, /* @__PURE__ */ React17.createElement(EGDSMediaGalleryThumbnail, _object_spread_props(_object_spread({}, image), {
            index: index,
            imagesRatio: imagesRatio,
            onImageSelected: function() {
                return onImageSelected(index);
            },
            focusIndex: focusIndex,
            containerRef: containerRef
        }))), exposure.bucket === 1 ? /* @__PURE__ */ React17.createElement(EGDSSpacing6, {
            padding: {
                blockend: index + 1 === images.length ? "sixteen" : "unset"
            },
            margin: {
                blockstart: "two",
                blockend: index + 1 === images.length ? "twelve" : "three"
            }
        }, /* @__PURE__ */ React17.createElement(EGDSText5, {
            align: "left",
            overflow: "truncate",
            "aria-hidden": "true"
        }, image.caption)) : /* @__PURE__ */ React17.createElement(EGDSSpacing6, {
            margin: {
                blockstart: "two",
                blockend: "three"
            }
        }, /* @__PURE__ */ React17.createElement(EGDSText5, {
            align: "left",
            overflow: "truncate",
            "aria-hidden": "true"
        }, image.caption))));
    })));
};
MediaGalleryThumbnailView.displayName = "MediaGalleryThumbnailView";
// src/components/gallery/__private/__fragments/dialogs/multi-image-layout-view.tsx
import React18 from "react";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType3, EGDSImage as EGDSImage2, EGDSImageLink as EGDSImageLink2 } from "@egds/react-core/images";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment5 } from "@shared-ui/experiment-context";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
import { useViewportMap, ViewSizes } from "@shared-ui/viewport-context";
var MultiImageLayoutView = function(param) {
    var images = param.images, onImageSelected = param.onImageSelected, propertyId = param.propertyId, categoryId = param.categoryId;
    var formatText = useLocalization2().formatText;
    var _useExperiment5 = useExperiment5("Add_reserve_button_in_the_image_gallery_Web"), reserveButtonExposure = _useExperiment5.exposure;
    var _obj;
    var isMobile = useViewportMap((_obj = {}, _define_property(_obj, ViewSizes.SMALL, true), _define_property(_obj, ViewSizes.MEDIUM, false), _obj));
    if (!(images === null || images === void 0 ? void 0 : images.length)) {
        return null;
    }
    var imagePosition = function(index) {
        var totalImages = images === null || images === void 0 ? void 0 : images.length;
        if (totalImages < 3) {
            return 2;
        }
        var isEndSpecialCase = totalImages % 3 === 2 && index === totalImages - 2;
        if (isEndSpecialCase) {
            return 1;
        }
        return index % 3 === 0 ? 2 : 1;
    };
    var getImageRatio2 = function(index) {
        if (!isMobile) {
            return EGDSFigureAspectRatioType3.R16_9;
        }
        return imagePosition(index) === 2 ? EGDSFigureAspectRatioType3.R16_9 : EGDSFigureAspectRatioType3.R3_2;
    };
    var buttonLabel = function(image, index) {
        return (image === null || image === void 0 ? void 0 : image.caption) ? formatText("mediagallery.thumbnailWithCaption", image === null || image === void 0 ? void 0 : image.caption) : formatText("mediagallery.thumbnailWithoutCaption", index + 1);
    };
    return /* @__PURE__ */ React18.createElement(EGDSLayoutGrid3, {
        columns: 2,
        space: "two"
    }, images.map(function(image, index) {
        return /* @__PURE__ */ React18.createElement(EGDSLayoutGridItem3, {
            colSpan: {
                small: imagePosition(index),
                medium: 1
            },
            key: index
        }, /* @__PURE__ */ React18.createElement(EGDSSpacing7, {
            padding: {
                blockend: reserveButtonExposure.bucket === 1 && index + 1 === images.length ? "sixteen" : "unset"
            }
        }, /* @__PURE__ */ React18.createElement("div", {
            "data-stid": "multi-image-layout-view"
        }, /* @__PURE__ */ React18.createElement(IntersectionTracker3, {
            trackOnce: true,
            referrerId: "HOT.HIS.ThumbnailImageImpression.".concat(categoryId ? "".concat(categoryId, ".") : "").concat(index),
            linkName: "Thumbnail Image Impression",
            additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(index, image.trackingId, images.length, image.imageId, propertyId, "PDP_FULL_IMAGE_GALLERY" /* PDP_FULL_IMAGE_GALLERY */ , categoryId)
        }, /* @__PURE__ */ React18.createElement(EGDSFigure2, {
            ratio: getImageRatio2(index),
            imageFit: "cover",
            roundcorner: {
                medium: [
                    "all"
                ]
            }
        }, /* @__PURE__ */ React18.createElement(EGDSImage2, {
            placeholderImage: true,
            src: image.src,
            alt: image.alt
        }), /* @__PURE__ */ React18.createElement(EGDSImageLink2, null, /* @__PURE__ */ React18.createElement("button", {
            onClick: function() {
                return onImageSelected(index);
            },
            type: "button"
        }, /* @__PURE__ */ React18.createElement("span", {
            className: "is-visually-hidden"
        }, buttonLabel(image, index)))))))));
    }));
};
MultiImageLayoutView.displayName = "MultiImageLayoutView";
// src/components/gallery/__private/__fragments/dialogs/thumbnail-gallery-pills.tsx
var ThumbnailGalleryPills = function(param) {
    var categories = param.categories, images = param.images, _param_useCenteredSheet = param.useCenteredSheet, useCenteredSheet = _param_useCenteredSheet === void 0 ? false : _param_useCenteredSheet, onImageClick = param.onImageClick, categoryIndexState = param.categoryIndexState, imageIndexState = param.imageIndexState, propertyId = param.propertyId, _param_showImageNumber = param.showImageNumber, showImageNumber = _param_showImageNumber === void 0 ? false : _param_showImageNumber, refGallery = param.refGallery, isSmallView = param.isSmallView, setIsScrolled = param.setIsScrolled, refContent = param.refContent;
    var _imageIndexState = _sliced_to_array(imageIndexState, 1), imageIndex = _imageIndexState[0];
    var _categoryIndexState = _sliced_to_array(categoryIndexState, 1), categoryIndex = _categoryIndexState[0];
    var useFallbackLogic = !(categories === null || categories === void 0 ? void 0 : categories.length);
    var refTop = React19.useRef(null);
    var refCategory = React19.useRef({});
    var refSticky = React19.useRef(null);
    var track = useClickTracker7();
    var _useExperiment6 = useExperiment6("Wider_centred_sheet_for_the_image_gallery"), widerCenteredSheetExpousre = _useExperiment6.exposure;
    var _useExperiment61 = useExperiment6("Multi_image_layout_optimisation_for_gallery_view_Web", true), multiImageLayoutExposure = _useExperiment61.exposure;
    var isDesktop = useMediaQueries({
        viewSizes: defaultViewSizes
    }) >= defaultViewSizes.LARGE;
    var useMultiImageLayout = multiImageLayoutExposure.bucket !== 0;
    var imageColumns = widerCenteredSheetExpousre.bucket === 2 && isDesktop ? 3 : 2;
    var _React19_useState = _sliced_to_array(React19.useState(categoryIndex >= 0 || !(categories === null || categories === void 0 ? void 0 : categories.length) ? categoryIndex : 0), 2), currentLocalCategoryIndex = _React19_useState[0], setCurrentLocalCategoryIndex = _React19_useState[1];
    var _React19_useState1 = _sliced_to_array(React19.useState([]), 2), isPillSelected = _React19_useState1[0], setIsPillSelected = _React19_useState1[1];
    var _useExperiment62 = useExperiment6("Akamai_smart_cropping_for_PDP_image_gallery"), akamaiSmartCroppingExposure = _useExperiment62.exposure;
    var isPreviewImageUsed = akamaiSmartCroppingExposure.bucket !== 0;
    React19.useEffect(function() {
        var newCategories = new Array(categories === null || categories === void 0 ? void 0 : categories.length).fill(false);
        newCategories[0] = !newCategories[0];
        setIsPillSelected(newCategories);
    }, [
        categories
    ]);
    var setRef = function(id) {
        return function(el) {
            refCategory.current[id] = el;
        };
    };
    var handlePillSelect = React19.useCallback(function(selectedCategoryIndex) {
        var _refCategory_current_selectedCategoryIndex, _refSticky_current_offsetParent, _refSticky_current, _refGallery_current_offsetParent, _refGallery_current;
        if (categories) {
            var _categories_selectedCategoryIndex;
            var selectedCategoryName = selectedCategoryIndex >= 0 ? (_categories_selectedCategoryIndex = categories[selectedCategoryIndex]) === null || _categories_selectedCategoryIndex === void 0 ? void 0 : _categories_selectedCategoryIndex.name : "";
            track("HOT.HIS.Gallery.".concat(selectedCategoryName, ".").concat(selectedCategoryIndex), "Selected gallery tab");
        }
        var updateSelectedPill = new Array(isPillSelected.length).fill(false);
        updateSelectedPill[selectedCategoryIndex] = true;
        setIsPillSelected(updateSelectedPill);
        setCurrentLocalCategoryIndex(selectedCategoryIndex);
        setIsScrolled(true);
        var location = ((_refCategory_current_selectedCategoryIndex = refCategory.current[selectedCategoryIndex]) === null || _refCategory_current_selectedCategoryIndex === void 0 ? void 0 : _refCategory_current_selectedCategoryIndex.offsetTop) || 0;
        var categoriesHeight = ((_refSticky_current = refSticky.current) === null || _refSticky_current === void 0 ? void 0 : (_refSticky_current_offsetParent = _refSticky_current.offsetParent) === null || _refSticky_current_offsetParent === void 0 ? void 0 : _refSticky_current_offsetParent.clientHeight) || 0;
        refGallery === null || refGallery === void 0 ? void 0 : (_refGallery_current = refGallery.current) === null || _refGallery_current === void 0 ? void 0 : (_refGallery_current_offsetParent = _refGallery_current.offsetParent) === null || _refGallery_current_offsetParent === void 0 ? void 0 : _refGallery_current_offsetParent.scrollTo(0, location - categoriesHeight);
    }, [
        setCurrentLocalCategoryIndex,
        categories,
        track
    ]);
    var handleImageSelected = React19.useCallback(function(index) {
        if (currentLocalCategoryIndex) {
            var localCategory = categories === null || categories === void 0 ? void 0 : categories[currentLocalCategoryIndex];
            var _ref = localCategory || {}, categoryId = _ref.categoryId, tmp = _ref.images, localCategoryImages = tmp === void 0 ? [] : tmp;
            var _ref1 = localCategoryImages[index] || {}, image = _ref1.image, trackingId = _ref1.trackingId, imageId = _ref1.imageId;
            var thumbnailClickAnalytics = (image || {}).thumbnailClickAnalytics;
            var localCategoryImagesLength = localCategoryImages.length;
            track("HOT.HIS.ClickThumbnailImage.".concat(categoryId, ".").concat(index), "Launch Thumbnail Gallery From Image Click", void 0, additionalUisPrimeMicroMessages(index, trackingId, localCategoryImagesLength, imageId, propertyId, "PDP_FULL_IMAGE_GALLERY" /* PDP_FULL_IMAGE_GALLERY */ ));
            if (thumbnailClickAnalytics) {
                track(thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.referrerId, thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.linkName);
            }
            onImageClick(index, currentLocalCategoryIndex);
        } else {
            var _ref2 = images[index] || {}, image1 = _ref2.image, trackingId1 = _ref2.trackingId, imageId1 = _ref2.imageId;
            var thumbnailClickAnalytics1 = (image1 || {}).thumbnailClickAnalytics;
            track("HOT.HIS.ClickThumbnailImage.".concat(index), "Launch Thumbnail Gallery From Image Click", void 0, additionalUisPrimeMicroMessages(index, trackingId1, images.length, imageId1, propertyId, "PDP_FULL_IMAGE_GALLERY" /* PDP_FULL_IMAGE_GALLERY */ ));
            if (thumbnailClickAnalytics1) {
                track(thumbnailClickAnalytics1 === null || thumbnailClickAnalytics1 === void 0 ? void 0 : thumbnailClickAnalytics1.referrerId, thumbnailClickAnalytics1 === null || thumbnailClickAnalytics1 === void 0 ? void 0 : thumbnailClickAnalytics1.linkName);
            }
            onImageClick(index, currentLocalCategoryIndex);
        }
    }, [
        currentLocalCategoryIndex,
        onImageClick,
        categories,
        track,
        images
    ]);
    var thumbnailViewWithImageLabel = React19.useCallback(function(galleryImages, columns, categoryId) {
        return /* @__PURE__ */ React19.createElement(MediaGalleryThumbnailView, {
            imagesRatio: EGDSFigureAspectRatioType4.R16_9,
            images: galleryImages,
            onImageSelected: handleImageSelected,
            columns: columns,
            space: "three",
            focusIndex: imageIndex,
            propertyId: propertyId,
            categoryId: categoryId
        });
    }, [
        handleImageSelected,
        imageIndex
    ]);
    var multiLayoutImageView = React19.useCallback(function(galleryImages, categoryId) {
        return /* @__PURE__ */ React19.createElement(MultiImageLayoutView, {
            images: galleryImages,
            onImageSelected: handleImageSelected,
            propertyId: propertyId,
            categoryId: categoryId
        });
    }, [
        handleImageSelected,
        imageIndex,
        propertyId
    ]);
    var mediaGalleryThumbnailViewBody = React19.useCallback(function(galleryImages, title, categoryId, columns, headingSize, headingTag, indexCategory) {
        var hasSpacing = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : true;
        var selectedSection = indexCategory === currentLocalCategoryIndex;
        var body = /* @__PURE__ */ React19.createElement(React19.Fragment, null, title && /* @__PURE__ */ React19.createElement(EGDSSpacing8, {
            padding: {
                blockend: "three",
                small: {
                    inline: useMultiImageLayout ? "three" : "unset"
                },
                medium: {
                    inline: "unset"
                }
            }
        }, /* @__PURE__ */ React19.createElement(EGDSHeading4, {
            tag: headingTag,
            size: headingSize,
            id: "category-".concat(indexCategory)
        }, /* @__PURE__ */ React19.createElement("div", {
            ref: setRef(indexCategory)
        }, title))), useMultiImageLayout ? multiLayoutImageView(galleryImages, categoryId) : thumbnailViewWithImageLabel(galleryImages, columns, categoryId));
        if (selectedSection || useFallbackLogic) {
            if (hasSpacing || useCenteredSheet) {
                return /* @__PURE__ */ React19.createElement(EGDSSpacing8, {
                    padding: {
                        blockend: "three",
                        small: {
                            inline: useMultiImageLayout ? "unset" : "three"
                        },
                        medium: {
                            inline: "three"
                        }
                    }
                }, /* @__PURE__ */ React19.createElement("div", null, body));
            }
            return body;
        }
    }, [
        thumbnailViewWithImageLabel,
        useCenteredSheet,
        currentLocalCategoryIndex,
        multiLayoutImageView
    ]);
    var mediaGalleryThumbnailView = React19.useCallback(function(galleryImages, title, categoryId, indexCategory) {
        return /* @__PURE__ */ React19.createElement(Viewport6, null, /* @__PURE__ */ React19.createElement(ViewSmall6, null, mediaGalleryThumbnailViewBody(galleryImages, title, categoryId, 1, 4, "h4", indexCategory)), /* @__PURE__ */ React19.createElement(ViewMedium4, null, mediaGalleryThumbnailViewBody(galleryImages, title, categoryId, imageColumns, 3, "h3", indexCategory)), /* @__PURE__ */ React19.createElement(ViewLarge3, null, mediaGalleryThumbnailViewBody(galleryImages, title, categoryId, imageColumns, 3, "h3", indexCategory, false)));
    }, [
        mediaGalleryThumbnailViewBody
    ]);
    var pillContent = React19.useCallback(function(category, indexCategory) {
        var defaultPillView = mediaGalleryThumbnailView(toEGDSImagesWithThumbnailAnalytics(category.images, isPreviewImageUsed), category.name, category.categoryId, indexCategory);
        return defaultPillView;
    }, [
        mediaGalleryThumbnailView,
        useCenteredSheet,
        isPreviewImageUsed
    ]);
    var pillsContent = /* @__PURE__ */ React19.createElement(React19.Fragment, null, /* @__PURE__ */ React19.createElement(EGDSLayoutPosition5, {
        type: "sticky",
        position: {
            top: "zero",
            zindex: "layer2"
        },
        display: "block"
    }, /* @__PURE__ */ React19.createElement(EGDSSpacing8, {
        padding: {
            small: {
                block: "one",
                inline: "three"
            },
            medium: {
                block: "one",
                inline: "three"
            },
            large: useCenteredSheet ? {
                block: "three",
                inline: "three"
            } : {
                block: "three",
                inline: "unset"
            }
        }
    }, /* @__PURE__ */ React19.createElement(ViewRow, {
        canvasTheme: "primary",
        layout: "fullwidth",
        paddedViewRow: false,
        maxWidth: true
    }, /* @__PURE__ */ React19.createElement("div", {
        ref: refSticky
    }, /* @__PURE__ */ React19.createElement(EGDSScrollable, {
        direction: "horizontal"
    }, /* @__PURE__ */ React19.createElement(EGDSSpacing8, {
        padding: {
            small: {
                block: "three"
            },
            medium: {
                block: "three"
            },
            large: {
                block: "one"
            }
        }
    }, /* @__PURE__ */ React19.createElement(EGDSLayoutPosition5, {
        type: "relative"
    }, /* @__PURE__ */ React19.createElement(EGDSLayoutFlex7, null, categories === null || categories === void 0 ? void 0 : categories.map(function(category, i) {
        var imageLength = category.images.length;
        var pillText = showImageNumber ? "".concat(category === null || category === void 0 ? void 0 : category.name, " (").concat(imageLength, ")") : category === null || category === void 0 ? void 0 : category.name;
        return /* @__PURE__ */ React19.createElement(EGDSPill, {
            key: "thumbail-gallery-pill-".concat(i),
            id: "thumbail-gallery-pill-".concat(i),
            checked: isPillSelected[i],
            onChange: function() {
                return handlePillSelect(i);
            },
            value: category === null || category === void 0 ? void 0 : category.name,
            altText: pillText
        }, pillText);
    }))))))))), isSmallView ? /* @__PURE__ */ React19.createElement(EGDSLayoutGrid4, {
        blockSize: "85vb"
    }, /* @__PURE__ */ React19.createElement(EGDSScrollable, {
        direction: "vertical"
    }, /* @__PURE__ */ React19.createElement("div", {
        ref: refContent,
        style: {
            height: "1px"
        }
    }), categories === null || categories === void 0 ? void 0 : categories.map(function(category, i) {
        return pillContent(category, i);
    }))) : categories === null || categories === void 0 ? void 0 : categories.map(function(category, i) {
        return pillContent(category, i);
    }));
    if (useFallbackLogic) {
        return mediaGalleryThumbnailView(toEGDSImagesWithThumbnailAnalytics(images, isPreviewImageUsed));
    }
    if (useCenteredSheet) {
        return /* @__PURE__ */ React19.createElement(React19.Fragment, null, /* @__PURE__ */ React19.createElement("div", {
            ref: refTop
        }), /* @__PURE__ */ React19.createElement(EGDSLayoutPosition5, {
            type: "sticky",
            position: {
                top: "zero",
                zindex: "layer2"
            },
            cloneElement: true
        }, pillsContent));
    }
    return pillsContent;
};
// src/components/gallery/__private/__fragments/dialogs/thumbnail-gallery-dialog.tsx
var __ThumbnailGalleryDialogFragment = gql12(_templateObject11());
var ThumbnailGalleryDialog = function(props) {
    var _primaryButton_button, _primaryButton_button1, _primaryButton_button2, _thumbnailGalleryDialog_toolbar_icon, _thumbnailGalleryDialog_toolbar, _thumbnailGalleryDialog_toolbar_icon1, _thumbnailGalleryDialog_toolbar1, _thumbnailGalleryDialog_toolbar2, _thumbnailGalleryDialog_toolbar_icon2, _thumbnailGalleryDialog_toolbar3, _thumbnailGalleryDialog_toolbar_icon3, _thumbnailGalleryDialog_toolbar4, _thumbnailGalleryDialog_toolbar5, _categories_find;
    var data = props.data, isDialogOpen = props.isDialogOpen, onDialogDismiss = props.onDialogDismiss, onImageClick = props.onImageClick, categoryIndexState = props.categoryIndexState, imageIndexState = props.imageIndexState, triggerRef = props.triggerRef, propertyId = props.propertyId;
    var categories = data.categories, thumbnailGalleryDialog = data.thumbnailGalleryDialog, images = data.images, primaryButton = data.primaryButton;
    var targetRef = (primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.__typename) === "PropertyLodgingStickyButton" && primaryButton.propertyTargetRef || "";
    var buttonText = primaryButton === null || primaryButton === void 0 ? void 0 : (_primaryButton_button = primaryButton.button) === null || _primaryButton_button === void 0 ? void 0 : _primaryButton_button.text;
    var accessibilityLabel = (primaryButton === null || primaryButton === void 0 ? void 0 : (_primaryButton_button1 = primaryButton.button) === null || _primaryButton_button1 === void 0 ? void 0 : _primaryButton_button1.accessibilityLabel) || void 0;
    var primaryButtonAnalytics = primaryButton === null || primaryButton === void 0 ? void 0 : (_primaryButton_button2 = primaryButton.button) === null || _primaryButton_button2 === void 0 ? void 0 : _primaryButton_button2.analytics;
    var _React20_useState = _sliced_to_array(React20.useState(false), 2), isScrolled = _React20_useState[0], setIsScrolled = _React20_useState[1];
    var exposure = useExperiment7("Wider_centred_sheet_for_the_image_gallery").exposure;
    var _useExperiment7 = useExperiment7("Add_reserve_button_in_the_image_gallery_Web", true), reserveButtonExposure = _useExperiment7.exposure;
    var scrollTo = useRefTargetScroll2().scrollTo;
    var getTargets = useRefContext().getTargets;
    var _getTargets = getTargets([
        targetRef
    ]), offersRef = _getTargets.Offers;
    var refGallery = React20.useRef(null);
    var track = useClickTracker8();
    var toolbarAnalytics = {
        id: "HOT.HIS.PhotoGalleryTrigger",
        description: "Close thumbnail gallery dialog",
        callback: function(id, desc) {
            return track(id, desc);
        }
    };
    var trackReserveButtonClick = function() {
        var _ref = primaryButtonAnalytics || {}, linkName = _ref.linkName, referrerId = _ref.referrerId;
        if (linkName && referrerId) {
            var thumbnailReferrerId = "".concat(referrerId, ".Thumbnail_Gallery");
            track(thumbnailReferrerId, linkName);
        }
    };
    var _useInView = useInView({
        threshold: 0
    }), ref = _useInView.ref, inView = _useInView.inView, entry = _useInView.entry;
    React20.useEffect(function() {
        if (!inView && (entry === null || entry === void 0 ? void 0 : entry.target)) {
            setIsScrolled(true);
        }
    }, [
        inView
    ]);
    var onReserveButtonClick = function() {
        trackReserveButtonClick();
        setTimeout(function() {
            onDialogDismiss();
            setTimeout(function() {
                if (targetRef) {
                    scrollTo(targetRef, [
                        {
                            sectionName: "navigation"
                        }
                    ]);
                    setTimeout(function() {
                        var _offersRef_current;
                        offersRef === null || offersRef === void 0 ? void 0 : (_offersRef_current = offersRef.current) === null || _offersRef_current === void 0 ? void 0 : _offersRef_current.focus({
                            preventScroll: true
                        });
                    }, 300);
                }
            }, 500);
        }, 300);
    };
    var toolbarComponentSmalllViewport = thumbnailGalleryDialog && /* @__PURE__ */ React20.createElement(EGDSToolbar3, {
        navigationContent: {
            onClick: onDialogDismiss,
            onClickAnalytics: toolbarAnalytics,
            navType: (_thumbnailGalleryDialog_toolbar = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar === void 0 ? void 0 : (_thumbnailGalleryDialog_toolbar_icon = _thumbnailGalleryDialog_toolbar.icon) === null || _thumbnailGalleryDialog_toolbar_icon === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar_icon.iconId,
            navIconLabel: (_thumbnailGalleryDialog_toolbar1 = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar1 === void 0 ? void 0 : (_thumbnailGalleryDialog_toolbar_icon1 = _thumbnailGalleryDialog_toolbar1.icon) === null || _thumbnailGalleryDialog_toolbar_icon1 === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar_icon1.description
        },
        toolbarTitle: ((_thumbnailGalleryDialog_toolbar2 = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar2 === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar2.title) || ""
    });
    var toolbarComponent = thumbnailGalleryDialog && /* @__PURE__ */ React20.createElement(EGDSToolbar3, {
        navigationContent: {
            onClick: onDialogDismiss,
            onClickAnalytics: toolbarAnalytics,
            navType: (_thumbnailGalleryDialog_toolbar3 = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar3 === void 0 ? void 0 : (_thumbnailGalleryDialog_toolbar_icon2 = _thumbnailGalleryDialog_toolbar3.icon) === null || _thumbnailGalleryDialog_toolbar_icon2 === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar_icon2.iconId,
            navIconLabel: (_thumbnailGalleryDialog_toolbar4 = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar4 === void 0 ? void 0 : (_thumbnailGalleryDialog_toolbar_icon3 = _thumbnailGalleryDialog_toolbar4.icon) === null || _thumbnailGalleryDialog_toolbar_icon3 === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar_icon3.description
        },
        toolbarTitle: ((_thumbnailGalleryDialog_toolbar5 = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar5 === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar5.title) || "",
        toolbarActionContent: reserveButtonExposure.bucket !== 0 && /* @__PURE__ */ React20.createElement(UitkPrimaryButton, {
            "aria-label": accessibilityLabel,
            onClick: onReserveButtonClick
        }, /* @__PURE__ */ React20.createElement(UitkText, {
            whiteSpace: "nowrap",
            theme: "light"
        }, buttonText))
    });
    var sheetProps = {
        returnFocusOnClose: true,
        isVisible: isDialogOpen,
        triggerRef: triggerRef
    };
    var pillsCategories = function(isSmallView) {
        return /* @__PURE__ */ React20.createElement(ThumbnailGalleryPills, {
            categories: categories,
            images: images,
            useCenteredSheet: exposure.bucket !== 0,
            onImageClick: onImageClick,
            categoryIndexState: categoryIndexState,
            imageIndexState: imageIndexState,
            propertyId: propertyId,
            showImageNumber: true,
            refGallery: refGallery,
            isSmallView: isSmallView,
            setIsScrolled: setIsScrolled,
            refContent: ref
        });
    };
    var sheetContent = function(isSmallView) {
        return /* @__PURE__ */ React20.createElement(React20.Fragment, null, /* @__PURE__ */ React20.createElement(Viewport7, null, /* @__PURE__ */ React20.createElement(ViewSmall7, null, /* @__PURE__ */ React20.createElement(React20.Fragment, null, toolbarComponentSmalllViewport)), /* @__PURE__ */ React20.createElement(ViewMedium5, null, /* @__PURE__ */ React20.createElement(Experiment2, {
            name: "Wider_centred_sheet_for_the_image_gallery"
        }, /* @__PURE__ */ React20.createElement(ExperimentControl2, null, /* @__PURE__ */ React20.createElement(React20.Fragment, null, toolbarComponent)), /* @__PURE__ */ React20.createElement(ExperimentVariant2, {
            bucket: 1
        }, /* @__PURE__ */ React20.createElement(UitkLayoutPosition, {
            type: "sticky",
            position: {
                top: "zero",
                zindex: "layer2"
            }
        }, /* @__PURE__ */ React20.createElement(React20.Fragment, null, toolbarComponent))), /* @__PURE__ */ React20.createElement(ExperimentVariant2, {
            bucket: 2
        }, /* @__PURE__ */ React20.createElement(UitkLayoutPosition, {
            type: "sticky",
            position: {
                top: "zero",
                zindex: "layer2"
            }
        }, /* @__PURE__ */ React20.createElement(React20.Fragment, null, toolbarComponent)))))), /* @__PURE__ */ React20.createElement(EGDSSheetContent2, {
            padded: false
        }, /* @__PURE__ */ React20.createElement("div", {
            ref: refGallery
        }, pillsCategories(isSmallView))));
    };
    var fullScreenDialog = /* @__PURE__ */ React20.createElement(EGDSSheet3, {
        type: "full",
        isVisible: isDialogOpen,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, toolbarComponent, /* @__PURE__ */ React20.createElement(EGDSSpacing9, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React20.createElement(EGDSSheetContent2, {
        padded: false
    }, /* @__PURE__ */ React20.createElement(EGDSLayoutFlex8, {
        justifyContent: "center"
    }, /* @__PURE__ */ React20.createElement(EGDSLayoutFlexItem5, {
        maxWidth: "312x",
        grow: 1
    }, /* @__PURE__ */ React20.createElement("div", {
        ref: refGallery
    }, pillsCategories(false)))))));
    var firstCategorySingleImage = (categories === null || categories === void 0 ? void 0 : (_categories_find = categories.find(function(category) {
        return category.categoryId === "all";
    })) === null || _categories_find === void 0 ? void 0 : _categories_find.images.length) === 1;
    var showReserveButton = isScrolled || firstCategorySingleImage;
    var addReserveButton = /* @__PURE__ */ React20.createElement(Experiment2, {
        name: "Add_reserve_button_in_the_image_gallery_Web"
    }, /* @__PURE__ */ React20.createElement(ExperimentControl2, null), /* @__PURE__ */ React20.createElement(ExperimentVariant2, {
        bucket: 1
    }, showReserveButton && /* @__PURE__ */ React20.createElement(UitkScrim, {
        type: UitkScrimType.BUTTON
    }, /* @__PURE__ */ React20.createElement(UitkFloatingFullWidthButton, {
        isFullWidth: true,
        onClick: onReserveButtonClick,
        "aria-label": accessibilityLabel
    }, buttonText))), /* @__PURE__ */ React20.createElement(ExperimentVariant2, {
        bucket: 2
    }, /* @__PURE__ */ React20.createElement(UitkSpacing, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React20.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: {
            bottom: "six",
            left: "center",
            zindex: "layer1"
        }
    }, /* @__PURE__ */ React20.createElement(UitkFloatingButton, {
        onClick: onReserveButtonClick,
        "aria-label": accessibilityLabel
    }, buttonText)))));
    return /* @__PURE__ */ React20.createElement(Viewport7, null, /* @__PURE__ */ React20.createElement(ViewSmall7, null, /* @__PURE__ */ React20.createElement(EGDSSheet3, _object_spread_props(_object_spread({}, sheetProps), {
        type: "full"
    }), sheetContent(true), addReserveButton)), /* @__PURE__ */ React20.createElement(ViewMedium5, null, /* @__PURE__ */ React20.createElement(Experiment2, {
        name: "Wider_centred_sheet_for_the_image_gallery"
    }, /* @__PURE__ */ React20.createElement(ExperimentControl2, null, fullScreenDialog), /* @__PURE__ */ React20.createElement(ExperimentVariant2, {
        bucket: 1
    }, /* @__PURE__ */ React20.createElement(SheetCenteredLarge, _object_spread_props(_object_spread({}, sheetProps), {
        centeredSheetSize: "xxxlarge",
        height: 1200
    }), sheetContent(false))), /* @__PURE__ */ React20.createElement(ExperimentVariant2, {
        bucket: 2
    }, /* @__PURE__ */ React20.createElement(SheetCenteredLarge, _object_spread_props(_object_spread({}, sheetProps), {
        centeredSheetSize: "xxxlarge",
        height: 1200
    }), sheetContent(false))))));
};
ThumbnailGalleryDialog.displayName = "ThumbnailGalleryDialog";
ThumbnailGalleryDialog.fragment = __ThumbnailGalleryDialogFragment;
// src/components/gallery/property-image-gallery.tsx
var __PropertyImageGalleryFragment = gql13(_templateObject12(), MosaicContainer.fragment, CarouselContainer.fragment, MediaGalleryDialog.fragment, ThumbnailGalleryDialog.fragment);
var PropertyImageGallery = function(param) {
    var data = param.data, propertyId = param.propertyId, className = param.className;
    var _data_thumbnailGalleryDialog_trigger, _data_thumbnailGalleryDialog, _data_thumbnailGalleryDialog_trigger1, _data_thumbnailGalleryDialog1, _data_images;
    var _useDialog = _sliced_to_array(useDialog("media-gallery", "pwaDialogNested"), 3), isMediaGalleryDialogOpen = _useDialog[0], mediaGalleryDialogActions = _useDialog[1], MediaGalleryDialogWrapper = _useDialog[2];
    var _useDialog1 = _sliced_to_array(useDialog("thumbnail-gallery", "pwaThumbnailDialog"), 3), isThumbnailGalleryDialogOpen = _useDialog1[0], thumbnailGalleryDialogActions = _useDialog1[1], ThumbnailGalleryDialogWrapper = _useDialog1[2];
    var _useDialog2 = _sliced_to_array(useDialog("aerial-view", "pwaAerialDialog"), 3), isAerialViewDialogOpen = _useDialog2[0], aerialViewDialogActions = _useDialog2[1], AerialViewDialogWrapper = _useDialog2[2];
    var triggerBtn = React21.useRef(null);
    var triggerImageBtn = React21.useRef(null);
    var imageIndexState = React21.useState(0);
    var categoryIndexState = React21.useState(-1);
    var categoryImageIndexState = React21.useState(0);
    var _imageIndexState = _sliced_to_array(imageIndexState, 2), setImageIndex = _imageIndexState[1];
    var _categoryIndexState = _sliced_to_array(categoryIndexState, 2), setCategoryIndex = _categoryIndexState[1];
    var _categoryImageIndexState = _sliced_to_array(categoryImageIndexState, 2), setCategoryImageIndex = _categoryImageIndexState[1];
    var _React21_useState = _sliced_to_array(React21.useState(""), 2), aerialViewUrl = _React21_useState[0], setAerialViewState = _React21_useState[1];
    var onMosaicImageClick = React21.useCallback(function(index) {
        setImageIndex(index);
        setCategoryIndex(-1);
        triggerBtn.current = document.activeElement;
        thumbnailGalleryDialogActions.openDialog();
    }, [
        mediaGalleryDialogActions,
        thumbnailGalleryDialogActions,
        setCategoryIndex,
        setImageIndex
    ]);
    var onVirtualTourClick = React21.useCallback(function(imageResource) {
        if (typeof window !== "undefined") {
            window.open(imageResource);
        }
    }, []);
    var onAerialViewClick = React21.useCallback(function() {
        var _ref = _async_to_generator(function(videoId) {
            return _ts_generator(this, function(_state) {
                if (!aerialViewUrl) {
                    fetchAerialViewVideo(videoId).then(function(aerialViewResponse) {
                        var _aerialViewResponse_uris;
                        if (aerialViewResponse === null || aerialViewResponse === void 0 ? void 0 : (_aerialViewResponse_uris = aerialViewResponse.uris) === null || _aerialViewResponse_uris === void 0 ? void 0 : _aerialViewResponse_uris.MP4_MEDIUM) {
                            setAerialViewState(aerialViewResponse.uris.MP4_MEDIUM.landscapeUri);
                        } else {
                            setAerialViewState("error");
                        }
                    });
                }
                aerialViewDialogActions.openDialog();
                return [
                    2
                ];
            });
        });
        return function(videoId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        aerialViewDialogActions,
        setAerialViewState
    ]);
    var onCarouselImageClick = React21.useCallback(function() {
        setCategoryIndex(-1);
        thumbnailGalleryDialogActions.openDialog();
    }, [
        mediaGalleryDialogActions,
        thumbnailGalleryDialogActions,
        setCategoryIndex
    ]);
    var onThumbnailImageClick = React21.useCallback(function(index, categoryIndex) {
        triggerImageBtn.current = document.activeElement;
        setCategoryIndex(categoryIndex);
        setCategoryImageIndex(index);
        if (categoryIndex < 0) {
            setImageIndex(index);
        }
        mediaGalleryDialogActions.openDialog();
    }, [
        setCategoryIndex,
        setCategoryImageIndex,
        mediaGalleryDialogActions,
        setImageIndex
    ]);
    var onOpenThumbnailGalleryDialog = React21.useCallback(function() {
        var activeEl = document.activeElement;
        triggerBtn.current = activeEl;
        setImageIndex(0);
        thumbnailGalleryDialogActions.openDialog();
    }, [
        thumbnailGalleryDialogActions,
        setImageIndex
    ]);
    var onDialogDismiss = React21.useCallback(function() {
        thumbnailGalleryDialogActions.closeDialog();
        setTimeout(function() {
            var _triggerBtn_current;
            (_triggerBtn_current = triggerBtn.current) === null || _triggerBtn_current === void 0 ? void 0 : _triggerBtn_current.focus();
        }, 0);
    }, [
        thumbnailGalleryDialogActions
    ]);
    var onMediaDialogDismiss = React21.useCallback(function() {
        mediaGalleryDialogActions.closeDialog();
        setTimeout(function() {
            var _triggerImageBtn_current;
            (_triggerImageBtn_current = triggerImageBtn.current) === null || _triggerImageBtn_current === void 0 ? void 0 : _triggerImageBtn_current.focus();
        }, 0);
    }, [
        mediaGalleryDialogActions
    ]);
    var onAerialDialogDismiss = React21.useCallback(function() {
        aerialViewDialogActions.closeDialog();
        setTimeout(function() {
            var _triggerBtn_current;
            (_triggerBtn_current = triggerBtn.current) === null || _triggerBtn_current === void 0 ? void 0 : _triggerBtn_current.focus();
        });
    }, [
        aerialViewDialogActions
    ]);
    var controlProps = {
        imageIndexState: imageIndexState,
        categoryImageIndexState: categoryImageIndexState,
        categoryIndexState: categoryIndexState
    };
    var containerProps = _object_spread({
        onTriggerClick: onOpenThumbnailGalleryDialog,
        thumbnailDialogTriggerTitle: data === null || data === void 0 ? void 0 : (_data_thumbnailGalleryDialog = data.thumbnailGalleryDialog) === null || _data_thumbnailGalleryDialog === void 0 ? void 0 : (_data_thumbnailGalleryDialog_trigger = _data_thumbnailGalleryDialog.trigger) === null || _data_thumbnailGalleryDialog_trigger === void 0 ? void 0 : _data_thumbnailGalleryDialog_trigger.value,
        thumbnailDialogTriggerAccessibilityLabel: data === null || data === void 0 ? void 0 : (_data_thumbnailGalleryDialog1 = data.thumbnailGalleryDialog) === null || _data_thumbnailGalleryDialog1 === void 0 ? void 0 : (_data_thumbnailGalleryDialog_trigger1 = _data_thumbnailGalleryDialog1.trigger) === null || _data_thumbnailGalleryDialog_trigger1 === void 0 ? void 0 : _data_thumbnailGalleryDialog_trigger1.accessibilityLabel
    }, controlProps);
    if (!(data === null || data === void 0 ? void 0 : (_data_images = data.images) === null || _data_images === void 0 ? void 0 : _data_images.length)) {
        return null;
    }
    return /* @__PURE__ */ React21.createElement("div", {
        className: className
    }, /* @__PURE__ */ React21.createElement(Viewport8, null, /* @__PURE__ */ React21.createElement(ViewSmall8, null, /* @__PURE__ */ React21.createElement(CarouselContainer, _object_spread_props(_object_spread({
        data: data,
        onVirtualTourClick: onVirtualTourClick,
        onAerialViewClick: onAerialViewClick,
        onImageClick: onCarouselImageClick
    }, containerProps), {
        onTriggerClick: onOpenThumbnailGalleryDialog,
        propertyId: propertyId
    }))), /* @__PURE__ */ React21.createElement(ViewMedium6, null, /* @__PURE__ */ React21.createElement(MosaicContainer, _object_spread_props(_object_spread({
        data: data,
        onVirtualTourClick: onVirtualTourClick,
        onAerialViewClick: onAerialViewClick,
        onImageClick: function(index) {
            return onMosaicImageClick(index);
        },
        imagesToShow: 3
    }, containerProps), {
        onTriggerClick: onOpenThumbnailGalleryDialog,
        propertyId: propertyId
    }))), /* @__PURE__ */ React21.createElement(ViewLarge4, null, /* @__PURE__ */ React21.createElement(MosaicContainer, _object_spread_props(_object_spread({
        data: data,
        onVirtualTourClick: onVirtualTourClick,
        onAerialViewClick: onAerialViewClick,
        onImageClick: function(index) {
            return onMosaicImageClick(index);
        },
        imagesToShow: 5
    }, containerProps), {
        onTriggerClick: onOpenThumbnailGalleryDialog,
        propertyId: propertyId
    })))), /* @__PURE__ */ React21.createElement(EGDSSheetTransition2, {
        isVisible: isThumbnailGalleryDialogOpen
    }, /* @__PURE__ */ React21.createElement(ThumbnailGalleryDialogWrapper, null, /* @__PURE__ */ React21.createElement(ThumbnailGalleryDialog, _object_spread({
        data: data,
        isDialogOpen: isThumbnailGalleryDialogOpen,
        onDialogDismiss: onDialogDismiss,
        onImageClick: onThumbnailImageClick,
        triggerRef: triggerBtn,
        propertyId: propertyId
    }, controlProps)))), /* @__PURE__ */ React21.createElement(EGDSSheetTransition2, {
        isVisible: isMediaGalleryDialogOpen
    }, /* @__PURE__ */ React21.createElement(MediaGalleryDialogWrapper, null, /* @__PURE__ */ React21.createElement(MediaGalleryDialog, _object_spread({
        data: data,
        isDialogOpen: isMediaGalleryDialogOpen,
        onDialogDismiss: onMediaDialogDismiss,
        propertyId: propertyId
    }, controlProps)))), /* @__PURE__ */ React21.createElement(EGDSSheetTransition2, {
        isVisible: isAerialViewDialogOpen
    }, /* @__PURE__ */ React21.createElement(AerialViewDialogWrapper, null, /* @__PURE__ */ React21.createElement(AerialViewDialog, {
        isDialogOpen: isAerialViewDialogOpen,
        onDialogDismiss: onAerialDialogDismiss,
        triggerRef: triggerBtn,
        aerialViewLandscape: aerialViewUrl
    }))));
};
PropertyImageGallery.displayName = "sharedui-PropertyImageGallery";
PropertyImageGallery.fragment = __PropertyImageGalleryFragment;
// src/components/summary/__private/__fragments/map-trigger/index.tsx
import React24, { useState as useState2 } from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSFigure as EGDSFigure3, EGDSImage as EGDSImage3, EGDSImageLink as EGDSImageLink3 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex10 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { VideoPlayer as VideoPlayer2 } from "@egds/react-property-experience";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { defaultCloseMapDialogPropBuilder, MapTrigger } from "@shared-ui/lodging-fragments";
import { UitkButtonSize as UitkButtonSize2 } from "uitk-react-button";
var _obj2;
// src/components/summary/analytics.ts
var SummaryAnalyticsMapping = (_obj2 = {}, _define_property(_obj2, "REVIEWS" /* REVIEWS */ , [
    "HOT.HIS.UGC.ViewAllResults",
    "Display detailed reviews"
]), _define_property(_obj2, "AMENITIES" /* AMENITIES */ , [
    "HOT.HIS.ViewAllAmenities",
    "View all amenities"
]), _define_property(_obj2, "MAP_IMAGE" /* MAP_IMAGE */ , [
    "HOT.HIS.Map.StaticMap",
    "Click static map"
]), _define_property(_obj2, "MAP_LINK" /* MAP_LINK */ , [
    "HOT.HIS.ClickAddressCTALinkViewMap",
    "ClickAddressCTALinkViewMap"
]), _define_property(_obj2, "CLEANING_AND_SAFETY_LINK" /* CLEANING_AND_SAFETY_LINK */ , [
    "HOT.HIS.ViewAllCleanliness",
    "Click on see all cleanliness link"
]), _define_property(_obj2, "NEAR_BY_POIS_LINK" /* NEAR_BY_POIS_LINK */ , [
    "HOT.HIS.SeeMoreLocationDetails",
    "See more location details"
]), _obj2);
var chatbotAnalyticsSchema = function(chatbotEntryPoint, chatbotName, propertyId) {
    return {
        schemaName: "chatbot",
        messageContent: {
            chatbotEntryPoint: chatbotEntryPoint,
            chatbotName: chatbotName,
            propertyId: propertyId
        }
    };
};
// src/components/summary/__private/__fragments/near-by-pois/heading.tsx
import React22 from "react";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading5 } from "@egds/react-core/text";
import { useExperiment as useExperiment8 } from "@shared-ui/experiment-context";
var POIHeadingComponent = function(param) {
    var heading = param.heading;
    var _useExperiment8_exposure = useExperiment8("PDP_MODULARISED_LOCATION_SECTION").exposure, isShowingModularisedSection = _useExperiment8_exposure.bucket;
    return /* @__PURE__ */ React22.createElement(EGDSSpacing10, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React22.createElement(EGDSHeading5, {
        tag: isShowingModularisedSection ? "h2" : "h3",
        size: isShowingModularisedSection ? 4 : 5
    }, heading));
};
POIHeadingComponent.displayName = "POIHeadingComponent";
// src/components/summary/__private/__fragments/map-trigger/address.tsx
import React23 from "react";
import { gql as gql14 } from "@apollo/client";
import { EGDSIcon as EGDSIcon5 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";
var __AddressFragment = gql14(_templateObject13());
var Schema = function(param) {
    var coordinates = param.coordinates;
    var latitude = String(coordinates === null || coordinates === void 0 ? void 0 : coordinates.latitude);
    var longitude = String(coordinates === null || coordinates === void 0 ? void 0 : coordinates.longitude);
    return /* @__PURE__ */ React23.createElement("div", {
        itemProp: "geo",
        itemScope: true,
        itemType: "http://schema.org/GeoCoordinates"
    }, /* @__PURE__ */ React23.createElement("meta", {
        itemProp: "latitude",
        content: latitude
    }), /* @__PURE__ */ React23.createElement("meta", {
        itemProp: "longitude",
        content: longitude
    }));
};
Schema.displayName = "Schema";
var Address = function(param) {
    var data = param.data, onClick = param.onClick;
    var _data_address, _data_mapDialog_trigger, _data_mapDialog, _data_address1, _data_address2, _data_address3, _data_address4, _data_mapDialog_trigger_icon, _data_mapDialog_trigger1, _data_mapDialog1;
    var addressLine = (_data_address = data.address) === null || _data_address === void 0 ? void 0 : _data_address.addressLine;
    var triggerLabel = (_data_mapDialog = data.mapDialog) === null || _data_mapDialog === void 0 ? void 0 : (_data_mapDialog_trigger = _data_mapDialog.trigger) === null || _data_mapDialog_trigger === void 0 ? void 0 : _data_mapDialog_trigger.value;
    var city = ((_data_address1 = data.address) === null || _data_address1 === void 0 ? void 0 : _data_address1.city) || void 0;
    var countryCode = ((_data_address2 = data.address) === null || _data_address2 === void 0 ? void 0 : _data_address2.countryCode) || void 0;
    var province = ((_data_address3 = data.address) === null || _data_address3 === void 0 ? void 0 : _data_address3.province) || void 0;
    var streetAddress = ((_data_address4 = data.address) === null || _data_address4 === void 0 ? void 0 : _data_address4.firstAddressLine) || void 0;
    var triggerIcon = ((_data_mapDialog1 = data.mapDialog) === null || _data_mapDialog1 === void 0 ? void 0 : (_data_mapDialog_trigger1 = _data_mapDialog1.trigger) === null || _data_mapDialog_trigger1 === void 0 ? void 0 : (_data_mapDialog_trigger_icon = _data_mapDialog_trigger1.icon) === null || _data_mapDialog_trigger_icon === void 0 ? void 0 : _data_mapDialog_trigger_icon.iconId) || "";
    return /* @__PURE__ */ React23.createElement(EGDSSpacing11, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React23.createElement(EGDSLayoutFlex9, {
        wrap: "wrap"
    }, /* @__PURE__ */ React23.createElement(EGDSLayoutFlexItem6, {
        minWidth: "full_width"
    }, /* @__PURE__ */ React23.createElement(EGDSText6, {
        "data-stid": "content-hotel-address"
    }, /* @__PURE__ */ React23.createElement("div", {
        itemProp: "address",
        itemScope: true,
        itemType: "http://schema.org/PostalAddress"
    }, /* @__PURE__ */ React23.createElement("meta", {
        itemProp: "name",
        content: city
    }), /* @__PURE__ */ React23.createElement("meta", {
        itemProp: "addressRegion",
        content: province
    }), /* @__PURE__ */ React23.createElement("meta", {
        itemProp: "streetAddress",
        content: streetAddress
    }), /* @__PURE__ */ React23.createElement("meta", {
        itemProp: "addressCountry",
        content: countryCode
    })), addressLine)), /* @__PURE__ */ React23.createElement(Schema, _object_spread({}, data)), triggerLabel && /* @__PURE__ */ React23.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */ React23.createElement(EGDSSpacing11, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React23.createElement(EGDSLink, {
        onClick: onClick && onClick
    }, /* @__PURE__ */ React23.createElement("button", {
        type: "button"
    }, triggerLabel, /* @__PURE__ */ React23.createElement(EGDSIcon5, {
        name: triggerIcon
    })))))));
};
Address.displayName = "Address";
Address.fragment = __AddressFragment;
// src/components/summary/__private/__fragments/map-trigger/index.tsx
var __SummaryMapTriggerFragment = gql15(_templateObject14(), Address.fragment, MapTrigger.fragment);
var SummaryMapTrigger = function(param) {
    var data = param.data, onClickMap = param.onClickMap, className = param.className, aspectRatio = param.aspectRatio, _param_spacing = param.spacing, spacing = _param_spacing === void 0 ? {} : _param_spacing, _param_mapDialogId = param.mapDialogId, mapDialogId = _param_mapDialogId === void 0 ? "property-summary-map" : _param_mapDialogId, _param_mapDialogQueryKey = param.mapDialogQueryKey, mapDialogQueryKey = _param_mapDialogQueryKey === void 0 ? "pwaOverlay" : _param_mapDialogQueryKey, children = param.children;
    var _data_summary, _data_summary_nearbyPOIs, _data_summary1;
    var mapTriggerRef = React24.useRef(null);
    var track = useClickTracker9();
    var createHandlerClick = React24.useCallback(function(summaryEvent) {
        return function(event) {
            event.preventDefault();
            var _SummaryAnalyticsMapping_summaryEvent = _sliced_to_array(SummaryAnalyticsMapping[summaryEvent], 2), id = _SummaryAnalyticsMapping_summaryEvent[0], description2 = _SummaryAnalyticsMapping_summaryEvent[1];
            track(id, description2, true);
            onClickMap();
        };
    }, [
        onClickMap,
        track
    ]);
    var handleAerialAnalytics = React24.useCallback(function(summaryEvent) {
        return function(event) {
            event.preventDefault();
            if (video === null || video === void 0 ? void 0 : video[summaryEvent]) {
                track(video[summaryEvent].referrerId, video[summaryEvent].linkName);
            }
        };
    }, [
        track
    ]);
    var location = data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.location;
    var _ref = location || {}, staticImage = _ref.staticImage, mapTrigger = _ref.mapTrigger, video = _ref.video;
    var _ref1 = video || {}, videoUrl = _ref1.url, thumbnail = _ref1.thumbnail;
    var _useState2 = _sliced_to_array(useState2(!!videoUrl), 2), showAerialMap = _useState2[0], setShowAerialMap = _useState2[1];
    if (!location || !staticImage && !mapTrigger || !data.id) {
        return null;
    }
    var _ref2 = staticImage || {}, url = _ref2.url, description = _ref2.description;
    var nearbyPOIHeading = data === null || data === void 0 ? void 0 : (_data_summary1 = data.summary) === null || _data_summary1 === void 0 ? void 0 : (_data_summary_nearbyPOIs = _data_summary1.nearbyPOIs) === null || _data_summary_nearbyPOIs === void 0 ? void 0 : _data_summary_nearbyPOIs.heading;
    var handleError = function() {
        setShowAerialMap(false);
    };
    var renderAerialMap = /* @__PURE__ */ React24.createElement(React24.Fragment, null, videoUrl && /* @__PURE__ */ React24.createElement(EGDSSpacing12, _object_spread({}, spacing), /* @__PURE__ */ React24.createElement(EGDSFigure3, {
        ratio: aspectRatio,
        className: "uitk-card-roundcorner-all"
    }, /* @__PURE__ */ React24.createElement(VideoPlayer2, {
        thumbnail: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.value,
        src: videoUrl.value,
        onError: handleError,
        autoplay: true,
        loop: true,
        showDefaultControls: false,
        controlButtonSize: UitkButtonSize2.LARGE,
        autoplayInView: true,
        onPlay: handleAerialAnalytics("playPauseAnalytics" /* AERIAL_MAP_PLAY_PAUSE */ ),
        onPause: handleAerialAnalytics("playPauseAnalytics" /* AERIAL_MAP_PLAY_PAUSE */ ),
        showLoader: false,
        showScrim: true
    }), /* @__PURE__ */ React24.createElement(EGDSImageLink3, null, /* @__PURE__ */ React24.createElement("button", {
        type: "button",
        onClick: handleAerialAnalytics("thumbnailClickAnalytics" /* AERIAL_MAP_THUMBNAIL */ )
    }, description)))));
    var map = children !== null && children !== void 0 ? children : /* @__PURE__ */ React24.createElement(Map, {
        inputs: {
            propertyId: data.id
        },
        triggerRef: mapTriggerRef
    });
    var renderMapTrigger = /* @__PURE__ */ React24.createElement(React24.Fragment, null, mapTrigger && /* @__PURE__ */ React24.createElement(EGDSSpacing12, _object_spread({}, spacing), /* @__PURE__ */ React24.createElement(MapTrigger, {
        address: location === null || location === void 0 ? void 0 : location.address,
        data: mapTrigger,
        dialogId: mapDialogId,
        dialogQueryKey: mapDialogQueryKey,
        triggerRef: mapTriggerRef,
        closeMapDialogPropBuilder: defaultCloseMapDialogPropBuilder,
        useMapPreview: true,
        video: video
    }, map)));
    var renderStaticImage = /* @__PURE__ */ React24.createElement(EGDSSpacing12, _object_spread({}, spacing), /* @__PURE__ */ React24.createElement(EGDSFigure3, {
        ratio: aspectRatio,
        className: "uitk-card-roundcorner-all"
    }, /* @__PURE__ */ React24.createElement(EGDSImage3, {
        alt: description,
        src: url
    }), /* @__PURE__ */ React24.createElement(EGDSImageLink3, null, /* @__PURE__ */ React24.createElement("button", {
        type: "button",
        onClick: createHandlerClick("MAP_IMAGE" /* MAP_IMAGE */ )
    }, description))));
    return /* @__PURE__ */ React24.createElement(EGDSLayoutFlex10, {
        direction: "column",
        className: className
    }, nearbyPOIHeading && /* @__PURE__ */ React24.createElement(POIHeadingComponent, {
        heading: nearbyPOIHeading
    }), mapTrigger && renderMapTrigger, showAerialMap && !mapTrigger && renderAerialMap, url && !mapTrigger && !showAerialMap && renderStaticImage, !mapTrigger && /* @__PURE__ */ React24.createElement(Address, {
        data: location,
        onClick: createHandlerClick("MAP_LINK" /* MAP_LINK */ )
    }));
};
SummaryMapTrigger.displayName = "SummaryMapTrigger";
SummaryMapTrigger.fragment = __SummaryMapTriggerFragment;
// src/components/property-info-details/__private/__fragments/property-description-and-more-info-section.tsx
import React37 from "react";
import { gql as gql24 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing17 } from "@egds/react-core/spacing";
import { LodgingEGDSParagraph } from "@shared-ui/lodging-fragments";
// src/components/summary/__private/__fragments/shared/property-info-content-with-see-more-action.tsx
import React36 from "react";
import { gql as gql23 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex11 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid5, EGDSLayoutGridItem as EGDSLayoutGridItem4 } from "@egds/react-core/layout-grid";
import { PropertyInfoContentHeader, PropertyInfoContentItems } from "@shared-ui/lodging-fragments";
import { ViewLarge as ViewLarge5, Viewport as Viewport9, ViewSmall as ViewSmall9 } from "@shared-ui/viewport-context";
// src/components/summary/__private/__fragments/shared/see-more-action.tsx
import React35 from "react";
import { gql as gql22 } from "@apollo/client";
// src/components/summary/__private/__fragments/shared/cleanliness-dialog.tsx
import React26 from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSDialogContent } from "@egds/react-core/dialog";
import { EGDSSheet as EGDSSheet4, EGDSSheetTransition as EGDSSheetTransition3 } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { EGDSDialogToolbar, LodgingDialogTriggerMessage } from "@shared-ui/lodging-fragments";
import { PropertyCleanliness } from "@shared-ui/retail-lodging-property-cleanliness";
// src/components/property-info-details/property-info-details-inputs-provider.tsx
import React25 from "react";
var PropertyInfoDetailsInputsContext = React25.createContext(void 0);
var usePropertyInfoDetailsInputs = function() {
    var context = React25.useContext(PropertyInfoDetailsInputsContext);
    if (context === void 0) {
        throw new Error("usePropertyInfoDetailsInputs must be used with a PropertyInfoDetailsInputContext provider");
    }
    return context;
};
// src/components/summary/__private/__fragments/shared/cleanliness-dialog.tsx
var fragment = gql16(_templateObject15(), EGDSDialogToolbar.fragment, LodgingDialogTriggerMessage.fragment);
var CleanlinessDialog = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var _useDialog2 = _sliced_to_array(useDialog2("PropertyCleaningAndSafetyPracticesDialog", "pwaDialogNested"), 3), isDialogOpen = _useDialog2[0], cleanlinessDialogActions = _useDialog2[1], CleanlinessDialogComponent = _useDialog2[2];
    var track = useClickTracker10();
    var propertyId = usePropertyInfoDetailsInputs();
    var triggerRef = React26.useRef(null);
    var closeDialog = function() {
        if (dialog.closeAnalytics) {
            track(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
        }
        cleanlinessDialogActions.closeDialog();
    };
    return /* @__PURE__ */ React26.createElement(React26.Fragment, null, /* @__PURE__ */ React26.createElement(LodgingDialogTriggerMessage, {
        onClickAction: cleanlinessDialogActions.openDialog,
        data: trigger,
        triggerRef: triggerRef
    }), /* @__PURE__ */ React26.createElement(EGDSSheetTransition3, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React26.createElement(CleanlinessDialogComponent, null, /* @__PURE__ */ React26.createElement(EGDSSheet4, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React26.createElement(EGDSDialogToolbar, {
        toolbarType: "close",
        toolbarAction: closeDialog,
        data: dialog.toolbar
    }), /* @__PURE__ */ React26.createElement(EGDSDialogContent, null, /* @__PURE__ */ React26.createElement(PropertyCleanliness, {
        inputs: propertyId
    }))))));
};
CleanlinessDialog.displayName = "CleanlinessDialog";
CleanlinessDialog.fragment = fragment;
// src/components/summary/__private/__fragments/shared/more-info-dialog.tsx
import React28 from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSSheet as EGDSSheet5, EGDSSheetContent as EGDSSheetContent3, EGDSSheetTransition as EGDSSheetTransition4 } from "@egds/react-core/sheet";
import { EGDSToolbar as EGDSToolbar4 } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { LodgingDialogTriggerMessage as LodgingDialogTriggerMessage2 } from "@shared-ui/lodging-fragments";
// src/components/summary/__private/__fragments/near-by-pois/near-by-pois-link.tsx
import React27 from "react";
import { gql as gql17 } from "@apollo/client";
import { EGDSIcon as EGDSIcon6 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing13 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
var __NearByPoisLinkFragment = gql17(_templateObject16());
var NearByPoisLink = function(param) {
    var data = param.data, onClick = param.onClick, triggerRef = param.triggerRef;
    var _SummaryAnalyticsMapping_NEAR_BY_POIS_LINK = _sliced_to_array(SummaryAnalyticsMapping["NEAR_BY_POIS_LINK" /* NEAR_BY_POIS_LINK */ ], 2), id = _SummaryAnalyticsMapping_NEAR_BY_POIS_LINK[0], description = _SummaryAnalyticsMapping_NEAR_BY_POIS_LINK[1];
    var track = useClickTracker11();
    var handleClick = React27.useCallback(function(event) {
        event.preventDefault();
        track(id, description, true);
        onClick();
    }, [
        track,
        id,
        description,
        onClick
    ]);
    if (!data) {
        return null;
    }
    var _ref = data || {}, text = _ref.value, icon = _ref.icon, accessibilityLabel = _ref.accessibilityLabel;
    var iconId = (icon === null || icon === void 0 ? void 0 : icon.id) || "chevron_right" /* CHEVRON_RIGHT */ ;
    return /* @__PURE__ */ React27.createElement(EGDSSpacing13, {
        padding: {
            blockstart: "three",
            blockend: "unset"
        }
    }, /* @__PURE__ */ React27.createElement(EGDSLink2, {
        align: "left",
        onClick: handleClick,
        domRef: triggerRef
    }, /* @__PURE__ */ React27.createElement("button", {
        type: "button",
        "data-stid": "progressive-disclosure-link"
    }, /* @__PURE__ */ React27.createElement("span", {
        "aria-hidden": true
    }, text), (accessibilityLabel || text) && /* @__PURE__ */ React27.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel || text), /* @__PURE__ */ React27.createElement(EGDSIcon6, {
        name: iconId
    }))));
};
NearByPoisLink.displayName = "NearByPoisLink";
NearByPoisLink.fragment = __NearByPoisLinkFragment;
// src/components/summary/__private/__fragments/shared/more-info-dialog.tsx
var fragment2 = gql18(_templateObject17(), LodgingDialogTriggerMessage2.fragment);
var MoreInfoDialog = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger, children = param.children, isNearByPoiLink = param.isNearByPoiLink, type = param.type, _param_isRandomAccess = param.isRandomAccess, isRandomAccess = _param_isRandomAccess === void 0 ? false : _param_isRandomAccess;
    var _dialog_icon;
    var _useDialog3 = _sliced_to_array(useDialog3("MoreInfoDialog", "pwaMoreInfoDialog"), 3), isDialogOpen = _useDialog3[0], moreInfoDialogActions = _useDialog3[1], MoreInfoDialogComponent = _useDialog3[2];
    var track = useClickTracker12();
    var triggerRef = React28.useRef(null);
    if (!trigger) {
        return null;
    }
    var closeDialog = function() {
        if (dialog.clientSideAnalytics) {
            track(dialog.clientSideAnalytics.referrerId, dialog.clientSideAnalytics.linkName);
        }
        moreInfoDialogActions.closeDialog();
    };
    var _dialog_title;
    var DialogSheet = /* @__PURE__ */ React28.createElement(EGDSSheetTransition4, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React28.createElement(MoreInfoDialogComponent, null, /* @__PURE__ */ React28.createElement(EGDSSheet5, {
        type: type || "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React28.createElement(EGDSToolbar4, {
        toolbarTitle: (_dialog_title = dialog.title) !== null && _dialog_title !== void 0 ? _dialog_title : void 0,
        navigationContent: {
            onClick: closeDialog,
            navType: "close",
            navIconLabel: dialog === null || dialog === void 0 ? void 0 : (_dialog_icon = dialog.icon) === null || _dialog_icon === void 0 ? void 0 : _dialog_icon.description
        }
    }), /* @__PURE__ */ React28.createElement(EGDSSheetContent3, null, children))));
    if (isRandomAccess) {
        return /* @__PURE__ */ React28.createElement(React28.Fragment, null, DialogSheet);
    }
    return /* @__PURE__ */ React28.createElement(React28.Fragment, null, isNearByPoiLink ? /* @__PURE__ */ React28.createElement(NearByPoisLink, {
        onClick: moreInfoDialogActions.openDialog,
        triggerRef: triggerRef,
        data: trigger
    }) : /* @__PURE__ */ React28.createElement(LodgingDialogTriggerMessage2, {
        onClickAction: moreInfoDialogActions.openDialog,
        data: trigger,
        triggerRef: triggerRef
    }), DialogSheet);
};
MoreInfoDialog.displayName = "MoreInfoDialog";
MoreInfoDialog.fragment = fragment2;
// src/components/summary/__private/__fragments/shared/see-more-property-amenities-dialog.tsx
import React34 from "react";
import { gql as gql21 } from "@apollo/client";
import { EGDSDialogContent as EGDSDialogContent2 } from "@egds/react-core/dialog";
import { EGDSSheet as EGDSSheet6, EGDSSheetTransition as EGDSSheetTransition5 } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { EGDSDialogToolbar as EGDSDialogToolbar2, LodgingDialogTriggerMessage as LodgingDialogTriggerMessage3 } from "@shared-ui/lodging-fragments";
// src/components/property-amenities/property-amenities.tsx
import React33, { useEffect } from "react";
import { gql as gql20, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { ITrackType, useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
import { lightweightAdaptExMicroMessage } from "@shared-ui/lodging-fragments";
import { useInView as useInView2 } from "react-intersection-observer";
// src/components/summary/__private/__fragments/amenities/property-takeover-amenities.tsx
import React32 from "react";
import { gql as gql19 } from "@apollo/client";
import { EGDSScrollable as EGDSScrollable2 } from "@egds/react-core/scrollable";
import { PropertyInfoContent as PropertyInfoContent3 } from "@shared-ui/lodging-fragments";
// src/components/summary/__private/__fragments/amenities/amenity-closures.tsx
import React29 from "react";
import { EGDSSpacing as EGDSSpacing14 } from "@egds/react-core/spacing";
import { PropertyInfoContent } from "@shared-ui/lodging-fragments";
var AmenityClosures = function(props) {
    var _amenityClosures_items;
    var amenityClosures = props.amenityClosures;
    var baseIconItemsProps = {
        columns: 2
    };
    var smallIconItemsProps = _object_spread_props(_object_spread({}, baseIconItemsProps), {
        space: "two"
    });
    var largeIconItemsProps = _object_spread_props(_object_spread({}, baseIconItemsProps), {
        space: "three"
    });
    return amenityClosures && (amenityClosures === null || amenityClosures === void 0 ? void 0 : (_amenityClosures_items = amenityClosures.items) === null || _amenityClosures_items === void 0 ? void 0 : _amenityClosures_items.length) > 0 && /* @__PURE__ */ React29.createElement(EGDSSpacing14, {
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React29.createElement("div", null, /* @__PURE__ */ React29.createElement(PropertyInfoContent, {
        data: amenityClosures,
        small: _object_spread_props(_object_spread({}, smallIconItemsProps), {
            prefix: "temporaryClosures"
        }),
        large: _object_spread_props(_object_spread({}, largeIconItemsProps), {
            prefix: "temporaryClosures"
        })
    })));
};
// src/components/summary/__private/__fragments/amenities/highlighted-amenities-section.tsx
import React30 from "react";
import { EGDSSpacing as EGDSSpacing15 } from "@egds/react-core/spacing";
import { PropertyInfoContent as PropertyInfoContent2 } from "@shared-ui/lodging-fragments";
var HighlightedAmenitiesSection = function(param) {
    var highlight = param.highlight;
    var oneColumn = 1;
    var twoColumns = 2;
    var smallSpacing = "two";
    var bigSpacing = "three";
    var baseIconItemsProps = {
        columns: twoColumns,
        prefix: "highlightedAmenities",
        space: smallSpacing
    };
    var smallIconItemsProps = function(isFirstSectionOfMany) {
        return _object_spread_props(_object_spread({}, baseIconItemsProps), {
            columns: isFirstSectionOfMany ? oneColumn : twoColumns
        });
    };
    var largeIconItemsProps = _object_spread_props(_object_spread({}, baseIconItemsProps), {
        space: smallSpacing
    });
    return highlight.map(function(section, idx) {
        var isFirstSectionOfMany = highlight.length > 1 && idx === 0;
        return section.items.length > 0 && /* @__PURE__ */ React30.createElement(EGDSSpacing15, {
            key: "highlightedAmenities-section-".concat(idx),
            padding: {
                blockend: "six"
            }
        }, /* @__PURE__ */ React30.createElement("div", null, /* @__PURE__ */ React30.createElement(PropertyInfoContent2, {
            data: section,
            small: smallIconItemsProps(isFirstSectionOfMany),
            large: largeIconItemsProps
        })));
    });
};
// src/components/summary/__private/__fragments/amenities/property-amenities-section.tsx
import React31 from "react";
import { EGDSSpacing as EGDSSpacing16 } from "@egds/react-core/spacing";
import { UitkHeading } from "@egds/react-core/text";
import { useExperiment as useExperiment9 } from "@shared-ui/experiment-context";
import { CONTENT_TYPE, PropertyInfoContentList } from "@shared-ui/lodging-fragments";
var PropertyAmenitiesSection = function(props) {
    var property = props.property;
    var _useExperiment9 = useExperiment9("Remove_About_the_Property_Web"), topOfPDPRedesignExposure = _useExperiment9.exposure;
    var isTopOfPDPRedesignVariant = topOfPDPRedesignExposure.bucket === 1;
    return property.map(function(section, idx) {
        var _section_items;
        if (((_section_items = section.items) === null || _section_items === void 0 ? void 0 : _section_items.length) > 0) {
            return /* @__PURE__ */ React31.createElement(EGDSSpacing16, {
                key: "propertyAmenities-section-".concat(idx),
                padding: {
                    blockend: "four"
                }
            }, /* @__PURE__ */ React31.createElement("div", null, /* @__PURE__ */ React31.createElement(PropertyInfoContentList, {
                data: section,
                prefix: "propertyAmenities",
                contentType: CONTENT_TYPE.AMENITIES_DIALOG,
                headingSize: 7,
                className: "uitk-spacing-padding-inlinestart-six",
                listItemPadding: {
                    blockend: "two",
                    inlinestart: "half"
                }
            })));
        }
        if (isTopOfPDPRedesignVariant) {
            return /* @__PURE__ */ React31.createElement(EGDSSpacing16, {
                key: "propertyAmenities-section-".concat(idx),
                padding: {
                    blockstart: "one",
                    blockend: "four"
                }
            }, /* @__PURE__ */ React31.createElement(UitkHeading, {
                tag: "h3",
                size: 5
            }, section.header.text));
        }
        return null;
    });
};
// src/components/summary/__private/__fragments/amenities/property-takeover-amenities.tsx
var __PropertyTakeoverAmenitiesFragment = gql19(_templateObject18(), PropertyInfoContent3.fragment);
var PropertyTakeoverAmenities = React32.forwardRef(function(props, ref) {
    var data = props.data;
    var amenityClosures = data.amenityClosures, highlight = data.highlight, property = data.property;
    if (highlight.length === 0 && property.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React32.createElement("div", {
        ref: ref
    }, /* @__PURE__ */ React32.createElement(EGDSScrollable2, {
        direction: "vertical"
    }, /* @__PURE__ */ React32.createElement(AmenityClosures, {
        amenityClosures: amenityClosures
    }), /* @__PURE__ */ React32.createElement(HighlightedAmenitiesSection, {
        highlight: highlight
    }), /* @__PURE__ */ React32.createElement(PropertyAmenitiesSection, {
        property: property
    })));
});
PropertyTakeoverAmenities.fragment = __PropertyTakeoverAmenitiesFragment;
PropertyTakeoverAmenities.displayName = "PropertyTakeoverAmenities";
// src/components/property-amenities/property-amenities.tsx
var __Query = gql20(_templateObject19(), PropertyTakeoverAmenities.fragment);
var PropertyAmenities = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var _data_propertyInfo_summary, _data_propertyInfo;
    var context = useBexApi3().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery2 = useQuery2(__Query, {
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all"
    }), data = _useQuery2.data, loading = _useQuery2.loading;
    var _ref = (data === null || data === void 0 ? void 0 : (_data_propertyInfo = data.propertyInfo) === null || _data_propertyInfo === void 0 ? void 0 : (_data_propertyInfo_summary = _data_propertyInfo.summary) === null || _data_propertyInfo_summary === void 0 ? void 0 : _data_propertyInfo_summary.amenities) || {}, takeover = _ref.takeover, adaptExAttemptEvents = _ref.viewAmenitiesAdaptExAttemptEvents;
    var track = useClickstreamAnalytics().track;
    var _useInView2 = useInView2({
        triggerOnce: true,
        threshold: 0.1
    }), ref = _useInView2.ref, inView = _useInView2.inView;
    useEffect(function() {
        if (inView && (adaptExAttemptEvents === null || adaptExAttemptEvents === void 0 ? void 0 : adaptExAttemptEvents.length)) {
            adaptExAttemptEvents.forEach(function(adaptExAttemptEvent) {
                var _adaptExAttemptEvent_events_, _adaptExAttemptEvent_events_1, _adaptExAttemptEvent_events_2;
                track(ITrackType.EVENT, {
                    data: lightweightAdaptExMicroMessage({
                        campaignId: adaptExAttemptEvent.campaignId,
                        payloadId: ((_adaptExAttemptEvent_events_ = adaptExAttemptEvent.events[0]) === null || _adaptExAttemptEvent_events_ === void 0 ? void 0 : _adaptExAttemptEvent_events_.payloadId) || "",
                        eventType: ((_adaptExAttemptEvent_events_1 = adaptExAttemptEvent.events[0]) === null || _adaptExAttemptEvent_events_1 === void 0 ? void 0 : _adaptExAttemptEvent_events_1.eventType) || "",
                        eventTarget: ((_adaptExAttemptEvent_events_2 = adaptExAttemptEvent.events[0]) === null || _adaptExAttemptEvent_events_2 === void 0 ? void 0 : _adaptExAttemptEvent_events_2.eventTarget) || ""
                    })
                });
            });
        }
    }, [
        adaptExAttemptEvents,
        inView,
        track
    ]);
    if (loading || !takeover) {
        return null;
    }
    return /* @__PURE__ */ React33.createElement(PropertyTakeoverAmenities, {
        data: takeover,
        ref: ref
    });
};
PropertyAmenities.displayName = "sharedui-PropertyAmenities";
// src/components/summary/__private/__fragments/shared/see-more-property-amenities-dialog.tsx
var fragment3 = gql21(_templateObject20(), EGDSDialogToolbar2.fragment, LodgingDialogTriggerMessage3.fragment);
var SeeMorePropertyAmenitiesDialog = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var _useDialog4 = _sliced_to_array(useDialog4("PropertyAmenitiesDialog", "pwaDialogNested"), 3), isDialogOpen = _useDialog4[0], seeMorePropertyAmenitiesDialogActions = _useDialog4[1], SeeMorePropertyAmenitiesDialogComponent = _useDialog4[2];
    var track = useClickTracker13();
    var propertyId = usePropertyInfoDetailsInputs();
    var triggerRef = React34.useRef(null);
    var closeDialog = function() {
        if (dialog.closeAnalytics) {
            track(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
        }
        seeMorePropertyAmenitiesDialogActions.closeDialog();
    };
    return /* @__PURE__ */ React34.createElement(React34.Fragment, null, /* @__PURE__ */ React34.createElement(LodgingDialogTriggerMessage3, {
        data: trigger,
        onClickAction: seeMorePropertyAmenitiesDialogActions.openDialog,
        triggerRef: triggerRef
    }), /* @__PURE__ */ React34.createElement(EGDSSheetTransition5, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React34.createElement(SeeMorePropertyAmenitiesDialogComponent, null, /* @__PURE__ */ React34.createElement(EGDSSheet6, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React34.createElement(EGDSDialogToolbar2, {
        toolbarType: "close",
        toolbarAction: closeDialog,
        data: dialog.toolbar
    }), /* @__PURE__ */ React34.createElement(EGDSDialogContent2, null, /* @__PURE__ */ React34.createElement(PropertyAmenities, {
        inputs: propertyId
    }))))));
};
SeeMorePropertyAmenitiesDialog.displayName = "SeeMorePropertyAmenitiesDialog";
SeeMorePropertyAmenitiesDialog.fragment = fragment3;
// src/components/summary/__private/__fragments/shared/see-more-action.tsx
var fragment4 = gql22(_templateObject21(), SeeMorePropertyAmenitiesDialog.fragment, CleanlinessDialog.fragment, MoreInfoDialog.fragment);
var SeeMoreAction = function(_param) {
    var data = _param.data, props = _object_without_properties(_param, [
        "data"
    ]);
    switch(data.__typename){
        case "AmenitiesDialog":
            return /* @__PURE__ */ React35.createElement(SeeMorePropertyAmenitiesDialog, {
                data: data
            });
        case "CleanlinessDialog":
            return /* @__PURE__ */ React35.createElement(CleanlinessDialog, {
                data: data
            });
        case "MoreInfoDialog":
            return /* @__PURE__ */ React35.createElement(MoreInfoDialog, _object_spread({
                data: data
            }, props));
        default:
            return null;
    }
};
SeeMoreAction.displayName = "SeeMoreAction";
SeeMoreAction.fragment = fragment4;
// src/components/summary/__private/__fragments/shared/property-info-content-with-see-more-action.tsx
var __PropertyInfoContentWithSeeMoreAction = gql23(_templateObject22(), PropertyInfoContentHeader.fragment, PropertyInfoContentItems.fragment, SeeMoreAction.fragment);
var PropertyInfoContentWithSeeMoreAction = function(param) {
    var data = param.data, small = param.small, large = param.large;
    var header = data.header, seeMoreAction = data.seeMoreAction;
    return /* @__PURE__ */ React36.createElement(EGDSLayoutFlex11, {
        direction: "column"
    }, header && /* @__PURE__ */ React36.createElement(PropertyInfoContentHeader, {
        data: header
    }), /* @__PURE__ */ React36.createElement(Viewport9, null, /* @__PURE__ */ React36.createElement(ViewSmall9, null, /* @__PURE__ */ React36.createElement(React36.Fragment, null, /* @__PURE__ */ React36.createElement(PropertyInfoContentItems, _object_spread_props(_object_spread({}, small), {
        data: data
    })), seeMoreAction && /* @__PURE__ */ React36.createElement(SeeMoreAction, {
        data: seeMoreAction
    }))), /* @__PURE__ */ React36.createElement(ViewLarge5, null, /* @__PURE__ */ React36.createElement(EGDSLayoutGrid5, {
        space: "three",
        columns: 1
    }, /* @__PURE__ */ React36.createElement(EGDSLayoutGridItem4, null, /* @__PURE__ */ React36.createElement("div", null, /* @__PURE__ */ React36.createElement(PropertyInfoContentItems, _object_spread_props(_object_spread({}, large), {
        data: data
    })))), /* @__PURE__ */ React36.createElement(EGDSLayoutGridItem4, {
        justifySelf: "end"
    }, /* @__PURE__ */ React36.createElement("div", null, seeMoreAction && /* @__PURE__ */ React36.createElement(SeeMoreAction, {
        data: seeMoreAction
    })))))));
};
PropertyInfoContentWithSeeMoreAction.displayName = "PropertyInfoContentWithSeeMoreAction";
PropertyInfoContentWithSeeMoreAction.fragment = __PropertyInfoContentWithSeeMoreAction;
// src/components/property-info-details/__private/__fragments/property-description-and-more-info-section.tsx
var fragment5 = gql24(_templateObject23(), LodgingEGDSParagraph.fragment, PropertyInfoContentWithSeeMoreAction.fragment);
var contentItemsProps = Object.freeze({
    overflow: "wrap",
    prefix: "cleaningAndSafety",
    space: "four",
    subset: 6,
    autoflow: "row",
    columns: 2,
    rows: 1
});
var PropertyDescriptionAndMoreInfoSection = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React37.createElement("div", null, data.description && /* @__PURE__ */ React37.createElement(LodgingEGDSParagraph, {
        data: data.description,
        size: 2
    }), data.contentSections.map(function(contentSection, index) {
        return /* @__PURE__ */ React37.createElement(EGDSSpacing17, {
            margin: {
                blockstart: "six"
            },
            key: index
        }, /* @__PURE__ */ React37.createElement("div", null, /* @__PURE__ */ React37.createElement(PropertyInfoContentWithSeeMoreAction, {
            data: contentSection,
            small: contentItemsProps,
            large: contentItemsProps
        })));
    }));
};
PropertyDescriptionAndMoreInfoSection.displayName = "PropertyDescriptionAndMoreInfoSection";
PropertyDescriptionAndMoreInfoSection.fragment = fragment5;
// src/components/property-info-details/__private/__fragments/property-details-reviews-breakdown.tsx
import React38 from "react";
import { gql as gql25 } from "@apollo/client";
import { PropertyFilteredReviewsDialogContext, PropertyReviewsBreakdown } from "@shared-ui/lodging-fragments";
import { PropertyFilteredReviews } from "@shared-ui/lodging-reviews";
var fragment6 = gql25(_templateObject24(), PropertyReviewsBreakdown.fragment);
var PropertyDetailsReviewsBreakdown = function(param) {
    var data = param.data, inputs = param.inputs;
    var PropertyFilteredReviewsDialogContent = React38.memo(function() {
        return /* @__PURE__ */ React38.createElement(PropertyFilteredReviews, {
            inputs: _object_spread_props(_object_spread({}, inputs), {
                includeRecentReviews: true
            })
        });
    });
    PropertyFilteredReviewsDialogContent.displayName = "PropertyFilteredReviewsDialogContent";
    return(// eslint-disable-next-line react/jsx-no-constructed-context-values
    /* @__PURE__ */ React38.createElement(PropertyFilteredReviewsDialogContext.Provider, {
        value: {
            PropertyFilteredReviewsDialogContent: PropertyFilteredReviewsDialogContent
        }
    }, /* @__PURE__ */ React38.createElement(PropertyReviewsBreakdown, {
        data: data
    })));
};
PropertyDetailsReviewsBreakdown.displayName = "PropertyDetailsReviewsBreakdown";
PropertyDetailsReviewsBreakdown.fragment = fragment6;
// src/components/property-info-details/property-info-details.tsx
var __Query2 = gql26(_templateObject25(), PropertyImageGallery.fragment, LodgingEGDSHeading.fragment, LodgingEGDSRating.fragment, PropertyDescriptionAndMoreInfoSection.fragment, PropertyDetailsReviewsBreakdown.fragment, PropertyContentSectionGroup.fragment, SummaryMapTrigger.fragment);
var propertyContentSectionGroupsMargin = {
    blockstart: "twelve"
};
var mapHeadingMargin = {
    blockend: "three"
};
var propertyDescriptionAndMoreInfoSectionMargin = {
    large: {
        inlinestart: "six",
        blockstart: "unset"
    },
    small: {
        blockstart: "three"
    }
};
var PropertyInfoDetails = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, children = param.children;
    var _data_propertyInfo_summary_nearbyPOIs_header, _data_propertyInfo_summary_nearbyPOIs, _data_propertyInfo_summary;
    var context = useBexApi4().context;
    var _useDialog5 = _sliced_to_array(useDialog5("propertyInfoDetailsMap", "pwaMapDialog"), 3), isDialogOpen = _useDialog5[0], dialogActions = _useDialog5[1], MapDialogComponent = _useDialog5[2];
    var triggerRef = React39.useRef(null);
    var onClickMap = React39.useCallback(function() {
        dialogActions.openDialog();
    }, [
        dialogActions
    ]);
    var onClose = React39.useCallback(function() {
        dialogActions.closeDialog();
    }, [
        dialogActions
    ]);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery3 = useQuery3(__Query2, {
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all"
    }), data = _useQuery3.data, loading = _useQuery3.loading;
    var propertyId = inputs.propertyId, shoppingContext = inputs.shoppingContext;
    var mapInputs = React39.useMemo(function() {
        return {
            propertyId: propertyId,
            shoppingContext: shoppingContext
        };
    }, [
        propertyId,
        shoppingContext
    ]);
    if (loading || !data) {
        return null;
    }
    var _data_propertyInfo_propertyDetails = data.propertyInfo.propertyDetails, heading = _data_propertyInfo_propertyDetails.heading, rating = _data_propertyInfo_propertyDetails.rating, gallery = _data_propertyInfo_propertyDetails.gallery;
    var _data_propertyInfo_propertyContentSectionGroups = data.propertyInfo.propertyContentSectionGroups, policies = _data_propertyInfo_propertyContentSectionGroups.policies, importantInfo = _data_propertyInfo_propertyContentSectionGroups.importantInfo;
    var mapHeading = (_data_propertyInfo_summary = data.propertyInfo.summary) === null || _data_propertyInfo_summary === void 0 ? void 0 : (_data_propertyInfo_summary_nearbyPOIs = _data_propertyInfo_summary.nearbyPOIs) === null || _data_propertyInfo_summary_nearbyPOIs === void 0 ? void 0 : (_data_propertyInfo_summary_nearbyPOIs_header = _data_propertyInfo_summary_nearbyPOIs.header) === null || _data_propertyInfo_summary_nearbyPOIs_header === void 0 ? void 0 : _data_propertyInfo_summary_nearbyPOIs_header.text;
    return /* @__PURE__ */ React39.createElement(PropertyInfoDetailsInputsContext.Provider, {
        value: inputs
    }, gallery && /* @__PURE__ */ React39.createElement(EGDSSpacing18, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React39.createElement(PropertyImageGallery, {
        data: gallery,
        propertyId: inputs.propertyId
    })), /* @__PURE__ */ React39.createElement(LodgingEGDSHeading, {
        data: heading,
        tag: "h3",
        size: 3
    }), rating && /* @__PURE__ */ React39.createElement(LodgingEGDSRating, {
        data: rating
    }), /* @__PURE__ */ React39.createElement(EGDSSpacing18, {
        margin: propertyContentSectionGroupsMargin
    }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(EGDSLayoutGrid6, {
        columns: {
            large: [
                "1fr",
                "2fr"
            ]
        }
    }, /* @__PURE__ */ React39.createElement(EGDSLayoutGridItem5, null, /* @__PURE__ */ React39.createElement("div", null, mapHeading && /* @__PURE__ */ React39.createElement(EGDSSpacing18, {
        margin: mapHeadingMargin
    }, /* @__PURE__ */ React39.createElement(EGDSHeading6, {
        tag: "h3",
        size: 5
    }, mapHeading)), /* @__PURE__ */ React39.createElement(Viewport10, null, /* @__PURE__ */ React39.createElement(ViewSmall10, null, /* @__PURE__ */ React39.createElement(SummaryMapTrigger, {
        onClickMap: onClickMap,
        data: data.propertyInfo
    }, children)), /* @__PURE__ */ React39.createElement(ViewMedium7, null, /* @__PURE__ */ React39.createElement(SummaryMapTrigger, {
        onClickMap: onClickMap,
        data: data.propertyInfo,
        aspectRatio: EGDSFigureAspectRatioType6.R4_1
    }, children))), data.propertyReviewSummaries.length === 1 && data.propertyReviewSummaries[0] && /* @__PURE__ */ React39.createElement(EGDSSpacing18, {
        margin: propertyContentSectionGroupsMargin
    }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(PropertyDetailsReviewsBreakdown, {
        data: data.propertyReviewSummaries[0],
        inputs: inputs
    }))))), /* @__PURE__ */ React39.createElement(EGDSLayoutGridItem5, null, /* @__PURE__ */ React39.createElement(EGDSSpacing18, {
        margin: propertyDescriptionAndMoreInfoSectionMargin
    }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(PropertyDescriptionAndMoreInfoSection, {
        data: data.propertyInfo.propertyDetails
    }))))))), /* @__PURE__ */ React39.createElement(EGDSSpacing18, {
        margin: propertyContentSectionGroupsMargin
    }, /* @__PURE__ */ React39.createElement(EGDSLayoutGrid6, null, policies && /* @__PURE__ */ React39.createElement(PropertyContentSectionGroup, {
        data: policies,
        isCardComponent: false
    }), importantInfo && /* @__PURE__ */ React39.createElement(PropertyContentSectionGroup, {
        data: importantInfo,
        isCardComponent: false
    }))), /* @__PURE__ */ React39.createElement(EGDSSheetTransition6, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React39.createElement(MapDialogComponent, null, /* @__PURE__ */ React39.createElement(Map, {
        inputs: mapInputs,
        triggerRef: triggerRef,
        onClose: onClose
    }))));
};
PropertyInfoDetails.displayName = "sharedui-PropertyInfoDetails";
// src/components/product-highlights/product-highlights.tsx
import React45 from "react";
import { gql as gql29, useQuery as useQuery4 } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { useMockData } from "@shared-ui/retail-product-type-providers";
// src/components/product-highlights/__private/product-highlights-section/product-highlights-section.tsx
import React43 from "react";
import { gql as gql27 } from "@apollo/client/core";
// src/components/product-highlights/__private/product-highlights-list/product-highlights-list.tsx
import React41, { useEffect as useEffect2 } from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid7 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing19 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading7 } from "@egds/react-core/text";
import { useClickstreamAnalytics as useClickstreamAnalytics2 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment3, ExperimentControl as ExperimentControl3, ExperimentVariant as ExperimentVariant3, useExperiment as useExperiment10 } from "@shared-ui/experiment-context";
import { useSignalSubscriber } from "@shared-ui/signal-events-context";
import { ViewLarge as ViewLarge6, ViewMedium as ViewMedium8, Viewport as Viewport11, ViewSmall as ViewSmall11 } from "@shared-ui/viewport-context";
import { useInView as useInView3 } from "react-intersection-observer";
// src/components/product-highlights/analytics/highlights-adaptex-analytics.ts
import { ITrackType as ITrackType2 } from "@shared-ui/clickstream-analytics-context";
import { lightweightAdaptExMicroMessage as lightweightAdaptExMicroMessage2 } from "@shared-ui/lodging-fragments";
var trackAdaptexEvent = function(data, adaptexCampaignId, trackAnalytics) {
    var campaignId = adaptexCampaignId || "";
    var payloadId = data.payloadId, eventType = data.eventType, eventTarget = data.eventTarget;
    trackAnalytics(ITrackType2.EVENT, {
        data: lightweightAdaptExMicroMessage2({
            campaignId: campaignId,
            payloadId: payloadId,
            eventType: eventType || "",
            eventTarget: eventTarget || ""
        })
    });
};
// src/components/product-highlights/__private/product-highlights-list/product-highlights-list-element.tsx
import React40 from "react";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon7, UitkIconSize as UitkIconSize2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex12 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGridItem as EGDSLayoutGridItem6 } from "@egds/react-core/layout-grid";
import { EGDSText as EGDSText7 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker4 } from "@shared-ui/clickstream-analytics-context";
var ProductHighlightsListElement = function(param) {
    var isColumnView = param.isColumnView, data = param.data;
    if (data.__typename !== "ShoppingProductContentGraphicsItem") {
        return null;
    }
    var _ref = (data === null || data === void 0 ? void 0 : data.impressionAnalytics) || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
    var CardLayout = (data === null || data === void 0 ? void 0 : data.text) && /* @__PURE__ */ React40.createElement(EGDSCard, {
        backgroundTheme: "secondary",
        padded: true
    }, /* @__PURE__ */ React40.createElement(EGDSLayoutFlex12, {
        direction: "row",
        space: "four",
        alignItems: "center",
        blockSize: "full_size"
    }, (data === null || data === void 0 ? void 0 : data.leadingIcon) && /* @__PURE__ */ React40.createElement(EGDSIcon7, {
        name: data.leadingIcon.id,
        size: UitkIconSize2.MEDIUM
    }), /* @__PURE__ */ React40.createElement(EGDSText7, null, data.text)));
    return /* @__PURE__ */ React40.createElement(EGDSLayoutGridItem6, {
        colSpan: isColumnView ? void 0 : {
            small: 4,
            medium: 3,
            large: 3
        }
    }, /* @__PURE__ */ React40.createElement("div", null, referrerId && linkName ? /* @__PURE__ */ React40.createElement(IntersectionTracker4, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName,
        className: "uitk-layout-flex-block-size-full-size"
    }, CardLayout) : CardLayout));
};
// src/components/product-highlights/__private/product-highlights-list/product-highlights-list.tsx
var ProductHighlightsList = function(param) {
    var data = param.data, className = param.className;
    var _data_content, _data_content1;
    var track = useClickstreamAnalytics2().track;
    var _useInView3 = useInView3({
        triggerOnce: true
    }), ref = _useInView3.ref, inView = _useInView3.inView;
    var _useExperiment10_exposure = useExperiment10("PDP_MODULARISED_LOCATION_SECTION").exposure, isShowingModularisedSection = _useExperiment10_exposure.bucket;
    var _ref = (data === null || data === void 0 ? void 0 : data.adaptExCampaignEvents) || {}, adaptExAttemptEvents = _ref.adaptExAttemptEvents, campaignId = _ref.campaignId, adaptExSuccessEvents = _ref.adaptExSuccessEvents;
    var onAdaptexSuccesEvent = function() {
        if (adaptExSuccessEvents === null || adaptExSuccessEvents === void 0 ? void 0 : adaptExSuccessEvents.length) {
            var matchedSignalEvent = adaptExSuccessEvents.filter(function(event) {
                return event.eventType === "progression";
            });
            if (matchedSignalEvent[0]) {
                trackAdaptexEvent(matchedSignalEvent[0], campaignId, track);
            }
        }
    };
    useSignalSubscriber({
        query: {
            type: "ADAPTEX_HIGHLIGHTS_PROGRESSION_EVENT"
        },
        onSignal: onAdaptexSuccesEvent
    });
    useEffect2(function() {
        if (inView && (adaptExAttemptEvents === null || adaptExAttemptEvents === void 0 ? void 0 : adaptExAttemptEvents.length)) {
            adaptExAttemptEvents.forEach(function(adaptExAttemptEvent) {
                trackAdaptexEvent(adaptExAttemptEvent, campaignId, track);
            });
        }
    }, [
        adaptExAttemptEvents,
        inView,
        track,
        campaignId
    ]);
    if (!((_data_content = data.content) === null || _data_content === void 0 ? void 0 : _data_content.items) || !((_data_content1 = data.content) === null || _data_content1 === void 0 ? void 0 : _data_content1.header)) {
        return null;
    }
    var _data_content2 = data.content, header = _data_content2.header, items = _data_content2.items;
    var RowView = /* @__PURE__ */ React41.createElement(EGDSLayoutGrid7, {
        space: "four",
        alignItems: "stretch",
        justifyContent: "center",
        rows: items.length,
        columns: 4,
        dataTestId: "row-view"
    }, items.map(function(item, idx) {
        return /* @__PURE__ */ React41.createElement(ProductHighlightsListElement, {
            data: item,
            isColumnView: false,
            key: "product-highlights-list-element-".concat(idx)
        });
    }));
    var ColumnView = /* @__PURE__ */ React41.createElement(EGDSLayoutGrid7, {
        space: "four",
        alignItems: "stretch",
        justifyContent: "center",
        columns: 3,
        rows: void 0,
        dataTestId: "column-view"
    }, items.map(function(item, idx) {
        return /* @__PURE__ */ React41.createElement(ProductHighlightsListElement, {
            data: item,
            isColumnView: true,
            key: "product-highlights-list-element-".concat(idx)
        });
    }));
    return /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
        padding: {
            blockend: isShowingModularisedSection ? "six" : "eight"
        }
    }, /* @__PURE__ */ React41.createElement("div", {
        ref: ref,
        className: className
    }, /* @__PURE__ */ React41.createElement(EGDSHeading7, {
        tag: "h2",
        size: isShowingModularisedSection ? 4 : 5
    }, header.text), /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(Viewport11, null, /* @__PURE__ */ React41.createElement(ViewSmall11, null, RowView), /* @__PURE__ */ React41.createElement(ViewMedium8, null, ColumnView), /* @__PURE__ */ React41.createElement(ViewLarge6, null, /* @__PURE__ */ React41.createElement(Experiment3, {
        name: "PDP_MODULARISED_LOCATION_SECTION"
    }, /* @__PURE__ */ React41.createElement(ExperimentControl3, null, RowView), /* @__PURE__ */ React41.createElement(ExperimentVariant3, {
        bucket: 1
    }, ColumnView), /* @__PURE__ */ React41.createElement(ExperimentVariant3, {
        bucket: 2
    }, ColumnView))))))));
};
ProductHighlightsList.displayName = "ProductHighlightsList";
// src/components/product-highlights/__private/product-highlights-section/product-highlights-section-component.tsx
import React42 from "react";
import { EGDSCard as EGDSCard2, EGDSCardBackgroundThemes } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon8 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex13, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSList as EGDSList2, EGDSListItem } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing20 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading8, EGDSText as EGDSText8 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker5 } from "@shared-ui/clickstream-analytics-context";
var ProductHighlightSectionComponent = function(param) {
    var className = param.className, data = param.data;
    var content = data.content;
    var header = content.header, items = content.items;
    var _content_impressionAnalytics = content.impressionAnalytics, referrerId = _content_impressionAnalytics.referrerId, linkName = _content_impressionAnalytics.linkName;
    var renderHighlight = function(item, idx) {
        if ((item === null || item === void 0 ? void 0 : item.__typename) === "EGDSPlainText") {
            return /* @__PURE__ */ React42.createElement(EGDSLayoutFlexItem7, {
                key: "product-highlight-section-item-".concat(idx)
            }, /* @__PURE__ */ React42.createElement(EGDSSpacing20, {
                margin: {
                    inline: "one"
                }
            }, /* @__PURE__ */ React42.createElement(EGDSList2, {
                spacing: false
            }, /* @__PURE__ */ React42.createElement(EGDSListItem, {
                key: "product-highlight-section-item-text".concat(idx)
            }, item.text))));
        }
        return null;
    };
    var ProductHighlightsSectionComponentLayout = /* @__PURE__ */ React42.createElement("div", {
        className: className
    }, /* @__PURE__ */ React42.createElement(EGDSSpacing20, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React42.createElement("div", null, /* @__PURE__ */ React42.createElement(EGDSCard2, {
        backgroundTheme: EGDSCardBackgroundThemes.SECONDARY,
        tag: "section"
    }, /* @__PURE__ */ React42.createElement(EGDSSpacing20, {
        padding: "four"
    }, /* @__PURE__ */ React42.createElement("div", null, header && /* @__PURE__ */ React42.createElement(EGDSSpacing20, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React42.createElement(EGDSLayoutFlex13, {
        space: "two",
        alignItems: "center"
    }, header.icon && /* @__PURE__ */ React42.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */ React42.createElement(EGDSIcon8, {
        spotlight: "positive",
        name: header.icon.id,
        id: header.icon.id,
        description: header.icon.description
    })), header.text && /* @__PURE__ */ React42.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */ React42.createElement("div", null, /* @__PURE__ */ React42.createElement(EGDSSpacing20, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React42.createElement(EGDSHeading8, {
        size: 5
    }, header.text)), header.subText && /* @__PURE__ */ React42.createElement(EGDSText8, null, header.subText))))), (items === null || items === void 0 ? void 0 : items.length) > 0 && /* @__PURE__ */ React42.createElement(EGDSLayoutFlex13, {
        space: "two",
        direction: "column"
    }, items.map(function(item, idx) {
        return renderHighlight(item, idx);
    }))))))));
    return referrerId && linkName ? /* @__PURE__ */ React42.createElement(IntersectionTracker5, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName
    }, ProductHighlightsSectionComponentLayout) : ProductHighlightsSectionComponentLayout;
};
// src/components/product-highlights/__private/product-highlights-section/product-highlights-section.tsx
var ShoppingAdaptExEventsFragment = gql27(_templateObject26());
var fragment7 = gql27(_templateObject27(), ShoppingAdaptExEventsFragment);
var ProductHighlightsSection = function(param) {
    var className = param.className, data = param.data;
    var _data_content, _data_content1;
    if (!(data === null || data === void 0 ? void 0 : (_data_content = data.content) === null || _data_content === void 0 ? void 0 : _data_content.header) || !(data === null || data === void 0 ? void 0 : (_data_content1 = data.content) === null || _data_content1 === void 0 ? void 0 : _data_content1.items)) {
        return null;
    }
    switch(data.highlightsType){
        case "HIGHLIGHTS_LIST":
            return /* @__PURE__ */ React43.createElement(ProductHighlightsList, {
                className: className,
                data: data
            });
        case "FAMILY_HIGHLIGHTS":
            return /* @__PURE__ */ React43.createElement(ProductHighlightSectionComponent, {
                className: className,
                data: data
            });
        default:
            return null;
    }
};
ProductHighlightsSection.displayName = "ProductHighlightsSection";
ProductHighlightsSection.fragment = fragment7;
// src/components/product-highlights/__private/property-uniqueness/property-uniqueness.tsx
import React44 from "react";
import { gql as gql28 } from "@apollo/client";
import { EGDSCard as EGDSCard3 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid8, EGDSLayoutGridItem as EGDSLayoutGridItem7 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing21 } from "@egds/react-core/spacing";
import { IntersectionTracker as IntersectionTracker6 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment11 } from "@shared-ui/experiment-context";
import { EGDSSpannableList, LodgingEGDSGraphicText } from "@shared-ui/lodging-fragments";
var fragment8 = gql28(_templateObject28(), LodgingEGDSGraphicText.fragment, EGDSSpannableList.fragment);
var PAGE_TYPE = "PAGE_SPEC";
var PAGE_TYPE_REGEX = new RegExp(PAGE_TYPE, "g");
var createAdditionalUisPrimeMicroMessages = function(impression, pageId) {
    return impression.uisPrimeMessages.map(function(param) {
        var messageContent = param.messageContent, schemaName = param.schemaName;
        return {
            messageContent: JSON.parse(messageContent.includes(PAGE_TYPE) && pageId ? messageContent.replace(PAGE_TYPE_REGEX, pageId) : messageContent),
            schemaName: schemaName
        };
    });
};
var ProductUniqueness = function(param) {
    var data = param.data, className = param.className, onClickReviews = param.onClickReviews, triggerRef = param.triggerRef, pageId = param.pageId;
    var _useExperiment11_exposure = useExperiment11("PDP_MODULARISED_LOCATION_SECTION").exposure, isModularised = _useExperiment11_exposure.bucket;
    var title = data.title, details = data.details, impression = data.impression;
    var ProductUniqenessComponent = /* @__PURE__ */ React44.createElement("div", {
        className: className
    }, /* @__PURE__ */ React44.createElement(EGDSSpacing21, {
        padding: isModularised ? {
            blockstart: "six"
        } : {
            blockend: "six"
        }
    }, /* @__PURE__ */ React44.createElement("div", null, /* @__PURE__ */ React44.createElement(EGDSLayoutGrid8, {
        columns: 4
    }, /* @__PURE__ */ React44.createElement(EGDSLayoutGridItem7, {
        colSpan: {
            small: 4,
            medium: isModularised ? 4 : 3
        }
    }, /* @__PURE__ */ React44.createElement("div", null, /* @__PURE__ */ React44.createElement(EGDSCard3, {
        backgroundTheme: "secondary",
        padded: true
    }, /* @__PURE__ */ React44.createElement("div", null, /* @__PURE__ */ React44.createElement(EGDSSpacing21, {
        padding: "two"
    }, /* @__PURE__ */ React44.createElement("div", null, title && /* @__PURE__ */ React44.createElement(LodgingEGDSGraphicText, {
        customTextSize: 400,
        flexLayout: true,
        data: title,
        textProps: {
            weight: "medium",
            theme: "default"
        }
    }), details && /* @__PURE__ */ React44.createElement(EGDSSpacing21, {
        padding: {
            blockstart: "two",
            inline: "two"
        }
    }, /* @__PURE__ */ React44.createElement("div", null, /* @__PURE__ */ React44.createElement(EGDSSpannableList, {
        trackingPrefix: pageId,
        handleInlineLinkClick: onClickReviews,
        triggerRef: triggerRef,
        data: details
    })))))))))))));
    return impression.referrerId && impression.linkName ? /* @__PURE__ */ React44.createElement(IntersectionTracker6, {
        referrerId: "".concat(pageId ? "".concat(pageId, ".").concat(impression.referrerId) : impression.referrerId),
        linkName: impression.linkName,
        additionalUisPrimeMicroMessages: impression.uisPrimeMessages ? createAdditionalUisPrimeMicroMessages(impression, pageId) : {},
        trackOnce: true
    }, ProductUniqenessComponent) : ProductUniqenessComponent;
};
ProductUniqueness.displayName = "ProductUniqueness";
ProductUniqueness.fragment = fragment8;
// src/components/product-highlights/product-highlights.tsx
var __Query3 = gql29(_templateObject29(), ProductUniqueness.fragment, ProductHighlightsSection.fragment);
var ProductHighlights = function(param) {
    var inputs = param.inputs, className = param.className, onClickReviews = param.onClickReviews, triggerRef = param.triggerRef, pageId = param.pageId, skipSsr = param.skipSsr;
    var _mockData_product, _mockData_product1;
    var mockData = useMockData();
    var context = useBexApi5().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery4 = useQuery4(__Query3, {
        variables: variables,
        skip: mockData === null || mockData === void 0 ? void 0 : (_mockData_product = mockData.product) === null || _mockData_product === void 0 ? void 0 : _mockData_product.productHighlights,
        ssr: !skipSsr
    }), data = _useQuery4.data, error = _useQuery4.error;
    var productHighlights = (data === null || data === void 0 ? void 0 : data.productHighlights) || (mockData === null || mockData === void 0 ? void 0 : (_mockData_product1 = mockData.product) === null || _mockData_product1 === void 0 ? void 0 : _mockData_product1.productHighlights);
    if (error || !productHighlights) {
        return null;
    }
    switch(productHighlights.__typename){
        case "ProductUniqueness":
            return /* @__PURE__ */ React45.createElement(ProductUniqueness, {
                className: className,
                data: productHighlights,
                onClickReviews: onClickReviews,
                triggerRef: triggerRef,
                pageId: pageId
            });
        case "ProductHighlightsSection":
            return /* @__PURE__ */ React45.createElement(ProductHighlightsSection, {
                className: className,
                data: productHighlights
            });
        default:
            return null;
    }
};
ProductHighlights.displayName = "sharedui-ProductHighlights";
// src/components/property-see-all-amenities/see-all-amenities.tsx
import React50 from "react";
import { gql as gql34, useQuery as useQuery5 } from "@apollo/client";
import { EGDSSheetTransition as EGDSSheetTransition8 } from "@egds/react-core/sheet";
import { EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing26 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";
import { useExperiment as useExperiment14 } from "@shared-ui/experiment-context";
import { __PropertyInfoContent, PropertyContent, PropertyContentSectionGroup as PropertyContentSectionGroup2 } from "@shared-ui/lodging-fragments";
// src/components/relevant-amenities/relevant-amenities.tsx
import React46 from "react";
import { gql as gql30 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid9, EGDSLayoutGridItem as EGDSLayoutGridItem8 } from "@egds/react-core/layout-grid";
import { EGDSList as EGDSList3, EGDSListItem as EGDSListItem2 } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing22 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading9 } from "@egds/react-core/text";
var __RelevantAmenitiesItem = gql30(_templateObject30());
var RelevantAmenitiesItem = function(param) {
    var data = param.data;
    var header = data.header, contents = data.contents;
    var listMap = contents.map(function(element) {
        return element.items.map(function(item, idx) {
            return item && /* @__PURE__ */ React46.createElement(EGDSListItem2, {
                key: "amenities-list-item-".concat(idx)
            }, item.text);
        });
    });
    return listMap && /* @__PURE__ */ React46.createElement(EGDSLayoutGridItem8, {
        colSpan: {
            small: 3,
            medium: 1
        }
    }, /* @__PURE__ */ React46.createElement("div", null, /* @__PURE__ */ React46.createElement(EGDSHeading9, {
        tag: "h6",
        size: 6
    }, header === null || header === void 0 ? void 0 : header.text), /* @__PURE__ */ React46.createElement(EGDSList3, {
        bullet: "no-bullet"
    }, listMap)));
};
RelevantAmenitiesItem.displayName = "RelevantAmenitiesItem";
RelevantAmenitiesItem.fragment = __RelevantAmenitiesItem;
var __RelevantAmenitiesFragment = gql30(_templateObject31(), RelevantAmenitiesItem.fragment);
var RelevantAmenities = function(param) {
    var data = param.data, className = param.className;
    var _summary_amenities_relevantAmenities, _summary_amenities, _summary_amenities1;
    var summary = data.summary;
    if ((summary === null || summary === void 0 ? void 0 : (_summary_amenities = summary.amenities) === null || _summary_amenities === void 0 ? void 0 : (_summary_amenities_relevantAmenities = _summary_amenities.relevantAmenities) === null || _summary_amenities_relevantAmenities === void 0 ? void 0 : _summary_amenities_relevantAmenities.length) === 0) {
        return null;
    }
    var _summary_amenities_relevantAmenities1;
    var relevantAmenities = (_summary_amenities_relevantAmenities1 = summary === null || summary === void 0 ? void 0 : (_summary_amenities1 = summary.amenities) === null || _summary_amenities1 === void 0 ? void 0 : _summary_amenities1.relevantAmenities) !== null && _summary_amenities_relevantAmenities1 !== void 0 ? _summary_amenities_relevantAmenities1 : null;
    var relevantAmenitiesColumns = relevantAmenities === null || relevantAmenities === void 0 ? void 0 : relevantAmenities.map(function(item, idx) {
        var _item_contents, _item_contents__items, _item_contents_;
        if (!item || !item.header || !item.header.text || ((_item_contents = item.contents) === null || _item_contents === void 0 ? void 0 : _item_contents.length) === 0 || ((_item_contents_ = item.contents[0]) === null || _item_contents_ === void 0 ? void 0 : (_item_contents__items = _item_contents_.items) === null || _item_contents__items === void 0 ? void 0 : _item_contents__items.length) === 0) {
            return null;
        }
        return item && /* @__PURE__ */ React46.createElement(RelevantAmenitiesItem, {
            data: item,
            key: "amenities-list-".concat(idx)
        });
    }).filter(function(element) {
        return element !== null;
    });
    return /* @__PURE__ */ React46.createElement(React46.Fragment, null, relevantAmenitiesColumns && relevantAmenitiesColumns.length > 0 && /* @__PURE__ */ React46.createElement("div", {
        className: className
    }, /* @__PURE__ */ React46.createElement(EGDSSpacing22, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React46.createElement(EGDSLayoutGrid9, {
        columns: 3,
        space: "six"
    }, relevantAmenitiesColumns))));
};
RelevantAmenities.displayName = "RelevantAmenities";
RelevantAmenities.fragment = __RelevantAmenitiesFragment;
// src/components/summary/__private/__fragments/amenities/amenities-dialog.tsx
import React48, { useEffect as useEffect4, useState as useState3 } from "react";
import { gql as gql32 } from "@apollo/client";
import { EGDSSheet as EGDSSheet7, EGDSSheetContent as EGDSSheetContent4, EGDSSheetTransition as EGDSSheetTransition7 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing24, EGDSSpacingHr, UitkSpacing as UitkSpacing2 } from "@egds/react-core/spacing";
import { UitkHeading as UitkHeading2 } from "@egds/react-core/text";
import { EGDSToolbar as EGDSToolbar5 } from "@egds/react-core/toolbar";
import { ITrackType as ITrackType3, useClickstreamAnalytics as useClickstreamAnalytics3 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment12 } from "@shared-ui/experiment-context";
import { AboutThisProperty, lightweightAdaptExMicroMessage as lightweightAdaptExMicroMessage3 } from "@shared-ui/lodging-fragments";
import { ViewMedium as ViewMedium9, Viewport as Viewport12, ViewSmall as ViewSmall12 } from "@shared-ui/viewport-context";
import { useInView as useInView5 } from "react-intersection-observer";
// src/utils/amenities-tabs-helpers.ts
import { useInView as useInView4 } from "react-intersection-observer";
var amenityContentId = "amenities";
var aboutContentId = "aboutThisProperty";
var scrollIntoView = function(id) {
    var _document_getElementById;
    (_document_getElementById = document.getElementById(id)) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.scrollIntoView({
        behavior: "smooth"
    });
};
var useAmenitiesDialogSectionsInView = function(containerRef) {
    var _useInView4 = useInView4({
        triggerOnce: false,
        threshold: [
            0.5,
            0.75,
            1
        ],
        root: containerRef
    }), aboutRef = _useInView4.ref, isAboutInView = _useInView4.inView;
    var _useInView41 = useInView4({
        triggerOnce: false,
        threshold: [
            0.25,
            0.5,
            0.75,
            1
        ],
        root: containerRef
    }), amenitiesRef = _useInView41.ref, isAmenitiesInView = _useInView41.inView;
    return {
        about: {
            ref: aboutRef,
            inView: isAboutInView
        },
        amenities: {
            ref: amenitiesRef,
            inView: isAmenitiesInView
        }
    };
};
var findContentIdInView = function(aboutInView, amenitiesInView) {
    if (aboutInView) {
        return aboutContentId;
    }
    if (amenitiesInView) {
        return amenityContentId;
    }
    return null;
};
// src/components/summary/__private/__fragments/amenities/amenities-tabs.tsx
import React47, { useEffect as useEffect3 } from "react";
import { gql as gql31 } from "@apollo/client";
import { EGDSLayoutPosition as EGDSLayoutPosition6 } from "@egds/react-core/layout-position";
import { EGDSSpacing as EGDSSpacing23 } from "@egds/react-core/spacing";
import { EGDSTab, EGDSTabs, UitkNavigationType } from "@egds/react-core/tabs";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
var fragment9 = gql31(_templateObject32());
var AmenitiesTabs = function(param) {
    var data = param.data, _param_contentIdInView = param.contentIdInView, contentIdInView = _param_contentIdInView === void 0 ? null : _param_contentIdInView;
    var selectedTabId = data.selectedTabId, tabs = data.tabs;
    var track = useClickTracker14();
    var initialTabIndex = (tabs === null || tabs === void 0 ? void 0 : tabs.findIndex(function(tab) {
        return tab.tabId === selectedTabId;
    })) || 0;
    var _React47_useState = _sliced_to_array(React47.useState(initialTabIndex), 2), activeTabIndex = _React47_useState[0], setActiveTabIndex = _React47_useState[1];
    useEffect3(function() {
        if (tabs && contentIdInView) {
            var tabIdxForContentIdInView = tabs.findIndex(function(tab) {
                return tab.contentId === contentIdInView;
            });
            if (!(activeTabIndex === tabIdxForContentIdInView)) {
                setActiveTabIndex(tabIdxForContentIdInView);
            }
        }
    }, [
        activeTabIndex,
        contentIdInView,
        tabs
    ]);
    if (!tabs) {
        return null;
    }
    var onTabClick = function(selectedTabIndex) {
        var clickedTab = tabs[selectedTabIndex];
        if (clickedTab) {
            var clickedTabContentId = clickedTab.contentId;
            var clickedTabLabel = clickedTab.label;
            var _clickedTab_clickAnalytics = clickedTab.clickAnalytics, _clickedTab_clickAnalytics_referrerId = _clickedTab_clickAnalytics.referrerId, referrerId = _clickedTab_clickAnalytics_referrerId === void 0 ? "HOT.HIS.AmenitiesDialog.".concat(clickedTabLabel) : _clickedTab_clickAnalytics_referrerId, _clickedTab_clickAnalytics_linkName = _clickedTab_clickAnalytics.linkName, linkName = _clickedTab_clickAnalytics_linkName === void 0 ? "Clicked ".concat(clickedTabLabel, " tab") : _clickedTab_clickAnalytics_linkName;
            if (selectedTabIndex === activeTabIndex) {
                return;
            }
            scrollIntoView(clickedTabContentId);
            track(referrerId, linkName);
            setActiveTabIndex(selectedTabIndex);
        }
    };
    return /* @__PURE__ */ React47.createElement(EGDSSpacing23, {
        padding: {
            blockend: "half"
        }
    }, /* @__PURE__ */ React47.createElement(EGDSLayoutPosition6, {
        type: "sticky"
    }, /* @__PURE__ */ React47.createElement(EGDSTabs, {
        navigationType: UitkNavigationType.JUMPLINK,
        onTabClickCB: onTabClick,
        selectedTab: activeTabIndex,
        "data-stid": "amenities-navigation-tabs"
    }, tabs.map(function(tab) {
        return /* @__PURE__ */ React47.createElement(EGDSTab, {
            id: tab.tabId,
            key: "tab-key-".concat(tab.tabId),
            name: tab.label
        });
    }))));
};
AmenitiesTabs.displayName = "AmenitiesTabs";
AmenitiesTabs.fragment = fragment9;
// src/components/summary/__private/__fragments/amenities/amenities-dialog.tsx
var __AmenitiesDialog = gql32(_templateObject33(), PropertyTakeoverAmenities.fragment);
var SheetComponent = function(param) {
    var type = param.type, dialogTabs = param.dialogTabs, title = param.title, description = param.description, takeover = param.takeover, closeDialog = param.closeDialog, isDialogOpen = param.isDialogOpen, _param_triggerRef = param.triggerRef, triggerRef = _param_triggerRef === void 0 ? null : _param_triggerRef, _param_forwardRef = param.forwardRef, forwardRef = _param_forwardRef === void 0 ? null : _param_forwardRef, dialogPreviouslyViewed = param.dialogPreviouslyViewed, aboutThisPropertyData = param.aboutThisPropertyData;
    var containerRef = React48.useRef(null);
    var _useAmenitiesDialogSectionsInView = useAmenitiesDialogSectionsInView(containerRef === null || containerRef === void 0 ? void 0 : containerRef.current), _useAmenitiesDialogSectionsInView_about = _useAmenitiesDialogSectionsInView.about, aboutRef = _useAmenitiesDialogSectionsInView_about.ref, aboutInView = _useAmenitiesDialogSectionsInView_about.inView, _useAmenitiesDialogSectionsInView_amenities = _useAmenitiesDialogSectionsInView.amenities, amenitiesRef = _useAmenitiesDialogSectionsInView_amenities.ref, amenitiesInView = _useAmenitiesDialogSectionsInView_amenities.inView;
    var _useState3 = _sliced_to_array(useState3(null), 2), contentIdInView = _useState3[0], setContentIdInView = _useState3[1];
    useEffect4(function() {
        var currentlyInView = findContentIdInView(aboutInView, amenitiesInView);
        setContentIdInView(currentlyInView);
    }, [
        aboutInView,
        amenitiesInView
    ]);
    var _useExperiment12 = useExperiment12("Remove_About_the_Property_Web"), topOfPDPRedesignExposure = _useExperiment12.exposure;
    var isTopOfPDPRedesignVariant = topOfPDPRedesignExposure.bucket === 1;
    var showSeparator = dialogTabs != null;
    return /* @__PURE__ */ React48.createElement(EGDSSheetTransition7, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React48.createElement(EGDSSheet7, {
        returnFocusOnClose: true,
        triggerRef: triggerRef,
        isVisible: isDialogOpen,
        type: type
    }, /* @__PURE__ */ React48.createElement(EGDSToolbar5, {
        navigationContent: {
            onClick: closeDialog,
            navType: "close",
            navIconLabel: description
        }
    }), dialogTabs && /* @__PURE__ */ React48.createElement(AmenitiesTabs, {
        data: dialogTabs,
        contentIdInView: contentIdInView
    }), /* @__PURE__ */ React48.createElement(EGDSSheetContent4, {
        contentDomRef: containerRef
    }, isTopOfPDPRedesignVariant && (dialogTabs === null || dialogTabs === void 0 ? void 0 : dialogTabs.tabs) && /* @__PURE__ */ React48.createElement("section", {
        ref: aboutRef,
        id: aboutContentId
    }, /* @__PURE__ */ React48.createElement(AboutThisProperty, {
        data: aboutThisPropertyData
    })), showSeparator && /* @__PURE__ */ React48.createElement(EGDSSpacing24, {
        margin: {
            blockstart: "four",
            blockend: "six"
        }
    }, /* @__PURE__ */ React48.createElement("div", null, /* @__PURE__ */ React48.createElement(EGDSSpacingHr, null))), /* @__PURE__ */ React48.createElement("section", {
        ref: amenitiesRef,
        id: amenityContentId
    }, /* @__PURE__ */ React48.createElement(UitkSpacing2, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React48.createElement(UitkHeading2, {
        tag: "h2",
        size: 5
    }, title)), /* @__PURE__ */ React48.createElement(PropertyTakeoverAmenities, {
        data: takeover,
        ref: forwardRef
    })))));
};
var AmenitiesDialog = function(param) {
    var closeDialog = param.closeDialog, data = param.data, dialogTabs = param.dialogTabs, isDialogOpen = param.isDialogOpen, triggerRef = param.triggerRef, dialogPreviouslyViewed = param.dialogPreviouslyViewed, aboutThisPropertyData = param.aboutThisPropertyData;
    var _amenitiesDialog_toolbar, _amenitiesDialog_toolbar_icon, _amenitiesDialog_toolbar1;
    var amenitiesDialog = data.amenitiesDialog, takeover = data.takeover, viewAmenitiesAdaptExAttemptEvents = data.viewAmenitiesAdaptExAttemptEvents;
    var track = useClickstreamAnalytics3().track;
    var _useInView5 = useInView5({
        triggerOnce: true,
        threshold: 0
    }), forwardRef = _useInView5.ref, inView = _useInView5.inView;
    useEffect4(function() {
        if (!dialogPreviouslyViewed && inView && viewAmenitiesAdaptExAttemptEvents) {
            viewAmenitiesAdaptExAttemptEvents.forEach(function(adaptExAttemptEvent) {
                var _adaptExAttemptEvent_events_, _adaptExAttemptEvent_events_1, _adaptExAttemptEvent_events_2;
                track(ITrackType3.EVENT, {
                    data: lightweightAdaptExMicroMessage3({
                        campaignId: adaptExAttemptEvent.campaignId,
                        payloadId: ((_adaptExAttemptEvent_events_ = adaptExAttemptEvent.events[0]) === null || _adaptExAttemptEvent_events_ === void 0 ? void 0 : _adaptExAttemptEvent_events_.payloadId) || "",
                        eventType: ((_adaptExAttemptEvent_events_1 = adaptExAttemptEvent.events[0]) === null || _adaptExAttemptEvent_events_1 === void 0 ? void 0 : _adaptExAttemptEvent_events_1.eventType) || "",
                        eventTarget: ((_adaptExAttemptEvent_events_2 = adaptExAttemptEvent.events[0]) === null || _adaptExAttemptEvent_events_2 === void 0 ? void 0 : _adaptExAttemptEvent_events_2.eventTarget) || ""
                    })
                });
            });
        }
    }, [
        viewAmenitiesAdaptExAttemptEvents,
        inView,
        track,
        dialogPreviouslyViewed
    ]);
    if (!amenitiesDialog || !takeover) {
        return null;
    }
    var title = (_amenitiesDialog_toolbar = amenitiesDialog.toolbar) === null || _amenitiesDialog_toolbar === void 0 ? void 0 : _amenitiesDialog_toolbar.title;
    var description = (_amenitiesDialog_toolbar1 = amenitiesDialog.toolbar) === null || _amenitiesDialog_toolbar1 === void 0 ? void 0 : (_amenitiesDialog_toolbar_icon = _amenitiesDialog_toolbar1.icon) === null || _amenitiesDialog_toolbar_icon === void 0 ? void 0 : _amenitiesDialog_toolbar_icon.description;
    var sheetProps = {
        title: title,
        dialogTabs: dialogTabs,
        description: description,
        takeover: takeover,
        isDialogOpen: isDialogOpen,
        closeDialog: closeDialog,
        triggerRef: triggerRef,
        forwardRef: forwardRef,
        dialogPreviouslyViewed: dialogPreviouslyViewed,
        aboutThisPropertyData: aboutThisPropertyData
    };
    return /* @__PURE__ */ React48.createElement(Viewport12, null, /* @__PURE__ */ React48.createElement(ViewSmall12, null, /* @__PURE__ */ React48.createElement(SheetComponent, _object_spread({
        type: "full"
    }, sheetProps))), /* @__PURE__ */ React48.createElement(ViewMedium9, null, /* @__PURE__ */ React48.createElement(SheetComponent, _object_spread({
        type: "centered"
    }, sheetProps))));
};
AmenitiesDialog.displayName = "AmenitiesDialog";
AmenitiesDialog.fragment = __AmenitiesDialog;
// src/components/summary/__private/__fragments/amenities/amenities-link.tsx
import React49 from "react";
import { gql as gql33 } from "@apollo/client";
import { EGDSIcon as EGDSIcon9 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink3 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing25 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment13 } from "@shared-ui/experiment-context";
import { useLocalization as useLocalization3 } from "@shared-ui/localization-context";
var __AmenitiesLinkFragment = gql33(_templateObject34());
var AmenitiesLink = function(param) {
    var data = param.data, onClick = param.onClick, triggerRef = param.triggerRef;
    var _SummaryAnalyticsMapping_AMENITIES = _sliced_to_array(SummaryAnalyticsMapping["AMENITIES" /* AMENITIES */ ], 2), id = _SummaryAnalyticsMapping_AMENITIES[0], description = _SummaryAnalyticsMapping_AMENITIES[1];
    var track = useClickTracker15();
    var _useExperiment13 = useExperiment13("Remove_About_the_Property_Web"), topOfPDPRedesignExposure = _useExperiment13.exposure;
    var isTopOfPDPRedesignVariant = topOfPDPRedesignExposure.bucket === 1;
    var formatText = useLocalization3().formatText;
    var localizedText = formatText("seeAllButton.text");
    var handleClick = React49.useCallback(function(event) {
        event.preventDefault();
        track(id, description, true);
        onClick();
    }, [
        track,
        id,
        description,
        onClick
    ]);
    var amenitiesDialog = data.amenitiesDialog;
    if (!amenitiesDialog) {
        return null;
    }
    var _amenitiesDialog_trigger = amenitiesDialog.trigger, value = _amenitiesDialog_trigger.value, accessibilityLabel = _amenitiesDialog_trigger.accessibilityLabel, icon = _amenitiesDialog_trigger.icon;
    var buttonText = isTopOfPDPRedesignVariant ? value : localizedText || value;
    var iconId = (icon === null || icon === void 0 ? void 0 : icon.iconId) || "";
    return /* @__PURE__ */ React49.createElement(EGDSSpacing25, {
        padding: {
            blockstart: isTopOfPDPRedesignVariant ? void 0 : "three",
            blockend: "unset"
        }
    }, /* @__PURE__ */ React49.createElement(EGDSLink3, {
        align: "left",
        onClick: handleClick,
        domRef: triggerRef
    }, /* @__PURE__ */ React49.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React49.createElement("span", {
        "aria-hidden": true
    }, buttonText), accessibilityLabel && /* @__PURE__ */ React49.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React49.createElement(EGDSIcon9, {
        name: iconId
    }))));
};
AmenitiesLink.displayName = "AmenitiesLink";
AmenitiesLink.fragment = __AmenitiesLinkFragment;
// src/components/property-see-all-amenities/see-all-amenities.tsx
var __SummarySeeAllAmenitiesQuery = gql34(_templateObject35(), __PropertyInfoContent, PropertyContent.fragment, AmenitiesLink.fragment, AmenitiesDialog.fragment, RelevantAmenities.fragment, AmenitiesTabs.fragment, PropertyContentSectionGroup2.fragment);
var SeeAllAmenitiesComponent = function(props) {
    var _amenities_topAmenities_items, _amenities_topAmenities;
    var context = useBexApi6().context;
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var _useDialog6 = _sliced_to_array(useDialog6("property-amenities-dialog", "pwaDialog"), 3), isDialogOpen = _useDialog6[0], dialogActions = _useDialog6[1], DialogComponent = _useDialog6[2];
    var triggerAmenitiesRef = React50.useRef(null);
    var _React50_useState = _sliced_to_array(React50.useState(false), 2), dialogPreviouslyViewed = _React50_useState[0], setDialogPreviouslyViewed = _React50_useState[1];
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery5 = useQuery5(__SummarySeeAllAmenitiesQuery, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery5.data, error = _useQuery5.error, loading = _useQuery5.loading;
    var propertyInfo = (data !== null && data !== void 0 ? data : {}).propertyInfo;
    var _useExperiment14 = useExperiment14("Remove_About_the_Property_Web"), topOfPDPRedesignExposure = _useExperiment14.exposure;
    var isTopOfPDPRedesignVariant = topOfPDPRedesignExposure.bucket === 1;
    if (loading) {
        return /* @__PURE__ */ React50.createElement(EGDSSpacing26, {
            padding: {
                blockstart: isTopOfPDPRedesignVariant ? void 0 : "three",
                blockend: "unset"
            }
        }, /* @__PURE__ */ React50.createElement(EGDSLineSkeleton, {
            animation: true
        }));
    }
    if (error || !(propertyInfo === null || propertyInfo === void 0 ? void 0 : propertyInfo.summary)) {
        return null;
    }
    var amenities = (propertyInfo.summary || {}).amenities;
    var tabs = (amenities || {}).tabs;
    if (!(amenities === null || amenities === void 0 ? void 0 : (_amenities_topAmenities = amenities.topAmenities) === null || _amenities_topAmenities === void 0 ? void 0 : (_amenities_topAmenities_items = _amenities_topAmenities.items) === null || _amenities_topAmenities_items === void 0 ? void 0 : _amenities_topAmenities_items.length)) {
        return null;
    }
    var onClose = function() {
        dialogActions.closeDialog();
        setDialogPreviouslyViewed(true);
    };
    return /* @__PURE__ */ React50.createElement(React50.Fragment, null, /* @__PURE__ */ React50.createElement(AmenitiesLink, {
        key: "amenities-link",
        data: amenities,
        onClick: dialogActions.openDialog,
        triggerRef: triggerAmenitiesRef
    }), /* @__PURE__ */ React50.createElement(EGDSSheetTransition8, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React50.createElement(DialogComponent, null, /* @__PURE__ */ React50.createElement(AmenitiesDialog, {
        data: amenities,
        dialogTabs: tabs,
        closeDialog: onClose,
        isDialogOpen: isDialogOpen,
        triggerRef: triggerAmenitiesRef,
        dialogPreviouslyViewed: dialogPreviouslyViewed,
        aboutThisPropertyData: propertyInfo
    }))));
};
SeeAllAmenitiesComponent.displayName = "sharedui-SeeAllAmenities";
var PropertySeeAllAmenities = SeeAllAmenitiesComponent;
// src/components/property-details.tsx
import React119, { useContext as useContext3, useEffect as useEffect8 } from "react";
import { gql as gql83, useQuery as useQuery6 } from "@apollo/client";
import { useBexApi as useBexApi11 } from "@shared-ui/bex-api-context";
import { useExperiment as useExperiment23 } from "@shared-ui/experiment-context";
import { AboutThisProperty as AboutThisProperty3, DetailedAmenities, HostProfile as HostProfile2, ImportantInfo, Policies, SpecialFeatures } from "@shared-ui/lodging-fragments";
import { __Query as __RandomAccessOneQuery, IdentifierType as IdentifierType9 } from "@shared-ui/retail-product-random-access-one";
// src/context/random-access-one-context.tsx
import React51, { createContext as createContext2, useMemo } from "react";
var RandomAccessOneContext = createContext2({
    isRandomAccessOne: false,
    data: void 0
});
var RandomAccessOneContextProvider = function(param) {
    var data = param.data, children = param.children;
    var contextValue = useMemo(function() {
        var _data_randomAccessOne_mapping, _data_randomAccessOne;
        return {
            isRandomAccessOne: !!(data === null || data === void 0 ? void 0 : (_data_randomAccessOne = data.randomAccessOne) === null || _data_randomAccessOne === void 0 ? void 0 : (_data_randomAccessOne_mapping = _data_randomAccessOne.mapping) === null || _data_randomAccessOne_mapping === void 0 ? void 0 : _data_randomAccessOne_mapping.length),
            data: data
        };
    }, [
        data
    ]);
    return /* @__PURE__ */ React51.createElement(RandomAccessOneContext.Provider, {
        value: contextValue
    }, children);
};
// src/components/about-this-property-summary/about-this-property-summary.tsx
import React55 from "react";
import Lazyload from "react-lazy-load";
import { gql as gql38 } from "@apollo/client";
import { EGDSIcon as EGDSIcon10 } from "@egds/react-core/icons";
import { UitkFigure, UitkFigureAspectRatioType } from "@egds/react-core/images";
import { EGDSLayoutGridItem as EGDSLayoutGridItem9 } from "@egds/react-core/layout-grid";
import { EGDSLink as EGDSLink4 } from "@egds/react-core/link";
import { EGDSSheetTransition as EGDSSheetTransition10 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing27, UitkSpacing as UitkSpacing4 } from "@egds/react-core/spacing";
import { UitkVideo } from "@egds/react-core/video";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog7 } from "@shared-ui/dialog-context";
import { Experiment as Experiment4, ExperimentControl as ExperimentControl4, ExperimentVariant as ExperimentVariant4 } from "@shared-ui/experiment-context";
// src/components/about-this-property-summary/__private/__fragments/about-this-property-dialog.tsx
import React53 from "react";
import { gql as gql36 } from "@apollo/client";
import { EGDSSheet as EGDSSheet8, EGDSSheetContent as EGDSSheetContent5, EGDSSheetTransition as EGDSSheetTransition9 } from "@egds/react-core/sheet";
import { EGDSToolbar as EGDSToolbar6 } from "@egds/react-core/toolbar";
import { AboutThisProperty as AboutThisProperty2, PropertyContentSectionGroup as PropertyContentSectionGroup4 } from "@shared-ui/lodging-fragments";
import { ViewMedium as ViewMedium10, Viewport as Viewport13, ViewSmall as ViewSmall13 } from "@shared-ui/viewport-context";
// src/components/about-this-property-summary/__private/__fragments/property-host.tsx
import React52 from "react";
import { gql as gql35 } from "@apollo/client";
import { EGDSAvatar } from "@egds/react-core/avatar";
import { EGDSCard as EGDSCard4, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex14, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { UitkSpacing as UitkSpacing3, UitkSpacingHr } from "@egds/react-core/spacing";
import { UitkHeading as UitkHeading3, UitkSubheading, UitkText as UitkText2 } from "@egds/react-core/text";
import { PropertyContentSectionGroup as PropertyContentSectionGroup3, PropertyContentSubSection } from "@shared-ui/lodging-fragments";
var __HostProfileFragment = gql35(_templateObject36(), PropertyContentSectionGroup3.fragment);
var HostProfile = function(props) {
    var _data_propertyContentSectionGroups, _sections__bodySubSections__elementsV2_, _sections__bodySubSections_, _sections_, _sections_1, _sections_2, _header_headerImage, _header_headerImage1, _sections__header, _sections_3;
    var data = props.data, isRedesignDialog = props.isRedesignDialog;
    var content = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.aboutThisHost;
    if (!content) {
        return null;
    }
    var sections = content.sections;
    var hostElement = (_sections_ = sections[0]) === null || _sections_ === void 0 ? void 0 : (_sections__bodySubSections_ = _sections_.bodySubSections[0]) === null || _sections__bodySubSections_ === void 0 ? void 0 : (_sections__bodySubSections__elementsV2_ = _sections__bodySubSections_.elementsV2[0]) === null || _sections__bodySubSections__elementsV2_ === void 0 ? void 0 : _sections__bodySubSections__elementsV2_.elements[0];
    var hostSubSections = (_sections_1 = sections[0]) === null || _sections_1 === void 0 ? void 0 : _sections_1.bodySubSections;
    var hostDescriptionSection = (_sections_2 = sections[0]) === null || _sections_2 === void 0 ? void 0 : _sections_2.bodySubSections[1];
    if (!hostElement || hostElement.__typename !== "PropertyContent") {
        return null;
    }
    var header = (hostElement || {}).header;
    var headerText = header === null || header === void 0 ? void 0 : header.text;
    var headerSubText = header === null || header === void 0 ? void 0 : header.subText;
    var hostImg = header === null || header === void 0 ? void 0 : (_header_headerImage = header.headerImage) === null || _header_headerImage === void 0 ? void 0 : _header_headerImage.url;
    var hostImgDescription = header === null || header === void 0 ? void 0 : (_header_headerImage1 = header.headerImage) === null || _header_headerImage1 === void 0 ? void 0 : _header_headerImage1.description;
    var hostAvatar = /* @__PURE__ */ React52.createElement(UitkSpacing3, {
        padding: {
            blockstart: "four",
            blockend: "four"
        }
    }, /* @__PURE__ */ React52.createElement(EGDSLayoutFlex14, {
        space: "two"
    }, /* @__PURE__ */ React52.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */ React52.createElement(EGDSAvatar, {
        border: false,
        image: {
            alt: hostImgDescription || "",
            src: hostImg
        },
        size: "extra_large"
    })), /* @__PURE__ */ React52.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */ React52.createElement("div", null, /* @__PURE__ */ React52.createElement(UitkSubheading, null, headerText), /* @__PURE__ */ React52.createElement(UitkText2, {
        inline: "strong",
        spacing: "four",
        size: 500
    }, headerSubText)))));
    return isRedesignDialog ? /* @__PURE__ */ React52.createElement(EGDSCard4, null, /* @__PURE__ */ React52.createElement(UitkSpacingHr, null), /* @__PURE__ */ React52.createElement(EGDSCardContentSection, {
        padded: false
    }, /* @__PURE__ */ React52.createElement(UitkSpacing3, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React52.createElement("div", null, /* @__PURE__ */ React52.createElement(UitkHeading3, {
        tag: "h3",
        size: 5
    }, (_sections_3 = sections[0]) === null || _sections_3 === void 0 ? void 0 : (_sections__header = _sections_3.header) === null || _sections__header === void 0 ? void 0 : _sections__header.text), /* @__PURE__ */ React52.createElement(UitkSpacing3, {
        padding: {
            blockstart: "three"
        }
    }, hostAvatar), hostDescriptionSection && (hostSubSections === null || hostSubSections === void 0 ? void 0 : hostSubSections.slice(1).map(function(bodySubSection, i) {
        return /* @__PURE__ */ React52.createElement(PropertyContentSubSection, {
            key: "host-subsection-".concat(i),
            data: bodySubSection
        });
    })))))) : /* @__PURE__ */ React52.createElement(UitkSpacing3, {
        padding: {
            blockstart: "three"
        }
    }, hostAvatar);
};
HostProfile.fragment = __HostProfileFragment;
HostProfile.displayName = "HostProfile";
// src/components/about-this-property-summary/__private/__fragments/about-this-property-dialog.tsx
var __AboutThisPropertyDialog = gql36(_templateObject37(), PropertyContentSectionGroup4.fragment);
var SheetComponent2 = function(param) {
    var type = param.type, description = param.description, data = param.data, closeDialog = param.closeDialog, isDialogOpen = param.isDialogOpen, triggerRef = param.triggerRef;
    return /* @__PURE__ */ React53.createElement(EGDSSheetTransition9, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React53.createElement(EGDSSheet8, {
        returnFocusOnClose: true,
        type: type,
        triggerRef: triggerRef,
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React53.createElement(EGDSToolbar6, {
        navigationContent: {
            onClick: closeDialog,
            navType: "close",
            navIconLabel: description
        }
    }), /* @__PURE__ */ React53.createElement(EGDSSheetContent5, null, /* @__PURE__ */ React53.createElement(AboutThisProperty2, {
        data: data,
        columns: 1
    }), /* @__PURE__ */ React53.createElement(HostProfile, {
        data: data,
        columns: 1,
        isRedesignDialog: true
    }))));
};
var AboutThisPropertyDialog = function(param) {
    var data = param.data, closeDialog = param.closeDialog, isDialogOpen = param.isDialogOpen, triggerRef = param.triggerRef;
    var sheetProps = {
        data: data,
        closeDialog: closeDialog,
        isDialogOpen: isDialogOpen,
        triggerRef: triggerRef
    };
    return /* @__PURE__ */ React53.createElement(Viewport13, null, /* @__PURE__ */ React53.createElement(ViewSmall13, null, /* @__PURE__ */ React53.createElement(SheetComponent2, _object_spread({
        type: "full"
    }, sheetProps))), /* @__PURE__ */ React53.createElement(ViewMedium10, null, /* @__PURE__ */ React53.createElement(SheetComponent2, _object_spread({
        type: "centered"
    }, sheetProps))));
};
AboutThisPropertyDialog.displayName = "AboutThisPropertyDialog";
AboutThisPropertyDialog.fragment = __AboutThisPropertyDialog;
// src/components/about-this-property-summary/__private/__fragments/property-info.tsx
import React54 from "react";
import { gql as gql37 } from "@apollo/client";
import { EGDSText as EGDSText9 } from "@egds/react-core/text";
import { EGDSUnformattedHtml } from "@egds/react-core/unformatted-html";
import { PropertyContentSectionGroup as PropertyContentSectionGroup5 } from "@shared-ui/lodging-fragments";
var __PropertyInfoFragment = gql37(_templateObject38(), PropertyContentSectionGroup5.fragment);
function findPropertyContentItemMarkup(bodySubSections) {
    return bodySubSections ? bodySubSections.flatMap(function(section) {
        return section.elementsV2.flatMap(function(elementV2) {
            return elementV2.elements.filter(function(element) {
                return element.__typename === "PropertyContent";
            }).flatMap(function(element) {
                return element.items.filter(function(item) {
                    return item.__typename === "PropertyContentItemMarkup";
                });
            });
        });
    }) : [];
}
var PropertyInfo = function(props) {
    var _data_propertyContentSectionGroups, _content_sections_, _propertyDescriptionItems_;
    var data = props.data;
    var content = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.aboutThisProperty;
    var bodySubSections = content === null || content === void 0 ? void 0 : (_content_sections_ = content.sections[0]) === null || _content_sections_ === void 0 ? void 0 : _content_sections_.bodySubSections;
    var propertyDescriptionItems = findPropertyContentItemMarkup(bodySubSections);
    var propertyDescription = propertyDescriptionItems === null || propertyDescriptionItems === void 0 ? void 0 : (_propertyDescriptionItems_ = propertyDescriptionItems[0]) === null || _propertyDescriptionItems_ === void 0 ? void 0 : _propertyDescriptionItems_.content.text;
    return propertyDescription ? /* @__PURE__ */ React54.createElement(EGDSText9, {
        size: 300,
        overflow: "truncate-2-lines"
    }, /* @__PURE__ */ React54.createElement("div", {
        "data-stid": "content-markup"
    }, /* @__PURE__ */ React54.createElement(EGDSUnformattedHtml, {
        htmlToParse: propertyDescription
    }))) : null;
};
PropertyInfo.fragment = __PropertyInfoFragment;
PropertyInfo.displayName = "PropertyInfo";
// src/components/about-this-property-summary/about-this-property-summary.tsx
var __AboutThisPropertySummaryFragment = gql38(_templateObject39(), PropertyInfo.fragment, HostProfile.fragment, AboutThisPropertyDialog.fragment);
var AboutThisPropertySummary = function(props) {
    var _data_propertyContentSectionGroups_aboutThisProperty_sections, _data_propertyContentSectionGroups_aboutThisProperty, _data_propertyContentSectionGroups, _data_propertyContentSectionGroups_aboutThisHost_sections, _data_propertyContentSectionGroups_aboutThisHost, _data_propertyContentSectionGroups1, _data_propertyContentSectionGroups2, _data_propertyContentSectionGroups_aboutThisHost1, _data_propertyContentSectionGroups3, _aboutThisHostAction_trigger, _aboutThisPropertyContent_sections__bodySubSections__elementsV2_, _aboutThisPropertyContent_sections__bodySubSections_, _aboutThisPropertyContent_sections_, _propertyDescriptionVideoURL_url, _aboutThisHostTrigger_icon;
    var data = props.data;
    var track = useClickTracker16();
    var triggerAboutThisPropertyRef = React55.useRef(null);
    var _useDialog7 = _sliced_to_array(useDialog7("about-this-property-dialog", "suvrPropertyDetailsDialog"), 3), isDialogOpen = _useDialog7[0], dialogActions = _useDialog7[1], DialogComponent = _useDialog7[2];
    if (!(data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : (_data_propertyContentSectionGroups_aboutThisProperty = _data_propertyContentSectionGroups.aboutThisProperty) === null || _data_propertyContentSectionGroups_aboutThisProperty === void 0 ? void 0 : (_data_propertyContentSectionGroups_aboutThisProperty_sections = _data_propertyContentSectionGroups_aboutThisProperty.sections) === null || _data_propertyContentSectionGroups_aboutThisProperty_sections === void 0 ? void 0 : _data_propertyContentSectionGroups_aboutThisProperty_sections.length) && !(data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups1 = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups1 === void 0 ? void 0 : (_data_propertyContentSectionGroups_aboutThisHost = _data_propertyContentSectionGroups1.aboutThisHost) === null || _data_propertyContentSectionGroups_aboutThisHost === void 0 ? void 0 : (_data_propertyContentSectionGroups_aboutThisHost_sections = _data_propertyContentSectionGroups_aboutThisHost.sections) === null || _data_propertyContentSectionGroups_aboutThisHost_sections === void 0 ? void 0 : _data_propertyContentSectionGroups_aboutThisHost_sections.length)) {
        return null;
    }
    var aboutThisPropertyContent = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups2 = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups2 === void 0 ? void 0 : _data_propertyContentSectionGroups2.aboutThisProperty;
    var aboutThisHostAction = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups3 = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups3 === void 0 ? void 0 : (_data_propertyContentSectionGroups_aboutThisHost1 = _data_propertyContentSectionGroups3.aboutThisHost) === null || _data_propertyContentSectionGroups_aboutThisHost1 === void 0 ? void 0 : _data_propertyContentSectionGroups_aboutThisHost1.action;
    var aboutThisHostActionType = (aboutThisHostAction === null || aboutThisHostAction === void 0 ? void 0 : aboutThisHostAction.__typename) === "PropertyContentSectionDetailedDialog";
    var aboutThisHostTrigger = aboutThisHostActionType && (aboutThisHostAction === null || aboutThisHostAction === void 0 ? void 0 : aboutThisHostAction.trigger);
    var aboutThisHostAnalytics = aboutThisHostActionType && (aboutThisHostAction === null || aboutThisHostAction === void 0 ? void 0 : (_aboutThisHostAction_trigger = aboutThisHostAction.trigger) === null || _aboutThisHostAction_trigger === void 0 ? void 0 : _aboutThisHostAction_trigger.analytics);
    var propertyDescriptionElement = aboutThisPropertyContent === null || aboutThisPropertyContent === void 0 ? void 0 : (_aboutThisPropertyContent_sections_ = aboutThisPropertyContent.sections[0]) === null || _aboutThisPropertyContent_sections_ === void 0 ? void 0 : (_aboutThisPropertyContent_sections__bodySubSections_ = _aboutThisPropertyContent_sections_.bodySubSections[0]) === null || _aboutThisPropertyContent_sections__bodySubSections_ === void 0 ? void 0 : (_aboutThisPropertyContent_sections__bodySubSections__elementsV2_ = _aboutThisPropertyContent_sections__bodySubSections_.elementsV2[0]) === null || _aboutThisPropertyContent_sections__bodySubSections__elementsV2_ === void 0 ? void 0 : _aboutThisPropertyContent_sections__bodySubSections__elementsV2_.elements[0];
    var propertyDescriptionVideo = (propertyDescriptionElement === null || propertyDescriptionElement === void 0 ? void 0 : propertyDescriptionElement.__typename) === "PropertyContent" ? propertyDescriptionElement.leadingGraphic : null;
    var propertyDescriptionVideoURL = (propertyDescriptionVideo === null || propertyDescriptionVideo === void 0 ? void 0 : propertyDescriptionVideo.__typename) === "Video" ? propertyDescriptionVideo : null;
    if (!aboutThisHostTrigger || !aboutThisHostAnalytics) {
        return null;
    }
    var handleClick = function() {
        dialogActions.openDialog();
        var referrerId = aboutThisHostAnalytics.referrerId, linkName = aboutThisHostAnalytics.linkName;
        track(referrerId, linkName, true);
    };
    var onClose = function() {
        dialogActions.closeDialog();
    };
    var leadingGraphicComponent = /* @__PURE__ */ React55.createElement(Experiment4, {
        name: "Add_PDP_YouTube_Videos"
    }, /* @__PURE__ */ React55.createElement(ExperimentControl4, null), /* @__PURE__ */ React55.createElement(ExperimentVariant4, {
        bucket: 1
    }, /* @__PURE__ */ React55.createElement(EGDSSpacing27, {
        margin: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React55.createElement(EGDSLayoutGridItem9, {
        colSpan: {
            medium: 1,
            large: 1
        },
        rowSpan: {
            medium: 1,
            large: 1
        }
    }, /* @__PURE__ */ React55.createElement(UitkFigure, {
        ratio: UitkFigureAspectRatioType.R16_9
    }, /* @__PURE__ */ React55.createElement(UitkVideo, {
        src: propertyDescriptionVideoURL === null || propertyDescriptionVideoURL === void 0 ? void 0 : (_propertyDescriptionVideoURL_url = propertyDescriptionVideoURL.url) === null || _propertyDescriptionVideoURL_url === void 0 ? void 0 : _propertyDescriptionVideoURL_url.value,
        alt: propertyDescriptionVideoURL === null || propertyDescriptionVideoURL === void 0 ? void 0 : propertyDescriptionVideoURL.description
    }))))));
    return /* @__PURE__ */ React55.createElement("div", null, propertyDescriptionVideoURL && /* @__PURE__ */ React55.createElement(Lazyload, null, leadingGraphicComponent), /* @__PURE__ */ React55.createElement(PropertyInfo, {
        data: data
    }), /* @__PURE__ */ React55.createElement(HostProfile, {
        data: data
    }), /* @__PURE__ */ React55.createElement(UitkSpacing4, {
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React55.createElement(EGDSLink4, {
        align: "left",
        onClick: handleClick
    }, /* @__PURE__ */ React55.createElement("button", {
        type: "button",
        name: (_aboutThisHostTrigger_icon = aboutThisHostTrigger.icon) === null || _aboutThisHostTrigger_icon === void 0 ? void 0 : _aboutThisHostTrigger_icon.description
    }, /* @__PURE__ */ React55.createElement("span", {
        "aria-hidden": true
    }, aboutThisHostTrigger.message), aboutThisHostTrigger.icon && /* @__PURE__ */ React55.createElement(EGDSIcon10, {
        name: aboutThisHostTrigger.icon.token,
        description: aboutThisHostTrigger.icon.description,
        id: aboutThisHostTrigger.icon.id,
        title: aboutThisHostTrigger.icon.id
    })))), /* @__PURE__ */ React55.createElement(EGDSSheetTransition10, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React55.createElement(DialogComponent, null, /* @__PURE__ */ React55.createElement(AboutThisPropertyDialog, {
        data: data,
        closeDialog: onClose,
        isDialogOpen: isDialogOpen,
        triggerRef: triggerAboutThisPropertyRef
    }))));
};
AboutThisPropertySummary.displayName = "AboutThisPropertySummary";
AboutThisPropertySummary.fragment = __AboutThisPropertySummaryFragment;
// src/components/amenities-simplified-view/amenities-simplified-view.tsx
import React56 from "react";
import { gql as gql39 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing28 } from "@egds/react-core/spacing";
import { PropertyInfoContent as PropertyInfoContent4 } from "@shared-ui/lodging-fragments";
var __AmenitiesSimplifiedViewFragment = gql39(_templateObject40(), PropertyInfoContent4.fragment);
var AmenitiesSimplifiedView = function(props) {
    var _data_summary_amenities, _data_summary;
    var data = props.data;
    var topAmenities = data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_amenities = _data_summary.amenities) === null || _data_summary_amenities === void 0 ? void 0 : _data_summary_amenities.topAmenities;
    var items = topAmenities === null || topAmenities === void 0 ? void 0 : topAmenities.items;
    if (!topAmenities || !items || items.length === 0) {
        return null;
    }
    var smallIconItemsProps = {
        columns: 2,
        space: "two",
        subset: 6
    };
    var largeIconItemsProps = {
        columns: 6,
        rows: 1,
        space: "three",
        subset: 6
    };
    return /* @__PURE__ */ React56.createElement(EGDSSpacing28, {
        margin: {
            blockend: "three"
        },
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React56.createElement("div", null, /* @__PURE__ */ React56.createElement(PropertyInfoContent4, {
        data: topAmenities,
        small: _object_spread_props(_object_spread({}, smallIconItemsProps), {
            prefix: "highlightedAmenities"
        }),
        large: _object_spread_props(_object_spread({}, largeIconItemsProps), {
            prefix: "highlightedAmenities"
        })
    })));
};
AmenitiesSimplifiedView.displayName = "AmenitiesSimplifiedView";
AmenitiesSimplifiedView.fragment = __AmenitiesSimplifiedViewFragment;
// src/components/amenity-description/amenity-description.tsx
import React62, { useEffect as useEffect5 } from "react";
import { gql as gql44 } from "@apollo/client";
import { EGDSCard as EGDSCard5, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing31 } from "@egds/react-core/spacing";
import { ITrackType as ITrackType4, useClickstreamAnalytics as useClickstreamAnalytics4 } from "@shared-ui/clickstream-analytics-context";
import { lightweightAdaptExMicroMessage as lightweightAdaptExMicroMessage4 } from "@shared-ui/lodging-fragments";
import { useInView as useInView6 } from "react-intersection-observer";
// src/components/amenity-description/__private/__fragments/amenity-section.tsx
import React60 from "react";
import { gql as gql43 } from "@apollo/client";
import { EGDSExpandoPeek } from "@egds/react-core/expando";
import { EGDSLayoutColumns } from "@egds/react-core/layout-columns";
import { EGDSLayoutGrid as EGDSLayoutGrid11, EGDSLayoutGridItem as EGDSLayoutGridItem10 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing30 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi7 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge as ViewLarge7, Viewport as Viewport14, ViewSmall as ViewSmall14 } from "@shared-ui/viewport-context";
// src/components/amenity-description/amenity-description-jumplink.tsx
import React57 from "react";
import { gql as gql40 } from "@apollo/client";
import { LodgingJumpLink } from "@shared-ui/lodging-fragments";
var __AmenityDescriptionJumpLinkFragment = gql40(_templateObject41(), LodgingJumpLink.fragment);
var AmenityDescriptionJumpLink = function(param) {
    var action = param.data.action;
    if (!action) {
        return null;
    }
    return /* @__PURE__ */ React57.createElement(LodgingJumpLink, {
        data: action
    });
};
AmenityDescriptionJumpLink.displayName = "AmenityDescriptionJumpLink";
AmenityDescriptionJumpLink.fragment = __AmenityDescriptionJumpLinkFragment;
// src/components/amenity-description/__private/__fragments/amenity-content.tsx
import React58 from "react";
import { gql as gql41 } from "@apollo/client";
import { EGDSIcon as EGDSIcon11, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSLayoutColumnsItem } from "@egds/react-core/layout-columns";
import { EGDSLayoutFlex as EGDSLayoutFlex15, EGDSLayoutFlexItem as EGDSLayoutFlexItem9 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing29 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading10, EGDSText as EGDSText10 } from "@egds/react-core/text";
var __AmenityContentFragment = gql41(_templateObject42());
var AmenityContent = function(param) {
    var data = param.data;
    var heading = data.heading, items = data.items, icon = data.icon, structuredData = data.structuredData;
    if (!heading) {
        return null;
    }
    var isAmenityFeature = (structuredData === null || structuredData === void 0 ? void 0 : structuredData.itemprop) === "amenityFeature";
    var isAmenityLanguage = (structuredData === null || structuredData === void 0 ? void 0 : structuredData.itemprop) === "availableLanguage";
    return /* @__PURE__ */ React58.createElement(EGDSSpacing29, {
        margin: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React58.createElement("div", null, /* @__PURE__ */ React58.createElement(EGDSLayoutColumnsItem, {
        forceNoBreak: true
    }, /* @__PURE__ */ React58.createElement("div", {
        itemProp: structuredData === null || structuredData === void 0 ? void 0 : structuredData.itemprop,
        itemScope: structuredData === null || structuredData === void 0 ? void 0 : structuredData.itemscope,
        itemType: structuredData === null || structuredData === void 0 ? void 0 : structuredData.itemtype
    }, /* @__PURE__ */ React58.createElement(EGDSLayoutFlex15, {
        space: "two"
    }, /* @__PURE__ */ React58.createElement(EGDSLayoutFlexItem9, null, /* @__PURE__ */ React58.createElement(EGDSSpacing29, {
        padding: {
            inlineend: "three"
        }
    }, /* @__PURE__ */ React58.createElement(EGDSIcon11, {
        name: (icon === null || icon === void 0 ? void 0 : icon.iconId) || "",
        size: EGDSIconSize2.MEDIUM
    }))), /* @__PURE__ */ React58.createElement("span", {
        itemProp: isAmenityFeature ? "name" : void 0
    }, /* @__PURE__ */ React58.createElement(EGDSHeading10, {
        tag: "h3",
        size: 5
    }, heading))), (items === null || items === void 0 ? void 0 : items.length) > 0 && /* @__PURE__ */ React58.createElement(EGDSSpacing29, {
        padding: {
            inlinestart: "twelve"
        }
    }, /* @__PURE__ */ React58.createElement("ul", {
        className: "no-bullet"
    }, items.map(function(item, index) {
        return /* @__PURE__ */ React58.createElement(EGDSSpacing29, {
            margin: {
                blockstart: "two"
            },
            key: index
        }, /* @__PURE__ */ React58.createElement("li", {
            itemProp: isAmenityLanguage ? "name" : void 0
        }, /* @__PURE__ */ React58.createElement(EGDSText10, {
            size: 300,
            theme: "standard"
        }, item.text), isAmenityFeature && /* @__PURE__ */ React58.createElement("meta", {
            itemProp: "value",
            content: item.text
        })));
    })))))));
};
AmenityContent.displayName = "AmenityContent";
AmenityContent.fragment = __AmenityContentFragment;
// src/components/amenity-description/__private/__fragments/amenity-heading.tsx
import React59 from "react";
import { gql as gql42 } from "@apollo/client";
import { EGDSHeading as EGDSHeading11, EGDSText as EGDSText11 } from "@egds/react-core/text";
var __AmenityHeadingFragment = gql42(_templateObject43());
var AmenityHeading = function(param) {
    var data = param.data;
    var text = data.text, subText = data.subText;
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React59.createElement(React59.Fragment, null, /* @__PURE__ */ React59.createElement(EGDSHeading11, {
        tag: "h2",
        size: 4,
        tabIndex: -1
    }, text), subText && /* @__PURE__ */ React59.createElement(EGDSText11, {
        spacing: "two"
    }, subText));
};
AmenityHeading.displayName = "AmenityHeading";
AmenityHeading.fragment = __AmenityHeadingFragment;
// src/components/amenity-description/__private/__fragments/amenity-section.tsx
var __AmenitySectionFragment = gql43(_templateObject44(), AmenityHeading.fragment, AmenityContent.fragment, AmenityDescriptionJumpLink.fragment);
var AmenitySection = function(param) {
    var data = param.data, isExpandoSection = param.isExpandoSection, displayThreshold = param.displayThreshold, isFullyCollapsible = param.isFullyCollapsible;
    var _context_device, _expandButton_analytics, _collapseButton_analytics, _expandButton_analytics1, _collapseButton_analytics1;
    var context = useBexApi7().context;
    var isMobile = (context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */ ;
    var _ref = data || {}, contents = _ref.contents, header = _ref.header, expando = _ref.expando;
    var _React60_useState = _sliced_to_array(React60.useState(false), 2), isVisible = _React60_useState[0], setIsVisible = _React60_useState[1];
    var track = useClickTracker17();
    if (!(contents === null || contents === void 0 ? void 0 : contents.length)) {
        return null;
    }
    var _ref1 = expando || {}, expandButton = _ref1.expandButton, collapseButton = _ref1.collapseButton, items = _ref1.items;
    var expandoReferrerId = !isVisible ? expandButton === null || expandButton === void 0 ? void 0 : (_expandButton_analytics = expandButton.analytics) === null || _expandButton_analytics === void 0 ? void 0 : _expandButton_analytics.referrerId : collapseButton === null || collapseButton === void 0 ? void 0 : (_collapseButton_analytics = collapseButton.analytics) === null || _collapseButton_analytics === void 0 ? void 0 : _collapseButton_analytics.referrerId;
    var expandoLinkName = !isVisible ? expandButton === null || expandButton === void 0 ? void 0 : (_expandButton_analytics1 = expandButton.analytics) === null || _expandButton_analytics1 === void 0 ? void 0 : _expandButton_analytics1.linkName : collapseButton === null || collapseButton === void 0 ? void 0 : (_collapseButton_analytics1 = collapseButton.analytics) === null || _collapseButton_analytics1 === void 0 ? void 0 : _collapseButton_analytics1.linkName;
    var expandoPeekAnalysis = {
        id: expandoReferrerId !== null && expandoReferrerId !== void 0 ? expandoReferrerId : "",
        description: expandoLinkName !== null && expandoLinkName !== void 0 ? expandoLinkName : "",
        callback: function(refererId, lnkName) {
            track(refererId, lnkName);
        }
    };
    var showDatedPDPExpando = expando && items && items > 0;
    var getThresholdValue = function() {
        if (items && items < 0) {
            return displayThreshold;
        }
        if (items && items > 0 && isMobile) {
            return items;
        }
        return 0;
    };
    var _expandButton_accessibilityLabel, _collapseButton_accessibilityLabel;
    return /* @__PURE__ */ React60.createElement(React60.Fragment, null, isExpandoSection || showDatedPDPExpando ? /* @__PURE__ */ React60.createElement(Viewport14, null, /* @__PURE__ */ React60.createElement(ViewSmall14, null, /* @__PURE__ */ React60.createElement(React60.Fragment, null, header && /* @__PURE__ */ React60.createElement(EGDSSpacing30, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(AmenityHeading, {
        data: header
    }))), /* @__PURE__ */ React60.createElement(EGDSExpandoPeek, {
        analytics: expandoPeekAnalysis,
        isVisible: isVisible,
        handleClick: function() {
            return setIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        expandLabel: expandButton === null || expandButton === void 0 ? void 0 : expandButton.text,
        collapseLabel: collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.text,
        items: getThresholdValue(),
        hideScrim: !showDatedPDPExpando,
        whitespace: !showDatedPDPExpando
    }, contents.map(function(content, index) {
        return /* @__PURE__ */ React60.createElement(AmenityContent, {
            key: "amenity-content-".concat(index),
            data: content
        });
    })))), /* @__PURE__ */ React60.createElement(ViewLarge7, null, /* @__PURE__ */ React60.createElement(EGDSLayoutGrid11, {
        columns: {
            medium: 3
        },
        space: "six"
    }, header && /* @__PURE__ */ React60.createElement(EGDSLayoutGridItem10, {
        colSpan: 1
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(AmenityHeading, {
        data: header
    }))), /* @__PURE__ */ React60.createElement(EGDSLayoutGridItem10, {
        colSpan: 2
    }, /* @__PURE__ */ React60.createElement(EGDSExpandoPeek, {
        analytics: expandoPeekAnalysis,
        isVisible: isVisible,
        handleClick: function() {
            return setIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        expandLabel: expandButton === null || expandButton === void 0 ? void 0 : expandButton.text,
        collapseLabel: collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.text,
        expandA11yLabel: (_expandButton_accessibilityLabel = expandButton === null || expandButton === void 0 ? void 0 : expandButton.accessibilityLabel) !== null && _expandButton_accessibilityLabel !== void 0 ? _expandButton_accessibilityLabel : "",
        collapseA11yLabel: (_collapseButton_accessibilityLabel = collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.accessibilityLabel) !== null && _collapseButton_accessibilityLabel !== void 0 ? _collapseButton_accessibilityLabel : "",
        items: getThresholdValue(),
        hideScrim: true
    }, /* @__PURE__ */ React60.createElement(EGDSLayoutColumns, {
        minWidth: "half_width",
        columns: 2,
        space: "twelve"
    }, contents.map(function(content, index) {
        return /* @__PURE__ */ React60.createElement(AmenityContent, {
            key: "amenity-content-".concat(index),
            data: content
        });
    }))))))) : /* @__PURE__ */ React60.createElement(Viewport14, null, /* @__PURE__ */ React60.createElement(ViewSmall14, null, /* @__PURE__ */ React60.createElement(React60.Fragment, null, header && !isFullyCollapsible && /* @__PURE__ */ React60.createElement(EGDSSpacing30, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(AmenityHeading, {
        data: header
    }))), contents.map(function(content, index) {
        return /* @__PURE__ */ React60.createElement(AmenityContent, {
            key: "amenity-content-".concat(index),
            data: content
        });
    }))), /* @__PURE__ */ React60.createElement(ViewLarge7, null, /* @__PURE__ */ React60.createElement(EGDSLayoutGrid11, {
        columns: {
            medium: 3
        },
        space: "six"
    }, header && !isFullyCollapsible && /* @__PURE__ */ React60.createElement(EGDSLayoutGridItem10, {
        colSpan: 1
    }, /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(AmenityHeading, {
        data: header
    }))), /* @__PURE__ */ React60.createElement(EGDSLayoutGridItem10, {
        colSpan: isFullyCollapsible ? void 0 : 2,
        colStart: isFullyCollapsible ? 2 : void 0,
        colEnd: isFullyCollapsible ? 4 : void 0
    }, /* @__PURE__ */ React60.createElement(EGDSLayoutColumns, {
        minWidth: "half_width",
        columns: 2,
        space: "twelve"
    }, contents.map(function(content, index) {
        return /* @__PURE__ */ React60.createElement(AmenityContent, {
            key: "amenity-content-".concat(index),
            data: content
        });
    })))))));
};
AmenitySection.displayName = "AmenitySection";
AmenitySection.fragment = __AmenitySectionFragment;
// src/components/amenity-description/amenity-expando-section.tsx
import React61, { useState as useState4 } from "react";
import { EGDSExpandoList, EGDSExpandoListItem } from "@egds/react-core/expando";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
var AmenityExpandoSection = function(param) {
    var title = param.title, body = param.body, expando = param.expando;
    var _expandButton_analytics, _collapseButton_analytics, _expandButton_analytics1, _collapseButton_analytics1;
    var _useState4 = _sliced_to_array(useState4(false), 2), isVisible = _useState4[0], setIsVisible = _useState4[1];
    var track = useClickTracker18();
    var _ref = expando || {}, expandButton = _ref.expandButton, collapseButton = _ref.collapseButton;
    var expandoReferrerId = !isVisible ? expandButton === null || expandButton === void 0 ? void 0 : (_expandButton_analytics = expandButton.analytics) === null || _expandButton_analytics === void 0 ? void 0 : _expandButton_analytics.referrerId : collapseButton === null || collapseButton === void 0 ? void 0 : (_collapseButton_analytics = collapseButton.analytics) === null || _collapseButton_analytics === void 0 ? void 0 : _collapseButton_analytics.referrerId;
    var expandoLinkName = !isVisible ? expandButton === null || expandButton === void 0 ? void 0 : (_expandButton_analytics1 = expandButton.analytics) === null || _expandButton_analytics1 === void 0 ? void 0 : _expandButton_analytics1.linkName : collapseButton === null || collapseButton === void 0 ? void 0 : (_collapseButton_analytics1 = collapseButton.analytics) === null || _collapseButton_analytics1 === void 0 ? void 0 : _collapseButton_analytics1.linkName;
    return /* @__PURE__ */ React61.createElement(EGDSExpandoList, null, /* @__PURE__ */ React61.createElement(EGDSExpandoListItem, {
        isVisible: isVisible,
        onToggle: function() {
            if (expandoReferrerId && expandoLinkName) {
                track(expandoReferrerId, expandoLinkName);
            }
            setIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        triggerPosition: "trailing",
        expandoTitle: title,
        expandoDescription: body
    }));
};
// src/components/amenity-description/amenity-description.tsx
var __AmenityDescriptionFragment = gql44(_templateObject45(), AmenitySection.fragment);
var AmenityDescription = function(props) {
    var _data_summary;
    var data = props.data, isExpandoSection = props.isExpandoSection, displayThreshold = props.displayThreshold, disableSectionSeparator = props.disableSectionSeparator;
    var _ref = (data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.amenities) || {}, amenitySections = _ref.amenities, adaptExAttemptEvents = _ref.viewAmenitiesAdaptExAttemptEvents;
    var amenitySectionLength = amenitySections === null || amenitySections === void 0 ? void 0 : amenitySections.length;
    var track = useClickstreamAnalytics4().track;
    var _useInView6 = useInView6({
        triggerOnce: true,
        threshold: 0.1
    }), ref = _useInView6.ref, inView = _useInView6.inView;
    useEffect5(function() {
        if (inView && (adaptExAttemptEvents === null || adaptExAttemptEvents === void 0 ? void 0 : adaptExAttemptEvents.length)) {
            adaptExAttemptEvents.forEach(function(adaptExAttemptEvent) {
                var _adaptExAttemptEvent_events_, _adaptExAttemptEvent_events_1, _adaptExAttemptEvent_events_2;
                track(ITrackType4.EVENT, {
                    data: lightweightAdaptExMicroMessage4({
                        campaignId: adaptExAttemptEvent.campaignId,
                        payloadId: ((_adaptExAttemptEvent_events_ = adaptExAttemptEvent.events[0]) === null || _adaptExAttemptEvent_events_ === void 0 ? void 0 : _adaptExAttemptEvent_events_.payloadId) || "",
                        eventType: ((_adaptExAttemptEvent_events_1 = adaptExAttemptEvent.events[0]) === null || _adaptExAttemptEvent_events_1 === void 0 ? void 0 : _adaptExAttemptEvent_events_1.eventType) || "",
                        eventTarget: ((_adaptExAttemptEvent_events_2 = adaptExAttemptEvent.events[0]) === null || _adaptExAttemptEvent_events_2 === void 0 ? void 0 : _adaptExAttemptEvent_events_2.eventTarget) || ""
                    })
                });
            });
        }
    }, [
        adaptExAttemptEvents,
        inView,
        track
    ]);
    if (!amenitySections || !amenitySectionLength) {
        return null;
    }
    return /* @__PURE__ */ React62.createElement(EGDSSpacing31, {
        padding: {
            block: "six",
            small: {
                inline: "three"
            },
            large: {
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React62.createElement(EGDSCard5, {
        ref: ref
    }, amenitySections.map(function(amenitySection, index) {
        var _amenitySection_expando;
        var isLastSection = index === amenitySectionLength - 1;
        var border = isLastSection ? void 0 : "bottom";
        var title = amenitySection.header ? /* @__PURE__ */ React62.createElement(AmenityHeading, {
            data: amenitySection.header
        }) : null;
        var isFullyCollapsible = Boolean(title) && ((amenitySection === null || amenitySection === void 0 ? void 0 : (_amenitySection_expando = amenitySection.expando) === null || _amenitySection_expando === void 0 ? void 0 : _amenitySection_expando.items) === 0 || displayThreshold === 0);
        var body = /* @__PURE__ */ React62.createElement(EGDSSpacing31, {
            margin: isFullyCollapsible ? {
                small: {
                    blockstart: "six"
                },
                large: {
                    blockstart: "unset"
                }
            } : void 0
        }, /* @__PURE__ */ React62.createElement(EGDSCardContentSection2, {
            border: disableSectionSeparator ? void 0 : border,
            padded: false
        }, /* @__PURE__ */ React62.createElement(AmenitySection, {
            data: amenitySection,
            isExpandoSection: isFullyCollapsible ? void 0 : isExpandoSection,
            displayThreshold: displayThreshold,
            isFullyCollapsible: isFullyCollapsible
        }), /* @__PURE__ */ React62.createElement(AmenityDescriptionJumpLink, {
            data: amenitySection
        })));
        return /* @__PURE__ */ React62.createElement(EGDSSpacing31, {
            margin: isLastSection ? void 0 : {
                blockend: "six"
            },
            padding: isLastSection ? void 0 : {
                blockend: "three"
            },
            key: "amenity-section-".concat(index)
        }, isFullyCollapsible ? /* @__PURE__ */ React62.createElement("div", null, /* @__PURE__ */ React62.createElement(AmenityExpandoSection, {
            title: title,
            body: body,
            expando: amenitySection.expando
        })) : body);
    })));
};
AmenityDescription.displayName = "AmenityDescription";
AmenityDescription.fragment = __AmenityDescriptionFragment;
// src/components/book-by-phone/book-by-phone.tsx
import React63 from "react";
import { gql as gql45 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex16 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink5 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing32 } from "@egds/react-core/spacing";
import { EGDSParagraph } from "@egds/react-core/text";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
var __BookByPhoneFragment = gql45(_templateObject46());
var BookByPhone = function(props) {
    var data = props.data, className = props.className;
    var track = useClickTracker19();
    var handleClick = React63.useCallback(function(linkName2, referrerId2) {
        track(referrerId2, linkName2);
    }, [
        track
    ]);
    if (!(data === null || data === void 0 ? void 0 : data.telesales)) {
        return null;
    }
    var telesales = data.telesales;
    var telesalesNumber = telesales.telesalesNumber, description = telesales.description, tracking = telesales.tracking;
    var phoneNumber = telesalesNumber.phoneNumber, teleUri = telesalesNumber.value;
    var teleDescription = description.value;
    var linkName = tracking.linkName, referrerId = tracking.referrerId;
    return /* @__PURE__ */ React63.createElement(EGDSLayoutFlex16, {
        justifyContent: "center",
        className: className
    }, /* @__PURE__ */ React63.createElement(EGDSSpacing32, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React63.createElement(EGDSParagraph, {
        size: 1
    }, teleDescription)), /* @__PURE__ */ React63.createElement(EGDSLink5, {
        onClick: function() {
            return handleClick(linkName, referrerId);
        },
        inline: true
    }, /* @__PURE__ */ React63.createElement("a", {
        href: teleUri
    }, /* @__PURE__ */ React63.createElement("span", {
        "data-stid": "telesales-number"
    }, phoneNumber))));
};
BookByPhone.displayName = "BookByPhone";
BookByPhone.fragment = __BookByPhoneFragment;
// src/components/book-by-phone/book-by-phone-placeholder.tsx
import React64 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex17 } from "@egds/react-core/layout-flex";
import { EGDSLineSkeleton as EGDSLineSkeleton2 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing33 } from "@egds/react-core/spacing";
var BookByPhonePlaceholder = function(param) {
    var data = param.data, className = param.className;
    if (data === null || data === void 0 ? void 0 : data.telesales) {
        return /* @__PURE__ */ React64.createElement(BookByPhone, {
            data: data,
            className: className
        });
    }
    return /* @__PURE__ */ React64.createElement(EGDSLayoutFlex17, {
        justifyContent: "center",
        className: className
    }, /* @__PURE__ */ React64.createElement(EGDSSpacing33, {
        margin: "one"
    }, /* @__PURE__ */ React64.createElement(EGDSLineSkeleton2, {
        animation: true,
        type: "primary"
    })));
};
// src/components/direct-feedback/direct-feedback-call-to-action.tsx
import React65 from "react";
import { EGDSIcon as EGDSIcon12, EGDSIconSize as EGDSIconSize3 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink6 } from "@egds/react-core/link";
import { EGDSSpacingHr as EGDSSpacingHr2 } from "@egds/react-core/spacing";
import { IntersectionTracker as IntersectionTracker7, useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog8 } from "@shared-ui/dialog-context";
import { DirectFeedbackDialog } from "@shared-ui/retail-customer-direct-feedback";
var DirectFeedbackCallToAction = function(props) {
    var _props_callToAction = props.callToAction, promptId = _props_callToAction.promptId, contextValues = _props_callToAction.contextValues, callToAction = _props_callToAction.callToAction, _props_withHorizontalLine = props.withHorizontalLine, withHorizontalLine = _props_withHorizontalLine === void 0 ? false : _props_withHorizontalLine, _props_align = props.align, align = _props_align === void 0 ? "left" : _props_align;
    var track = useClickTracker20();
    var _useDialog8 = _sliced_to_array(useDialog8(promptId, "cdfPromptDialog"), 2), actions = _useDialog8[1];
    if (callToAction.__typename !== "EGDSStandardLink") {
        return null;
    }
    var analytics = callToAction === null || callToAction === void 0 ? void 0 : callToAction.action.analytics;
    var ctaText = callToAction === null || callToAction === void 0 ? void 0 : callToAction.text;
    var ctaIcon = callToAction === null || callToAction === void 0 ? void 0 : callToAction.icon;
    var handleOnClick = function() {
        actions.openDialog();
        track(analytics.referrerId, analytics.linkName);
    };
    var callToActionElement = /* @__PURE__ */ React65.createElement(React65.Fragment, null, /* @__PURE__ */ React65.createElement(EGDSLink6, {
        onClick: handleOnClick,
        align: align
    }, /* @__PURE__ */ React65.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React65.createElement(EGDSIcon12, {
        name: (ctaIcon === null || ctaIcon === void 0 ? void 0 : ctaIcon.id) || "",
        key: ctaIcon === null || ctaIcon === void 0 ? void 0 : ctaIcon.id,
        size: (ctaIcon === null || ctaIcon === void 0 ? void 0 : ctaIcon.size) && EGDSIconSize3[ctaIcon.size]
    }), ctaText)), withHorizontalLine && /* @__PURE__ */ React65.createElement("div", null, /* @__PURE__ */ React65.createElement(EGDSSpacingHr2, {
        blockMargin: "eight"
    })));
    var impressionAnalytics = {
        // e.g. DirectFeedback.2b633e34-98cb-4d1c-a834-ee11a65ac2ac.CallToAction.impressed
        referrerId: "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.referrerId, ".impressed"),
        linkName: "Direct feedback call to action"
    };
    var content = /* @__PURE__ */ React65.createElement(React65.Fragment, null, callToActionElement, /* @__PURE__ */ React65.createElement(DirectFeedbackDialog, {
        contextValues: contextValues,
        inputs: {
            promptId: promptId
        }
    }));
    return (analytics === null || analytics === void 0 ? void 0 : analytics.referrerId) ? /* @__PURE__ */ React65.createElement(IntersectionTracker7, {
        trackOnce: true,
        referrerId: impressionAnalytics.referrerId,
        linkName: impressionAnalytics.linkName
    }, content) : content;
};
DirectFeedbackCallToAction.displayName = "DirectFeedbackCallToAction";
// src/components/direct-feedback/direct-feedback-prompt-id-fragment.tsx
import React66 from "react";
import { gql as gql46 } from "@apollo/client";
var PropertyDirectFeedbackPromptIdFragment = gql46(_templateObject47());
var PropertyDirectFeedbackCallToAction = function(param) {
    var directFeedback = param.data.directFeedback, withHorizontalLine = param.withHorizontalLine, align = param.align;
    var _directFeedback_callToAction;
    return (directFeedback === null || directFeedback === void 0 ? void 0 : (_directFeedback_callToAction = directFeedback.callToAction) === null || _directFeedback_callToAction === void 0 ? void 0 : _directFeedback_callToAction.promptId) ? /* @__PURE__ */ React66.createElement(DirectFeedbackCallToAction, {
        callToAction: directFeedback === null || directFeedback === void 0 ? void 0 : directFeedback.callToAction,
        withHorizontalLine: withHorizontalLine,
        align: align
    }) : null;
};
PropertyDirectFeedbackCallToAction.displayName = "PropertyDirectFeedbackCallToAction";
PropertyDirectFeedbackCallToAction.fragment = PropertyDirectFeedbackPromptIdFragment;
// src/components/frequently-asked-questions/frequently-asked-questions.tsx
import React69, { useCallback } from "react";
import { gql as gql48 } from "@apollo/client";
import { EGDSSecondaryButton } from "@egds/react-core/button";
import { EGDSCard as EGDSCard6, EGDSCardContentSection as EGDSCardContentSection3 } from "@egds/react-core/cards";
import { EGDSExpandoList as EGDSExpandoList2, EGDSExpandoPeek as EGDSExpandoPeek2 } from "@egds/react-core/expando";
import { EGDSLayoutFlex as EGDSLayoutFlex18, EGDSLayoutFlexItem as EGDSLayoutFlexItem10 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid12, EGDSLayoutGridItem as EGDSLayoutGridItem11 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing34 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading12, EGDSParagraph as EGDSParagraph2 } from "@egds/react-core/text";
import { useBexApi as useBexApi8 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog9 } from "@shared-ui/dialog-context";
import { DirectFeedbackDialog as DirectFeedbackDialog2 } from "@shared-ui/retail-customer-direct-feedback";
// src/components/frequently-asked-questions/__private/__fragments/faq.tsx
import React67 from "react";
import { gql as gql47 } from "@apollo/client";
import { EGDSExpandoListItem as EGDSExpandoListItem2 } from "@egds/react-core/expando";
import { EGDSText as EGDSText12 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
var __FaqFragment = gql47(_templateObject48());
var Faq = function(param) {
    var data = param.data, rfrr = param.rfrr;
    var _ref = data || {}, question = _ref.question, answer = _ref.answer;
    var _React67_useState = _sliced_to_array(React67.useState(false), 2), isVisible = _React67_useState[0], setIsVisible = _React67_useState[1];
    var track = useClickTracker21();
    var onToggle = React67.useCallback(function() {
        setIsVisible(!isVisible);
    }, [
        isVisible
    ]);
    var callback = React67.useCallback(function(id, description) {
        track(id, description);
    }, [
        track
    ]);
    if (!(question === null || question === void 0 ? void 0 : question.text) || !(answer === null || answer === void 0 ? void 0 : answer.text)) {
        return null;
    }
    return /* @__PURE__ */ React67.createElement(EGDSExpandoListItem2, {
        expandoTitle: /* @__PURE__ */ React67.createElement(EGDSText12, {
            size: 400,
            weight: "bold"
        }, question.text),
        expandoDescription: /* @__PURE__ */ React67.createElement("div", {
            dangerouslySetInnerHTML: {
                __html: answer.text
            }
        }),
        isVisible: isVisible,
        onToggle: onToggle,
        analytics: {
            id: "".concat(rfrr, ".").concat(isVisible ? "close" : "open"),
            description: "See frequently asked questions",
            callback: callback
        }
    });
};
Faq.displayName = "Faq";
Faq.fragment = __FaqFragment;
// src/components/frequently-asked-questions/structured-data.tsx
import React68 from "react";
var generateSchema = function(faqs) {
    if (!faqs || !faqs.length) {
        return null;
    }
    var faqsMainEntity = faqs.map(function(faq) {
        var textValue = faq.answer.text.replace(/"/g, '\\"');
        return {
            name: faq.question.text,
            "@type": "Question",
            acceptedAnswer: {
                "@type": "Answer",
                text: textValue
            }
        };
    });
    var schemaJson = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqsMainEntity
    };
    return JSON.stringify(schemaJson);
};
var FaqStructuredData = function(param) {
    var faqs = param.faqs;
    var structuredData = generateSchema(faqs);
    if (!structuredData) {
        return null;
    }
    return /* @__PURE__ */ React68.createElement("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: structuredData
        }
    });
};
// src/components/frequently-asked-questions/frequently-asked-questions.tsx
var __FrequentlyAskedQuestionsFragment = gql48(_templateObject49(), Faq.fragment);
var FrequentlyAskedQuestions = function(props) {
    var _context_device, _frequentlyAskedQuestions_askAQuestion, _frequentlyAskedQuestions_askAQuestion1, _expandButton_analytics, _collapseButton_analytics, _expandButton_analytics1, _collapseButton_analytics1;
    var context = useBexApi8().context;
    var isMobile = (context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */ ;
    var data = props.data, displayThreshold = props.displayThreshold, showExpandoPeek = props.showExpandoPeek;
    var frequentlyAskedQuestions = data === null || data === void 0 ? void 0 : data.frequentlyAskedQuestions;
    var title = frequentlyAskedQuestions === null || frequentlyAskedQuestions === void 0 ? void 0 : frequentlyAskedQuestions.title.text;
    var subTitle = frequentlyAskedQuestions === null || frequentlyAskedQuestions === void 0 ? void 0 : frequentlyAskedQuestions.title.subText;
    var faqs = frequentlyAskedQuestions === null || frequentlyAskedQuestions === void 0 ? void 0 : frequentlyAskedQuestions.faqs;
    var directFeedbackDialogPromptId = "6fa1b1cb-a4b4-4e36-8560-b9349b8d72e9";
    var _useDialog9 = _sliced_to_array(useDialog9(directFeedbackDialogPromptId, "cdfPromptDialog"), 2), openDialog = _useDialog9[1].openDialog;
    var askAQuestionText = frequentlyAskedQuestions === null || frequentlyAskedQuestions === void 0 ? void 0 : (_frequentlyAskedQuestions_askAQuestion = frequentlyAskedQuestions.askAQuestion) === null || _frequentlyAskedQuestions_askAQuestion === void 0 ? void 0 : _frequentlyAskedQuestions_askAQuestion.primary;
    var _ref = (frequentlyAskedQuestions === null || frequentlyAskedQuestions === void 0 ? void 0 : (_frequentlyAskedQuestions_askAQuestion1 = frequentlyAskedQuestions.askAQuestion) === null || _frequentlyAskedQuestions_askAQuestion1 === void 0 ? void 0 : _frequentlyAskedQuestions_askAQuestion1.analytics) || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
    var expando = (frequentlyAskedQuestions || {}).expando;
    var _ref1 = expando || {}, expandButton = _ref1.expandButton, collapseButton = _ref1.collapseButton, items = _ref1.items;
    var _React69_useState = _sliced_to_array(React69.useState(false), 2), isExpanded = _React69_useState[0], setIsExpanded = _React69_useState[1];
    var expandoReferrerId = !isExpanded ? expandButton === null || expandButton === void 0 ? void 0 : (_expandButton_analytics = expandButton.analytics) === null || _expandButton_analytics === void 0 ? void 0 : _expandButton_analytics.referrerId : collapseButton === null || collapseButton === void 0 ? void 0 : (_collapseButton_analytics = collapseButton.analytics) === null || _collapseButton_analytics === void 0 ? void 0 : _collapseButton_analytics.referrerId;
    var expandoLinkName = !isExpanded ? expandButton === null || expandButton === void 0 ? void 0 : (_expandButton_analytics1 = expandButton.analytics) === null || _expandButton_analytics1 === void 0 ? void 0 : _expandButton_analytics1.linkName : collapseButton === null || collapseButton === void 0 ? void 0 : (_collapseButton_analytics1 = collapseButton.analytics) === null || _collapseButton_analytics1 === void 0 ? void 0 : _collapseButton_analytics1.linkName;
    var track = useClickTracker22();
    var showDatedPDPExpando = expando && items && items > 0;
    var handleAskAQuestionClick = useCallback(function() {
        openDialog();
        if (referrerId && linkName) {
            track(referrerId, linkName);
        }
    }, [
        linkName,
        referrerId,
        track,
        openDialog
    ]);
    if (!faqs || faqs.length === 0) {
        return null;
    }
    var mergedFaqs = faqs.slice(0);
    var expandoPeekAnalysis = {
        id: expandoReferrerId !== null && expandoReferrerId !== void 0 ? expandoReferrerId : "",
        description: expandoLinkName !== null && expandoLinkName !== void 0 ? expandoLinkName : "",
        callback: function(refererId, lnkName) {
            track(refererId, lnkName);
        }
    };
    var faqList = mergedFaqs.map(function(faq, index) {
        return /* @__PURE__ */ React69.createElement(Faq, {
            key: "faq-".concat(index),
            data: faq,
            rfrr: "HOT.HIS.question.".concat(index)
        });
    });
    var getThresholdValue = function() {
        if (items && items < 0) {
            return displayThreshold;
        }
        if (items && items > 0 && isMobile) {
            return items;
        }
        return 0;
    };
    return /* @__PURE__ */ React69.createElement(EGDSSpacing34, {
        padding: {
            block: "six",
            large: {
                inline: "six"
            },
            extra_large: {
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React69.createElement(EGDSCard6, null, /* @__PURE__ */ React69.createElement(EGDSCardContentSection3, null, /* @__PURE__ */ React69.createElement(DirectFeedbackDialog2, {
        inputs: {
            promptId: "6fa1b1cb-a4b4-4e36-8560-b9349b8d72e9"
        },
        contextValues: [
            {
                key: "property_id",
                value: data.id
            }
        ]
    }), /* @__PURE__ */ React69.createElement(EGDSLayoutGrid12, {
        space: "six",
        columns: {
            large: [
                "1fr",
                "1fr",
                "1fr"
            ],
            medium: [
                "1fr"
            ],
            small: [
                "1fr"
            ]
        },
        rows: {
            large: [
                "min-content"
            ],
            medium: [
                "min-content",
                "min-content",
                "min-content"
            ],
            small: [
                "min-content",
                "min-content",
                "min-content"
            ]
        },
        areas: {
            small: [
                "heading",
                "faqExpandoList"
            ],
            medium: [
                "heading",
                "faqExpandoList"
            ],
            large: [
                "heading faqExpandoList faqExpandoList"
            ]
        }
    }, /* @__PURE__ */ React69.createElement(EGDSLayoutGridItem11, {
        area: "heading"
    }, title && /* @__PURE__ */ React69.createElement(EGDSLayoutFlex18, {
        direction: "column"
    }, /* @__PURE__ */ React69.createElement(EGDSSpacing34, {
        margin: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React69.createElement(EGDSHeading12, {
        tag: "h2",
        size: 4
    }, title)), subTitle && /* @__PURE__ */ React69.createElement(React69.Fragment, null, /* @__PURE__ */ React69.createElement(EGDSSpacing34, {
        margin: {
            blockstart: "one",
            blockend: "one"
        }
    }, /* @__PURE__ */ React69.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */ React69.createElement(EGDSParagraph2, {
        size: 1
    }, subTitle))), /* @__PURE__ */ React69.createElement(EGDSLayoutFlexItem10, {
        alignSelf: "start"
    }, /* @__PURE__ */ React69.createElement(EGDSSpacing34, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React69.createElement(EGDSSecondaryButton, {
        id: "ask-a-question",
        onClick: handleAskAQuestionClick
    }, askAQuestionText)))))), /* @__PURE__ */ React69.createElement(EGDSLayoutGridItem11, {
        area: "faqExpandoList"
    }, showExpandoPeek || showDatedPDPExpando ? /* @__PURE__ */ React69.createElement(EGDSExpandoPeek2, {
        analytics: expandoPeekAnalysis,
        collapseLabel: (collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.text) || void 0,
        collapseA11yLabel: (collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.accessibilityLabel) || void 0,
        expandLabel: (expandButton === null || expandButton === void 0 ? void 0 : expandButton.text) || void 0,
        expandA11yLabel: (expandButton === null || expandButton === void 0 ? void 0 : expandButton.accessibilityLabel) || void 0,
        isVisible: isExpanded,
        items: getThresholdValue(),
        handleClick: function() {
            return setIsExpanded(!isExpanded);
        },
        hideScrim: !showDatedPDPExpando,
        whitespace: !showDatedPDPExpando
    }, /* @__PURE__ */ React69.createElement(EGDSExpandoList2, null, faqList)) : /* @__PURE__ */ React69.createElement(EGDSExpandoList2, null, faqList))), /* @__PURE__ */ React69.createElement(FaqStructuredData, {
        faqs: mergedFaqs
    }))));
};
FrequentlyAskedQuestions.displayName = "FrequentlyAskedQuestions";
FrequentlyAskedQuestions.fragment = __FrequentlyAskedQuestionsFragment;
// src/components/gallery/gallery.tsx
import React70 from "react";
import { gql as gql49 } from "@apollo/client";
// src/components/gallery/use-property-gallery.tsx
import { useMemo as useMemo2 } from "react";
var usePropertyGallery = function(propertyGallery, placeholderData) {
    return useMemo2(function() {
        var _placeholderData_images, _propertyGallery_images;
        if (!(placeholderData === null || placeholderData === void 0 ? void 0 : (_placeholderData_images = placeholderData.images) === null || _placeholderData_images === void 0 ? void 0 : _placeholderData_images.length) || !(propertyGallery === null || propertyGallery === void 0 ? void 0 : (_propertyGallery_images = propertyGallery.images) === null || _propertyGallery_images === void 0 ? void 0 : _propertyGallery_images.length)) {
            return propertyGallery;
        }
        var propertyGalleryImagesBaseUrl = propertyGallery.images.map(function(img) {
            var _img_lowResImage;
            var _img_lowResImage_url_split_;
            return _object_spread_props(_object_spread({}, img), {
                baseUrl: (_img_lowResImage_url_split_ = (_img_lowResImage = img.lowResImage) === null || _img_lowResImage === void 0 ? void 0 : _img_lowResImage.url.split("?")[0]) !== null && _img_lowResImage_url_split_ !== void 0 ? _img_lowResImage_url_split_ : ""
            });
        });
        var placeholderImagesWithBaseUrl = placeholderData.images.map(function(img) {
            return _object_spread_props(_object_spread({}, img), {
                baseUrl: img.url.split("?")[0]
            });
        });
        var placeholderDataIndexMap = placeholderImagesWithBaseUrl.reduce(function(idMap, img, index) {
            return _object_spread_props(_object_spread({}, idMap), _define_property({}, img.baseUrl, index));
        }, {});
        var imageUrlMap = placeholderImagesWithBaseUrl.reduce(function(idMap, img) {
            return _object_spread_props(_object_spread({}, idMap), _define_property({}, img.baseUrl, img));
        }, {});
        var mappedPlaceholderImagesWithBaseUrl = propertyGalleryImagesBaseUrl.filter(function(img) {
            return imageUrlMap[img.baseUrl];
        }).map(function(img) {
            var _imageUrlMap_img_baseUrl, _imageUrlMap_img_baseUrl1;
            return _object_spread_props(_object_spread({}, img), {
                image: _object_spread_props(_object_spread({}, img.image), {
                    url: ((_imageUrlMap_img_baseUrl = imageUrlMap[img.baseUrl]) === null || _imageUrlMap_img_baseUrl === void 0 ? void 0 : _imageUrlMap_img_baseUrl.url) || img.image.url
                }),
                lowResImage: _object_spread_props(_object_spread({}, img.lowResImage), {
                    url: ((_imageUrlMap_img_baseUrl1 = imageUrlMap[img.baseUrl]) === null || _imageUrlMap_img_baseUrl1 === void 0 ? void 0 : _imageUrlMap_img_baseUrl1.url) || ""
                })
            });
        });
        var mappedPlaceholderImages = _to_consumable_array(mappedPlaceholderImagesWithBaseUrl).sort(function(a, b) {
            return (placeholderDataIndexMap[a.baseUrl] || -1) - (placeholderDataIndexMap[b.baseUrl] || -1);
        }).map(function(_param) {
            var baseUrl = _param.baseUrl, img = _object_without_properties(_param, [
                "baseUrl"
            ]);
            return img;
        });
        var nonPlaceholderPropertyGalleryImages = propertyGallery.images.filter(function(_, index) {
            var _propertyGalleryImagesBaseUrl_index;
            var _propertyGalleryImagesBaseUrl_index_baseUrl;
            return !imageUrlMap[(_propertyGalleryImagesBaseUrl_index_baseUrl = (_propertyGalleryImagesBaseUrl_index = propertyGalleryImagesBaseUrl[index]) === null || _propertyGalleryImagesBaseUrl_index === void 0 ? void 0 : _propertyGalleryImagesBaseUrl_index.baseUrl) !== null && _propertyGalleryImagesBaseUrl_index_baseUrl !== void 0 ? _propertyGalleryImagesBaseUrl_index_baseUrl : ""];
        });
        var updatedPropertyGallery = _object_spread_props(_object_spread({}, propertyGallery), {
            images: _to_consumable_array(mappedPlaceholderImages).concat(_to_consumable_array(nonPlaceholderPropertyGalleryImages))
        });
        return updatedPropertyGallery;
    }, [
        propertyGallery,
        placeholderData
    ]);
};
// src/components/gallery/gallery.tsx
var __GalleryFragment = gql49(_templateObject50(), PropertyImageGallery.fragment);
var Gallery = function(props) {
    var _syncedPropertyGallery_images;
    var data = props.data, placeholderData = props.placeholderData;
    var propertyGallery = data.propertyGallery, summary = data.summary, id = data.id;
    var _ref = summary || {
        name: ""
    }, propertyName = _ref.name, overview = _ref.overview;
    var syncedPropertyGallery = usePropertyGallery(propertyGallery, placeholderData);
    if (!(syncedPropertyGallery === null || syncedPropertyGallery === void 0 ? void 0 : (_syncedPropertyGallery_images = syncedPropertyGallery.images) === null || _syncedPropertyGallery_images === void 0 ? void 0 : _syncedPropertyGallery_images.length)) {
        return null;
    }
    return /* @__PURE__ */ React70.createElement(React70.Fragment, null, propertyName && /* @__PURE__ */ React70.createElement("h1", {
        className: "is-visually-hidden"
    }, propertyName), propertyName && /* @__PURE__ */ React70.createElement("meta", {
        itemProp: "name",
        content: propertyName
    }), /* @__PURE__ */ React70.createElement(PropertyImageGallery, {
        data: syncedPropertyGallery,
        propertyId: id
    }), (overview === null || overview === void 0 ? void 0 : overview.accessibilityLabel) && /* @__PURE__ */ React70.createElement("h2", {
        className: "is-visually-hidden"
    }, overview.accessibilityLabel));
};
Gallery.displayName = "Gallery";
Gallery.fragment = __GalleryFragment;
// src/components/gallery/placeholder.tsx
import React71 from "react";
import { EGDSFigure as EGDSFigure4, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType8, EGDSImage as EGDSImage4 } from "@egds/react-core/images";
import { EGDSLayoutGrid as EGDSLayoutGrid13, EGDSLayoutGridItem as EGDSLayoutGridItem12 } from "@egds/react-core/layout-grid";
import { useExperiment as useExperiment15 } from "@shared-ui/experiment-context";
import { ViewLarge as ViewLarge8, ViewMedium as ViewMedium11, Viewport as Viewport15, ViewSmall as ViewSmall15 } from "@shared-ui/viewport-context";
// src/hooks/use-component-mount.ts
import { useEffect as useEffect6, useState as useState5 } from "react";
var useComponentMount = function() {
    var _useState5 = _sliced_to_array(useState5(false), 2), ready = _useState5[0], setReady = _useState5[1];
    useEffect6(function() {
        setReady(true);
    }, []);
    return ready;
};
// src/components/gallery/placeholder.tsx
var GalleryPlaceholder = /* istanbul ignore next -- @preserve */ function(param) {
    var data = param.data;
    var ready = useComponentMount();
    return /* @__PURE__ */ React71.createElement(React71.Fragment, null, ready ? /* @__PURE__ */ React71.createElement(CSRGalleryPlaceholderChild, {
        data: data
    }) : /* @__PURE__ */ React71.createElement(SSRGalleryPlaceholderChild, {
        data: data
    }));
};
var getImageRatio = function(bucket) {
    switch(bucket){
        case 1:
            return EGDSFigureAspectRatioType8.R3_2;
        case 2:
            return EGDSFigureAspectRatioType8.R1_1;
        default:
            return EGDSFigureAspectRatioType8.R16_9;
    }
};
var withPlaceholderChild = function(displayName) {
    var Component = function(param) {
        var data = param.data;
        var _data_images;
        return /* @__PURE__ */ React71.createElement(Viewport15, null, /* @__PURE__ */ React71.createElement(ViewSmall15, null, /* @__PURE__ */ React71.createElement(PlaceholderImage, {
            data: data,
            additionalImage: data === null || data === void 0 ? void 0 : (_data_images = data.images) === null || _data_images === void 0 ? void 0 : _data_images[0]
        })), /* @__PURE__ */ React71.createElement(ViewMedium11, null, /* @__PURE__ */ React71.createElement(EGDSLayoutGrid13, {
            rows: 2,
            columns: 3,
            space: "half"
        }, Array.from(Array(3)).map(function(_, index) {
            var _data_images;
            return /* @__PURE__ */ React71.createElement(EGDSLayoutGridItem12, {
                rowSpan: index === 0 ? 2 : 1,
                colSpan: index === 0 ? 2 : 1,
                key: "gallery-placeholder-".concat(index)
            }, /* @__PURE__ */ React71.createElement(PlaceholderImage, {
                additionalImage: data === null || data === void 0 ? void 0 : (_data_images = data.images) === null || _data_images === void 0 ? void 0 : _data_images[index]
            }));
        }))), /* @__PURE__ */ React71.createElement(ViewLarge8, null, /* @__PURE__ */ React71.createElement(EGDSLayoutGrid13, {
            rows: 2,
            columns: 4,
            space: "half"
        }, Array.from(Array(5)).map(function(_, index) {
            var _data_images;
            return /* @__PURE__ */ React71.createElement(EGDSLayoutGridItem12, {
                rowSpan: index === 0 ? 2 : 1,
                colSpan: index === 0 ? 2 : 1,
                key: "gallery-placeholder-".concat(index)
            }, /* @__PURE__ */ React71.createElement(PlaceholderImage, {
                additionalImage: data === null || data === void 0 ? void 0 : (_data_images = data.images) === null || _data_images === void 0 ? void 0 : _data_images[index]
            }));
        }))));
    };
    Component.displayName = displayName;
    return Component;
};
var CSRGalleryPlaceholderChild = withPlaceholderChild("CsrPlaceholder");
var SSRGalleryPlaceholderChild = withPlaceholderChild("SsrPlaceholder");
var PlaceholderImage = function(param) {
    var data = param.data, additionalImage = param.additionalImage, className = param.className, style = param.style;
    var _data_propertyGallery_images, _data_propertyGallery, _data_propertyGallery_images_;
    var _useExperiment15 = useExperiment15("mWeb_larger_image_for_top_of_PDP_gallery"), mWebLargerImageExposure = _useExperiment15.exposure;
    var image = (data === null || data === void 0 ? void 0 : (_data_propertyGallery = data.propertyGallery) === null || _data_propertyGallery === void 0 ? void 0 : (_data_propertyGallery_images = _data_propertyGallery.images) === null || _data_propertyGallery_images === void 0 ? void 0 : _data_propertyGallery_images.length) ? (_data_propertyGallery_images_ = data.propertyGallery.images[0]) === null || _data_propertyGallery_images_ === void 0 ? void 0 : _data_propertyGallery_images_.image : void 0;
    if (image) {
        var url = image.url;
        return /* @__PURE__ */ React71.createElement(EGDSFigure4, {
            ratio: getImageRatio(mWebLargerImageExposure.bucket),
            className: className,
            style: style
        }, /* @__PURE__ */ React71.createElement(EGDSImage4, {
            src: url,
            alt: image.description,
            additionalProps: {
                fetchPriority: "high"
            }
        }));
    }
    return /* @__PURE__ */ React71.createElement(EGDSFigure4, {
        ratio: getImageRatio(mWebLargerImageExposure.bucket),
        className: className,
        style: style
    }, /* @__PURE__ */ React71.createElement(EGDSImage4, {
        placeholderImage: true,
        src: additionalImage === null || additionalImage === void 0 ? void 0 : additionalImage.url,
        alt: additionalImage === null || additionalImage === void 0 ? void 0 : additionalImage.description,
        additionalProps: {
            fetchPriority: (additionalImage === null || additionalImage === void 0 ? void 0 : additionalImage.url) ? "high" : void 0
        }
    }));
};
// src/components/inputs-context.tsx
import React72 from "react";
var InputsContext = React72.createContext({});
var usePropertyDetailsInputs = function() {
    return React72.useContext(InputsContext);
};
// src/components/inventory-source/inventory-source.tsx
import React73 from "react";
import { gql as gql50 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex19, EGDSLayoutFlexItem as EGDSLayoutFlexItem11 } from "@egds/react-core/layout-flex";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing35 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText13 } from "@egds/react-core/text";
import { ViewLarge as ViewLarge9, Viewport as Viewport16, ViewSmall as ViewSmall16 } from "@shared-ui/viewport-context";
var __InventorySourceFragment = gql50(_templateObject51());
var InventorySource = function(param) {
    var data = param.data;
    var _data_summary;
    var _ref = (data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.propertySource) || {}, text = _ref.text, graphic = _ref.graphic;
    if (!text || text === "") {
        return null;
    }
    var _ref1 = (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Mark" && graphic || {}, id = _ref1.id, description = _ref1.description, url = _ref1.url;
    return /* @__PURE__ */ React73.createElement(Viewport16, null, /* @__PURE__ */ React73.createElement(ViewSmall16, null, /* @__PURE__ */ React73.createElement(EGDSSpacing35, {
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React73.createElement(EGDSLayoutFlex19, {
        space: "one",
        direction: "column"
    }, /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */ React73.createElement(EGDSSpacing35, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React73.createElement("div", null, (url === null || url === void 0 ? void 0 : url.value) ? /* @__PURE__ */ React73.createElement(EGDSMark, {
        url: url.value,
        size: EGDSMarkSize.EXTRA_SMALL,
        description: description
    }) : /* @__PURE__ */ React73.createElement(EGDSMark, {
        name: id,
        size: EGDSMarkSize.MEDIUM,
        description: description
    })))), /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */ React73.createElement(EGDSText13, {
        size: 300,
        "data-stid": "inventory-source"
    }, text))))), /* @__PURE__ */ React73.createElement(ViewLarge9, null, /* @__PURE__ */ React73.createElement(EGDSSpacing35, {
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React73.createElement(EGDSLayoutFlex19, {
        space: "two",
        alignItems: "center"
    }, /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem11, null, (url === null || url === void 0 ? void 0 : url.value) ? /* @__PURE__ */ React73.createElement(EGDSMark, {
        url: url.value,
        size: EGDSMarkSize.EXTRA_SMALL,
        description: description
    }) : /* @__PURE__ */ React73.createElement(EGDSSpacing35, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React73.createElement("div", null, /* @__PURE__ */ React73.createElement(EGDSMark, {
        name: id,
        size: EGDSMarkSize.MEDIUM,
        description: description
    })))), /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */ React73.createElement(EGDSText13, {
        size: 300,
        overflow: "truncate",
        "data-stid": "property-source"
    }, text))))));
};
InventorySource.fragment = __InventorySourceFragment;
InventorySource.displayName = "InventorySource";
// src/components/navigation-bar/navigation-bar.tsx
import React75 from "react";
import { gql as gql52 } from "@apollo/client";
import { useRefContext as useRefContext2 } from "@shared-ui/ref-context";
// src/components/navigation-bar/__private/__fragments/navigation-bar-tabs.tsx
import React74 from "react";
import { gql as gql51 } from "@apollo/client";
import { EGDSNavigationType, EGDSTab as EGDSTab2, EGDSTabs as EGDSTabs2, EGDSTabsType } from "@egds/react-core/tabs";
import { useClickTracker as useClickTracker23 } from "@shared-ui/clickstream-analytics-context";
import { useVisibility, VisibilityEventType } from "@shared-ui/ref-context";
var SCROLL_TIMEOUT2 = 1500;
var VISIBILITY_OPTIONS = {
    rootMargin: -60,
    thresholds: new Array(51).fill(0).map(function(v, i) {
        return i * 0.02;
    })
};
var fragment10 = gql51(_templateObject52());
var NavigationBarTabs = function(props) {
    var data = props.data, targets = props.targets;
    var tabs = data.navigationBarTabs || [];
    var track = useClickTracker23();
    var _React74_useState = _sliced_to_array(React74.useState(0), 2), activeTabIndex = _React74_useState[0], setActiveTabIndex = _React74_useState[1];
    var tabList = React74.useMemo(function() {
        return tabs.map(function(tab) {
            return {
                id: tab.sectionName,
                ref: targets[tab.sectionName] || {
                    current: null
                }
            };
        });
    }, [
        tabs,
        targets
    ]);
    var onVisibilityChange = React74.useCallback(function(visibilityEvents) {
        var newActiveTabIndex = -1;
        Object.keys(visibilityEvents).forEach(function(sectionName) {
            if (visibilityEvents[sectionName] === VisibilityEventType.PARTIAL_TOP || visibilityEvents[sectionName] === VisibilityEventType.SPAN_VIEWPORT) {
                newActiveTabIndex = tabs.findIndex(function(tab) {
                    return tab.sectionName === sectionName;
                });
            }
        });
        if (newActiveTabIndex >= 0) {
            setActiveTabIndex(newActiveTabIndex);
        }
    }, [
        tabs
    ]);
    var _useVisibility = useVisibility(tabList, onVisibilityChange, VISIBILITY_OPTIONS), disableObserver = _useVisibility.disableObserver, enableObserver = _useVisibility.enableObserver;
    var onTabSelect = function(selectedTabIndex) {
        if (selectedTabIndex === activeTabIndex) {
            return;
        }
        disableObserver();
        setTimeout(enableObserver, SCROLL_TIMEOUT2);
        var navigationTab = tabs[selectedTabIndex];
        if (!navigationTab) {
            return;
        }
        setActiveTabIndex(selectedTabIndex);
    };
    var onTabClick = function(selectedTabIndex) {
        if (selectedTabIndex === activeTabIndex) {
            return;
        }
        var navigationTab = tabs[selectedTabIndex];
        if (!navigationTab) {
            return;
        }
        track("HOT.HIS.NavBar.".concat(navigationTab.sectionName), navigationTab.sectionName);
    };
    return /* @__PURE__ */ React74.createElement(EGDSTabs2, {
        navigationType: EGDSNavigationType.JUMPLINK,
        onTabSelect: onTabSelect,
        onTabClickCB: onTabClick,
        selectedTab: activeTabIndex,
        tabsType: EGDSTabsType.NATURAL,
        scrollOffsetSelf: true,
        "data-stid": "navigation-tabs"
    }, tabs.map(function(tab) {
        return /* @__PURE__ */ React74.createElement(EGDSTab2, {
            id: tab.sectionName,
            key: "uitk-tab-key-".concat(tab.sectionName),
            name: tab.localizedName,
            targetRef: targets[tab.sectionName],
            targetURI: "#".concat(tab.sectionName)
        });
    }));
};
NavigationBarTabs.displayName = "NavigationBarTabs";
NavigationBarTabs.fragment = fragment10;
// src/components/navigation-bar/navigation-bar.tsx
var __NavigationBarFragment = gql52(_templateObject53(), NavigationBarTabs.fragment);
var NavigationBar = function(props) {
    var data = props.data;
    var summary = data === null || data === void 0 ? void 0 : data.summary;
    var tabs = (summary === null || summary === void 0 ? void 0 : summary.navigationBarTabs) || [];
    var getTargets = useRefContext2().getTargets;
    var targets = getTargets(tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab) {
        return tab.sectionName;
    }));
    if (!summary || tabs.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React75.createElement(NavigationBarTabs, {
        data: summary,
        targets: targets
    });
};
NavigationBar.displayName = "NavigationBar";
NavigationBar.fragment = __NavigationBarFragment;
// src/components/navigation-bar/navigation-bar-placeholder.tsx
import React76 from "react";
import { EGDSTabs as EGDSTabs3 } from "@egds/react-core/tabs";
var NavigationBarPlaceholder = /* istanbul ignore next -- @preserve */ function() {
    return /* @__PURE__ */ React76.createElement(EGDSTabs3, null);
};
// src/components/property-number/property-number.tsx
import React77 from "react";
import { gql as gql53 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex20, EGDSLayoutFlexItem as EGDSLayoutFlexItem12 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing36 } from "@egds/react-core/spacing";
import { EGDSSpannableText } from "@shared-ui/lodging-fragments";
var __PropertyNumberFragment = gql53(_templateObject54(), EGDSSpannableText.fragment);
var propertyNumberMargin = {
    large: {
        block: "three",
        inlinestart: "three"
    }
};
var propertyNumberPadding = {
    blockstart: "four"
};
var PropertyNumber = function(props) {
    var data = props.data;
    var content = data === null || data === void 0 ? void 0 : data.propertyIdDisplay;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React77.createElement(EGDSSpacing36, {
        margin: propertyNumberMargin,
        padding: propertyNumberPadding,
        border: [
            "blockstart"
        ]
    }, /* @__PURE__ */ React77.createElement(EGDSLayoutFlex20, {
        justifyContent: "center"
    }, /* @__PURE__ */ React77.createElement(EGDSLayoutFlexItem12, null, /* @__PURE__ */ React77.createElement("div", null, /* @__PURE__ */ React77.createElement(EGDSSpannableText, {
        data: content
    })))));
};
PropertyNumber.fragment = __PropertyNumberFragment;
PropertyNumber.displayName = "PropertyNumber";
// src/components/save-trip-item/save-trip-item.tsx
import React78 from "react";
import { gql as gql54 } from "@apollo/client";
import { LodgingTripsSaveItemAdapter } from "@shared-ui/lodging-fragments";
import { buildStateProvider } from "@shared-ui/provided-state-context";
import { Source, TripSaveItem, ValidatedInputsState } from "@shared-ui/trips-save-item";
// src/components/save-trip-item/_private/use-to-update-attributes.tsx
import { SystemEvent, SystemEventLevel, useLoggerEvents } from "@shared-ui/logger-context";
var EVENTS = {
    SAVE_TRIP_ITEM_ATTRIBUTES_UNSUPPORTED_TYPENAME: new SystemEvent(SystemEventLevel.INFO, "SAVE_TRIP_ITEM_ATTRIBUTES_UNSUPPORTED_TYPENAME")
};
function useUpdateAttributesWithSearchCriteria() {
    var loggerEvents = useLoggerEvents(EVENTS);
    return function(param) {
        var dataSaveItemAttributes = param.originalAttributes, searchCriteria = param.searchCriteria;
        return getNewAttributesWithSearchCriteria(dataSaveItemAttributes, searchCriteria, loggerEvents);
    };
}
function getNewAttributesWithSearchCriteria(dataSaveItemAttributes, searchCriteria, loggerEvents) {
    if (!(searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.dateRange) || !dataSaveItemAttributes) {
        return dataSaveItemAttributes;
    }
    switch(dataSaveItemAttributes.__typename){
        case "TripsSaveStayAttributes":
            return _object_spread_props(_object_spread({}, dataSaveItemAttributes), {
                checkInDate: _object_spread({
                    __typename: "Date"
                }, searchCriteria.dateRange.checkInDate),
                checkoutDate: _object_spread({
                    __typename: "Date"
                }, searchCriteria.dateRange.checkOutDate),
                roomConfiguration: searchCriteria.rooms.map(function(room) {
                    return {
                        __typename: "PropertyRoom",
                        numberOfAdults: room.adults,
                        childAges: room.children ? room.children.map(function(child) {
                            return child.age;
                        }) : []
                    };
                })
            });
        default:
            loggerEvents.SAVE_TRIP_ITEM_ATTRIBUTES_UNSUPPORTED_TYPENAME.log({});
            return dataSaveItemAttributes;
    }
}
// src/components/save-trip-item/save-trip-item.tsx
var __SaveTripItemFragment = gql54(_templateObject55(), LodgingTripsSaveItemAdapter.fragment);
var ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());
var SaveTripItem = function(param) {
    var data = param.data, searchCriteria = param.searchCriteria;
    var updateAttributes = useUpdateAttributesWithSearchCriteria();
    if (!data.saveTripItem) {
        return null;
    }
    var updatedAttributes = updateAttributes({
        originalAttributes: data.saveTripItem.attributes,
        searchCriteria: searchCriteria
    });
    return /* @__PURE__ */ React78.createElement(ValidatedInputsStateProvider, null, /* @__PURE__ */ React78.createElement(TripSaveItem, {
        data: _object_spread_props(_object_spread({}, data.saveTripItem), {
            attributes: updatedAttributes
        }),
        source: Source.LODGING_DETAILS
    }));
};
SaveTripItem.fragment = __SaveTripItemFragment;
SaveTripItem.displayName = "SaveTripItem";
// src/components/share-actions/share-actions.tsx
import React83 from "react";
import { gql as gql59 } from "@apollo/client";
import { UitkFloatingButton as UitkFloatingButton2 } from "@egds/react-core/button";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize5 } from "@egds/react-core/icons";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "@egds/react-core/layout-position";
import { UitkSpacing as UitkSpacing8 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker25 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog10 } from "@shared-ui/dialog-context";
import { ViewLarge as ViewLarge11, Viewport as Viewport18, ViewSmall as ViewSmall18 } from "@shared-ui/viewport-context";
// src/components/share-actions/__private/__fragments/share-dialog.tsx
import React81 from "react";
import { gql as gql57 } from "@apollo/client";
import { UitkSheet, UitkSheetContent, UitkSheetTransition } from "@egds/react-core/sheet";
import { UitkSpacing as UitkSpacing6 } from "@egds/react-core/spacing";
// src/components/share-actions/__private/__fragments/share-description-section.tsx
import React79 from "react";
import { gql as gql55 } from "@apollo/client";
import { UitkFigure as UitkFigure2, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage } from "@egds/react-core/images";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "@egds/react-core/layout-flex";
import { UitkText as UitkText3 } from "@egds/react-core/text";
import { defaultViewSizes as defaultViewSizes2, useMediaQueries as useMediaQueries2 } from "@shared-ui/viewport-context";
var __ShareDescriptionFragment = gql55(_templateObject56());
var ContentImageRender = function(param) {
    var image = param.image;
    return /* @__PURE__ */ React79.createElement(UitkFigure2, {
        className: "uitk-card-roundcorner-all",
        ratio: UitkFigureAspectRatioType2.R4_3
    }, /* @__PURE__ */ React79.createElement(UitkImage, {
        alt: image === null || image === void 0 ? void 0 : image.altText,
        blankDefault: false,
        placeholderImage: true,
        src: image === null || image === void 0 ? void 0 : image.url
    }));
};
var ShareDescriptionSection = function(param) {
    var data = param.data;
    var image = data.image, description = data.description;
    var viewSize = useMediaQueries2({
        viewSizes: defaultViewSizes2
    });
    return /* @__PURE__ */ React79.createElement(UitkLayoutFlex, {
        alignItems: "start",
        space: "three"
    }, /* @__PURE__ */ React79.createElement(UitkLayoutFlexItem, {
        minWidth: viewSize === defaultViewSizes2.SMALL ? 100 : 200
    }, /* @__PURE__ */ React79.createElement("div", null, /* @__PURE__ */ React79.createElement(ContentImageRender, {
        image: image
    }))), /* @__PURE__ */ React79.createElement(UitkLayoutFlexItem, {
        minWidth: 300,
        grow: 1
    }, /* @__PURE__ */ React79.createElement(UitkText3, {
        spacing: "one",
        overflow: "truncate-2-lines",
        size: 500
    }, description)));
};
ShareDescriptionSection.displayName = "ShareDescriptionSection";
ShareDescriptionSection.fragment = __ShareDescriptionFragment;
var share_description_section_default = ShareDescriptionSection;
// src/components/share-actions/__private/__fragments/share-options-section.tsx
import React80 from "react";
import { useLocation } from "react-router-dom";
import { gql as gql56 } from "@apollo/client";
import { UitkActionList, UitkActionListItem, UitkActionListItemLink } from "@egds/react-core/action-list-item";
import { UitkButton, UitkPrimaryButton as UitkPrimaryButton2 } from "@egds/react-core/button";
import { UitkIcon, UitkIconSize as UitkIconSize3 } from "@egds/react-core/icons";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { UitkMark } from "@egds/react-core/mark";
import { UitkSpacing as UitkSpacing5 } from "@egds/react-core/spacing";
import { UitkText as UitkText4 } from "@egds/react-core/text";
import { UitkToast } from "@egds/react-core/toast";
import { useClickTracker as useClickTracker24 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge as ViewLarge10, Viewport as Viewport17, ViewSmall as ViewSmall17 } from "@shared-ui/viewport-context";
// src/components/share-actions/share-links-construction-util.ts
var addRoomParameter = function(searchParams, newSearchParams) {
    searchParams.forEach(function(value, key) {
        return key.startsWith("rm") && newSearchParams.append(key, value);
    });
};
var constructPDPLink = function(shareLink, location, urlParameterKeys, domain) {
    var searchParams = new URLSearchParams(location.search);
    var newSearchParams = new URLSearchParams();
    urlParameterKeys.forEach(function(key) {
        switch(key){
            case "rm":
                addRoomParameter(searchParams, newSearchParams);
                break;
            case "referrerId":
                newSearchParams.append(key, shareLink.referrerId);
                break;
            default:
                {
                    var urlParameterValue = searchParams.get(key);
                    if (urlParameterValue !== null) {
                        newSearchParams.append(key, urlParameterValue);
                    }
                    break;
                }
        }
    });
    return "https://".concat(domain).concat(location.pathname, "?").concat(newSearchParams.toString());
};
var createCopyLink = function(shareLink, location, urlParameterKeys, domain) {
    return shareLink.copiedUrl === "" ? constructPDPLink(shareLink, location, urlParameterKeys, domain) : shareLink.copiedUrl;
};
var socialMediaLink = function(shareLink, location, urlParameterKeys, domain) {
    var socialMediaBaseUrl = new URL(shareLink.url);
    var socialMediaSearchParams = new URLSearchParams(socialMediaBaseUrl.search);
    if (socialMediaSearchParams.get("href") === null && socialMediaSearchParams.get("url") === null) {
        var encodedLink = encodeURIComponent(constructPDPLink(shareLink, location, urlParameterKeys, domain));
        var socialMediaShareLink = "".concat(socialMediaBaseUrl, "&").concat(shareLink.encodedUrlParameterKey, "=").concat(encodedLink);
        return socialMediaShareLink;
    }
    return shareLink.url;
};
// src/components/share-actions/__private/__fragments/share-options-section.tsx
var __ShareOptionsFragment = gql56(_templateObject57());
var OptionIconRender = function(param) {
    var shareLink = param.shareLink;
    var __typename = shareLink.__typename;
    return /* @__PURE__ */ React80.createElement(React80.Fragment, null, __typename === "ShoppingCopyLink" && shareLink.icon && /* @__PURE__ */ React80.createElement(UitkIcon, {
        name: shareLink.icon.id,
        size: UitkIconSize3.SMALL
    }), __typename === "ShoppingSocialMediaLink" && shareLink.graphic && /* @__PURE__ */ React80.createElement(UitkMark, {
        url: shareLink.graphic.url.value,
        size: 4,
        orientation: "portrait"
    }));
};
var ShareOptionsSection = function(param) {
    var data = param.data, domain = param.domain;
    var shareLinks = data.shareLinks, urlParameterKeys = data.urlParameterKeys;
    var trackEvent = useClickTracker24();
    var _React80_useState = _sliced_to_array(React80.useState(null), 2), textToast = _React80_useState[0], setTextToast = _React80_useState[1];
    var location = useLocation();
    var handleAction = function() {
        var _ref = _async_to_generator(function(shareLink) {
            var analytics, __typename, _navigator_clipboard, _navigator, linkToCopy, linkToOpen;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        analytics = shareLink.analytics, __typename = shareLink.__typename;
                        if (analytics) {
                            trackEvent(analytics.referrerId, analytics.linkName);
                        }
                        switch(__typename){
                            case "ShoppingCopyLink":
                                return [
                                    3,
                                    1
                                ];
                            case "ShoppingSocialMediaLink":
                                return [
                                    3,
                                    3
                                ];
                        }
                        return [
                            3,
                            4
                        ];
                    case 1:
                        setTextToast(shareLink.toast.text);
                        linkToCopy = createCopyLink(shareLink, location, urlParameterKeys, domain);
                        return [
                            4,
                            (_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator_clipboard = _navigator.clipboard) === null || _navigator_clipboard === void 0 ? void 0 : _navigator_clipboard.writeText(linkToCopy)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        {
                            linkToOpen = socialMediaLink(shareLink, location, urlParameterKeys, domain);
                            window.open("".concat(linkToOpen), "_blank");
                            return [
                                3,
                                5
                            ];
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            null
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAction(shareLink) {
            return _ref.apply(this, arguments);
        };
    }();
    return /* @__PURE__ */ React80.createElement(React80.Fragment, null, /* @__PURE__ */ React80.createElement(Viewport17, null, /* @__PURE__ */ React80.createElement(ViewSmall17, null, /* @__PURE__ */ React80.createElement(UitkSpacing5, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React80.createElement(UitkActionList, null, shareLinks === null || shareLinks === void 0 ? void 0 : shareLinks.map(function(shareLink, index) {
        var name = shareLink.name;
        return /* @__PURE__ */ React80.createElement(UitkActionListItem, {
            key: "shareLink-optionSmall-".concat(index)
        }, /* @__PURE__ */ React80.createElement(UitkActionListItemLink, null, /* @__PURE__ */ React80.createElement(UitkButton, {
            type: "button",
            onClick: function() {
                return handleAction(shareLink);
            }
        }, name)), /* @__PURE__ */ React80.createElement(UitkLayoutFlex2, {
            space: "three"
        }, /* @__PURE__ */ React80.createElement(UitkLayoutFlexItem2, {
            shrink: 0,
            alignSelf: "center"
        }, /* @__PURE__ */ React80.createElement(OptionIconRender, {
            shareLink: shareLink
        })), /* @__PURE__ */ React80.createElement(UitkLayoutFlexItem2, {
            grow: 1
        }, /* @__PURE__ */ React80.createElement(UitkText4, {
            size: 500
        }, name))));
    })))), /* @__PURE__ */ React80.createElement(ViewLarge10, null, /* @__PURE__ */ React80.createElement(UitkLayoutFlex2, {
        space: "two"
    }, shareLinks.map(function(shareLink, index) {
        var name = shareLink.name;
        return /* @__PURE__ */ React80.createElement(UitkLayoutFlexItem2, {
            key: "shareLink-option-".concat(index)
        }, /* @__PURE__ */ React80.createElement(UitkSpacing5, {
            margin: {
                blockstart: "six"
            }
        }, /* @__PURE__ */ React80.createElement(UitkPrimaryButton2, {
            onClick: function() {
                return handleAction(shareLink);
            },
            inverse: true,
            type: "button"
        }, /* @__PURE__ */ React80.createElement(OptionIconRender, {
            shareLink: shareLink
        }), name)));
    })))), /* @__PURE__ */ React80.createElement(UitkToast, {
        onDismiss: function() {
            return setTextToast(null);
        },
        show: !!textToast
    }, /* @__PURE__ */ React80.createElement(UitkSpacing5, {
        margin: {
            inline: "one",
            blockend: "one"
        }
    }, /* @__PURE__ */ React80.createElement(UitkIcon, {
        name: "check_circle",
        size: UitkIconSize3.SMALL
    })), textToast));
};
ShareOptionsSection.displayName = "ShareOptionsSection";
ShareOptionsSection.fragment = __ShareOptionsFragment;
var share_options_section_default = ShareOptionsSection;
// src/components/share-actions/__private/__fragments/share-dialog.tsx
var __ShareDialogFragment = gql57(_templateObject58(), share_description_section_default.fragment, share_options_section_default.fragment);
var ShareDialog = function(param) {
    var data = param.data, DialogComponent = param.DialogComponent, isDialogOpen = param.isDialogOpen, triggerRef = param.triggerRef, domain = param.domain;
    var content = data.content;
    return /* @__PURE__ */ React81.createElement(UitkSheetTransition, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React81.createElement(DialogComponent, null, /* @__PURE__ */ React81.createElement(UitkSheet, {
        isVisible: isDialogOpen,
        type: "bottom",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React81.createElement(UitkSheetContent, {
        padded: false
    }, /* @__PURE__ */ React81.createElement(UitkSpacing6, {
        padding: "six"
    }, content && /* @__PURE__ */ React81.createElement("div", null, /* @__PURE__ */ React81.createElement(share_description_section_default, {
        data: content
    }), /* @__PURE__ */ React81.createElement(share_options_section_default, {
        data: content,
        domain: domain
    })))))));
};
ShareDialog.displayName = "ShareDialog";
ShareDialog.fragment = __ShareDialogFragment;
var share_dialog_default = ShareDialog;
// src/components/share-actions/__private/__fragments/share-dialog-popover.tsx
import React82 from "react";
import { gql as gql58 } from "@apollo/client";
import { UitkTertiaryButton } from "@egds/react-core/button";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize4 } from "@egds/react-core/icons";
import { UitkSheet as UitkSheet2, UitkSheetCloseButton, UitkSheetContent as UitkSheetContent2, UitkSheetTransition as UitkSheetTransition2 } from "@egds/react-core/sheet";
import { UitkSpacing as UitkSpacing7 } from "@egds/react-core/spacing";
var __ShareDialogPopOverFragment = gql58(_templateObject59(), share_description_section_default.fragment, share_options_section_default.fragment);
var ShareDialogPopover = function(param) {
    var data = param.data, isDialogOpen = param.isDialogOpen, closeDialog = param.closeDialog, triggerRef = param.triggerRef, domain = param.domain;
    var content = data.content;
    if (!data) {
        return null;
    }
    return /* @__PURE__ */ React82.createElement(UitkSheetTransition2, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React82.createElement(UitkSheet2, {
        position: {
            inline: "leading",
            block: "trailing"
        },
        isVisible: isDialogOpen,
        type: "popover",
        triggerRef: triggerRef,
        onDismiss: closeDialog,
        width: 495
    }, /* @__PURE__ */ React82.createElement(UitkSheetCloseButton, {
        alignment: "top"
    }, /* @__PURE__ */ React82.createElement(UitkTertiaryButton, {
        type: "button",
        onClick: closeDialog
    }, /* @__PURE__ */ React82.createElement(UitkIcon2, {
        name: "close",
        size: UitkIconSize4.MEDIUM,
        title: "close",
        id: "sheet-close-button"
    }))), /* @__PURE__ */ React82.createElement(UitkSheetContent2, {
        padded: false
    }, /* @__PURE__ */ React82.createElement(UitkSpacing7, {
        padding: {
            blockend: "six",
            inlineend: "six",
            inlinestart: "six"
        }
    }, content && /* @__PURE__ */ React82.createElement("div", null, /* @__PURE__ */ React82.createElement(share_description_section_default, {
        data: content
    }), /* @__PURE__ */ React82.createElement(share_options_section_default, {
        data: content,
        domain: domain
    }))))));
};
ShareDialogPopover.displayName = "ShareDialogPopover";
ShareDialogPopover.fragment = __ShareDialogPopOverFragment;
var share_dialog_popover_default = ShareDialogPopover;
// src/components/share-actions/share-actions.tsx
var __ShoppingShareLinksFragment = gql59(_templateObject60(), share_dialog_default.fragment);
var DIALOG_ID = "sheet-share-actions";
var ShareActions = function(param) {
    var data = param.data, dialogId = param.dialogId, domain = param.domain;
    var _data_shoppingShareLinks;
    var trackEvent = useClickTracker25();
    var _useDialog10 = _sliced_to_array(useDialog10(dialogId || DIALOG_ID), 3), isDialogOpen = _useDialog10[0], dialogActions = _useDialog10[1], DialogComponent = _useDialog10[2];
    if (!(data === null || data === void 0 ? void 0 : (_data_shoppingShareLinks = data.shoppingShareLinks) === null || _data_shoppingShareLinks === void 0 ? void 0 : _data_shoppingShareLinks.action)) {
        return null;
    }
    var _data_shoppingShareLinks1 = data.shoppingShareLinks, action = _data_shoppingShareLinks1.action, button = _data_shoppingShareLinks1.button;
    var primary = button.primary;
    var buttonLabel = primary || "";
    var triggerRef = React83.createRef();
    var openDialog = function() {
        var analytics = button.analytics;
        if (analytics) {
            trackEvent(analytics.referrerId, analytics.linkName);
        }
        dialogActions.openDialog();
    };
    var closeDialog = function() {
        var _action_sheet;
        if (action === null || action === void 0 ? void 0 : (_action_sheet = action.sheet) === null || _action_sheet === void 0 ? void 0 : _action_sheet.closeAnalytics) {
            var closeAnalytics = action.sheet.closeAnalytics;
            trackEvent(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        dialogActions.closeDialog();
    };
    return /* @__PURE__ */ React83.createElement(UitkLayoutPosition2, {
        type: "relative"
    }, /* @__PURE__ */ React83.createElement(UitkSpacing8, {
        padding: "two"
    }, /* @__PURE__ */ React83.createElement(UitkFloatingButton2, {
        onClick: openDialog,
        domRef: triggerRef,
        role: "button",
        name: buttonLabel,
        "aria-label": buttonLabel
    }, button.icon && /* @__PURE__ */ React83.createElement(UitkIcon3, {
        name: button.icon.id,
        size: UitkIconSize5.MEDIUM
    }))), action && /* @__PURE__ */ React83.createElement(Viewport18, null, /* @__PURE__ */ React83.createElement(ViewSmall18, null, /* @__PURE__ */ React83.createElement(share_dialog_default, {
        data: action,
        isDialogOpen: isDialogOpen,
        triggerRef: triggerRef,
        DialogComponent: DialogComponent,
        domain: domain
    })), /* @__PURE__ */ React83.createElement(ViewLarge11, null, /* @__PURE__ */ React83.createElement(share_dialog_popover_default, {
        data: action,
        isDialogOpen: isDialogOpen,
        closeDialog: closeDialog,
        triggerRef: triggerRef,
        domain: domain
    }))));
};
ShareActions.displayName = "ShareActions";
ShareActions.fragment = __ShoppingShareLinksFragment;
// src/components/shortlist/shortlist.tsx
import React84 from "react";
import { gql as gql60 } from "@apollo/client";
import { useClickTracker as useClickTracker26 } from "@shared-ui/clickstream-analytics-context";
import { ProductType, ShortlistToggle } from "@shared-ui/trip-planning-travelpulse";
var __fragment = gql60(_templateObject61());
var Shortlist = function(param) {
    var data = param.data;
    var track = useClickTracker26();
    var propertyId = usePropertyDetailsInputs().propertyId;
    var button = (data.shortList || {}).button;
    var name = (data.summary || {}).name;
    if (!button) {
        return null;
    }
    var handleChange = function(previousChecked, currentChecked, dispatch) {
        if (!currentChecked) {
            track(button.uncheckedAnalytics.referrerId, button.uncheckedAnalytics.linkName);
            return;
        }
        track(button.checkedAnalytics.referrerId, button.checkedAnalytics.linkName);
        dispatch({
            message: name
        });
    };
    var _button_checkedAccessibilityLabel;
    return /* @__PURE__ */ React84.createElement(ShortlistToggle, {
        label: (_button_checkedAccessibilityLabel = button.checkedAccessibilityLabel) !== null && _button_checkedAccessibilityLabel !== void 0 ? _button_checkedAccessibilityLabel : "",
        initialChecked: button.checked,
        onChange: handleChange,
        inputs: {
            productId: propertyId,
            productType: ProductType.PROPERTY_DETAILS
        }
    });
};
Shortlist.displayName = "Shortlist";
Shortlist.fragment = __fragment;
// src/components/space-overview/space-overview.tsx
import React87 from "react";
import { gql as gql63 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing38 } from "@egds/react-core/spacing";
import { useExperiment as useExperiment17 } from "@shared-ui/experiment-context";
// src/components/space-overview/__private/__fragments/space-overview-info.tsx
import React85 from "react";
import { gql as gql61 } from "@apollo/client";
import { EGDSIcon as EGDSIcon13 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex21, EGDSLayoutFlexItem as EGDSLayoutFlexItem13 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing37 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText14 } from "@egds/react-core/text";
import { defaultViewSizes as defaultViewSizes3, useMediaQueries as useMediaQueries3 } from "@shared-ui/viewport-context";
var __SpaceOverviewInfoFragment = gql61(_templateObject62());
var SpaceOverviewInfo = function(param) {
    var data = param.data;
    var viewSize = useMediaQueries3({
        viewSizes: defaultViewSizes3
    });
    var minWidth = data.items && viewSize === defaultViewSizes3.SMALL && data.items.length % 2 === 0 ? "half_width" : void 0;
    return /* @__PURE__ */ React85.createElement(EGDSLayoutFlex21, {
        wrap: "wrap"
    }, /* @__PURE__ */ React85.createElement(React85.Fragment, null, data.items.map(function(item, index) {
        return /* @__PURE__ */ React85.createElement(EGDSLayoutFlexItem13, {
            key: "".concat(item.__typename, "-").concat(index),
            grow: 1,
            minWidth: minWidth
        }, /* @__PURE__ */ React85.createElement(EGDSText14, {
            size: 300,
            inline: true,
            spacing: "three",
            theme: "standard"
        }, item.icon && /* @__PURE__ */ React85.createElement(EGDSSpacing37, {
            margin: {
                inlineend: "two"
            }
        }, /* @__PURE__ */ React85.createElement(EGDSIcon13, {
            name: item.icon.iconId,
            "aria-hidden": "true"
        })), item.text));
    })));
};
SpaceOverviewInfo.fragment = __SpaceOverviewInfoFragment;
SpaceOverviewInfo.displayName = "SpaceOverviewInfo";
// src/components/space-overview/__private/__fragments/space-overview-title.tsx
import React86 from "react";
import { gql as gql62 } from "@apollo/client";
import { EGDSHeading as EGDSHeading13 } from "@egds/react-core/text";
import { useExperiment as useExperiment16 } from "@shared-ui/experiment-context";
var __SpaceOverviewTitleFragment = gql62(_templateObject63());
var SpaceOverviewTitle = function(param) {
    var data = param.data;
    var header = data.header;
    var isTopOfPDPRedesignVariant = useExperiment16("Remove_About_the_Property_Web").exposure.bucket;
    var isModularised = useExperiment16("PDP_MODULARISED_LOCATION_SECTION").exposure.bucket;
    var headingSize = isTopOfPDPRedesignVariant && isModularised ? 4 : 5;
    if (!(header === null || header === void 0 ? void 0 : header.text)) {
        return null;
    }
    return /* @__PURE__ */ React86.createElement(EGDSHeading13, {
        tag: "h3",
        size: headingSize
    }, header.text);
};
SpaceOverviewTitle.fragment = __SpaceOverviewTitleFragment;
SpaceOverviewTitle.displayName = "SpaceOverviewTitle";
// src/components/space-overview/space-overview.tsx
var __SpaceOverviewFragment = gql63(_templateObject64(), SpaceOverviewTitle.fragment, SpaceOverviewInfo.fragment);
var SpaceOverview = function(param) {
    var data = param.data, className = param.className;
    var _propertyHighlightedDetails_items;
    var propertyHighlightedDetails = data.propertyHighlightedDetails;
    var searchCriteria = usePropertyDetailsInputs().searchCriteria;
    var isDated = searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.primary.dateRange;
    var _useExperiment17 = useExperiment17("Remove_About_the_Property_Web"), topOfPDPRedesignExposure = _useExperiment17.exposure;
    var _useExperiment17_exposure = useExperiment17("PDP_MODULARISED_LOCATION_SECTION").exposure, isShowingModularisedSection = _useExperiment17_exposure.bucket;
    var isTopOfPDPRedesignVariant = topOfPDPRedesignExposure.bucket === 1;
    if (!(propertyHighlightedDetails === null || propertyHighlightedDetails === void 0 ? void 0 : (_propertyHighlightedDetails_items = propertyHighlightedDetails.items) === null || _propertyHighlightedDetails_items === void 0 ? void 0 : _propertyHighlightedDetails_items.length)) {
        return null;
    }
    return /* @__PURE__ */ React87.createElement(EGDSSpacing38, {
        margin: {
            blockend: isShowingModularisedSection ? "three" : "four"
        },
        border: isTopOfPDPRedesignVariant && isDated ? [
            "blockend"
        ] : void 0,
        padding: isTopOfPDPRedesignVariant ? {
            blockend: "three"
        } : void 0
    }, /* @__PURE__ */ React87.createElement("div", {
        className: className
    }, /* @__PURE__ */ React87.createElement(SpaceOverviewTitle, {
        data: propertyHighlightedDetails
    }), /* @__PURE__ */ React87.createElement(SpaceOverviewInfo, {
        data: propertyHighlightedDetails
    })));
};
SpaceOverview.fragment = __SpaceOverviewFragment;
SpaceOverview.displayName = "SpaceOverview";
// src/components/summary/summary.tsx
import React108, { useContext as useContext2, useMemo as useMemo3 } from "react";
import { EGDSCard as EGDSCard10, EGDSCardContentSection as EGDSCardContentSection5 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid15, EGDSLayoutGridItem as EGDSLayoutGridItem15 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing56 } from "@egds/react-core/spacing";
import { useExperiment as useExperiment22 } from "@shared-ui/experiment-context";
import { findReactChildByType } from "@shared-ui/lodging-fragments";
import { RefTarget as RefTarget3 } from "@shared-ui/ref-context";
import { IdentifierType as RandomAccessOneIdentifierType, RandomAccessOne as RandomAccessOne5 } from "@shared-ui/retail-product-random-access-one";
import { IdentifierType as IdentifierType8, IdentifierType as ProductRatingSummaryIdentifier, ProductRatingSummary } from "@shared-ui/retail-product-rating-summary";
import { ProductType as ProductType4, useProductType as useProductType3 } from "@shared-ui/retail-product-type-providers";
// src/utils/adapt-inputs-with-search-id.ts
var SEARCH_ID_PARAM = "searchId";
var adaptSearchCriteriaWithSearchId = function(searchCriteria, searchId) {
    var _searchCriteria_secondary_selections, _searchCriteria_secondary, _searchCriteria_secondary1;
    var existingSearchId = searchCriteria === null || searchCriteria === void 0 ? void 0 : (_searchCriteria_secondary = searchCriteria.secondary) === null || _searchCriteria_secondary === void 0 ? void 0 : (_searchCriteria_secondary_selections = _searchCriteria_secondary.selections) === null || _searchCriteria_secondary_selections === void 0 ? void 0 : _searchCriteria_secondary_selections.some(function(selection) {
        return selection.id === SEARCH_ID_PARAM;
    });
    return searchCriteria && !existingSearchId && searchId ? _object_spread_props(_object_spread({}, searchCriteria), {
        secondary: _object_spread_props(_object_spread({}, searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.secondary), {
            selections: _to_consumable_array((searchCriteria === null || searchCriteria === void 0 ? void 0 : (_searchCriteria_secondary1 = searchCriteria.secondary) === null || _searchCriteria_secondary1 === void 0 ? void 0 : _searchCriteria_secondary1.selections) || []).concat([
                {
                    id: SEARCH_ID_PARAM,
                    value: searchId
                }
            ])
        })
    }) : searchCriteria;
};
// src/components/summary/__private/__fragments/amenities/index.tsx
import React89 from "react";
import { gql as gql64 } from "@apollo/client";
import { EGDSSheetTransition as EGDSSheetTransition11 } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker27 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog11 } from "@shared-ui/dialog-context";
import { __PropertyInfoContent as __PropertyInfoContent2, AdaptExAnalyticsEventFragment, PropertyContent as PropertyContent3 } from "@shared-ui/lodging-fragments";
import { RefTarget as RefTarget2 } from "@shared-ui/ref-context";
import { ViewLarge as ViewLarge12, Viewport as Viewport19, ViewSmall as ViewSmall19 } from "@shared-ui/viewport-context";
// src/components/summary/__private/__fragments/amenities/amenity-view.tsx
import React88 from "react";
import { EGDSSpacing as EGDSSpacing39 } from "@egds/react-core/spacing";
import { useExperiment as useExperiment18 } from "@shared-ui/experiment-context";
import { PropertyContent as PropertyContent2, PropertyInfoContent as PropertyInfoContent5 } from "@shared-ui/lodging-fragments";
import { RefTarget } from "@shared-ui/ref-context";
// src/utils/react-children-to-display-name-map.ts
import { Children } from "react";
function reactChildrenToDisplayNameMap(children) {
    if (!children) {
        return {};
    }
    var map = {};
    Children.forEach(children, function(c) {
        var _c_type, _map_displayName;
        var displayName = c === null || c === void 0 ? void 0 : (_c_type = c.type) === null || _c_type === void 0 ? void 0 : _c_type.displayName;
        if (!displayName) {
            return;
        }
        if (!map[displayName]) {
            map[displayName] = [];
        }
        (_map_displayName = map[displayName]) === null || _map_displayName === void 0 ? void 0 : _map_displayName.push(c);
    });
    return map;
}
// src/components/summary/__private/__fragments/amenities/amenity-view.tsx
var AmenityView = function(param) {
    var children = param.children, data = param.data;
    var _data_summary_amenities, _data_summary, _data_summary1, _data_summary_amenities1, _data_summary2;
    var topAmenities = (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_amenities = _data_summary.amenities) === null || _data_summary_amenities === void 0 ? void 0 : _data_summary_amenities.topAmenities;
    var propertyTagline = (_data_summary1 = data.summary) === null || _data_summary1 === void 0 ? void 0 : _data_summary1.tagline;
    var _useExperiment18 = useExperiment18("Remove_About_the_Property_Web"), topOfPDPRedesignExposure = _useExperiment18.exposure;
    var isTopOfPDPRedesignVariant = topOfPDPRedesignExposure.bucket === 1;
    var propertyContentPreferences = (_data_summary2 = data.summary) === null || _data_summary2 === void 0 ? void 0 : (_data_summary_amenities1 = _data_summary2.amenities) === null || _data_summary_amenities1 === void 0 ? void 0 : _data_summary_amenities1.propertyContentPreferences;
    var items = topAmenities === null || topAmenities === void 0 ? void 0 : topAmenities.items;
    var _useExperiment18_exposure = useExperiment18("PDP_MODULARISED_LOCATION_SECTION").exposure, isShowingModularisedSection = _useExperiment18_exposure.bucket;
    if (!topAmenities || !items || items.length === 0) {
        return null;
    }
    var _reactChildrenToDisplayNameMap = reactChildrenToDisplayNameMap(children), AmenitiesLink2 = _reactChildrenToDisplayNameMap.AmenitiesLink;
    var baseItemsProps = {
        overflow: "wrap",
        prefix: "cleaningAndSafety",
        space: "four",
        subset: items.length
    };
    var smallContentItemsProps = _object_spread_props(_object_spread({}, baseItemsProps), {
        columns: 2
    });
    var largeContentItemsProps = _object_spread_props(_object_spread({}, baseItemsProps), {
        columns: isShowingModularisedSection ? 3 : 2
    });
    return /* @__PURE__ */ React88.createElement(RefTarget, {
        name: "About"
    }, propertyContentPreferences && /* @__PURE__ */ React88.createElement(EGDSSpacing39, {
        padding: {
            blockend: "six"
        },
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React88.createElement("div", null, /* @__PURE__ */ React88.createElement(PropertyContent2, {
        data: propertyContentPreferences
    }))), /* @__PURE__ */ React88.createElement(PropertyInfoContent5, {
        data: topAmenities,
        small: smallContentItemsProps,
        large: largeContentItemsProps,
        tagline: isTopOfPDPRedesignVariant ? propertyTagline : null,
        headingSize: isShowingModularisedSection ? 4 : void 0,
        headingTag: isShowingModularisedSection ? "h2" : void 0
    }), AmenitiesLink2);
};
AmenityView.displayName = "AmenityView";
// src/components/summary/__private/__fragments/amenities/index.tsx
var __SummaryAmenitiesFragment = gql64(_templateObject65(), __PropertyInfoContent2, PropertyContent3.fragment, AmenitiesLink.fragment, AmenitiesDialog.fragment, AdaptExAnalyticsEventFragment, RelevantAmenities.fragment, AmenitiesTabs.fragment);
var SummaryAmenities = function(param) {
    var data = param.data, className = param.className;
    var _amenities_topAmenities_items, _amenities_topAmenities, _amenities_amenitiesDialog_toolbar, _amenities_amenitiesDialog;
    var amenities = (data.summary || {}).amenities;
    var _ref = amenities || {}, dialogTabs = _ref.tabs;
    var _useDialog11 = _sliced_to_array(useDialog11("amenities-dialog", "pwaDialog"), 3), isDialogOpen = _useDialog11[0], dialogActions = _useDialog11[1], DialogComponent = _useDialog11[2];
    var analyticsTracker = useClickTracker27();
    var triggerAmenitiesRef = React89.useRef(null);
    var _React89_useState = _sliced_to_array(React89.useState(false), 2), dialogPreviouslyViewed = _React89_useState[0], setDialogPreviouslyViewed = _React89_useState[1];
    if (!(amenities === null || amenities === void 0 ? void 0 : (_amenities_topAmenities = amenities.topAmenities) === null || _amenities_topAmenities === void 0 ? void 0 : (_amenities_topAmenities_items = _amenities_topAmenities.items) === null || _amenities_topAmenities_items === void 0 ? void 0 : _amenities_topAmenities_items.length)) {
        return null;
    }
    var clientSideAnalytics = amenities === null || amenities === void 0 ? void 0 : (_amenities_amenitiesDialog = amenities.amenitiesDialog) === null || _amenities_amenitiesDialog === void 0 ? void 0 : (_amenities_amenitiesDialog_toolbar = _amenities_amenitiesDialog.toolbar) === null || _amenities_amenitiesDialog_toolbar === void 0 ? void 0 : _amenities_amenitiesDialog_toolbar.clientSideAnalytics;
    var onClose = function() {
        dialogActions.closeDialog();
        setDialogPreviouslyViewed(true);
        if (clientSideAnalytics) {
            analyticsTracker(clientSideAnalytics.referrerId, clientSideAnalytics.linkName, true);
        }
    };
    var amenitiesLink = (amenities === null || amenities === void 0 ? void 0 : amenities.amenitiesDialog) && /* @__PURE__ */ React89.createElement(AmenitiesLink, {
        key: "amenities-link",
        data: amenities,
        onClick: dialogActions.openDialog,
        triggerRef: triggerAmenitiesRef
    });
    var HotelAmenitiesList = /* @__PURE__ */ React89.createElement("div", {
        className: className,
        "data-stid": "hotel-amenities-list"
    }, /* @__PURE__ */ React89.createElement(Viewport19, null, /* @__PURE__ */ React89.createElement(ViewSmall19, null, /* @__PURE__ */ React89.createElement(AmenityView, {
        data: data
    }, amenitiesLink)), /* @__PURE__ */ React89.createElement(ViewLarge12, null, /* @__PURE__ */ React89.createElement(AmenityView, {
        data: data
    }, amenitiesLink))));
    return /* @__PURE__ */ React89.createElement(React89.Fragment, null, /* @__PURE__ */ React89.createElement(RefTarget2, {
        name: "PopularAmenities"
    }, HotelAmenitiesList), (amenities === null || amenities === void 0 ? void 0 : amenities.amenitiesDialog) && /* @__PURE__ */ React89.createElement(EGDSSheetTransition11, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React89.createElement(DialogComponent, null, /* @__PURE__ */ React89.createElement(AmenitiesDialog, {
        data: amenities,
        closeDialog: onClose,
        isDialogOpen: isDialogOpen,
        triggerRef: triggerAmenitiesRef,
        dialogPreviouslyViewed: dialogPreviouslyViewed,
        aboutThisPropertyData: data,
        dialogTabs: dialogTabs
    }))));
};
SummaryAmenities.displayName = "SummaryAmenities";
SummaryAmenities.fragment = __SummaryAmenitiesFragment;
// src/components/summary/__private/__fragments/near-by-pois/index.tsx
import React95, { useContext, useEffect as useEffect7 } from "react";
import { gql as gql69 } from "@apollo/client";
import { EGDSIcon as EGDSIcon16, EGDSIconSize as EGDSIconSize4 } from "@egds/react-core/icons";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType10 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex23, EGDSLayoutFlexItem as EGDSLayoutFlexItem15 } from "@egds/react-core/layout-flex";
import { EGDSList as EGDSList5 } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing45 } from "@egds/react-core/spacing";
import { IntersectionTracker as IntersectionTracker8, ITrackType as ITrackType5, useClickstreamAnalytics as useClickstreamAnalytics5 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment6, ExperimentControl as ExperimentControl6, ExperimentVariant as ExperimentVariant6, useExperiment as useExperiment19 } from "@shared-ui/experiment-context";
import { adaptToAdaptExSuccessEventSchema } from "@shared-ui/lodging-fragments";
import { IdentifierType as IdentifierType2, RandomAccessOne as RandomAccessOne2 } from "@shared-ui/retail-product-random-access-one";
import { ViewLarge as ViewLarge13, ViewMedium as ViewMedium12, Viewport as Viewport20, ViewSmall as ViewSmall20 } from "@shared-ui/viewport-context";
import { useInView as useInView7 } from "react-intersection-observer";
// src/components/summary/__private/__fragments/near-by-pois/pois-images-loading-placeholder.tsx
import React90 from "react";
import { EGDSCard as EGDSCard7 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure5, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType9 } from "@egds/react-core/images";
import { EGDSLayoutGrid as EGDSLayoutGrid14, EGDSLayoutGridItem as EGDSLayoutGridItem13 } from "@egds/react-core/layout-grid";
import { EGDSBlockSkeleton, EGDSLineSkeleton as EGDSLineSkeleton3 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing40 } from "@egds/react-core/spacing";
var POIsImagesLoadingPlaceholder = function(param) {
    var aspectRatio = param.aspectRatio;
    return /* @__PURE__ */ React90.createElement(EGDSSpacing40, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React90.createElement("div", null, /* @__PURE__ */ React90.createElement(EGDSLayoutGrid14, {
        columns: {
            small: 2,
            medium: 2,
            large: 2
        },
        space: "three"
    }, [
        0,
        1
    ].map(function(_, index) {
        return /* @__PURE__ */ React90.createElement(EGDSLayoutGridItem13, {
            key: "image-rich-location-modal-placeholder-".concat(index)
        }, /* @__PURE__ */ React90.createElement(EGDSSpacing40, null, /* @__PURE__ */ React90.createElement("div", null, /* @__PURE__ */ React90.createElement(EGDSCard7, null, /* @__PURE__ */ React90.createElement(EGDSFigure5, {
            ratio: aspectRatio || EGDSFigureAspectRatioType9.R16_9
        }, /* @__PURE__ */ React90.createElement(EGDSBlockSkeleton, null))), /* @__PURE__ */ React90.createElement(EGDSSpacing40, {
            margin: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React90.createElement(EGDSLineSkeleton3, {
            animation: true,
            type: "secondary"
        })), /* @__PURE__ */ React90.createElement(EGDSSpacing40, {
            margin: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React90.createElement(EGDSLineSkeleton3, {
            animation: true
        })))));
    }))));
};
// src/components/summary/__private/__fragments/near-by-pois/whats-near-by-section.tsx
import React94 from "react";
import { gql as gql68 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing44, UitkSpacing as UitkSpacing9 } from "@egds/react-core/spacing";
import { UitkHeading as UitkHeading4 } from "@egds/react-core/text";
import { Experiment as Experiment5, ExperimentControl as ExperimentControl5, ExperimentVariant as ExperimentVariant5 } from "@shared-ui/experiment-context";
import { IdentifierType, RandomAccessOne } from "@shared-ui/retail-product-random-access-one";
// src/components/summary/__private/__fragments/near-by-pois/whats-near-by-editorial.tsx
import React91 from "react";
import { gql as gql65 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing41 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText15 } from "@egds/react-core/text";
var __WhatsNearbyEditorialFragment = gql65(_templateObject66());
var WhatsNearbyEditorial = function(param) {
    var data = param.data;
    if (!data || !data.content || data.content.length <= 0) {
        return null;
    }
    var content = data.content[0];
    return /* @__PURE__ */ React91.createElement("section", null, /* @__PURE__ */ React91.createElement(EGDSSpacing41, {
        padding: {
            blockstart: "three",
            blockend: "three"
        }
    }, /* @__PURE__ */ React91.createElement("div", {
        itemProp: "geo",
        itemScope: true,
        itemType: "https://schema.org/GeoCoordinates"
    }, /* @__PURE__ */ React91.createElement("meta", {
        itemProp: "description",
        content: content
    }), /* @__PURE__ */ React91.createElement(EGDSText15, {
        size: 300
    }, content))));
};
WhatsNearbyEditorial.displayName = "WhatsNearbyEditorial";
WhatsNearbyEditorial.fragment = __WhatsNearbyEditorialFragment;
// src/components/summary/__private/__fragments/near-by-pois/whats-near-by-pois.tsx
import React93 from "react";
import { gql as gql67 } from "@apollo/client";
import { EGDSIcon as EGDSIcon15 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex22, EGDSLayoutFlexItem as EGDSLayoutFlexItem14 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing43 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading14 } from "@egds/react-core/text";
// src/components/summary/__private/__fragments/near-by-pois/whats-near-by-pois-items.tsx
import React92 from "react";
import { gql as gql66 } from "@apollo/client";
import { EGDSIcon as EGDSIcon14 } from "@egds/react-core/icons";
import { EGDSList as EGDSList4, EGDSListItem as EGDSListItem3 } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing42 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText16 } from "@egds/react-core/text";
var __WhatsNearbyPoisItemsFragment = gql66(_templateObject67());
var WhatsNearbyPoisItems = function(param) {
    var data = param.data, hideIcon = param.hideIcon;
    var bullet = hideIcon ? "no-bullet" /* NO_BULLET */  : "icon-standard" /* ICON_STANDARD */ ;
    if (!data || !data.items || data.items.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React92.createElement(EGDSSpacing42, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React92.createElement(EGDSList4, {
        bullet: bullet,
        spacing: false
    }, data.items.map(function(item, idx) {
        var _item_icon, _item_icon1;
        return /* @__PURE__ */ React92.createElement(EGDSListItem3, {
            key: "whats-around-pois-list-".concat(idx)
        }, !hideIcon && (item === null || item === void 0 ? void 0 : item.icon) && /* @__PURE__ */ React92.createElement(EGDSIcon14, {
            id: item === null || item === void 0 ? void 0 : (_item_icon = item.icon) === null || _item_icon === void 0 ? void 0 : _item_icon.iconId,
            name: item === null || item === void 0 ? void 0 : (_item_icon1 = item.icon) === null || _item_icon1 === void 0 ? void 0 : _item_icon1.iconId
        }), /* @__PURE__ */ React92.createElement(EGDSText16, null, item.text, item.moreInfo && " - ".concat(item.moreInfo)));
    })));
};
WhatsNearbyPoisItems.displayName = "WhatsNearbyPoisItems";
WhatsNearbyPoisItems.fragment = __WhatsNearbyPoisItemsFragment;
// src/components/summary/__private/__fragments/near-by-pois/whats-near-by-pois.tsx
var __WhatsNearbyPoisFragment = gql67(_templateObject68(), WhatsNearbyPoisItems.fragment);
var WhatsAroundIcon = function(param) {
    var iconId = param.iconId;
    return /* @__PURE__ */ React93.createElement(EGDSIcon15, {
        id: "".concat(iconId, "-icon"),
        name: iconId
    });
};
var WhatsAroundPoiSection = function(props) {
    var title = props.title, items = props.items, icon = props.icon;
    if (!title || !items || !items.length) {
        return null;
    }
    var hideIcon = (icon === null || icon === void 0 ? void 0 : icon.iconId) !== "lob_cars" /* LOB_CARS */ ;
    return /* @__PURE__ */ React93.createElement(EGDSSpacing43, {
        padding: {
            block: "three"
        }
    }, /* @__PURE__ */ React93.createElement(EGDSLayoutFlex22, {
        space: "three"
    }, icon && /* @__PURE__ */ React93.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React93.createElement("div", null, /* @__PURE__ */ React93.createElement(WhatsAroundIcon, {
        iconId: icon === null || icon === void 0 ? void 0 : icon.iconId
    }))), /* @__PURE__ */ React93.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React93.createElement("div", null, /* @__PURE__ */ React93.createElement(EGDSHeading14, {
        tag: "h4",
        size: 6
    }, title), /* @__PURE__ */ React93.createElement(WhatsNearbyPoisItems, {
        data: props,
        hideIcon: hideIcon
    })))));
};
var WhatsNearbyPois = function(param) {
    var data = param.data;
    if (!data || !data.nearbyPOIs || data.nearbyPOIs.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React93.createElement(React93.Fragment, null, data.nearbyPOIs.map(function(section, idx) {
        return /* @__PURE__ */ React93.createElement(WhatsAroundPoiSection, _object_spread_props(_object_spread({}, section), {
            key: idx
        }));
    }));
};
WhatsNearbyPois.fragment = __WhatsNearbyPoisFragment;
WhatsNearbyPois.displayName = "WhatsNearbyPois";
// src/components/summary/__private/__fragments/near-by-pois/whats-near-by-section.tsx
var __WhatsNearbySectionFragment = gql68(_templateObject69(), WhatsNearbyPois.fragment, WhatsNearbyEditorial.fragment);
var WhatsNearbySection = function(param) {
    var data = param.data, propertyId = param.propertyId;
    var searchCriteria = usePropertyDetailsInputs().searchCriteria;
    if (!(data === null || data === void 0 ? void 0 : data.whatsAround)) {
        return null;
    }
    var _data_whatsAround = data.whatsAround, title = _data_whatsAround.title, editorial = _data_whatsAround.editorial;
    return /* @__PURE__ */ React94.createElement(React94.Fragment, null, /* @__PURE__ */ React94.createElement(Experiment5, {
        name: "PEXO_PDP_IMAGE_RICH_LOCATION_SECTION_NATIVE"
    }, /* @__PURE__ */ React94.createElement(ExperimentControl5, null), /* @__PURE__ */ React94.createElement(ExperimentVariant5, {
        bucket: 1
    }, /* @__PURE__ */ React94.createElement(EGDSSpacing44, {
        padding: {
            small: {
                blockend: "three"
            },
            large: {
                blockstart: "three"
            }
        }
    }, /* @__PURE__ */ React94.createElement("div", {
        "data-stid": "poi-images-modal"
    }, /* @__PURE__ */ React94.createElement(RandomAccessOne, {
        inputs: {
            featureId: "image_rich_location_modal_ab",
            productIdentifier: {
                id: propertyId,
                type: IdentifierType.PROPERTY_ID,
                travelSearchCriteria: {
                    property: searchCriteria
                }
            }
        },
        batchKey: "default-product-details-experience-batch-key",
        loadingPlaceholder: /* @__PURE__ */ React94.createElement(POIsImagesLoadingPlaceholder, null)
    }))))), /* @__PURE__ */ React94.createElement(UitkSpacing9, null, /* @__PURE__ */ React94.createElement(UitkHeading4, {
        tag: "h2",
        size: 5
    }, title)), /* @__PURE__ */ React94.createElement(WhatsNearbyEditorial, {
        data: editorial
    }), /* @__PURE__ */ React94.createElement(WhatsNearbyPois, {
        data: data.whatsAround
    }));
};
WhatsNearbySection.fragment = __WhatsNearbySectionFragment;
WhatsNearbySection.displayName = "WhatsNearbySection";
// src/components/summary/__private/__fragments/near-by-pois/index.tsx
var __SummaryNearByPoisFragment = gql69(_templateObject70(), SeeMoreAction.fragment, WhatsNearbySection.fragment);
var Icon = /* @__PURE__ */ function(Icon2) {
    Icon2["flight"] = "lob_flights";
    return Icon2;
}(Icon || {});
var getIconProps = function(icon, index) {
    return {
        id: "nearByPOIs-".concat(index),
        name: Icon[icon.iconId] || icon.iconId,
        title: icon.description,
        size: EGDSIconSize4.MEDIUM
    };
};
var SummaryNearByPois = function(param) {
    var data = param.data, className = param.className;
    var _data_summary, _data_summary1;
    var track = useClickstreamAnalytics5().track;
    var _useInView7 = useInView7({
        triggerOnce: true,
        threshold: 0.1
    }), ref = _useInView7.ref, inView = _useInView7.inView;
    var _ref = (data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.nearbyPOIs) || {}, heading = _ref.heading, items = _ref.items, seeMoreAction = _ref.seeMoreAction, adaptExAttemptEvents = _ref.adaptExAttemptEvents, adaptExSuccessEvents = _ref.adaptExSuccessEvents, impressionAnalytics = _ref.impressionAnalytics;
    var _ref1 = impressionAnalytics || {}, referrerId = _ref1.referrerId, linkName = _ref1.linkName;
    var propertyId = data.id;
    var _useExperiment19_exposure = useExperiment19("PDP_MODULARISED_LOCATION_SECTION").exposure, isShowingModularisedSection = _useExperiment19_exposure.bucket;
    var searchCriteria = usePropertyDetailsInputs().searchCriteria;
    var isDateless = !(searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.primary.dateRange);
    var _useContext = _sliced_to_array(useContext(PropertyDetailsAdaptExContext), 2), adaptExState = _useContext[0], setAdaptExState = _useContext[1];
    useEffect7(function() {
        if (adaptExSuccessEvents) {
            setAdaptExState(_object_spread_props(_object_spread({}, adaptExState), {
                nearByPoisAdaptExSuccessEvents: adaptExSuccessEvents
            }));
        }
    }, [
        adaptExSuccessEvents
    ]);
    useEffect7(function() {
        if (inView && (adaptExAttemptEvents === null || adaptExAttemptEvents === void 0 ? void 0 : adaptExAttemptEvents.length)) {
            adaptExAttemptEvents.forEach(function(adaptExAttemptEvent) {
                track(ITrackType5.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExAttemptEvent)
                });
            });
        }
    }, [
        adaptExAttemptEvents,
        inView,
        track
    ]);
    if (!((_data_summary1 = data.summary) === null || _data_summary1 === void 0 ? void 0 : _data_summary1.nearbyPOIs)) {
        return null;
    }
    var location = ((data === null || data === void 0 ? void 0 : data.summary) || {}).location;
    var nearbyPoiList = /* @__PURE__ */ React95.createElement(EGDSList5, {
        bullet: "no-bullet",
        spacing: true
    }, items === null || items === void 0 ? void 0 : items.map(function(param, index) {
        var icon = param.icon, text = param.text, moreInfo = param.moreInfo;
        var iconProps = icon && getIconProps(icon, index);
        return /* @__PURE__ */ React95.createElement(EGDSLayoutFlex23, {
            key: text,
            space: "two",
            wrap: "nowrap",
            tag: "li"
        }, iconProps && /* @__PURE__ */ React95.createElement(EGDSSpacing45, {
            padding: {
                inlineend: "three"
            }
        }, /* @__PURE__ */ React95.createElement(EGDSIcon16, _object_spread({}, iconProps))), /* @__PURE__ */ React95.createElement(EGDSLayoutFlexItem15, {
            grow: 1
        }, /* @__PURE__ */ React95.createElement("span", null, text)), /* @__PURE__ */ React95.createElement(EGDSLayoutFlexItem15, {
            shrink: 0
        }, /* @__PURE__ */ React95.createElement("span", null, moreInfo)));
    }));
    var seeMoreSection = function(isRandomAccess) {
        return /* @__PURE__ */ React95.createElement(React95.Fragment, null, seeMoreAction && /* @__PURE__ */ React95.createElement(Viewport20, null, /* @__PURE__ */ React95.createElement(ViewSmall20, null, /* @__PURE__ */ React95.createElement(SeeMoreAction, {
            data: seeMoreAction,
            isNearByPoiLink: true,
            type: "full",
            isRandomAccess: isRandomAccess
        }, location && /* @__PURE__ */ React95.createElement(WhatsNearbySection, {
            data: location,
            propertyId: propertyId
        }))), /* @__PURE__ */ React95.createElement(ViewMedium12, null, /* @__PURE__ */ React95.createElement(SeeMoreAction, {
            data: seeMoreAction,
            isNearByPoiLink: true,
            type: "centered",
            isRandomAccess: isRandomAccess
        }, location && /* @__PURE__ */ React95.createElement(WhatsNearbySection, {
            data: location,
            propertyId: propertyId
        })))));
    };
    var nearByPois = /* @__PURE__ */ React95.createElement(React95.Fragment, null, nearbyPoiList, seeMoreSection(false));
    var wrapInSpacing = function(blockstart, blockend) {
        return /* @__PURE__ */ React95.createElement(EGDSSpacing45, {
            margin: {
                blockstart: blockstart,
                blockend: blockend
            }
        }, /* @__PURE__ */ React95.createElement("div", null, nearByPois));
    };
    var poisWithoutImages = /* @__PURE__ */ React95.createElement(EGDSLayoutFlex23, {
        direction: "column",
        className: className,
        domRef: ref
    }, /* @__PURE__ */ React95.createElement(Viewport20, null, /* @__PURE__ */ React95.createElement(ViewSmall20, null, nearByPois), /* @__PURE__ */ React95.createElement(ViewMedium12, null, isShowingModularisedSection ? wrapInSpacing("twelve") : wrapInSpacing("eight")), /* @__PURE__ */ React95.createElement(ViewLarge13, null, isShowingModularisedSection ? wrapInSpacing("two") : nearByPois)));
    var poisWithImages = /* @__PURE__ */ React95.createElement("div", {
        "data-stid": "poi-images-primary-section"
    }, seeMoreSection(true), /* @__PURE__ */ React95.createElement(RandomAccessOne2, {
        inputs: {
            featureId: "image_rich_location_primary_ab",
            productIdentifier: {
                id: propertyId,
                type: IdentifierType2.PROPERTY_ID,
                travelSearchCriteria: {
                    property: searchCriteria
                }
            }
        },
        batchKey: "default-product-details-experience-batch-key",
        loadingPlaceholder: /* @__PURE__ */ React95.createElement(POIsImagesLoadingPlaceholder, {
            aspectRatio: EGDSFigureAspectRatioType10.R21_9
        })
    }));
    if (isDateless) {
        return referrerId && linkName ? /* @__PURE__ */ React95.createElement(IntersectionTracker8, {
            trackOnce: true,
            referrerId: referrerId,
            linkName: linkName
        }, poisWithoutImages) : poisWithoutImages;
    }
    var nearByPoisSection = /* @__PURE__ */ React95.createElement(Viewport20, null, /* @__PURE__ */ React95.createElement(ViewSmall20, null, /* @__PURE__ */ React95.createElement(Experiment6, {
        name: "PDP_IMAGE_RICH_LOCATION_PRIMARY_SECTION_WEB"
    }, /* @__PURE__ */ React95.createElement(ExperimentControl6, null, poisWithoutImages), /* @__PURE__ */ React95.createElement(ExperimentVariant6, {
        bucket: 1
    }, /* @__PURE__ */ React95.createElement(EGDSSpacing45, {
        padding: {
            small: {
                blockstart: "one"
            },
            medium: {
                blockstart: "unset"
            }
        }
    }, poisWithImages)))), /* @__PURE__ */ React95.createElement(ViewLarge13, null, poisWithoutImages));
    return referrerId && linkName ? /* @__PURE__ */ React95.createElement(IntersectionTracker8, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName
    }, nearByPoisSection) : nearByPoisSection;
};
SummaryNearByPois.displayName = "SummaryNearByPois";
SummaryNearByPois.fragment = __SummaryNearByPoisFragment;
// src/components/summary/__private/__fragments/banner-message/index.tsx
import React96 from "react";
import { gql as gql70 } from "@apollo/client";
import { EGDSCard as EGDSCard8 } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon17, EGDSIconSize as EGDSIconSize5 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex24, EGDSLayoutFlexItem as EGDSLayoutFlexItem16 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing46 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText17 } from "@egds/react-core/text";
var __SummaryBannerMessageFragment = gql70(_templateObject71());
var SummaryBannerMessage = function(param) {
    var data = param.data;
    var _data_summary, _bannerMessage_graphic, _bannerMessage_graphic1, _bannerMessage_graphic2, _bannerMessage_graphic3;
    var bannerMessage = data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.bannerMessageCard;
    if (!bannerMessage) {
        return null;
    }
    var bannerMessageId = ((_bannerMessage_graphic = bannerMessage.graphic) === null || _bannerMessage_graphic === void 0 ? void 0 : _bannerMessage_graphic.__typename) === "Mark" ? (_bannerMessage_graphic1 = bannerMessage.graphic) === null || _bannerMessage_graphic1 === void 0 ? void 0 : _bannerMessage_graphic1.id : "";
    var bannerMessageDescription = ((_bannerMessage_graphic2 = bannerMessage.graphic) === null || _bannerMessage_graphic2 === void 0 ? void 0 : _bannerMessage_graphic2.__typename) === "Mark" ? (_bannerMessage_graphic3 = bannerMessage.graphic) === null || _bannerMessage_graphic3 === void 0 ? void 0 : _bannerMessage_graphic3.description : "";
    return /* @__PURE__ */ React96.createElement(EGDSSpacing46, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React96.createElement(EGDSCard8, {
        padded: true,
        border: true
    }, /* @__PURE__ */ React96.createElement(EGDSLayoutFlex24, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React96.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */ React96.createElement("div", null, /* @__PURE__ */ React96.createElement(EGDSIcon17, {
        name: bannerMessageId,
        size: EGDSIconSize5.MEDIUM,
        id: "banner-message-".concat(bannerMessageId),
        title: bannerMessageDescription
    }))), /* @__PURE__ */ React96.createElement(EGDSSpacing46, {
        margin: {
            inlinestart: "two"
        }
    }, /* @__PURE__ */ React96.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */ React96.createElement("div", null, /* @__PURE__ */ React96.createElement(EGDSText17, {
        size: 300
    }, bannerMessage.message)))))));
};
SummaryBannerMessage.displayName = "SummaryBannerMessage";
SummaryBannerMessage.fragment = __SummaryBannerMessageFragment;
// src/components/summary/__private/__fragments/header/header.tsx
import React99 from "react";
import { gql as gql71 } from "@apollo/client";
import { EGDSVipBadge } from "@egds/react-core/badge";
import { EGDSIcon as EGDSIcon18, EGDSIconSize as EGDSIconSize6 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex25, EGDSLayoutFlexItem as EGDSLayoutFlexItem17 } from "@egds/react-core/layout-flex";
import { EGDSRating } from "@egds/react-core/rating";
import { EGDSSpacing as EGDSSpacing48 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading15, EGDSSubheading as EGDSSubheading2, EGDSText as EGDSText18 } from "@egds/react-core/text";
import { useExperiment as useExperiment20 } from "@shared-ui/experiment-context";
import { LodgingEGDSText } from "@shared-ui/lodging-fragments";
import { ViewLarge as ViewLarge14, Viewport as Viewport22, ViewSmall as ViewSmall22 } from "@shared-ui/viewport-context";
// src/components/summary/__private/__fragments/header/placeholder.tsx
import React98 from "react";
import { ViewMedium as ViewMedium13, Viewport as Viewport21, ViewSmall as ViewSmall21 } from "@shared-ui/viewport-context";
// src/components/summary/__private/__fragments/header/skeleton-header.tsx
import React97 from "react";
import { EGDSLineSkeleton as EGDSLineSkeleton4 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing47 } from "@egds/react-core/spacing";
var SkeletonHeader = function(param) {
    var rows = param.rows;
    return /* @__PURE__ */ React97.createElement(React97.Fragment, null, rows.map(function(param, index) {
        var type = param.type;
        return /* @__PURE__ */ React97.createElement(EGDSSpacing47, {
            key: index,
            margin: {
                blockend: "three"
            }
        }, /* @__PURE__ */ React97.createElement("div", null, /* @__PURE__ */ React97.createElement(EGDSLineSkeleton4, {
            animation: true,
            type: type
        })));
    }));
};
// src/components/summary/__private/__fragments/header/placeholder.tsx
var smallViewSkeletonProps = {
    rows: [
        {
            type: "primary"
        },
        {
            type: "secondary"
        },
        {
            type: "primary"
        },
        {
            type: "secondary"
        }
    ]
};
var mediumViewSkeletonProps = {
    rows: [
        {
            type: "primary"
        },
        {
            type: "secondary"
        },
        {
            type: "primary"
        }
    ]
};
var SummaryHeaderPlaceholder = function(param) {
    var data = param.data;
    var _data_summary;
    var ready = useComponentMount();
    if (data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.name) {
        return /* @__PURE__ */ React98.createElement(React98.Fragment, null, ready ? /* @__PURE__ */ React98.createElement(CSRHeaderPlaceholderChild, {
            data: data
        }) : /* @__PURE__ */ React98.createElement(SSRHeaderPlaceholderChild, {
            data: data
        }));
    }
    return /* @__PURE__ */ React98.createElement(Viewport21, null, /* @__PURE__ */ React98.createElement(ViewSmall21, null, /* @__PURE__ */ React98.createElement(SkeletonHeader, _object_spread({}, smallViewSkeletonProps))), /* @__PURE__ */ React98.createElement(ViewMedium13, null, /* @__PURE__ */ React98.createElement(SkeletonHeader, _object_spread({}, mediumViewSkeletonProps))));
};
var withPlaceholderChild2 = function(displayName) {
    var Component = function(param) {
        var data = param.data;
        return /* @__PURE__ */ React98.createElement(SummaryHeader, {
            data: data
        });
    };
    Component.displayName = displayName;
    return Component;
};
var CSRHeaderPlaceholderChild = withPlaceholderChild2("CsrPlaceholder");
var SSRHeaderPlaceholderChild = withPlaceholderChild2("SsrPlaceholder");
// src/components/summary/__private/__fragments/header/header.tsx
var __SummaryHeaderFragment = gql71(_templateObject72());
var SummaryHeader = function(param) {
    var data = param.data, propertyTopHeader = param.propertyTopHeader, inlineRating = param.inlineRating, _param_showVipBadge = param.showVipBadge, showVipBadge = _param_showVipBadge === void 0 ? true : _param_showVipBadge;
    var _overview_propertyRating, _overview_propertyRating1;
    var _ref = data.summary || {}, name = _ref.name, latinAlphabetName = _ref.latinAlphabetName, overview = _ref.overview, starRatingIcon = _ref.starRatingIcon, featuredMessages = _ref.featuredMessages, tagline = _ref.tagline, messages = _ref.messages;
    var shouldDisplayRating = Boolean((overview === null || overview === void 0 ? void 0 : overview.starRating) && starRatingIcon);
    var _useExperiment20 = useExperiment20("Remove_About_the_Property_Web"), topOfPDPRedesignExposure = _useExperiment20.exposure;
    var isTopOfPDPRedesignVariant = topOfPDPRedesignExposure.bucket === 1;
    if (!name) {
        return /* @__PURE__ */ React99.createElement(SummaryHeaderPlaceholder, {
            data: data
        });
    }
    var _overview_propertyRating_accessibility;
    var rating = shouldDisplayRating && inlineRating ? /* @__PURE__ */ React99.createElement(React99.Fragment, null, /* @__PURE__ */ React99.createElement(EGDSSpacing48, {
        padding: {
            inlinestart: "two"
        }
    }, /* @__PURE__ */ React99.createElement("span", null)), /* @__PURE__ */ React99.createElement(EGDSRating, {
        icon: (starRatingIcon === null || starRatingIcon === void 0 ? void 0 : starRatingIcon.iconId) === "STAR" ? "star" : "alternate",
        rating: String(overview === null || overview === void 0 ? void 0 : overview.starRating),
        a11yText: (_overview_propertyRating_accessibility = overview === null || overview === void 0 ? void 0 : (_overview_propertyRating = overview.propertyRating) === null || _overview_propertyRating === void 0 ? void 0 : _overview_propertyRating.accessibility) !== null && _overview_propertyRating_accessibility !== void 0 ? _overview_propertyRating_accessibility : void 0
    })) : null;
    var _overview_propertyRating_accessibility1;
    return /* @__PURE__ */ React99.createElement(EGDSSpacing48, {
        padding: {
            blockend: propertyTopHeader ? "two" : "unset"
        }
    }, /* @__PURE__ */ React99.createElement("div", null, /* @__PURE__ */ React99.createElement(EGDSSpacing48, {
        padding: {
            blockend: propertyTopHeader ? "one" : "two"
        }
    }, /* @__PURE__ */ React99.createElement(EGDSLayoutFlex25, {
        space: "two",
        className: "uitk-type-300",
        alignItems: "center"
    }, (overview === null || overview === void 0 ? void 0 : overview.vipMessaging) && !propertyTopHeader && showVipBadge && /* @__PURE__ */ React99.createElement(EGDSLayoutFlexItem17, null, /* @__PURE__ */ React99.createElement(EGDSVipBadge, {
        text: overview.vipMessaging
    })), featuredMessages && featuredMessages.length > 0 && /* @__PURE__ */ React99.createElement(EGDSLayoutFlexItem17, null, /* @__PURE__ */ React99.createElement("div", null, featuredMessages.map(function(message, index) {
        return /* @__PURE__ */ React99.createElement(EGDSText18, {
            theme: "standard",
            key: index,
            inline: true
        }, index !== 0 && /* @__PURE__ */ React99.createElement(EGDSSpacing48, {
            margin: {
                inline: "half"
            }
        }, /* @__PURE__ */ React99.createElement("span", {
            "aria-hidden": "true",
            className: "uitk-type-300 uitk-type-bold"
        }, "\xB7")), message.icon && /* @__PURE__ */ React99.createElement(EGDSIcon18, {
            name: message.icon.iconId,
            size: EGDSIconSize6.SMALL,
            "aria-hidden": "true"
        }), message.value);
    }))))), /* @__PURE__ */ React99.createElement(Viewport22, null, /* @__PURE__ */ React99.createElement(ViewSmall22, null, /* @__PURE__ */ React99.createElement(EGDSHeading15, {
        tag: "h1",
        size: 4,
        "aria-hidden": "true"
    }, name, rating)), /* @__PURE__ */ React99.createElement(ViewLarge14, null, /* @__PURE__ */ React99.createElement(EGDSHeading15, {
        tag: "h1",
        size: 3,
        "aria-hidden": "true"
    }, name, rating))), latinAlphabetName && /* @__PURE__ */ React99.createElement(EGDSSpacing48, {
        margin: {
            inlinestart: inlineRating ? "half" : "unset"
        }
    }, /* @__PURE__ */ React99.createElement(EGDSSubheading2, {
        tag: "h2"
    }, latinAlphabetName)), messages === null || messages === void 0 ? void 0 : messages.map(function(message, messageIndex) {
        return /* @__PURE__ */ React99.createElement(EGDSSpacing48, {
            key: "message-".concat(messageIndex),
            margin: {
                blockstart: propertyTopHeader ? "one" : "unset",
                inlinestart: inlineRating ? "half" : "unset"
            }
        }, /* @__PURE__ */ React99.createElement("div", null, /* @__PURE__ */ React99.createElement(LodgingEGDSText, {
            data: message
        })));
    }), shouldDisplayRating && !inlineRating && /* @__PURE__ */ React99.createElement(EGDSSpacing48, {
        margin: {
            blockstart: propertyTopHeader ? "one" : "unset"
        }
    }, /* @__PURE__ */ React99.createElement(EGDSRating, {
        icon: (starRatingIcon === null || starRatingIcon === void 0 ? void 0 : starRatingIcon.iconId) === "STAR" ? "star" : "alternate",
        rating: String(overview === null || overview === void 0 ? void 0 : overview.starRating),
        a11yText: (_overview_propertyRating_accessibility1 = overview === null || overview === void 0 ? void 0 : (_overview_propertyRating1 = overview.propertyRating) === null || _overview_propertyRating1 === void 0 ? void 0 : _overview_propertyRating1.accessibility) !== null && _overview_propertyRating_accessibility1 !== void 0 ? _overview_propertyRating_accessibility1 : void 0
    })), tagline && !isTopOfPDPRedesignVariant && /* @__PURE__ */ React99.createElement(EGDSSpacing48, {
        margin: {
            inlinestart: inlineRating ? "half" : "unset"
        }
    }, /* @__PURE__ */ React99.createElement(EGDSText18, {
        theme: "standard"
    }, tagline)), (overview === null || overview === void 0 ? void 0 : overview.vipMessaging) && propertyTopHeader && showVipBadge && /* @__PURE__ */ React99.createElement(EGDSLayoutFlex25, {
        space: "two",
        className: "uitk-type-300",
        alignItems: "center"
    }, /* @__PURE__ */ React99.createElement(EGDSLayoutFlexItem17, null, /* @__PURE__ */ React99.createElement(EGDSSpacing48, {
        padding: {
            blockstart: "three",
            blockend: "one"
        }
    }, /* @__PURE__ */ React99.createElement("div", null, /* @__PURE__ */ React99.createElement(EGDSVipBadge, {
        text: overview.vipMessaging
    })))))));
};
SummaryHeader.fragment = __SummaryHeaderFragment;
SummaryHeader.displayName = "SummaryHeader";
// src/components/summary/__private/__fragments/chatbot-launch/index.tsx
import React100, { useState as useState6 } from "react";
import { gql as gql72 } from "@apollo/client";
import { EGDSSecondaryButton as EGDSSecondaryButton2 } from "@egds/react-core/button";
import { EGDSCard as EGDSCard9, EGDSCardContentSection as EGDSCardContentSection4 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex26, EGDSLayoutFlexItem as EGDSLayoutFlexItem18 } from "@egds/react-core/layout-flex";
import { EGDSSheetTransition as EGDSSheetTransition12 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing49 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading16, EGDSText as EGDSText19 } from "@egds/react-core/text";
import { useBexApi as useBexApi9 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker28 } from "@shared-ui/clickstream-analytics-context";
import { VirtualAgentControl } from "@shared-ui/customer-virtual-agent-control";
import { VirtualAgentControlExitSurvey, VirtualAgentControlExitSurveyFeedback } from "@shared-ui/customer-virtual-agent-control-exit-survey";
import { useDialog as useDialog12 } from "@shared-ui/dialog-context";
import { useLogger } from "@shared-ui/logger-context";
import { ViewLarge as ViewLarge15, Viewport as Viewport23, ViewSmall as ViewSmall23 } from "@shared-ui/viewport-context";
var __SummaryChatbotLaunchFragment = gql72(_templateObject73());
var SummaryChatbotLaunch = function(param) {
    var data = param.data, applicationName = param.applicationName, pageName = param.pageName;
    var _data_summary, _searchCriteria_primary_dateRange, _searchCriteria_primary_dateRange1, _searchCriteria_primary_rooms__children, _searchCriteria_primary_rooms_, _searchCriteria_primary_rooms_1;
    var _ref = ((_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.lodgingChatbot) || {}, header = _ref.header, action = _ref.action, content = _ref.content;
    var context = useBexApi9().context;
    var _usePropertyDetailsInputs = usePropertyDetailsInputs(), propertyId = _usePropertyDetailsInputs.propertyId, searchCriteria = _usePropertyDetailsInputs.searchCriteria;
    var _useState6 = _sliced_to_array(useState6(false), 2), loaded = _useState6[0], setLoad = _useState6[1];
    var _useState61 = _sliced_to_array(useState6(false), 2), shouldLoadSurvey = _useState61[0], setShouldLoadSurvey = _useState61[1];
    var _useDialog12 = _sliced_to_array(useDialog12("virtual-agent-control-exit-survey-feedback"), 3), isDialogOpen = _useDialog12[0], dialogActions = _useDialog12[1], DialogComponent = _useDialog12[2];
    var clickTracker = useClickTracker28();
    var _useLogger = useLogger(), logInfo = _useLogger.info;
    var message = chatbotAnalyticsSchema("VR-SHOPPING", applicationName, propertyId);
    var currency = context.currency;
    var identity = context.identity;
    var havId = identity === null || identity === void 0 ? void 0 : identity.expUserId;
    var VAC_EVENTS = {
        VAC_WidgetOpened: "chatbot.presented",
        VAC_WidgetClosed: "chatbot.hidden",
        VAC_ConversationCreated: "chatbot_conversation.created",
        VAC_ChatMsgReceived: "chatbot_user_message.submitted",
        VAC_ChatMsgSent: "chatbot_response_message.presented"
    };
    if (!header) {
        return null;
    }
    if (currency == null) {
        currency = void 0;
    }
    if (havId == null) {
        havId = void 0;
    }
    var dateToString = function(date) {
        return "".concat(date.year, "-").concat(date.month, "-").concat(date.day);
    };
    var launchChatUi = function() {
        if (!loaded) {
            clickTracker("HOT.HIS.ChatbotLaunch", "chatbot_entrypoint.selected", void 0, [
                message
            ]);
            setLoad(true);
        } else {
            try {
                window.virtualAgentControl.openChatWidget();
            } catch (e) {
                logInfo("Virtual agent control not loaded");
            }
        }
    };
    var eventHandler = function(event) {
        clickTracker(event.type, VAC_EVENTS[event.type], void 0, [
            message
        ]);
        if (event.type === "VAC_WidgetClosed") {
            setShouldLoadSurvey(true);
        }
    };
    return /* @__PURE__ */ React100.createElement("div", null, /* @__PURE__ */ React100.createElement(Viewport23, null, /* @__PURE__ */ React100.createElement(ViewLarge15, null, /* @__PURE__ */ React100.createElement(EGDSLayoutFlex26, {
        justifyContent: "center",
        wrap: "wrap"
    }, /* @__PURE__ */ React100.createElement(EGDSLayoutFlexItem18, {
        minWidth: "full_width",
        alignSelf: "center"
    }, /* @__PURE__ */ React100.createElement(EGDSSpacing49, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React100.createElement(EGDSText19, {
        size: 300,
        align: "center"
    }, content))), /* @__PURE__ */ React100.createElement(EGDSLayoutFlexItem18, null, /* @__PURE__ */ React100.createElement(EGDSSpacing49, {
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React100.createElement("div", null, /* @__PURE__ */ React100.createElement(EGDSSecondaryButton2, {
        onClick: launchChatUi
    }, action === null || action === void 0 ? void 0 : action.primary)))))), /* @__PURE__ */ React100.createElement(ViewSmall23, null, /* @__PURE__ */ React100.createElement(EGDSCard9, {
        overflow: false,
        padded: true
    }, /* @__PURE__ */ React100.createElement(EGDSCardContentSection4, {
        padded: false
    }, /* @__PURE__ */ React100.createElement(EGDSHeading16, {
        size: 5,
        tag: "h2"
    }, header === null || header === void 0 ? void 0 : header.text)), /* @__PURE__ */ React100.createElement(EGDSCardContentSection4, {
        padded: false
    }, /* @__PURE__ */ React100.createElement(EGDSText19, {
        spacing: "four"
    }, content)), /* @__PURE__ */ React100.createElement(EGDSSpacing49, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React100.createElement(EGDSCardContentSection4, {
        padded: false
    }, /* @__PURE__ */ React100.createElement(EGDSSecondaryButton2, {
        onClick: launchChatUi
    }, action === null || action === void 0 ? void 0 : action.primary)))))), loaded && /* @__PURE__ */ React100.createElement(VirtualAgentControl, {
        applicationName: applicationName,
        pageName: pageName,
        clientOverrides: {
            enableAutoOpenChatWidget: true,
            conversationProperties: {
                listingId: String(propertyId),
                checkin: dateToString(searchCriteria === null || searchCriteria === void 0 ? void 0 : (_searchCriteria_primary_dateRange = searchCriteria.primary.dateRange) === null || _searchCriteria_primary_dateRange === void 0 ? void 0 : _searchCriteria_primary_dateRange.checkInDate),
                checkout: dateToString(searchCriteria === null || searchCriteria === void 0 ? void 0 : (_searchCriteria_primary_dateRange1 = searchCriteria.primary.dateRange) === null || _searchCriteria_primary_dateRange1 === void 0 ? void 0 : _searchCriteria_primary_dateRange1.checkOutDate),
                children: searchCriteria === null || searchCriteria === void 0 ? void 0 : (_searchCriteria_primary_rooms_ = searchCriteria.primary.rooms[0]) === null || _searchCriteria_primary_rooms_ === void 0 ? void 0 : (_searchCriteria_primary_rooms__children = _searchCriteria_primary_rooms_.children) === null || _searchCriteria_primary_rooms__children === void 0 ? void 0 : _searchCriteria_primary_rooms__children.length,
                adults: searchCriteria === null || searchCriteria === void 0 ? void 0 : (_searchCriteria_primary_rooms_1 = searchCriteria.primary.rooms[0]) === null || _searchCriteria_primary_rooms_1 === void 0 ? void 0 : _searchCriteria_primary_rooms_1.adults,
                pets: 0,
                device: "WEB",
                currency: currency,
                bookNow: "",
                havId: havId,
                site: "expedia",
                hostname: window.location.hostname,
                chatbotName: "shopping-pwa.pdp",
                chatbotEntryPoint: "VR-SHOPPING"
            },
            subscribedEvents: _to_consumable_array(Object.keys(VAC_EVENTS)),
            eventHandler: eventHandler
        },
        inputs: {}
    }), shouldLoadSurvey && /* @__PURE__ */ React100.createElement(VirtualAgentControlExitSurvey, {
        chatbotEntryPoint: "chat-now-button",
        chatbotName: "shopping-pwa",
        timeoutMs: 1e4,
        onDismiss: function() {
            return setShouldLoadSurvey(false);
        },
        inputs: {
            propertyId: String(propertyId)
        }
    }), isDialogOpen && /* @__PURE__ */ React100.createElement(EGDSSheetTransition12, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React100.createElement(DialogComponent, null, /* @__PURE__ */ React100.createElement(VirtualAgentControlExitSurveyFeedback, {
        inputs: {
            propertyId: String(propertyId)
        },
        onDismiss: dialogActions.closeDialog
    }))));
};
SummaryChatbotLaunch.fragment = __SummaryChatbotLaunchFragment;
SummaryChatbotLaunch.displayName = "SummaryChatbotLaunch";
// src/components/summary/__private/__fragments/vip-badge/vip-badge.tsx
import React101 from "react";
import { gql as gql73 } from "@apollo/client";
import { EGDSBadgeStandard, EGDSBadgeStandardThemes } from "@egds/react-core/badge";
var __VipBadgeFragment = gql73(_templateObject74());
var SummaryVipBadge = function(param) {
    var data = param.data;
    var _data_summary_overview, _data_summary;
    if (!((_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_overview = _data_summary.overview) === null || _data_summary_overview === void 0 ? void 0 : _data_summary_overview.vipMessaging)) {
        return null;
    }
    return /* @__PURE__ */ React101.createElement(EGDSBadgeStandard, {
        text: data.summary.overview.vipMessaging,
        theme: EGDSBadgeStandardThemes.EMPHASIS
    });
};
SummaryVipBadge.fragment = __VipBadgeFragment;
SummaryVipBadge.displayName = "VipBadge";
// src/components/summary/__private/__fragments/amenities/amenities-wrapper.tsx
import React102 from "react";
import { EGDSSpacing as EGDSSpacing50 } from "@egds/react-core/spacing";
import { Experiment as Experiment7, ExperimentControl as ExperimentControl7, ExperimentVariant as ExperimentVariant7 } from "@shared-ui/experiment-context";
import { Amenities, IdentifierType as IdentifierType3 } from "@shared-ui/retail-product-amenities";
import { ProductType as ProductType2, useProductType } from "@shared-ui/retail-product-type-providers";
var AmenitiesWrapper = function(param) {
    var data = param.data, propertyId = param.propertyId, searchCriteria = param.searchCriteria, isDataHydrated = param.isDataHydrated;
    if (useProductType() === ProductType2.Cruise) {
        return /* @__PURE__ */ React102.createElement(Amenities, {
            inputs: {
                productIdentifier: {
                    id: propertyId,
                    type: IdentifierType3.PROPERTY_ID,
                    travelSearchCriteria: {
                        property: searchCriteria
                    }
                }
            }
        });
    }
    return /* @__PURE__ */ React102.createElement(Experiment7, {
        name: "PEXO_PDP_AMENITY_PRODUCT_ENTITY_MIGRATION_WEB"
    }, /* @__PURE__ */ React102.createElement(ExperimentControl7, null, isDataHydrated && /* @__PURE__ */ React102.createElement(EGDSSpacing50, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React102.createElement("div", null, /* @__PURE__ */ React102.createElement(SummaryAmenities, {
        data: data
    })))), /* @__PURE__ */ React102.createElement(ExperimentVariant7, {
        bucket: 1
    }, /* @__PURE__ */ React102.createElement(Amenities, {
        inputs: {
            productIdentifier: {
                id: propertyId,
                type: IdentifierType3.PROPERTY_ID,
                travelSearchCriteria: {
                    property: searchCriteria
                }
            }
        }
    })));
};
// src/components/summary/__private/__fragments/check-in-out-wrapper.tsx
import React103 from "react";
import { EGDSSpacing as EGDSSpacing51 } from "@egds/react-core/spacing";
import { IdentifierType as IdentifierType4, RandomAccessOne as RandomAccessOne3 } from "@shared-ui/retail-product-random-access-one";
var CheckInOutWrapper = function(param) {
    var propertyId = param.propertyId, searchCriteria = param.searchCriteria;
    return /* @__PURE__ */ React103.createElement(EGDSSpacing51, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React103.createElement("div", null, /* @__PURE__ */ React103.createElement(RandomAccessOne3, {
        inputs: {
            featureId: "check-in-check-out",
            productIdentifier: {
                id: propertyId,
                type: IdentifierType4.PROPERTY_ID,
                travelSearchCriteria: {
                    property: searchCriteria
                }
            }
        },
        batchKey: "default-product-details-experience-batch-key"
    })));
};
// src/components/summary/__private/__fragments/geo/geo-wrapper.tsx
import React105 from "react";
import { EGDSLayoutGridItem as EGDSLayoutGridItem14 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing53 } from "@egds/react-core/spacing";
import { Experiment as Experiment8, ExperimentControl as ExperimentControl8, ExperimentVariant as ExperimentVariant8 } from "@shared-ui/experiment-context";
import { IdentifierType as IdentifierType5, LocationSection } from "@shared-ui/retail-product-location-section";
// src/components/summary/__private/__fragments/geo/index.tsx
import React104 from "react";
import { gql as gql74 } from "@apollo/client";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType11 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex27, EGDSLayoutFlexItem as EGDSLayoutFlexItem19 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing52 } from "@egds/react-core/spacing";
import { useExperiment as useExperiment21 } from "@shared-ui/experiment-context";
import { useMockData as useMockData2 } from "@shared-ui/retail-product-type-providers";
import { ViewLarge as ViewLarge16, ViewMedium as ViewMedium14, Viewport as Viewport24, ViewSmall as ViewSmall24 } from "@shared-ui/viewport-context";
var __SummaryGeoFragment = gql74(_templateObject75(), SummaryMapTrigger.fragment, SummaryNearByPois.fragment);
var SummaryGeo = function(_param) {
    var data = _param.data, children = _param.children, other = _object_without_properties(_param, [
        "data",
        "children"
    ]);
    var _geoData_summary;
    var mockData = useMockData2();
    var geoData = (mockData === null || mockData === void 0 ? void 0 : mockData.propertyInfo) || data;
    var _ref = (geoData === null || geoData === void 0 ? void 0 : (_geoData_summary = geoData.summary) === null || _geoData_summary === void 0 ? void 0 : _geoData_summary.location) || {}, staticImage = _ref.staticImage, mapDialog = _ref.mapDialog, mapTrigger = _ref.mapTrigger;
    var areMapsEnabled = staticImage && mapDialog || mapTrigger;
    var _useExperiment21_exposure = useExperiment21("PDP_MODULARISED_LOCATION_SECTION").exposure, isShowingModularisedSection = _useExperiment21_exposure.bucket;
    var summaryMapTrigger = function(aspectRatio) {
        return areMapsEnabled ? /* @__PURE__ */ React104.createElement("div", {
            "data-stid": "map-image-link"
        }, /* @__PURE__ */ React104.createElement(SummaryMapTrigger, _object_spread({
            data: geoData,
            aspectRatio: aspectRatio
        }, other), children)) : null;
    };
    var summaryNearByPois = /* @__PURE__ */ React104.createElement("div", {
        "data-stid": "location-summary"
    }, /* @__PURE__ */ React104.createElement(SummaryNearByPois, {
        data: geoData
    }));
    return /* @__PURE__ */ React104.createElement(Viewport24, null, /* @__PURE__ */ React104.createElement(ViewSmall24, null, /* @__PURE__ */ React104.createElement(EGDSLayoutFlex27, {
        direction: "column",
        space: "three"
    }, areMapsEnabled && /* @__PURE__ */ React104.createElement(EGDSLayoutFlexItem19, null, summaryMapTrigger(EGDSFigureAspectRatioType11.R21_9)), /* @__PURE__ */ React104.createElement(EGDSLayoutFlexItem19, null, summaryNearByPois))), /* @__PURE__ */ React104.createElement(ViewMedium14, null, /* @__PURE__ */ React104.createElement(EGDSLayoutFlex27, {
        direction: "row",
        space: "three"
    }, areMapsEnabled && /* @__PURE__ */ React104.createElement(EGDSLayoutFlexItem19, {
        minWidth: "full_width"
    }, summaryMapTrigger(EGDSFigureAspectRatioType11.R21_9)), /* @__PURE__ */ React104.createElement(EGDSLayoutFlexItem19, {
        minWidth: "full_width"
    }, summaryNearByPois))), /* @__PURE__ */ React104.createElement(ViewLarge16, null, /* @__PURE__ */ React104.createElement(EGDSLayoutFlex27, {
        direction: isShowingModularisedSection ? "row" : "column",
        space: isShowingModularisedSection ? "three" : void 0,
        justifyContent: "space-between"
    }, areMapsEnabled && /* @__PURE__ */ React104.createElement(EGDSLayoutFlexItem19, {
        minWidth: isShowingModularisedSection ? "full_width" : void 0
    }, /* @__PURE__ */ React104.createElement(EGDSSpacing52, {
        padding: !isShowingModularisedSection ? {
            large: {
                blockend: "six"
            }
        } : void 0
    }, summaryMapTrigger(isShowingModularisedSection ? EGDSFigureAspectRatioType11.R21_9 : EGDSFigureAspectRatioType11.R16_9))), /* @__PURE__ */ React104.createElement(EGDSLayoutFlexItem19, {
        minWidth: isShowingModularisedSection ? "full_width" : void 0
    }, /* @__PURE__ */ React104.createElement(EGDSSpacing52, {
        padding: isShowingModularisedSection ? {
            large: {
                blockend: "six",
                blockstart: "eight"
            }
        } : void 0
    }, summaryNearByPois)))));
};
SummaryGeo.displayName = "SummaryGeo";
SummaryGeo.fragment = __SummaryGeoFragment;
// src/components/summary/__private/__fragments/geo/geo-wrapper.tsx
var GeoWrapper = function(_param) {
    var data = _param.data, propertyId = _param.propertyId, searchCriteria = _param.searchCriteria, isDataHydrated = _param.isDataHydrated, children = _param.children, showSection = _param.showSection, isShowingModularisedSection = _param.isShowingModularisedSection, other = _object_without_properties(_param, [
        "data",
        "propertyId",
        "searchCriteria",
        "isDataHydrated",
        "children",
        "showSection",
        "isShowingModularisedSection"
    ]);
    if (!showSection) {
        return null;
    }
    return /* @__PURE__ */ React105.createElement(EGDSLayoutGridItem14, {
        colSpan: {
            small: 1,
            medium: 1,
            large: 4
        }
    }, /* @__PURE__ */ React105.createElement("div", null, /* @__PURE__ */ React105.createElement(EGDSSpacing53, {
        margin: {
            large: {
                inlinestart: isShowingModularisedSection ? void 0 : "three",
                blockstart: "three"
            }
        }
    }, /* @__PURE__ */ React105.createElement("div", null, /* @__PURE__ */ React105.createElement(Experiment8, {
        name: "PDP_LOCATION_SECTION_MIGRATION_WEB"
    }, /* @__PURE__ */ React105.createElement(ExperimentControl8, null, isDataHydrated && /* @__PURE__ */ React105.createElement(SummaryGeo, _object_spread({
        data: data
    }, other), children)), /* @__PURE__ */ React105.createElement(ExperimentVariant8, {
        bucket: 1
    }, /* @__PURE__ */ React105.createElement(LocationSection, {
        inputs: {
            productIdentifier: {
                id: propertyId,
                type: IdentifierType5.PROPERTY_ID,
                travelSearchCriteria: {
                    property: searchCriteria
                }
            }
        }
    }, children)))))));
};
// src/components/summary/__private/__fragments/header/headline-wrapper.tsx
import React106 from "react";
import { EGDSSpacing as EGDSSpacing54 } from "@egds/react-core/spacing";
import { Experiment as Experiment9, ExperimentControl as ExperimentControl9, ExperimentVariant as ExperimentVariant9 } from "@shared-ui/experiment-context";
import { ProductHeadline } from "@shared-ui/retail-product-headline";
import { IdentifierType as IdentifierType6, RandomAccessOne as RandomAccessOne4 } from "@shared-ui/retail-product-random-access-one";
import { ProductType as ProductType3, useProductType as useProductType2 } from "@shared-ui/retail-product-type-providers";
var HeadlineWrapper = function(param) {
    var data = param.data, hideHeader = param.hideHeader, propertyId = param.propertyId, searchCriteria = param.searchCriteria;
    if (useProductType2() === ProductType3.Cruise) {
        return /* @__PURE__ */ React106.createElement(ProductHeadline, {
            inputs: {
                productIdentifier: {
                    id: propertyId,
                    type: IdentifierType6.PROPERTY_ID,
                    travelSearchCriteria: {
                        property: searchCriteria
                    }
                }
            }
        });
    }
    return /* @__PURE__ */ React106.createElement(Experiment9, {
        name: "PDEA_Headline_Module_Web"
    }, /* @__PURE__ */ React106.createElement(ExperimentControl9, null, /* @__PURE__ */ React106.createElement(Experiment9, {
        name: "Headline_Module_AA_Test"
    }, /* @__PURE__ */ React106.createElement(ExperimentControl9, null, !hideHeader && /* @__PURE__ */ React106.createElement(EGDSSpacing54, {
        padding: {
            small: {
                blockend: "four"
            },
            large: {
                blockstart: "three"
            }
        }
    }, /* @__PURE__ */ React106.createElement("div", {
        "data-stid": "content-hotel-title"
    }, /* @__PURE__ */ React106.createElement(SummaryHeader, {
        data: data
    })))), /* @__PURE__ */ React106.createElement(ExperimentVariant9, {
        bucket: 1
    }, !hideHeader && /* @__PURE__ */ React106.createElement(EGDSSpacing54, {
        padding: {
            small: {
                blockend: "four"
            },
            large: {
                blockstart: "three"
            }
        }
    }, /* @__PURE__ */ React106.createElement("div", {
        "data-stid": "content-hotel-title"
    }, /* @__PURE__ */ React106.createElement(RandomAccessOne4, {
        inputs: {
            featureId: "headline_aa",
            productIdentifier: {
                id: propertyId,
                type: IdentifierType6.PROPERTY_ID,
                travelSearchCriteria: {
                    property: searchCriteria
                }
            }
        },
        batchKey: "default-product-details-experience-batch-key"
    })))))), /* @__PURE__ */ React106.createElement(ExperimentVariant9, {
        bucket: 1
    }, /* @__PURE__ */ React106.createElement("div", {
        "data-stid": "content-hotel-title"
    }, !hideHeader && /* @__PURE__ */ React106.createElement(ProductHeadline, {
        inputs: {
            productIdentifier: {
                id: propertyId,
                type: IdentifierType6.PROPERTY_ID,
                travelSearchCriteria: {
                    property: searchCriteria
                }
            }
        }
    }))));
};
// src/components/summary/__private/__fragments/relevant-content-wrapper.tsx
import React107 from "react";
import { EGDSSpacing as EGDSSpacing55 } from "@egds/react-core/spacing";
import { Experiment as Experiment10, ExperimentControl as ExperimentControl10, ExperimentVariant as ExperimentVariant10 } from "@shared-ui/experiment-context";
import { IdentifierType as IdentifierType7, RelevantContent } from "@shared-ui/retail-product-relevant-content";
var RelevantContentWrapper = function(param) {
    var propertyId = param.propertyId, searchCriteria = param.searchCriteria;
    return /* @__PURE__ */ React107.createElement(Experiment10, {
        name: "Filter_ranking_model_for_amenity_module_Web"
    }, /* @__PURE__ */ React107.createElement(ExperimentControl10, null), /* @__PURE__ */ React107.createElement(ExperimentVariant10, {
        bucket: 1
    }, /* @__PURE__ */ React107.createElement(EGDSSpacing55, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React107.createElement("div", null, /* @__PURE__ */ React107.createElement(RelevantContent, {
        inputs: {
            productIdentifier: {
                id: propertyId,
                type: IdentifierType7.PROPERTY_ID,
                travelSearchCriteria: {
                    property: searchCriteria
                }
            }
        }
    })))), /* @__PURE__ */ React107.createElement(ExperimentVariant10, {
        bucket: 2
    }, /* @__PURE__ */ React107.createElement(EGDSSpacing55, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React107.createElement("div", null, /* @__PURE__ */ React107.createElement(RelevantContent, {
        inputs: {
            productIdentifier: {
                id: propertyId,
                type: IdentifierType7.PROPERTY_ID,
                travelSearchCriteria: {
                    property: searchCriteria
                }
            }
        },
        skipSsr: true
    })))));
};
// src/components/summary/summary-fragment.ts
import { gql as gql75 } from "@apollo/client";
var __SummaryFragment = gql75(_templateObject76(), SummaryAmenities.fragment, SummaryHeader.fragment, SummaryMapTrigger.fragment, SummaryNearByPois.fragment, SummaryBannerMessage.fragment, SummaryChatbotLaunch.fragment, RelevantAmenities.fragment);
// src/components/summary/summary.tsx
var CarouselComponent = function(param) {
    var children = param.children;
    return /* @__PURE__ */ React108.createElement(React108.Fragment, null, children);
};
var HighlightedBenefitsComponent = function(param) {
    var children = param.children;
    return /* @__PURE__ */ React108.createElement(React108.Fragment, null, children);
};
var PropertyDetailsMapComponent = function(param) {
    var children = param.children;
    return /* @__PURE__ */ React108.createElement(React108.Fragment, null, children);
};
var Summary = function(_param) {
    var data = _param.data, onClickReviews = _param.onClickReviews, children = _param.children, triggerRef = _param.triggerRef, _param_hideHeader = _param.hideHeader, hideHeader = _param_hideHeader === void 0 ? false : _param_hideHeader, pageId = _param.pageId, _param_showHighlights = _param.showHighlights, showHighlights = _param_showHighlights === void 0 ? false : _param_showHighlights, _param_searchId = _param.searchId, searchId = _param_searchId === void 0 ? "" : _param_searchId, _param_disableMapAndLocationInsights = _param.disableMapAndLocationInsights, disableMapAndLocationInsights = _param_disableMapAndLocationInsights === void 0 ? false : _param_disableMapAndLocationInsights, other = _object_without_properties(_param, [
        "data",
        "onClickReviews",
        "children",
        "triggerRef",
        "hideHeader",
        "pageId",
        "showHighlights",
        "searchId",
        "disableMapAndLocationInsights"
    ]);
    var _useContext2 = useContext2(RandomAccessOneContext), isRandomAccessOne = _useContext2.isRandomAccessOne, randomAccessData = _useContext2.data;
    var _usePropertyDetailsInputs = usePropertyDetailsInputs(), propertyId = _usePropertyDetailsInputs.propertyId, searchCriteria = _usePropertyDetailsInputs.searchCriteria;
    var isDataHydrated = data === null || data === void 0 ? void 0 : data.summary;
    var _useExperiment22_exposure = useExperiment22("PDP_MODULARISED_LOCATION_SECTION", true).exposure, isShowingModularisedSection = _useExperiment22_exposure.bucket;
    var searchCriteriaWithSearchId = useMemo3(function() {
        return adaptSearchCriteriaWithSearchId(searchCriteria, searchId);
    }, [
        searchCriteria,
        searchId
    ]);
    var isCheckInOutVariant = useExperiment22("Add_check_in_and_out_times_", true).exposure.bucket === 1;
    var excludeReviewRating = useProductType3() === ProductType4.Cruise;
    var summaryGeo = function(showSection) {
        return /* @__PURE__ */ React108.createElement(GeoWrapper, _object_spread({
            data: data,
            isDataHydrated: isDataHydrated !== void 0 && isDataHydrated !== null,
            propertyId: propertyId,
            searchCriteria: searchCriteria,
            showSection: showSection,
            isShowingModularisedSection: isShowingModularisedSection !== void 0 && isShowingModularisedSection !== null
        }, other), findReactChildByType(children, PropertyDetailsMapComponent));
    };
    return /* @__PURE__ */ React108.createElement(React108.Fragment, null, isRandomAccessOne && isShowingModularisedSection ? /* @__PURE__ */ React108.createElement(React108.Fragment, null, /* @__PURE__ */ React108.createElement(EGDSSpacing56, {
        margin: {
            blockstart: "three",
            small: {
                inline: "three",
                blockend: "three"
            },
            medium: {
                inline: "unset",
                blockend: "six"
            }
        }
    }, /* @__PURE__ */ React108.createElement("div", {
        "data-stid": "standout-stays-card"
    }, /* @__PURE__ */ React108.createElement(RandomAccessOne5, {
        inputs: {
            featureId: "standout-stays",
            productIdentifier: {
                id: propertyId,
                type: RandomAccessOneIdentifierType.PROPERTY_ID,
                travelSearchCriteria: {
                    property: searchCriteria
                }
            }
        },
        mockData: randomAccessData
    }))), /* @__PURE__ */ React108.createElement(EGDSSpacing56, {
        margin: {
            blockstart: "six",
            small: {
                inline: "three",
                blockend: "three"
            },
            medium: {
                inline: "six",
                blockend: "six"
            }
        }
    }, /* @__PURE__ */ React108.createElement("div", {
        "data-stid": "modularised-section"
    }, /* @__PURE__ */ React108.createElement(AmenitiesWrapper, {
        data: data,
        propertyId: propertyId,
        searchCriteria: searchCriteria,
        isDataHydrated: isDataHydrated
    }), isCheckInOutVariant ? /* @__PURE__ */ React108.createElement(EGDSLayoutGrid15, {
        columns: {
            small: 1,
            medium: 1,
            large: 2
        }
    }, /* @__PURE__ */ React108.createElement(EGDSLayoutGridItem15, {
        colSpan: 1
    }, /* @__PURE__ */ React108.createElement(CheckInOutWrapper, {
        propertyId: propertyId,
        searchCriteria: searchCriteria
    }))) : null, summaryGeo(!!isShowingModularisedSection)))) : /* @__PURE__ */ React108.createElement(EGDSSpacing56, {
        margin: {
            blockend: isShowingModularisedSection ? void 0 : "three"
        },
        padding: {
            large: {
                inline: "six",
                blockend: "six"
            },
            medium: isShowingModularisedSection ? {
                blockend: "six",
                inline: "six"
            } : void 0,
            small: isShowingModularisedSection ? {
                blockend: "six",
                inline: "three"
            } : void 0
        }
    }, /* @__PURE__ */ React108.createElement(EGDSCard10, {
        className: "uitk-flat-border-top",
        overflow: true
    }, /* @__PURE__ */ React108.createElement(EGDSCardContentSection5, null, /* @__PURE__ */ React108.createElement(EGDSLayoutGrid15, {
        columns: {
            small: 1,
            medium: 1,
            large: 12
        }
    }, /* @__PURE__ */ React108.createElement(EGDSLayoutGridItem15, {
        colSpan: {
            small: 1,
            medium: 1,
            large: isShowingModularisedSection ? 12 : 8
        }
    }, /* @__PURE__ */ React108.createElement("div", null, /* @__PURE__ */ React108.createElement(EGDSSpacing56, {
        padding: {
            large: {
                inlineend: "three"
            }
        }
    }, /* @__PURE__ */ React108.createElement("div", null, /* @__PURE__ */ React108.createElement(HeadlineWrapper, {
        data: data,
        hideHeader: hideHeader,
        propertyId: propertyId,
        searchCriteria: searchCriteria
    }), findReactChildByType(children, HighlightedBenefitsComponent), isDataHydrated && /* @__PURE__ */ React108.createElement(SummaryBannerMessage, {
        data: data
    }), !excludeReviewRating && /* @__PURE__ */ React108.createElement(ProductRatingSummary, {
        inputs: {
            productIdentifier: {
                id: propertyId,
                type: IdentifierType8.PROPERTY_ID,
                travelSearchCriteria: {
                    property: searchCriteria
                }
            }
        },
        onClickReviews: onClickReviews,
        triggerRef: triggerRef
    }), showHighlights && /* @__PURE__ */ React108.createElement(ProductHighlights, {
        inputs: {
            productIdentifier: {
                id: propertyId,
                type: ProductRatingSummaryIdentifier.PROPERTY_ID,
                travelSearchCriteria: {
                    property: searchCriteriaWithSearchId
                }
            }
        },
        onClickReviews: onClickReviews,
        pageId: pageId
    }), isDataHydrated && /* @__PURE__ */ React108.createElement(React108.Fragment, null, findReactChildByType(children, CarouselComponent)), !isShowingModularisedSection && /* @__PURE__ */ React108.createElement(AmenitiesWrapper, {
        data: data,
        propertyId: propertyId,
        searchCriteria: searchCriteria,
        isDataHydrated: isDataHydrated
    }), isCheckInOutVariant && !isShowingModularisedSection && /* @__PURE__ */ React108.createElement(CheckInOutWrapper, {
        propertyId: propertyId,
        searchCriteria: searchCriteria
    }), /* @__PURE__ */ React108.createElement(RelevantContentWrapper, {
        propertyId: propertyId,
        searchCriteria: searchCriteria
    }))))), summaryGeo(!isShowingModularisedSection && !disableMapAndLocationInsights)), isDataHydrated && /* @__PURE__ */ React108.createElement(EGDSSpacing56, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React108.createElement(RelevantAmenities, {
        data: data
    })), isShowingModularisedSection && /* @__PURE__ */ React108.createElement(AmenitiesWrapper, {
        data: data,
        propertyId: propertyId,
        searchCriteria: searchCriteria,
        isDataHydrated: isDataHydrated
    }), isShowingModularisedSection && isCheckInOutVariant && /* @__PURE__ */ React108.createElement(EGDSLayoutGrid15, {
        columns: {
            small: 1,
            medium: 1,
            large: 2
        }
    }, /* @__PURE__ */ React108.createElement(EGDSLayoutGridItem15, {
        colSpan: 1
    }, /* @__PURE__ */ React108.createElement(CheckInOutWrapper, {
        propertyId: propertyId,
        searchCriteria: searchCriteria
    }))), /* @__PURE__ */ React108.createElement(RefTarget3, {
        name: "Location",
        dataStid: "explore-the-area"
    }, summaryGeo(!!isShowingModularisedSection && !disableMapAndLocationInsights))))));
};
Summary.displayName = "Summary";
Summary.fragment = __SummaryFragment;
// src/components/summary/placeholder.tsx
import React109 from "react";
import { EGDSCard as EGDSCard11, EGDSCardContentSection as EGDSCardContentSection6 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid16, EGDSLayoutGridItem as EGDSLayoutGridItem16 } from "@egds/react-core/layout-grid";
import { EGDSLineSkeleton as EGDSLineSkeleton5 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing57 } from "@egds/react-core/spacing";
var SummaryComponentPlaceholder = function() {
    return /* @__PURE__ */ React109.createElement(EGDSSpacing57, {
        margin: {
            blockstart: "three"
        },
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React109.createElement("div", null, /* @__PURE__ */ React109.createElement(EGDSSpacing57, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React109.createElement(EGDSLineSkeleton5, {
        animation: false,
        type: "primary"
    })), /* @__PURE__ */ React109.createElement(EGDSLineSkeleton5, {
        animation: false,
        type: "secondary"
    })));
};
// src/components/whats-around/whats-around.tsx
import React116 from "react";
import { gql as gql82 } from "@apollo/client";
import { EGDSCard as EGDSCard13, EGDSCardContentSection as EGDSCardContentSection8 } from "@egds/react-core/cards";
import { EGDSExpandoPeek as EGDSExpandoPeek4 } from "@egds/react-core/expando";
import { EGDSLayoutGrid as EGDSLayoutGrid17, EGDSLayoutGridItem as EGDSLayoutGridItem17 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing63 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading19 } from "@egds/react-core/text";
import { useBexApi as useBexApi10 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker32 } from "@shared-ui/clickstream-analytics-context";
// src/utils/whats-around-options.ts
var WhatsAroundLayout = /* @__PURE__ */ function(WhatsAroundLayout2) {
    WhatsAroundLayout2["DISABLE_MAP"] = "DISABLE_MAP";
    return WhatsAroundLayout2;
}(WhatsAroundLayout || {});
// src/components/whats-around/__private/__fragments/whats-around-editorial.tsx
import React111 from "react";
import { gql as gql77 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing59 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading17, EGDSText as EGDSText20 } from "@egds/react-core/text";
// src/components/whats-around/__private/__fragments/whats-around-link.tsx
import React110 from "react";
import { gql as gql76 } from "@apollo/client";
import { EGDSIcon as EGDSIcon19 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink7 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing58 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker29 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium15, Viewport as Viewport25, ViewSmall as ViewSmall25 } from "@shared-ui/viewport-context";
var __WhatsAroundLinkFragment = gql76(_templateObject77());
var WhatsAroundLink = function(param) {
    var data = param.data, index = param.index;
    var _data_link_uri, _data_link;
    var track = useClickTracker29();
    if (!(data === null || data === void 0 ? void 0 : data.value) || !(data === null || data === void 0 ? void 0 : (_data_link = data.link) === null || _data_link === void 0 ? void 0 : (_data_link_uri = _data_link.uri) === null || _data_link_uri === void 0 ? void 0 : _data_link_uri.value)) {
        return null;
    }
    var handleClick = function() {
        if (data.link.clientSideAnalytics) {
            track(data.link.clientSideAnalytics.referrerId, data.link.clientSideAnalytics.linkName);
        }
    };
    var text = data.value;
    var linkUrl = data.link.uri.value;
    var icon = data.icon;
    return /* @__PURE__ */ React110.createElement(Viewport25, null, /* @__PURE__ */ React110.createElement(ViewSmall25, null, /* @__PURE__ */ React110.createElement(Link, {
        href: linkUrl,
        onClickCapture: handleClick
    }, text)), /* @__PURE__ */ React110.createElement(ViewMedium15, null, /* @__PURE__ */ React110.createElement(Link, {
        href: linkUrl,
        onClickCapture: handleClick,
        target: "_blank"
    }, text, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */ React110.createElement(EGDSIcon19, {
        id: "".concat(icon.id, "-").concat(index),
        name: icon.id,
        title: icon.description
    }))));
};
WhatsAroundLink.displayName = "WhatsAroundLink";
WhatsAroundLink.fragment = __WhatsAroundLinkFragment;
var Link = function(_param) {
    var href = _param.href, target = _param.target, children = _param.children, props = _object_without_properties(_param, [
        "href",
        "target",
        "children"
    ]);
    return /* @__PURE__ */ React110.createElement(EGDSSpacing58, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React110.createElement(EGDSLink7, _object_spread({}, props), /* @__PURE__ */ React110.createElement("a", {
        href: href,
        target: target
    }, children)));
};
var whats_around_link_default = WhatsAroundLink;
// src/components/whats-around/__private/__fragments/whats-around-editorial.tsx
var __WhatsAroundEditorialFragment = gql77(_templateObject78(), whats_around_link_default.fragment);
var WhatsAroundEditorial = function(param) {
    var data = param.data, isWhatsAroundMapPoisEditorialView = param.isWhatsAroundMapPoisEditorialView;
    if (!data || !data.content || data.content.length <= 0) {
        return null;
    }
    var title = data.title, crossLinks = data.crossLinks, contentList = data.content;
    var content = contentList[0];
    return /* @__PURE__ */ React111.createElement("section", null, title && /* @__PURE__ */ React111.createElement(EGDSHeading17, {
        tag: "h3",
        size: 5
    }, title), content && /* @__PURE__ */ React111.createElement(React111.Fragment, null, /* @__PURE__ */ React111.createElement(EGDSSpacing59, {
        padding: isWhatsAroundMapPoisEditorialView ? {
            blockend: "four"
        } : {
            block: "three"
        }
    }, /* @__PURE__ */ React111.createElement("div", {
        itemProp: "geo",
        itemScope: true,
        itemType: "https://schema.org/GeoCoordinates"
    }, /* @__PURE__ */ React111.createElement("meta", {
        itemProp: "description",
        content: content
    }), /* @__PURE__ */ React111.createElement(EGDSText20, {
        size: 300
    }, content))), crossLinks === null || crossLinks === void 0 ? void 0 : crossLinks.map(function(crossLink, index) {
        return /* @__PURE__ */ React111.createElement(EGDSSpacing59, {
            padding: {
                blockend: "two"
            },
            key: index
        }, /* @__PURE__ */ React111.createElement("div", null, /* @__PURE__ */ React111.createElement(whats_around_link_default, {
            data: crossLink,
            index: index
        })));
    })));
};
WhatsAroundEditorial.displayName = "WhatsAroundEditorial";
WhatsAroundEditorial.fragment = __WhatsAroundEditorialFragment;
// src/components/whats-around/__private/__fragments/whats-around-map.tsx
import React112 from "react";
import LazyLoad from "react-lazy-load";
import { gql as gql78 } from "@apollo/client";
import { EGDSCard as EGDSCard12, EGDSCardContentSection as EGDSCardContentSection7, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure6, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType12, EGDSImage as EGDSImage5 } from "@egds/react-core/images";
import { EGDSLink as EGDSLink8 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing60 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker30 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog13 } from "@shared-ui/dialog-context";
import { defaultCloseMapDialogPropBuilder as defaultCloseMapDialogPropBuilder2, MapTrigger as MapTrigger2 } from "@shared-ui/lodging-fragments";
var __WhatsAroundMapFragment = gql78(_templateObject79(), MapTrigger2.fragment);
var WhatsAroundMap = function(param) {
    var data = param.data, mapCTALabel = param.mapCTALabel, propertyId = param.propertyId;
    var mapTriggerRef = React112.useRef(null);
    var _useDialog13 = _sliced_to_array(useDialog13("whats-around-map"), 3), mapDialogActions = _useDialog13[1], MapDialogWrapper = _useDialog13[2];
    var _ref = (data === null || data === void 0 ? void 0 : data.staticImage) || {}, description = _ref.description, url = _ref.url;
    var hasMapCTALabel = Boolean(mapCTALabel);
    var track = useClickTracker30();
    var handleMapTrigger = React112.useCallback(function(id, desc) {
        return function(e) {
            e.preventDefault();
            track(id, desc);
            mapDialogActions.openDialog();
        };
    }, [
        track,
        mapDialogActions
    ]);
    var closeMapDialog = React112.useCallback(function() {
        mapDialogActions.closeDialog();
    }, [
        mapDialogActions
    ]);
    var mapTriggerData = data === null || data === void 0 ? void 0 : data.mapTrigger;
    return /* @__PURE__ */ React112.createElement(React112.Fragment, null, mapTriggerData ? /* @__PURE__ */ React112.createElement(MapTrigger2, {
        data: mapTriggerData,
        dialogId: "whats-around-map",
        dialogQueryKey: "pwaOverlay",
        closeMapDialogPropBuilder: defaultCloseMapDialogPropBuilder2,
        triggerRef: mapTriggerRef,
        useMapPreview: true
    }, /* @__PURE__ */ React112.createElement(Map, {
        inputs: {
            propertyId: propertyId
        },
        triggerRef: mapTriggerRef
    })) : /* @__PURE__ */ React112.createElement(React112.Fragment, null, /* @__PURE__ */ React112.createElement(MapDialogWrapper, null, /* @__PURE__ */ React112.createElement(Map, {
        inputs: {
            propertyId: propertyId
        },
        onClose: closeMapDialog,
        triggerRef: mapTriggerRef
    })), /* @__PURE__ */ React112.createElement(EGDSSpacing60, {
        margin: {
            blockend: "six"
        },
        "data-stid": "whats-around-map"
    }, /* @__PURE__ */ React112.createElement(EGDSCard12, {
        border: hasMapCTALabel
    }, /* @__PURE__ */ React112.createElement(EGDSCardContentSection7, {
        padded: false
    }, /* @__PURE__ */ React112.createElement(LazyLoad, {
        height: 200
    }, /* @__PURE__ */ React112.createElement(React112.Fragment, null, /* @__PURE__ */ React112.createElement("h3", {
        className: "is-visually-hidden"
    }, description), /* @__PURE__ */ React112.createElement(EGDSFigure6, {
        ratio: EGDSFigureAspectRatioType12.R21_9,
        imageFit: "cover"
    }, /* @__PURE__ */ React112.createElement(EGDSImage5, {
        alt: "",
        src: url || ""
    }))))), /* @__PURE__ */ React112.createElement(EGDSCardLink, null, /* @__PURE__ */ React112.createElement("section", {
        className: "EGDS-button",
        onClickCapture: handleMapTrigger("HOT.HIS:WhatsAroundMap.Open", "Launch dynamic map")
    }, description)), mapCTALabel && /* @__PURE__ */ React112.createElement(EGDSCardContentSection7, {
        className: "EGDS-type-300",
        border: "top"
    }, /* @__PURE__ */ React112.createElement(EGDSCardLink, null, /* @__PURE__ */ React112.createElement("button", {
        ref: mapTriggerRef,
        type: "button",
        onClickCapture: handleMapTrigger("WhatsAroundMap.ClickLinkViewMap", "Launch dynamic map")
    }, mapCTALabel)), /* @__PURE__ */ React112.createElement(EGDSLink8, {
        inline: true
    }, /* @__PURE__ */ React112.createElement("button", {
        type: "button"
    }, mapCTALabel)))))));
};
WhatsAroundMap.displayName = "WhatsAroundMap";
WhatsAroundMap.fragment = __WhatsAroundMapFragment;
// src/components/whats-around/__private/__fragments/whats-around-pois.tsx
import React115 from "react";
import { gql as gql81 } from "@apollo/client";
import { EGDSExpandoPeek as EGDSExpandoPeek3 } from "@egds/react-core/expando";
import { EGDSLayoutColumns as EGDSLayoutColumns2, EGDSLayoutColumnsItem as EGDSLayoutColumnsItem2 } from "@egds/react-core/layout-columns";
import { EGDSLayoutFlex as EGDSLayoutFlex28, EGDSLayoutFlexItem as EGDSLayoutFlexItem20 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing62 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading18 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker31 } from "@shared-ui/clickstream-analytics-context";
// src/components/whats-around/__private/__fragments/whats-around-icon.tsx
import React113 from "react";
import { gql as gql79 } from "@apollo/client";
import { EGDSIcon as EGDSIcon20 } from "@egds/react-core/icons";
var __WhatsAroundIconFragment = gql79(_templateObject80());
var WhatsAroundIcon2 = function(param) {
    var data = param.data;
    if (!data) {
        return null;
    }
    var icon = data.iconId;
    return /* @__PURE__ */ React113.createElement(EGDSIcon20, {
        id: "".concat(icon, "-icon"),
        name: icon
    });
};
WhatsAroundIcon2.displayName = "WhatsAroundIcon";
WhatsAroundIcon2.fragment = __WhatsAroundIconFragment;
var whats_around_icon_default = WhatsAroundIcon2;
// src/components/whats-around/__private/__fragments/whats-around-pois-item.tsx
import React114 from "react";
import { gql as gql80 } from "@apollo/client";
import { EGDSList as EGDSList6, EGDSListItem as EGDSListItem4 } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing61 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText21 } from "@egds/react-core/text";
var __WhatsAroundPoisItemFragment = gql80(_templateObject81(), WhatsAroundIcon2.fragment);
var WhatsAroundPoisItem = function(param) {
    var data = param.data, hideIcon = param.hideIcon;
    var bullet = hideIcon ? "no-bullet" : "icon-standard";
    return /* @__PURE__ */ React114.createElement(EGDSSpacing61, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React114.createElement(EGDSList6, {
        bullet: bullet,
        spacing: false
    }, data.items.map(function(item, idx) {
        return /* @__PURE__ */ React114.createElement(EGDSListItem4, {
            key: "whats-around-pois-list-".concat(idx)
        }, !hideIcon && /* @__PURE__ */ React114.createElement(WhatsAroundIcon2, {
            data: item.icon
        }), /* @__PURE__ */ React114.createElement(EGDSText21, null, item.text, item.moreInfo && " - ".concat(item.moreInfo)));
    })));
};
WhatsAroundPoisItem.displayName = "WhatsAroundPoisItem";
WhatsAroundPoisItem.fragment = __WhatsAroundPoisItemFragment;
// src/components/whats-around/__private/__fragments/whats-around-pois.tsx
var __WhatsAroundPoisFragment = gql81(_templateObject82(), WhatsAroundIcon2.fragment, WhatsAroundPoisItem.fragment);
var sortAndByIcon = function(poisType) {
    return poisType.reduce(function(sortedList, item) {
        var _item_icon;
        var newSortedList = _to_consumable_array(sortedList);
        switch((_item_icon = item.icon) === null || _item_icon === void 0 ? void 0 : _item_icon.iconId){
            case "place":
                newSortedList[0] = item;
                break;
            case "lob_cars":
                newSortedList[1] = item;
                break;
            case "local_dining":
                newSortedList[2] = item;
                break;
            default:
                newSortedList.push(item);
                break;
        }
        return newSortedList;
    }, []);
};
var WhatsAroundPoiSection2 = function(props) {
    var title = props.title, items = props.items, icon = props.icon;
    if (!title || !items || !items.length) {
        return null;
    }
    var hideIcon = (icon === null || icon === void 0 ? void 0 : icon.iconId) !== "lob_cars";
    return /* @__PURE__ */ React115.createElement(EGDSLayoutColumnsItem2, {
        forceNoBreak: true
    }, /* @__PURE__ */ React115.createElement("div", null, /* @__PURE__ */ React115.createElement(EGDSSpacing62, {
        padding: {
            block: "three"
        }
    }, /* @__PURE__ */ React115.createElement(EGDSLayoutFlex28, {
        space: "three"
    }, /* @__PURE__ */ React115.createElement(EGDSLayoutFlexItem20, null, /* @__PURE__ */ React115.createElement("div", null, /* @__PURE__ */ React115.createElement(WhatsAroundIcon2, {
        data: icon
    }))), /* @__PURE__ */ React115.createElement(EGDSLayoutFlexItem20, null, /* @__PURE__ */ React115.createElement("div", null, /* @__PURE__ */ React115.createElement(EGDSHeading18, {
        tag: "h4",
        size: 5
    }, title), /* @__PURE__ */ React115.createElement(WhatsAroundPoisItem, {
        data: props,
        hideIcon: hideIcon
    })))))));
};
var WhatsAroundPois = function(param) {
    var data = param.data, expando = param.expando, isMobile = param.isMobile;
    var clickTracker = useClickTracker31();
    var _React115_useState = _sliced_to_array(React115.useState(false), 2), isExpanded = _React115_useState[0], setIsExpanded = _React115_useState[1];
    if (!data || !data.nearbyPOIs || data.nearbyPOIs.length <= 0) {
        return null;
    }
    var sortedPois = sortAndByIcon(data.nearbyPOIs);
    var multiColumn = sortedPois.length > 2;
    var _ref = expando || {}, expandButton = _ref.expandButton, collapseButton = _ref.collapseButton, items = _ref.items;
    var handleClickAction = function() {
        setIsExpanded(!isExpanded);
        var _ref;
        var _ref1 = (_ref = isExpanded ? collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.analytics : expandButton === null || expandButton === void 0 ? void 0 : expandButton.analytics) !== null && _ref !== void 0 ? _ref : {}, referrerId = _ref1.referrerId, _ref_linkName = _ref1.linkName, linkName = _ref_linkName === void 0 ? "" : _ref_linkName;
        if (referrerId) {
            clickTracker(referrerId, linkName);
        }
    };
    var defaultView = /* @__PURE__ */ React115.createElement(EGDSLayoutColumns2, {
        columns: multiColumn ? 2 : 1,
        minWidth: multiColumn ? "seventy_two" : void 0
    }, sortedPois.map(function(section, idx) {
        return /* @__PURE__ */ React115.createElement(WhatsAroundPoiSection2, _object_spread_props(_object_spread({}, section), {
            key: idx
        }));
    }));
    var _expandButton_accessibilityLabel, _collapseButton_accessibilityLabel;
    var expandoDatedPDPView = /* @__PURE__ */ React115.createElement(EGDSExpandoPeek3, {
        hideScrim: false,
        whitespace: false,
        items: items !== null && items !== void 0 ? items : 0,
        expandLabel: expando === null || expando === void 0 ? void 0 : expando.expandButton.text,
        collapseLabel: expando === null || expando === void 0 ? void 0 : expando.collapseButton.text,
        isVisible: isExpanded,
        handleClick: handleClickAction,
        expandA11yLabel: (_expandButton_accessibilityLabel = expandButton === null || expandButton === void 0 ? void 0 : expandButton.accessibilityLabel) !== null && _expandButton_accessibilityLabel !== void 0 ? _expandButton_accessibilityLabel : "",
        collapseA11yLabel: (_collapseButton_accessibilityLabel = collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.accessibilityLabel) !== null && _collapseButton_accessibilityLabel !== void 0 ? _collapseButton_accessibilityLabel : ""
    }, defaultView);
    var showDatedPDPExpando = expando && items && items > 0 && isMobile;
    return showDatedPDPExpando ? expandoDatedPDPView : defaultView;
};
WhatsAroundPois.displayName = "WhatsAroundPois";
WhatsAroundPois.fragment = __WhatsAroundPoisFragment;
// src/components/whats-around/whats-around.tsx
var __WhatsAroundFragment = gql82(_templateObject83(), WhatsAroundEditorial.fragment, WhatsAroundPois.fragment, WhatsAroundMap.fragment);
var WhatsAround = function(param) {
    var data = param.data, view = param.view, isExpando = param.isExpando;
    var _context_device, _data_summary_map, _data_summary, _data_summary_location, _data_summary1, _whatsAround_expando, _whatsAround_expando1, _data_summary2, _data_summary3, _whatsAround_expando2, _whatsAround_expando3;
    var context = useBexApi10().context;
    var isMobile = (context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */ ;
    var mapProps = {
        mapCTALabel: data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_map = _data_summary.map) === null || _data_summary_map === void 0 ? void 0 : _data_summary_map.trigger.value,
        propertyId: data.id
    };
    var whatsAround = data === null || data === void 0 ? void 0 : (_data_summary1 = data.summary) === null || _data_summary1 === void 0 ? void 0 : (_data_summary_location = _data_summary1.location) === null || _data_summary_location === void 0 ? void 0 : _data_summary_location.whatsAround;
    var expando = whatsAround === null || whatsAround === void 0 ? void 0 : whatsAround.expando;
    var _ref = expando || {}, expandButton = _ref.expandButton, collapseButton = _ref.collapseButton, items = _ref.items;
    var _React116_useState = _sliced_to_array(React116.useState(false), 2), isExpanded = _React116_useState[0], setIsExpanded = _React116_useState[1];
    var showDatedPDPExpando = expando && items === null && isMobile;
    var clickTracker = useClickTracker32();
    var handleClickAction = function() {
        setIsExpanded(!isExpanded);
        var _ref;
        var _ref1 = (_ref = isExpanded ? collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.analytics : expandButton === null || expandButton === void 0 ? void 0 : expandButton.analytics) !== null && _ref !== void 0 ? _ref : {}, referrerId = _ref1.referrerId, _ref_linkName = _ref1.linkName, linkName = _ref_linkName === void 0 ? "" : _ref_linkName;
        if (referrerId) {
            clickTracker(referrerId, linkName);
        }
    };
    if (!data || !whatsAround) {
        return null;
    }
    var _expandButton_accessibilityLabel, _collapseButton_accessibilityLabel;
    var expandoView = /* @__PURE__ */ React116.createElement(EGDSExpandoPeek4, {
        hideScrim: true,
        items: 1,
        expandLabel: whatsAround === null || whatsAround === void 0 ? void 0 : (_whatsAround_expando = whatsAround.expando) === null || _whatsAround_expando === void 0 ? void 0 : _whatsAround_expando.expandButton.text,
        collapseLabel: whatsAround === null || whatsAround === void 0 ? void 0 : (_whatsAround_expando1 = whatsAround.expando) === null || _whatsAround_expando1 === void 0 ? void 0 : _whatsAround_expando1.collapseButton.text,
        isVisible: isExpanded,
        handleClick: handleClickAction,
        expandA11yLabel: (_expandButton_accessibilityLabel = expandButton === null || expandButton === void 0 ? void 0 : expandButton.accessibilityLabel) !== null && _expandButton_accessibilityLabel !== void 0 ? _expandButton_accessibilityLabel : "",
        collapseA11yLabel: (_collapseButton_accessibilityLabel = collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.accessibilityLabel) !== null && _collapseButton_accessibilityLabel !== void 0 ? _collapseButton_accessibilityLabel : ""
    }, /* @__PURE__ */ React116.createElement(React116.Fragment, null, (whatsAround.editorial || view !== "DISABLE_MAP" /* DISABLE_MAP */  && ((_data_summary2 = data.summary) === null || _data_summary2 === void 0 ? void 0 : _data_summary2.map)) && /* @__PURE__ */ React116.createElement("div", null, view === "DISABLE_MAP" /* DISABLE_MAP */  ? /* @__PURE__ */ React116.createElement(WhatsAroundEditorial, {
        data: whatsAround.editorial
    }) : /* @__PURE__ */ React116.createElement(WhatsAroundMap, _object_spread({
        data: whatsAround
    }, mapProps))), /* @__PURE__ */ React116.createElement(WhatsAroundPois, {
        data: whatsAround,
        expando: expando,
        isMobile: isMobile
    })));
    var defaultView = /* @__PURE__ */ React116.createElement(React116.Fragment, null, view === "DISABLE_MAP" /* DISABLE_MAP */  ? /* @__PURE__ */ React116.createElement(WhatsAroundEditorial, {
        data: whatsAround.editorial
    }) : ((_data_summary3 = data.summary) === null || _data_summary3 === void 0 ? void 0 : _data_summary3.map) && /* @__PURE__ */ React116.createElement(WhatsAroundMap, _object_spread({
        data: whatsAround
    }, mapProps)), /* @__PURE__ */ React116.createElement(WhatsAroundPois, {
        data: whatsAround,
        expando: expando,
        isMobile: isMobile
    }));
    var _expandButton_accessibilityLabel1, _collapseButton_accessibilityLabel1;
    var expandoDatedPDPView = /* @__PURE__ */ React116.createElement(EGDSSpacing63, {
        padding: {
            small: {
                block: "six",
                inline: "three"
            },
            large: {
                block: "six",
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React116.createElement(EGDSCard13, null, /* @__PURE__ */ React116.createElement(EGDSCardContentSection8, null, /* @__PURE__ */ React116.createElement(EGDSExpandoPeek4, {
        hideScrim: false,
        whitespace: false,
        items: 1,
        expandLabel: whatsAround === null || whatsAround === void 0 ? void 0 : (_whatsAround_expando2 = whatsAround.expando) === null || _whatsAround_expando2 === void 0 ? void 0 : _whatsAround_expando2.expandButton.text,
        collapseLabel: whatsAround === null || whatsAround === void 0 ? void 0 : (_whatsAround_expando3 = whatsAround.expando) === null || _whatsAround_expando3 === void 0 ? void 0 : _whatsAround_expando3.collapseButton.text,
        isVisible: isExpanded,
        handleClick: handleClickAction,
        expandA11yLabel: (_expandButton_accessibilityLabel1 = expandButton === null || expandButton === void 0 ? void 0 : expandButton.accessibilityLabel) !== null && _expandButton_accessibilityLabel1 !== void 0 ? _expandButton_accessibilityLabel1 : "",
        collapseA11yLabel: (_collapseButton_accessibilityLabel1 = collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.accessibilityLabel) !== null && _collapseButton_accessibilityLabel1 !== void 0 ? _collapseButton_accessibilityLabel1 : ""
    }, /* @__PURE__ */ React116.createElement(EGDSLayoutGrid17, {
        columns: {
            small: 1,
            medium: 1,
            large: 3
        },
        space: "six"
    }, /* @__PURE__ */ React116.createElement(EGDSLayoutGridItem17, {
        colSpan: {
            small: 3,
            medium: 3,
            large: 1
        }
    }, /* @__PURE__ */ React116.createElement("div", null, /* @__PURE__ */ React116.createElement(EGDSSpacing63, {
        padding: {
            inlineend: "three",
            blockend: "six"
        }
    }, /* @__PURE__ */ React116.createElement(EGDSHeading19, {
        tag: "h2",
        size: 4,
        tabIndex: -1
    }, whatsAround.title)), view !== "DISABLE_MAP" /* DISABLE_MAP */  && /* @__PURE__ */ React116.createElement(WhatsAroundEditorial, {
        data: whatsAround.editorial
    }))), /* @__PURE__ */ React116.createElement(EGDSLayoutGridItem17, {
        colSpan: {
            small: 3,
            medium: 3,
            large: 2
        }
    }, /* @__PURE__ */ React116.createElement("div", null, isExpando ? expandoView : defaultView)))))));
    var editorialDefaultView = /* @__PURE__ */ React116.createElement(EGDSSpacing63, {
        padding: {
            small: {
                block: "six",
                inline: "three"
            },
            large: {
                block: "six",
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React116.createElement(EGDSCard13, null, /* @__PURE__ */ React116.createElement(EGDSCardContentSection8, null, /* @__PURE__ */ React116.createElement(EGDSLayoutGrid17, {
        columns: {
            small: 1,
            medium: 1,
            large: 3
        },
        space: "six"
    }, /* @__PURE__ */ React116.createElement(EGDSLayoutGridItem17, {
        colSpan: {
            small: 3,
            medium: 3,
            large: 1
        }
    }, /* @__PURE__ */ React116.createElement("div", null, /* @__PURE__ */ React116.createElement(EGDSSpacing63, {
        padding: {
            inlineend: "three",
            blockend: "six"
        }
    }, /* @__PURE__ */ React116.createElement(EGDSHeading19, {
        tag: "h2",
        size: 4,
        tabIndex: -1
    }, whatsAround.title)), view !== "DISABLE_MAP" /* DISABLE_MAP */  && /* @__PURE__ */ React116.createElement(WhatsAroundEditorial, {
        data: whatsAround.editorial
    }))), /* @__PURE__ */ React116.createElement(EGDSLayoutGridItem17, {
        colSpan: {
            small: 3,
            medium: 3,
            large: 2
        }
    }, /* @__PURE__ */ React116.createElement("div", null, isExpando ? expandoView : defaultView))))));
    return showDatedPDPExpando ? expandoDatedPDPView : editorialDefaultView;
};
WhatsAround.displayName = "WhatsAround";
WhatsAround.fragment = __WhatsAroundFragment;
// src/components/whats-around/whats-around-pois-view.tsx
import React117 from "react";
import { EGDSCard as EGDSCard14, EGDSCardContentSection as EGDSCardContentSection9 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid18, EGDSLayoutGridItem as EGDSLayoutGridItem18 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing64 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading20 } from "@egds/react-core/text";
import { ViewLarge as ViewLarge17, Viewport as Viewport26, ViewSmall as ViewSmall26 } from "@shared-ui/viewport-context";
var WhatsAroundPoisView = function(param) {
    var data = param.data, view = param.view;
    var _data_summary_map, _data_summary, _data_summary1, _data_summary2;
    var mapProps = {
        mapCTALabel: data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_map = _data_summary.map) === null || _data_summary_map === void 0 ? void 0 : _data_summary_map.trigger.value,
        propertyId: data.id
    };
    var whatsAround = ((data === null || data === void 0 ? void 0 : (_data_summary1 = data.summary) === null || _data_summary1 === void 0 ? void 0 : _data_summary1.location) || {
        whatsAround: null
    }).whatsAround;
    if (!data || !whatsAround) {
        return null;
    }
    var poisColumn = /* @__PURE__ */ React117.createElement(EGDSLayoutGridItem18, {
        colSpan: 1
    }, /* @__PURE__ */ React117.createElement("div", null, /* @__PURE__ */ React117.createElement(EGDSSpacing64, {
        padding: {
            inlineend: "three",
            blockstart: "six"
        }
    }, /* @__PURE__ */ React117.createElement(EGDSHeading20, {
        tag: "h2",
        size: 4
    }, whatsAround.title)), /* @__PURE__ */ React117.createElement(WhatsAroundPois, {
        data: whatsAround
    })));
    var defaultView = /* @__PURE__ */ React117.createElement(EGDSSpacing64, {
        padding: {
            block: "six",
            inline: "six"
        }
    }, /* @__PURE__ */ React117.createElement(EGDSCard14, null, /* @__PURE__ */ React117.createElement(EGDSCardContentSection9, null, /* @__PURE__ */ React117.createElement(EGDSLayoutGrid18, {
        columns: 2,
        space: "six"
    }, poisColumn, /* @__PURE__ */ React117.createElement(EGDSLayoutGridItem18, {
        colSpan: 1
    }, /* @__PURE__ */ React117.createElement("div", null, ((_data_summary2 = data.summary) === null || _data_summary2 === void 0 ? void 0 : _data_summary2.map) && /* @__PURE__ */ React117.createElement(WhatsAroundMap, _object_spread({
        data: whatsAround
    }, mapProps)), /* @__PURE__ */ React117.createElement(WhatsAroundEditorial, {
        data: whatsAround.editorial
    })))))));
    var disableMapView = /* @__PURE__ */ React117.createElement(EGDSSpacing64, {
        padding: {
            block: "six",
            inline: "six"
        }
    }, /* @__PURE__ */ React117.createElement(EGDSCard14, null, /* @__PURE__ */ React117.createElement(EGDSCardContentSection9, null, /* @__PURE__ */ React117.createElement(EGDSLayoutGrid18, {
        columns: 3,
        space: "six"
    }, /* @__PURE__ */ React117.createElement(EGDSLayoutGridItem18, {
        colSpan: 1
    }, /* @__PURE__ */ React117.createElement(EGDSSpacing64, {
        padding: {
            inlineend: "three"
        }
    }, /* @__PURE__ */ React117.createElement(EGDSHeading20, {
        tag: "h2",
        size: 4
    }, whatsAround.title))), /* @__PURE__ */ React117.createElement(EGDSLayoutGridItem18, {
        colSpan: 2
    }, /* @__PURE__ */ React117.createElement("div", null, /* @__PURE__ */ React117.createElement(WhatsAroundEditorial, {
        data: whatsAround.editorial
    }), /* @__PURE__ */ React117.createElement(WhatsAroundPois, {
        data: whatsAround
    })))))));
    var getViewComponent = function() {
        switch(view){
            case "DISABLE_MAP" /* DISABLE_MAP */ :
                return disableMapView;
            default:
                return defaultView;
        }
    };
    var ViewComponent = getViewComponent();
    return /* @__PURE__ */ React117.createElement(Viewport26, null, /* @__PURE__ */ React117.createElement(ViewSmall26, null, /* @__PURE__ */ React117.createElement(React117.Fragment, null, whatsAround.nearbyPOIs.length > 0 && /* @__PURE__ */ React117.createElement(EGDSSpacing64, {
        padding: {
            block: "six",
            inline: "three"
        }
    }, /* @__PURE__ */ React117.createElement(EGDSCard14, null, /* @__PURE__ */ React117.createElement(EGDSCardContentSection9, null, /* @__PURE__ */ React117.createElement(EGDSLayoutGrid18, {
        columns: 1,
        space: "six"
    }, poisColumn)))))), /* @__PURE__ */ React117.createElement(ViewLarge17, null, ViewComponent));
};
WhatsAroundPoisView.displayName = "WhatsAroundPoisView";
WhatsAroundPoisView.fragment = __WhatsAroundFragment;
// src/components/whats-around/whats-around-map-pois-editorial-view.tsx
import React118 from "react";
import { EGDSCard as EGDSCard15, EGDSCardContentSection as EGDSCardContentSection10 } from "@egds/react-core/cards";
import { EGDSExpandoPeek as EGDSExpandoPeek5 } from "@egds/react-core/expando";
import { EGDSLayoutColumns as EGDSLayoutColumns3, EGDSLayoutColumnsItem as EGDSLayoutColumnsItem3 } from "@egds/react-core/layout-columns";
import { EGDSLayoutFlex as EGDSLayoutFlex29, EGDSLayoutFlexItem as EGDSLayoutFlexItem21 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid19, EGDSLayoutGridItem as EGDSLayoutGridItem19 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing65 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading21 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker33 } from "@shared-ui/clickstream-analytics-context";
var WhatsAroundPoiSection3 = function(props) {
    var title = props.title, items = props.items, icon = props.icon;
    if (!title || !items || !items.length) {
        return null;
    }
    var hideIcon = (icon === null || icon === void 0 ? void 0 : icon.iconId) !== "lob_cars";
    return /* @__PURE__ */ React118.createElement(EGDSLayoutColumnsItem3, {
        forceNoBreak: true
    }, /* @__PURE__ */ React118.createElement("div", null, /* @__PURE__ */ React118.createElement(EGDSSpacing65, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React118.createElement(EGDSLayoutFlex29, {
        space: "three"
    }, /* @__PURE__ */ React118.createElement(EGDSLayoutFlexItem21, null, /* @__PURE__ */ React118.createElement("div", null, /* @__PURE__ */ React118.createElement(whats_around_icon_default, {
        data: icon
    }))), /* @__PURE__ */ React118.createElement(EGDSLayoutFlexItem21, null, /* @__PURE__ */ React118.createElement("div", null, /* @__PURE__ */ React118.createElement(EGDSHeading21, {
        tag: "h4",
        size: 5
    }, title), /* @__PURE__ */ React118.createElement(WhatsAroundPoisItem, {
        data: props,
        hideIcon: hideIcon
    })))))));
};
var WhatsAroundMapPoisEditorialView = function(param) {
    var data = param.data;
    var _data_summary_map, _data_summary, _data_summary_location, _data_summary1;
    var clickTracker = useClickTracker33();
    var _React118_useState = _sliced_to_array(React118.useState(false), 2), isExpanded = _React118_useState[0], setIsExpanded = _React118_useState[1];
    var mapProps = {
        mapCTALabel: data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_map = _data_summary.map) === null || _data_summary_map === void 0 ? void 0 : _data_summary_map.trigger.value,
        propertyId: data.id
    };
    var whatsAround = data === null || data === void 0 ? void 0 : (_data_summary1 = data.summary) === null || _data_summary1 === void 0 ? void 0 : (_data_summary_location = _data_summary1.location) === null || _data_summary_location === void 0 ? void 0 : _data_summary_location.whatsAround;
    var expando = whatsAround === null || whatsAround === void 0 ? void 0 : whatsAround.expando;
    if (!data || !whatsAround) {
        return null;
    }
    var sortedPois = sortAndByIcon(whatsAround.nearbyPOIs);
    var multiColumn = sortedPois.length > 2;
    var _ref = expando || {}, expandButton = _ref.expandButton, collapseButton = _ref.collapseButton;
    var handleClickAction = function() {
        setIsExpanded(!isExpanded);
        var _ref;
        var _ref1 = (_ref = isExpanded ? collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.analytics : expandButton === null || expandButton === void 0 ? void 0 : expandButton.analytics) !== null && _ref !== void 0 ? _ref : {}, referrerId = _ref1.referrerId, _ref_linkName = _ref1.linkName, linkName = _ref_linkName === void 0 ? "" : _ref_linkName;
        if (referrerId) {
            clickTracker(referrerId, linkName);
        }
    };
    var poisEditorialData = /* @__PURE__ */ React118.createElement(React118.Fragment, null, /* @__PURE__ */ React118.createElement(EGDSLayoutColumns3, {
        columns: multiColumn ? 2 : 1,
        minWidth: multiColumn ? "seventy_two" : void 0
    }, sortedPois.map(function(section, idx) {
        return /* @__PURE__ */ React118.createElement(WhatsAroundPoiSection3, _object_spread_props(_object_spread({}, section), {
            key: idx
        }));
    })), isExpanded ? /* @__PURE__ */ React118.createElement(WhatsAroundEditorial, {
        data: whatsAround.editorial,
        isWhatsAroundMapPoisEditorialView: true
    }) : null);
    var _expandButton_accessibilityLabel, _collapseButton_accessibilityLabel;
    var whatsAroundData = /* @__PURE__ */ React118.createElement(React118.Fragment, null, /* @__PURE__ */ React118.createElement(EGDSSpacing65, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React118.createElement("div", null, /* @__PURE__ */ React118.createElement(WhatsAroundMap, _object_spread({
        data: whatsAround
    }, mapProps)))), /* @__PURE__ */ React118.createElement("div", null, /* @__PURE__ */ React118.createElement(EGDSExpandoPeek5, {
        hideScrim: true,
        whitespace: false,
        items: 1,
        expandLabel: expando === null || expando === void 0 ? void 0 : expando.expandButton.text,
        collapseLabel: expando === null || expando === void 0 ? void 0 : expando.collapseButton.text,
        isVisible: isExpanded,
        handleClick: handleClickAction,
        expandA11yLabel: (_expandButton_accessibilityLabel = expandButton === null || expandButton === void 0 ? void 0 : expandButton.accessibilityLabel) !== null && _expandButton_accessibilityLabel !== void 0 ? _expandButton_accessibilityLabel : "",
        collapseA11yLabel: (_collapseButton_accessibilityLabel = collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.accessibilityLabel) !== null && _collapseButton_accessibilityLabel !== void 0 ? _collapseButton_accessibilityLabel : ""
    }, poisEditorialData)));
    var WhatsAroundMapPoisEditorialData = /* @__PURE__ */ React118.createElement(EGDSSpacing65, {
        padding: {
            small: {
                block: "six",
                inline: "three"
            },
            large: {
                block: "six",
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React118.createElement(EGDSCard15, null, /* @__PURE__ */ React118.createElement(EGDSCardContentSection10, null, /* @__PURE__ */ React118.createElement(EGDSLayoutGrid19, {
        columns: {
            small: 1,
            medium: 1,
            large: 3
        },
        space: "six"
    }, /* @__PURE__ */ React118.createElement(EGDSLayoutGridItem19, {
        colSpan: {
            small: 3,
            medium: 3,
            large: 1
        }
    }, /* @__PURE__ */ React118.createElement("div", null, /* @__PURE__ */ React118.createElement(EGDSSpacing65, null, /* @__PURE__ */ React118.createElement(EGDSHeading21, {
        tag: "h2",
        size: 4,
        tabIndex: -1
    }, whatsAround.title)))), /* @__PURE__ */ React118.createElement(EGDSLayoutGridItem19, {
        colSpan: {
            small: 3,
            medium: 3,
            large: 2
        }
    }, /* @__PURE__ */ React118.createElement("div", null, whatsAroundData))))));
    return WhatsAroundMapPoisEditorialData;
};
WhatsAroundMapPoisEditorialView.displayName = "WhatsAroundMapPoisEditorialView";
WhatsAroundMapPoisEditorialView.fragment = __WhatsAroundFragment;
// src/components/property-details.tsx
var __PropertyDetailsBasicQuery = gql83(_templateObject84(), AmenityDescription.fragment, Policies.fragment, DetailedAmenities.fragment, ImportantInfo.fragment, FrequentlyAskedQuestions.fragment, NavigationBar.fragment, AboutThisProperty3.fragment, WhatsAround.fragment, Gallery.fragment, BookByPhone.fragment, __SummaryFragment, SpaceOverview.fragment, InventorySource.fragment, Shortlist.fragment, SaveTripItem.fragment, AmenitiesSimplifiedView.fragment, RelevantAmenities.fragment, SpecialFeatures.fragment, HostProfile2.fragment, ShareActions.fragment, PropertyDirectFeedbackPromptIdFragment, PropertyNumber.fragment, SummaryVipBadge.fragment);
function withPropertyDetailsQuery(WrappedComponent, displayName, LoadingPlaceholder) {
    var isDataRequired = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var PropertyDetailsComponent = function(props) {
        var _basicData_propertyInfo_summary, _basicData_propertyInfo, _basicData_propertyInfo_summary1, _basicData_propertyInfo1;
        var skipSsr = props.skipSsr, placeholderData = props.placeholderData, inputs = props.inputs;
        var context = useBexApi11().context;
        var _useContext3 = _sliced_to_array(useContext3(PropertyDetailsAdaptExContext), 2), adaptExState = _useContext3[0], setAdaptExState = _useContext3[1];
        var _useExperiment23_exposure = useExperiment23("Luxury_PDP_Feature_Gate_Web").exposure, luxuryBucket = _useExperiment23_exposure.bucket;
        var variables = _object_spread({
            context: context
        }, inputs || {});
        var _useQuery6 = useQuery6(__PropertyDetailsBasicQuery, {
            variables: variables,
            ssr: !skipSsr,
            errorPolicy: "all"
        }), basicData = _useQuery6.data, basicLoading = _useQuery6.loading;
        var variableRandomAccessOne = {
            context: context,
            featureId: "standout-stays",
            productIdentifier: {
                id: inputs.propertyId,
                type: IdentifierType9.PROPERTY_ID
            }
        };
        var _useQuery61 = useQuery6(__RandomAccessOneQuery, {
            variables: variableRandomAccessOne,
            ssr: !skipSsr,
            errorPolicy: "all",
            skip: luxuryBucket === 0
        }), randomAccessData = _useQuery61.data;
        var propertyInfo = basicData === null || basicData === void 0 ? void 0 : basicData.propertyInfo;
        var _ref = (basicData === null || basicData === void 0 ? void 0 : (_basicData_propertyInfo = basicData.propertyInfo) === null || _basicData_propertyInfo === void 0 ? void 0 : (_basicData_propertyInfo_summary = _basicData_propertyInfo.summary) === null || _basicData_propertyInfo_summary === void 0 ? void 0 : _basicData_propertyInfo_summary.amenities) || {}, reserveAdaptExSuccessEvents = _ref.reserveAdaptExSuccessEvents, amenitiesAdaptExSuccessEvents = _ref.amenitiesAdaptExSuccessEvents;
        var _ref1 = (basicData === null || basicData === void 0 ? void 0 : (_basicData_propertyInfo1 = basicData.propertyInfo) === null || _basicData_propertyInfo1 === void 0 ? void 0 : (_basicData_propertyInfo_summary1 = _basicData_propertyInfo1.summary) === null || _basicData_propertyInfo_summary1 === void 0 ? void 0 : _basicData_propertyInfo_summary1.nearbyPOIs) || {}, nearByPoisAdaptExSuccessEvents = _ref1.adaptExSuccessEvents;
        useEffect8(function() {
            var successEventsState = {};
            if (reserveAdaptExSuccessEvents) {
                successEventsState = _object_spread_props(_object_spread({}, successEventsState), {
                    reserveAdaptExSuccessEvents: reserveAdaptExSuccessEvents
                });
            }
            if (amenitiesAdaptExSuccessEvents) {
                successEventsState = _object_spread_props(_object_spread({}, successEventsState), {
                    amenitiesAdaptExSuccessEvents: amenitiesAdaptExSuccessEvents
                });
            }
            if (nearByPoisAdaptExSuccessEvents) {
                successEventsState = _object_spread_props(_object_spread({}, successEventsState), {
                    nearByPoisAdaptExSuccessEvents: nearByPoisAdaptExSuccessEvents
                });
            }
            if (Object.keys(successEventsState).length) {
                setAdaptExState(_object_spread({}, adaptExState, successEventsState));
            }
        }, [
            reserveAdaptExSuccessEvents,
            amenitiesAdaptExSuccessEvents,
            nearByPoisAdaptExSuccessEvents,
            setAdaptExState
        ]);
        if (isDataRequired && basicLoading) {
            return LoadingPlaceholder ? /* @__PURE__ */ React119.createElement(LoadingPlaceholder, {
                data: placeholderData
            }) : null;
        }
        if (isDataRequired && !propertyInfo) {
            return basicLoading && LoadingPlaceholder ? /* @__PURE__ */ React119.createElement(LoadingPlaceholder, {
                data: placeholderData
            }) : null;
        }
        return /* @__PURE__ */ React119.createElement(React119.Fragment, null, basicLoading && LoadingPlaceholder ? /* @__PURE__ */ React119.createElement(LoadingPlaceholder, {
            data: placeholderData
        }) : null, /* @__PURE__ */ React119.createElement(InputsContext.Provider, {
            value: inputs
        }, /* @__PURE__ */ React119.createElement(RandomAccessOneContextProvider, {
            data: randomAccessData
        }, /* @__PURE__ */ React119.createElement(WrappedComponent, _object_spread({
            data: propertyInfo || {}
        }, props)))));
    };
    PropertyDetailsComponent.displayName = displayName;
    return PropertyDetailsComponent;
}
var PropertyFaq = withPropertyDetailsQuery(FrequentlyAskedQuestions, "PropertyFaq");
var PropertyAmenityDescription = withPropertyDetailsQuery(AmenityDescription, "PropertyAmenityDescription");
var PropertyPolicies = withPropertyDetailsQuery(Policies, "PropertyPolicies");
var PropertyImportantInfo = withPropertyDetailsQuery(ImportantInfo, "PropertyImportantInfo");
var PropertySpecialFeatures = withPropertyDetailsQuery(SpecialFeatures, "PropertySpecialFeatures");
var PropertyNavigationBar = withPropertyDetailsQuery(NavigationBar, "PropertyNavigationBar", NavigationBarPlaceholder);
var PropertyAboutThisProperty = withPropertyDetailsQuery(AboutThisProperty3, "PropertyAboutThisProperty");
var PropertyWhatsAround = withPropertyDetailsQuery(WhatsAround, "PropertyImportantInfo");
var PropertyWhatsAroundMapPoisEditorialView = withPropertyDetailsQuery(WhatsAroundMapPoisEditorialView, "PropertyImportantInfo");
var PropertyWhatsAroundPoisView = withPropertyDetailsQuery(WhatsAroundPoisView, "PropertyImportantInfo");
var PropertyGallery = withPropertyDetailsQuery(Gallery, "PropertyGallery", GalleryPlaceholder);
var PropertyBookByPhone = withPropertyDetailsQuery(BookByPhone, "PropertyBookByPhone", BookByPhonePlaceholder);
var PropertySpaceOverview = withPropertyDetailsQuery(SpaceOverview, "PropertySpaceOverview");
var PropertyInventorySource = withPropertyDetailsQuery(InventorySource, "PropertyInventorySource");
var PropertyAmenitiesSimplifiedView = withPropertyDetailsQuery(AmenitiesSimplifiedView, "PropertyAmenitiesSimplifiedView");
var PropertyRelevantAmenities = withPropertyDetailsQuery(RelevantAmenities, "PropertyRelevantAmenities");
var PropertyHostProfile = withPropertyDetailsQuery(HostProfile2, "PropertyHostProfile");
var PropertySummary = Object.assign(withPropertyDetailsQuery(Summary, "PropertySummary", void 0, false), {
    CarouselComponent: CarouselComponent,
    HighlightedBenefitsComponent: HighlightedBenefitsComponent,
    PropertyDetailsMapComponent: PropertyDetailsMapComponent
});
var PropertySummaryHeader = withPropertyDetailsQuery(SummaryHeader, "PropertySummaryHeader", SummaryHeaderPlaceholder);
var PropertySummaryAmenities = withPropertyDetailsQuery(SummaryAmenities, "PropertySummaryAmenities", SummaryComponentPlaceholder);
var PropertyDetailedAmenities = withPropertyDetailsQuery(DetailedAmenities, "PropertyDetailedAmenities", SummaryComponentPlaceholder);
var PropertySummaryNearByPois = withPropertyDetailsQuery(SummaryNearByPois, "PropertySummaryNearByPois");
var PropertySummaryMapTrigger = withPropertyDetailsQuery(SummaryMapTrigger, "PropertySummaryMapTrigger");
var PropertySummaryChatbotLaunch = withPropertyDetailsQuery(SummaryChatbotLaunch, "PropertySummaryChatbotLaunch", SummaryComponentPlaceholder);
var PropertyShortlist = withPropertyDetailsQuery(Shortlist, "PropertyShortlist");
var PropertySaveTripItem = withPropertyDetailsQuery(SaveTripItem, "PropertySaveTripItem");
var PropertyDirectFeedbackPromptId = withPropertyDetailsQuery(PropertyDirectFeedbackCallToAction, "PropertyDirectFeedbackPromptId");
var PropertySummaryGeo = withPropertyDetailsQuery(SummaryGeo, "PropertySummaryGeo");
var PropertyAboutThisPropertySummary = withPropertyDetailsQuery(AboutThisPropertySummary, "PropertyAboutThisPropertySummary");
var PropertySummaryBannerMessage = withPropertyDetailsQuery(SummaryBannerMessage, "PropertyBannerMessage");
var PropertyShareActions = withPropertyDetailsQuery(ShareActions, "PropertyShareActions");
var PropertyNumberMessage = withPropertyDetailsQuery(PropertyNumber, "PropertyNumberMessage");
var PropertySummaryVipBadge = withPropertyDetailsQuery(SummaryVipBadge, "PropertySummaryVipBadge");
export { Map, ProductHighlights, PropertyAboutThisProperty, PropertyAboutThisPropertySummary, PropertyAmenities, PropertyAmenitiesSimplifiedView, PropertyAmenityDescription, PropertyBookByPhone, PropertyDetailedAmenities, PropertyDetailsAdaptExContext, PropertyDetailsAdaptExProvider, PropertyDirectFeedbackPromptId, PropertyFaq, PropertyGallery, PropertyHostProfile, PropertyImageGallery, PropertyImportantInfo, PropertyInfoDetails, PropertyInventorySource, PropertyNavigationBar, PropertyNumberMessage, PropertyPolicies, PropertyRelevantAmenities, PropertySaveTripItem, PropertySeeAllAmenities, PropertyShareActions, PropertyShortlist, PropertySpaceOverview, PropertySpecialFeatures, PropertySummary, PropertySummaryAmenities, PropertySummaryBannerMessage, PropertySummaryChatbotLaunch, PropertySummaryGeo, PropertySummaryHeader, PropertySummaryMapTrigger, PropertySummaryNearByPois, PropertySummaryVipBadge, PropertyWhatsAround, PropertyWhatsAroundMapPoisEditorialView, PropertyWhatsAroundPoisView, WhatsAroundLayout }; /* istanbul ignore next -- @preserve */  // istanbul ignore next -- @preserve
 /* istanbul ignore file -- @preserve */ 
//# sourceMappingURL=index.js.map